/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import TagManager from 'react-gtm-module';
import $ from 'jquery';

function Caption0301() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	
	useEffect(() => {
		$('.book_about #fm_ConBtn').click(
			function () {
				var a = $(this).parent().children('#fm_desc')
				if (a.hasClass('many_txt')) {
					a.addClass('all_txt').removeClass('many_txt')
					this.innerHTML = '收起'
				} else {
					a.addClass('many_txt').removeClass('all_txt')
					this.innerHTML = '瞭解更多'
				}
			}
		)
		$('.btn_detail a').click(function () {
			var str = "#pop" + $(this).attr("id").replace('btn_set', '');
			$('.pop_overlay').addClass("show");
			$(".pop_overlay").find(str).addClass("show");
		});

		$('.btn_close').click(function () {
			$('.pop_overlay').removeClass("show");
			$('.pop_box').removeClass("show");
		});
	}, [location])

	return (
		<>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
						<li><a href="/container/caption/Caption0301">音樂故事清單</a></li>
						<li><a href="/container/caption/Caption0302">愛播聽書FM</a></li>
					</ul>
					<h2 className="tit_main">愛播聽書FM</h2>
					{/* 書本簡介 */}
					<div className="content_box music_box mb_book">
						<p>i寶貝精選「愛播聽書FM」8個最暢銷類別，超過200本書並持續更新，滿足全家老少對於生活、學習、娛樂全方面的需求，只需月付NT$100元，讓聆聽陪伴生活每一刻！即刻啟用享90天免費試聽(僅限首次啟用)</p>
						<div>
							<span id="tab-1"></span>
							<span id="tab-2"></span>
							<span id="tab-3"></span>
							<span id="tab-4"></span>
							<span id="tab-5"></span>
							<span id="tab-6"></span>
							<span id="tab-7"></span>
							<span id="tab-8"></span>
							<span id="tab-9"></span>
							<div id="tab">
								{/* 頁籤按鈕 */}
								<ul>
									<li><a href="#tab-1">所有類別</a></li>
									<li><a href="#tab-2">文學</a></li>
									<li><a href="#tab-3">相聲漫才</a></li>
									<li><a href="#tab-4">健康養生</a></li>
									<li><a href="#tab-5">藝術人文</a></li>
									<li><a href="#tab-6">財經企管</a></li>
									<li><a href="#tab-7">佛教</a></li>
									<li><a href="#tab-8">兒童故事</a></li>
									<li><a href="#tab-9">英語學習</a></li>
								</ul>
								{/* tag content block */}
								<div className="tab-content-1"><br /><br />
									<ul className="book">
										{/* html_book */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B1.png').default} alt="B1" /></div>
												<div className='btn_detail'><a id='btn_set1'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>郝哥說書解讀50部必讀的投資經典一</p>
												<p className='author'>作者：郝旭烈<br />時長 73分鐘</p>
												<p id='fm_desc' className='many_txt'>郝哥，知名創投公司的執行合夥人、培訓超過一萬人的企業王牌財務講師， 從財經的經典重溫、必讀經典理財書、思考致富、生活實用、投資知識、投資實戰、 財富自由等七大財管類別中，精選出50本理財投資暢銷書。 在《郝哥說書》中，郝哥親自為你導讀每本書的精華重點， 同時加入實戰與顧問案例，以十五分鐘時間，帶入簡易方法來解讀作者觀點， 陪你從個人理財到企業經營，了解投資這件事， 讓理財投資書籍再也不艱澀難懂，還能成為你的生活好幫手，帶你邁向財富自由!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B2.png').default} alt="B2" /></div>
												<div className='btn_detail'><a id='btn_set2'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>花媽說故事愛麗絲夢遊仙境</p>
												<p className='author'>作者：王瑞芹花媽<br />時長 145分鐘</p>
												<p id='fm_desc' className='many_txt'>台灣頂尖資深配音員花媽王瑞芹，為寶貝嚴選經典長篇名著－英國數學家「路易斯‧卡洛爾」筆下最天馬行空、流傳150年的冒險童話《愛麗絲夢遊仙境》。邀請寶貝打開小耳朵，跟隨愛麗絲的步伐，與白兔先生踏進兔子洞，來到神奇地底世界一探究竟。
													這場夢境探險共有十七個章節，你將聽見愛麗絲吃遍身體變大變小的甜品、蛋糕和蘑菇，你會為她撞見的奇怪動物驚嘆不已，還會為了脾氣暴躁的紙牌王后而膽戰心驚！
													旅程困難重重…，而古靈精怪、勇敢無畏的愛麗絲有辦法迎刃而解嗎？噓～請仔細聆聽這場驚奇故事，花媽將一人分飾多角，以活靈活現、極具張力的聲音表演，陪伴寶貝勇闖夢遊仙境，一起追尋終點的解答！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B3.png').default} alt="B3" /></div>
												<div className='btn_detail'><a id='btn_set3'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>寶寶探索科學繪本有聲書</p>
												<p className='author'>作者：幼福文化<br />時長 67分鐘</p>
												<p id='fm_desc' className='many_txt'>本系列故事希望幫助孩子們更喜歡閱讀，並多觀察自己或周遭生活的發現，進而得到屬於自己獨一無二的想法或感觸，因此藉著與我們息息相關的科學知識，並以生動的故事情節，跟著孩子一起歡樂閱讀！
													小男孩亮亮被外星人綁架了，奇怪的外星人對他東摸摸西碰碰，超級好奇的模樣到底想做什麼呢？
													最喜歡在太陽天出門去玩了，可是沒一下子天空又突然下起雨來了，這奇怪的小雨滴到底是從哪裡來的？
													聽說很久以前，陸地兄弟的感情很好都捨不得分開，那為什麼現在我們要去很遠的陸地時，還要坐飛機才能跨過陸地呢？他們是吵架了嗎？
													有沒有可能，有一天可以坐飛機上學去呢？
													蔬菜們跟我們一樣，也都住在不一樣的建築物裡！
													你能想像還有誰會比袋鼠跳得更遠嗎？什麼！紀錄上最厲害的選手不是牠，這怎麼可能呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B4.png').default} alt="B4" /></div>
												<div className='btn_detail'><a id='btn_set4'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下15出差旅遊</p>
												<p className='author'>作者：徐薇<br />時長 50分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B5.png').default} alt="B5" /></div>
												<div className='btn_detail'><a id='btn_set5'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下14房屋地產</p>
												<p className='author'>作者：徐薇<br />時長 52分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B6.png').default} alt="B6" /></div>
												<div className='btn_detail'><a id='btn_set6'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下13科技技術</p>
												<p className='author'>作者：徐薇<br />時長 56分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B7.png').default} alt="B7" /></div>
												<div className='btn_detail'><a id='btn_set7'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋安徒生童話</p>
												<p className='author'>作者：幼福文化<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>收錄有「拇指姑娘、醜小鴨、國王的新衣、豌豆公主、賣火柴的小女孩」共五篇孩子喜愛的安徒生童話故事。以活潑的敘述方式，讓孩子快樂讀故事。
													每篇故事都有簡易的單字學習，孩子可跟著故事唸唸看，結合內文加深印象，反覆聆聽後，很快就能記住，如此一來，學習英語遍得更好玩不枯燥，簡單就學會了100個英文單字囉！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B8.png').default} alt="B8" /></div>
												<div className='btn_detail'><a id='btn_set8'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋格林童話</p>
												<p className='author'>作者：幼福文化<br />時長 39分鐘</p>
												<p id='fm_desc' className='many_txt'>收錄「白雪公主、七隻小羊、小紅帽、糖果屋、青蛙王子」共五篇孩子喜愛的格林童話故事。以活潑的敘述方式，讓孩子快樂讀故事。
													每篇故事都有簡易的單字學習，孩子可以跟著故事唸唸看，結合內文加深印象，反覆領聽後，很快就能記住，如此一來，學習英語遍得更好玩不枯燥，簡單就學了100個英文單字囉！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B9.png').default} alt="B9" /></div>
												<div className='btn_detail'><a id='btn_set9'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋伊索寓言</p>
												<p className='author'>作者：幼福文化<br />時長 36分鐘</p>
												<p id='fm_desc' className='many_txt'> 收錄「龜兔賽跑、北風與太陽、放羊的孩子、金斧頭和銀斧頭、城市老鼠與鄉下老鼠」共五篇孩子喜愛的伊索寓言故事。以活潑的敘述方式，讓孩子快樂讀故事。
													每篇故事都有簡易的單字學習，孩子可以跟著故事唸唸看，結合內文加深印象，反覆聆聽後，很快就能記住，如此一來，學習英語遍得更好玩不枯燥，簡單就學了100個英文單字囉！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B10.png').default} alt="B10" /></div>
												<div className='btn_detail'><a id='btn_set10'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭6</p>
												<p className='author'>作者：孫越<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B11.png').default} alt="B11" /></div>
												<div className='btn_detail'><a id='btn_set11'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭5</p>
												<p className='author'>作者：孫越<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B12.png').default} alt="B12" /></div>
												<div className='btn_detail'><a id='btn_set12'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭4</p>
												<p className='author'>作者：孫越<br />時長 47分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B13.png').default} alt="B13" /></div>
												<div className='btn_detail'><a id='btn_set13'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的歡樂世界</p>
												<p className='author'>作者：幼福文化<br />時長 42分鐘</p>
												<p id='fm_desc' className='many_txt'>從生活中遭遇、理解、突破，全數收錄在小雞妙妙的趣味繪本系列～
													小雞妙妙最喜歡的好朋友「莉莉」為什麼要討厭他呢？妙妙只是想跟莉莉一起坐所以推開了豬小弟，叫小兔子走開……為什麼大家都要討厭他呢？
													爸爸上班有好多事情要做，下班回家要在電腦前面待好久，假日還要去河邊釣魚……為什麼爸爸總是這麼忙呢？
													哇！今天小雞妙妙家的隔壁好像來了一戶新鄰居，新鄰居有個可愛的女兒叫莉莉，妙妙好想要跟她做朋友……但不管怎麼做，都還差一點點才能成為朋友呢！
													小雞妙妙腦袋裡總有奇奇怪怪的想法，最近似乎很沉迷在想像未來的自己，一下子想當廚師、又想當公車司機、還想當醫生……這麼多志願，到底哪一個才是認真的呢？
													今天小雞妙妙說這週五他要上台表演唱歌呢！爸爸媽媽也跟小雞妙妙一樣興奮，不論是走路、吃飯、洗澡妙妙都一直很認真在練習！但為什麼……老師居然說表演要取消了呢？
													小雞妙妙跟莉莉最愛玩辦家家酒了，像是今天妙妙就扮演一位醫生呢！看他好像很專業的樣子幫莉莉看病，但看著看著鼻水怎麼流出來啦！這下子妙妙真的要去看醫生了，可是……他最怕打針，怎麼辦才能不打針呀！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B14.png').default} alt="B14" /></div>
												<div className='btn_detail'><a id='btn_set14'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的生活歷險</p>
												<p className='author'>作者：幼福文化<br />時長 48分鐘</p>
												<p id='fm_desc' className='many_txt'>小雞妙妙的媽咪是雙重人格嗎？一下子好凶，一下子又笑咪咪的。一張圓圓的臉會笑咪咪；另一張長長的臉是凶巴巴，小雞妙妙最愛媽咪圓圓的臉了。
													大新聞！今天小雞妙妙有了一個新朋友，他都叫他「小毛球」，可是，明天小雞妙妙不能再陪小毛球玩了，因為他可是一隻大野狼呢！
													肩負捕捉蜈蚣的小雞，居然不知道蜈蚣的樣子嗎？
													有了月亮的陪伴，晚上睡覺小雞妙妙也不會害怕
													這麼多厲害的動物們，到底誰的爸爸最了不起呢？
													嗚嗚嗚……小雞妙妙到底是誰生的呢？小豬、小牛、小羊、小狗都是從媽媽的肚子裡出生的，為什麼小雞妙妙卻是從一顆蛋裡面生出來的呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B15.png').default} alt="B15" /></div>
												<div className='btn_detail'><a id='btn_set15'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>嘻遊記二胡遊台灣</p>
												<p className='author'>作者：甄藝樂場<br />時長 104分鐘</p>
												<p id='fm_desc' className='many_txt'>豬八戒與音樂精靈帶著「神奇的胡琴」，來到寶島臺灣！
													善良的音樂精靈一心想淨化人心、改造地球，
													沒想到「神奇的胡琴」卻不聽話。
													原本想改造臺灣的音樂精靈，竟然變成「魔琴妖精」，
													造成土石流、地震、海嘯等大災難！
													豬八戒該怎麼拯救發狂的音樂精靈，與亂七八糟的臺灣呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B16.png').default} alt="B16" /></div>
												<div className='btn_detail'><a id='btn_set16'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>趣聽兒歌</p>
												<p className='author'>作者：甄藝樂場<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>《趣～聽兒歌》在製作人王甄羚、編劇吳政育及知名編曲家朱雲嵩老師的共同配合下,利用國樂演奏呈現出小朋友耳熟能詳的兒歌,另外在故事精靈和故事裡的角色帶領下,以歡樂開心的唱跳過程中,讓小朋友可以用輕鬆快樂的態度,來了解尊重別人及替別人著想的難能可貴之處!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B17.png').default} alt="B17" /></div>
												<div className='btn_detail'><a id='btn_set17'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟2021星座開運指南</p>
												<p className='author'>作者：季欣麟<br />時長 281分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，為您剖析在2021年12星座的事業、財富、感情、健康密碼！事業運勢如何提升？正財偏財如何取得？桃花將會如何開啟？健康狀況如何留意？還有事業財富及愛情開運的數字、顏色、物品、寶石、月份又將是甚麼？讓季欣麟為您帶來12星座在事業、財富、感情、健康各方面的指引；另外，根據2021年的星盤走勢，行星坐落在不同的宮位上又該如何趨吉避凶？讓季欣麟大師給您貼心叮嚀，指引你通往開運之路!!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B18.png').default} alt="B18" /></div>
												<div className='btn_detail'><a id='btn_set18'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>張艾嘉的音樂故事曖魅</p>
												<p className='author'>作者：張艾嘉<br />時長 76分鐘</p>
												<p id='fm_desc' className='many_txt'>東方人愛聽鄉野傳奇、西方人流行都市傳說，演出者與作曲家如何用聲音與音符述說這些精采故事，讓人聽得拍案叫絕又盪氣迴腸？
													愛情故事，向來為世人歌詠，那些千回百折的幽微心事，如何透過甜苦交織的幽幽訴說與百轉千回的曲調，讓人感同身受？
													張艾嘉的音樂故事，以鄉野傳奇為主軸，結合聲音演繹與古典樂曲，在音樂彈奏與視覺效果的演出中，不只能聽到魔性奇幻又刻骨銘心的經典樂曲名作，還能感受張艾嘉豐富多變的聲音表情以及鋼琴炫技的繽紛燦爛
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B19.png').default} alt="B19" /></div>
												<div className='btn_detail'><a id='btn_set19'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>許常德的愛情箴言愛情練習題QA</p>
												<p className='author'>作者：許常德<br />時長 105分鐘</p>
												<p id='fm_desc' className='many_txt'>擅於解答愛情與人生難題的許常德，某年開始不經意的回答愛情問題，對於愛情有獨到見解的許常德，讓提問者因此認清沒人敢說的真相，旁觀者也得到共鳴，他分享愛、書寫愛、講解愛，如果想要愛，就不能忽視愛裡的「得到」與「失去」的學問。
													集結許常德的愛情建議，替愛情上的各樣疑難雜症開立處方簽，一起探討「愛」這個人類社會最普遍又最迷惘的主題。透過許常德的解析，將感情從相識、相愛、相處到相守的要領全都拆解，幫助愛情中的迷途羔羊找到方向，引領你看透愛的本質，走過愛裡的迷思，重新練習好•好•愛。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B20.png').default} alt="B20" /></div>
												<div className='btn_detail'><a id='btn_set20'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>黃子佼演藝圈的生存之道</p>
												<p className='author'>作者：黃子佼<br />時長 121分鐘</p>
												<p id='fm_desc' className='many_txt'>五光十色的演藝圈，看似豐富精彩，但背後所需要的付出與努力，絕對超乎眾人想像！黃子佼在演藝圈歷練三十年，從一開始的幫襯綠葉，到現在的一線主持人，當中所累積的豐厚經驗，對許多嚮往演藝工作新進後輩來說，可以說是相當珍貴的教材。然而，在黃子佼享受成功果實之前，其實也經歷過相當長時間的低潮期，後來，他靠著勤奮不懈的態度與隨時充足的準備，才從低谷爬起。至今，黃子佼在主持、音樂、歌唱、戲劇、電影…等領域，都有相當出色的成績。他自成一格的處世態度以及工作心法，想必非常值得你我學習。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B21.png').default} alt="B21" /></div>
												<div className='btn_detail'><a id='btn_set21'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>SYR Snow White and the Seven Dwarves</p>
												<p className='author'>作者：優百科<br />時長 7分鐘</p>
												<p id='fm_desc' className='many_txt'>白雪公主因為被壞皇后嫉妒美貌，被趕到森林裡去了。她能平安地度過嗎？還會遇到什麼危險嗎？
													優百科英語故事書，訂購專線886-2-2556-3256</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B22.png').default} alt="B22" /></div>
												<div className='btn_detail'><a id='btn_set22'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>SYR Jack and the Beanstalk</p>
												<p className='author'>作者：優百科<br />時長 10分鐘</p>
												<p id='fm_desc' className='many_txt'>傑克與母親相依為命，窮到要變賣僅剩的一條牛來過日子。傑克到底會換得什麼東西來改善他們的生活呢？
													優百科英語故事書，訂購專線886-2-2556-3256</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B23.png').default} alt="B23" /></div>
												<div className='btn_detail'><a id='btn_set23'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>SYR Aladdin and the Wonderful Lamp</p>
												<p className='author'>作者：優百科<br />時長 9分鐘</p>
												<p id='fm_desc' className='many_txt'>阿拉丁遇到了一位魔術師，他請求阿拉丁幫他到一個洞穴中去取一
													盞燈。那盞燈有何神奇的魔力呢？
													優百科英語故事書，訂購專線886-2-2556-3256</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B24.png').default} alt="B24" /></div>
												<div className='btn_detail'><a id='btn_set24'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>海底兩萬哩</p>
												<p className='author'>作者：糖果姐姐<br />時長 50分鐘</p>
												<p id='fm_desc' className='many_txt'>時長：49分52秒
													太平洋、大西洋海面上；越來越多國家的船，被一隻全身漆黑、頭上有尖角的龐大怪物攻擊！終於，累積的恐懼與憤怒爆發，全世界都要消滅牠！
													但是，設備非常精良的林肯號軍艦與牠對峙時還是被擊垮；隨船的法國海洋生物學權威阿洛納斯博士與全美國最厲害的魚叉手尼德等人更是被吞進了怪物肚子裡，被迫經歷了一場讓人驚心動魄、嘆為觀止的海底之旅……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B25.png').default} alt="B25" /></div>
												<div className='btn_detail'><a id='btn_set25'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>木偶奇遇記</p>
												<p className='author'>作者：糖果姐姐<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>玉米鬚爺爺自從妻子生病過世後，日子變得好孤單！好辛苦！他多麼渴望有小孩子陪他啊！一天，身為木匠的他把一截木頭刻成一個小男孩的形狀，沒想到木頭男孩竟然會說話，還陪伴他一起生活……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B26.png').default} alt="B26" /></div>
												<div className='btn_detail'><a id='btn_set26'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小王子</p>
												<p className='author'>作者：糖果姐姐<br />時長 69分鐘</p>
												<p id='fm_desc' className='many_txt'>時長：1小時08分44秒
													依據安東‧德‧聖艾修伯里的作品改編。主角伯裡在一次飛行時迫降沙漠，遇見了來自某星球的小王子，聽小王子奇妙的星際之旅故事…</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B27.png').default} alt="B27" /></div>
												<div className='btn_detail'><a id='btn_set27'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我的5分鐘故事集快樂小故事</p>
												<p className='author'>作者：幼福文化<br />時長 43分鐘</p>
												<p id='fm_desc' className='many_txt'>閱讀不僅能開啟生活新視野，更能增加不同的知識領域，與其對孩子講一大串道理，不如讓孩子快樂的聽故事、讀故事，甚至模仿故事。當孩子聆聽一篇篇快樂小故事，不僅能滿足孩子的情感需求，天天保持一顆開朗的心情。現在，就一同享受閱讀新樂趣吧！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B28.png').default} alt="B28" /></div>
												<div className='btn_detail'><a id='btn_set28'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下12金融</p>
												<p className='author'>作者：徐薇<br />時長 52分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B29.png').default} alt="B29" /></div>
												<div className='btn_detail'><a id='btn_set29'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下11製造</p>
												<p className='author'>作者：徐薇<br />時長 55分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B30.png').default} alt="B30" /></div>
												<div className='btn_detail'><a id='btn_set30'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>歷史為什麼讓我們發笑</p>
												<p className='author'>作者：王偉忠張大春<br />時長 75分鐘</p>
												<p id='fm_desc' className='many_txt'>王偉忠VS張大春,兩人將以對談形式展現發笑對話的最高境界,說歷史為什麼讓我們發笑,這對談主題由張大春親自提出,向來滿腹詩書,信口成章的兩人,誓言要作場不一樣的顛覆對談,全場沒有嚴肅正經的歷史論述,只有一段段說古論今,體現現代情境的荒繆笑果.試想: 周幽王為求褒姒一笑，點燃烽火，戲弄諸侯的情節到五十步笑百步”的成語，乃至蘇軾的《蝶戀花》：「……牆裡鞦韆牆外道，牆外行人牆裡佳人笑……」等,這點點滴滴的經典陳跡,已成歷史,令人發笑，讓人不知所以!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B31.png').default} alt="B31" /></div>
												<div className='btn_detail'><a id='btn_set31'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>胖叔叔故事屋之美德故事1</p>
												<p className='author'>作者：胖叔叔<br />時長 92分鐘</p>
												<p id='fm_desc' className='many_txt'>美德故事是先人品格的展現，透過與他人的應對進退及無私付出，留下了一個又一個可敬的楷模典範，成為穿越數千年流傳下來的不敗經典，讓胖叔叔用最誠摯的聲音魅力，帶孩子悠遊穿梭於美德品格之中，再次感受人性的真善美。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B32.png').default} alt="B32" /></div>
												<div className='btn_detail'><a id='btn_set32'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我的5分鐘故事集之啟發小故事</p>
												<p className='author'>作者：幼福文化<br />時長 46分鐘</p>
												<p id='fm_desc' className='many_txt'>閱讀不僅能開啟生活新視野，更能增加不同的知識領域，在輕鬆簡短、寓意深遠的小故事中，以各種最奇妙、最耐人尋味的情節，激發孩子的想像空間以及提升想像力和創造力。現在，就一同享受閱讀新樂趣吧！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B33.png').default} alt="B33" /></div>
												<div className='btn_detail'><a id='btn_set33'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我的5分鐘故事集之趣味小故事</p>
												<p className='author'>作者：幼福文化<br />時長 44分鐘</p>
												<p id='fm_desc' className='many_txt'>閱讀不僅能開啟生活新視野，更能增加不同的知識領域，讓孩子聆聽故事完哈哈大笑的同時，除了有一個香甜的夢鄉外，還可以藉由學習、模仿書中的動物主角，懂得以樂觀的心境和態度面對困難。現在，就一同享受閱讀新樂趣吧！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B34.png').default} alt="B34" /></div>
												<div className='btn_detail'><a id='btn_set34'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋世界童話</p>
												<p className='author'>作者：幼福文化<br />時長 35分鐘</p>
												<p id='fm_desc' className='many_txt'>有「三隻小豬、十二生肖、小木偶、阿拉丁與神燈、穿長靴的貓」共五篇孩子喜愛的世界童話。以活潑的敘述方式，讓孩子快樂讀故事。每篇故事都有簡易的單字學習，跟著故事唸唸看，結合內文加深印象，反覆聆聽後，很快就能記住，如此一來，學習英語變得好玩不枯燥，聽完一個童話，就學了100個英文單字囉
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B35.png').default} alt="B35" /></div>
												<div className='btn_detail'><a id='btn_set35'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>胖叔叔故事屋之傳奇故事1</p>
												<p className='author'>作者：胖叔叔<br />時長 81分鐘</p>
												<p id='fm_desc' className='many_txt'>傳奇故事是老祖宗創意的結晶，透過對天地自然的觀察，編撰了一個又一個讓想像力無邊無際飛馳的故事，成為穿越數千年流傳下來的不敗經典，讓胖叔叔用最生動的聲音魅力，帶孩子開啟一場傳奇故事的冒險之旅，也帶您再次感受中國傳奇故事之美。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B36.png').default} alt="B36" /></div>
												<div className='btn_detail'><a id='btn_set36'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭1</p>
												<p className='author'>作者：孫越<br />時長 71分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B37.png').default} alt="B37" /></div>
												<div className='btn_detail'><a id='btn_set37'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭2</p>
												<p className='author'>作者：孫越<br />時長 64分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B38.png').default} alt="B38" /></div>
												<div className='btn_detail'><a id='btn_set38'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭3</p>
												<p className='author'>作者：孫越<br />時長 72分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B39.png').default} alt="B39" /></div>
												<div className='btn_detail'><a id='btn_set39'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的成長日記</p>
												<p className='author'>作者：幼福文化<br />時長 51分鐘</p>
												<p id='fm_desc' className='many_txt'>更多有趣的童言童語及孩子們的疑難雜症，通通在繪本故事裡趣味學習吧！
													每個週五是小雞妙妙就讀得幼兒園的快樂分享日喔！你不知道什麼是「分享」嗎？就是把自己的東西或心情跟其他人一起共有呀！這樣不就是一個人的快樂變成好多人的快樂了嗎？小雞妙妙這次會帶什麼意想不到的快樂跟其他人分享呢？
													「分享」是能將美好的體驗、喜愛的事物與他人共享的感覺，讓孩子學習分享，希望他們也能藉由這種互動，獲得更多的愛。但要讓孩子學習分享除了循序漸進外，尊重孩子的個體及意願也是很重要的，強迫的效果只會適得其反，家長也可以向孩子分享，能產生更棒的互動火花！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B40.png').default} alt="B40" /></div>
												<div className='btn_detail'><a id='btn_set40'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的幸福旅行</p>
												<p className='author'>作者：幼福文化<br />時長 94分鐘</p>
												<p id='fm_desc' className='many_txt'>原來除了爸爸媽媽、兄弟姐妹外，還有「朋友」在關心我！
													為什麼小雞不能游泳呢？小雞妙妙也好想跟小鴨子們一起玩水喔！咦？野狼先生願意教妙妙游泳嗎？這真是太棒了，可是怎麼野狼先生看起來不懷好意的樣子，救命呀！快救救小雞妙妙吧！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B41.png').default} alt="B41" /></div>
												<div className='btn_detail'><a id='btn_set41'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上2人事薪資福利</p>
												<p className='author'>作者：徐薇<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B42.png').default} alt="B42" /></div>
												<div className='btn_detail'><a id='btn_set42'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上3辦公室電話傳真</p>
												<p className='author'>作者：徐薇<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B43.png').default} alt="B43" /></div>
												<div className='btn_detail'><a id='btn_set43'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上4文書作業</p>
												<p className='author'>作者：徐薇<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B44.png').default} alt="B44" /></div>
												<div className='btn_detail'><a id='btn_set44'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上5會議</p>
												<p className='author'>作者：徐薇<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B45.png').default} alt="B45" /></div>
												<div className='btn_detail'><a id='btn_set45'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上6買賣交易</p>
												<p className='author'>作者：徐薇<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B46.png').default} alt="B46" /></div>
												<div className='btn_detail'><a id='btn_set46'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上7採購與物流</p>
												<p className='author'>作者：徐薇<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B47.png').default} alt="B47" /></div>
												<div className='btn_detail'><a id='btn_set47'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上8廣告與宣傳</p>
												<p className='author'>作者：徐薇<br />時長 56分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B48.png').default} alt="B48" /></div>
												<div className='btn_detail'><a id='btn_set48'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上9業務協調</p>
												<p className='author'>作者：徐薇<br />時長 47分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B49.png').default} alt="B49" /></div>
												<div className='btn_detail'><a id='btn_set49'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上10企業經營</p>
												<p className='author'>作者：徐薇<br />時長 51分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B50.png').default} alt="B50" /></div>
												<div className='btn_detail'><a id='btn_set50'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上1職稱職務聘僱面試</p>
												<p className='author'>作者：徐薇<br />時長 67分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B51.png').default} alt="B51" /></div>
												<div className='btn_detail'><a id='btn_set51'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>意識力量轉化癌症癌症不是絕症</p>
												<p className='author'>作者：許添盛<br />時長 72分鐘</p>
												<p id='fm_desc' className='many_txt'>得了癌症，就代表離死亡不遠了？
													許醫師給你一個癌症新定義──它不是絶症！
													癌症不應該只被視為身體的疾病，它是透過身體而反映出來的人生現況。你應該視它為人生的轉機──不是教你怎樣吃更多的健康食品，或是如何去找更多的抗癌方式；而教你如何去改變人生，引導你重新檢討對生命的態度。
													心靈如果沒有被瞭解、被洞悉、沒有予以面對的話，任何只考慮身體的醫療、物質的醫療，都是捨本逐末的做法。癌症的治療，如果只對身體進行手術、化療、放射治療或是荷爾蒙療法，甚至「另類療法」或實驗療法，都是不夠的，最終還是得從「心」著手。
													長久以來，大家都感受到醫學的無力感，也認同身心靈一體的觀點，可是卻鮮少有人能夠把這樣的洞見，變成可供操作、甚至複製的治療方法。許醫師從事身心靈整體健康研究十數年，對於癌症的治療及預防復發有獨特心得。在他的「身心靈整體健康成長團體」、「美麗人生癌症病患成長團體」裏，的確有現代醫學未知的的理論基礎及治療技巧，治癒的效果斐然可觀，而這些你可以在這套有聲書裏找到。
													當你聆聽時，也許呼應了你內心所隱約感覺到的真理，或是喚醒了你對生命的真知灼見。不管你是癌症病友、病友家屬，或是治療癌症的專業人員，希望這本對癌症截然不同的認知以及因而產生的全新治療法，能夠為你帶來不同的思考方式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B52.png').default} alt="B52" /></div>
												<div className='btn_detail'><a id='btn_set52'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>威力最強的抗癌心法癌症不是絕症</p>
												<p className='author'>作者：許添盛<br />時長 64分鐘</p>
												<p id='fm_desc' className='many_txt'>得了癌症，就代表離死亡不遠了？
													許醫師給你一個癌症新定義──它不是絶症！
													癌症不應該只被視為身體的疾病，它是透過身體而反映出來的人生現況。你應該視它為人生的轉機──不是教你怎樣吃更多的健康食品，或是如何去找更多的抗癌方式；而教你如何去改變人生，引導你重新檢討對生命的態度。
													心靈如果沒有被瞭解、被洞悉、沒有予以面對的話，任何只考慮身體的醫療、物質的醫療，都是捨本逐末的做法。癌症的治療，如果只對身體進行手術、化療、放射治療或是荷爾蒙療法，甚至「另類療法」或實驗療法，都是不夠的，最終還是得從「心」著手。
													長久以來，大家都感受到醫學的無力感，也認同身心靈一體的觀點，可是卻鮮少有人能夠把這樣的洞見，變成可供操作、甚至複製的治療方法。許醫師從事身心靈整體健康研究十數年，對於癌症的治療及預防復發有獨特心得。在他的「身心靈整體健康成長團體」、「美麗人生癌症病患成長團體」裏，的確有現代醫學未知的的理論基礎及治療技巧，治癒的效果斐然可觀，而這些你可以在這套有聲書裏找到。
													當你聆聽時，也許呼應了你內心所隱約感覺到的真理，或是喚醒了你對生命的真知灼見。不管你是癌症病友、病友家屬，或是治療癌症的專業人員，希望這本對癌症截然不同的認知以及因而產生的全新治療法，能夠為你帶來不同的思考方式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B53.png').default} alt="B53" /></div>
												<div className='btn_detail'><a id='btn_set53'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>你可以不生病癌症不是絕症</p>
												<p className='author'>作者：許添盛<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>得了癌症，就代表離死亡不遠了？
													許醫師給你一個癌症新定義──它不是絶症！
													癌症不應該只被視為身體的疾病，它是透過身體而反映出來的人生現況。你應該視它為人生的轉機──不是教你怎樣吃更多的健康食品，或是如何去找更多的抗癌方式；而教你如何去改變人生，引導你重新檢討對生命的態度。
													心靈如果沒有被瞭解、被洞悉、沒有予以面對的話，任何只考慮身體的醫療、物質的醫療，都是捨本逐末的做法。癌症的治療，如果只對身體進行手術、化療、放射治療或是荷爾蒙療法，甚至「另類療法」或實驗療法，都是不夠的，最終還是得從「心」著手。
													長久以來，大家都感受到醫學的無力感，也認同身心靈一體的觀點，可是卻鮮少有人能夠把這樣的洞見，變成可供操作、甚至複製的治療方法。許醫師從事身心靈整體健康研究十數年，對於癌症的治療及預防復發有獨特心得。在他的「身心靈整體健康成長團體」、「美麗人生癌症病患成長團體」裏，的確有現代醫學未知的的理論基礎及治療技巧，治癒的效果斐然可觀，而這些你可以在這套有聲書裏找到。
													當你聆聽時，也許呼應了你內心所隱約感覺到的真理，或是喚醒了你對生命的真知灼見。不管你是癌症病友、病友家屬，或是治療癌症的專業人員，希望這本對癌症截然不同的認知以及因而產生的全新治療法，能夠為你帶來不同的思考方式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B54.png').default} alt="B54" /></div>
												<div className='btn_detail'><a id='btn_set54'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>啟動內在感官的十二堂課</p>
												<p className='author'>作者：許添盛<br />時長 482分鐘</p>
												<p id='fm_desc' className='many_txt'>這套啟動內在感官的十二個初階練習，是以賽斯思想為基礎的靜心冥想課程，對於想要真正認識自己、想要瞭解事事物物的真實原貌、 想要擴展意識以覺知更大的心靈實相，甚至只是想讓心安靜下來，訓練專注力與練習放鬆，以儲備能量面對每天嶄新挑戰的現代人，提供一系列平易淺近的方法，能有效幫助學習者實際體驗並落實賽斯思想於生活當中。循序漸進，全程參與，相信大家將會體驗到生命的奇妙感受！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B55.png').default} alt="B55" /></div>
												<div className='btn_detail'><a id='btn_set55'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>消失的931</p>
												<p className='author'>作者：天行音樂<br />時長 71分鐘</p>
												<p id='fm_desc' className='many_txt'>〈公元1673年〉--公元1673年，人類歷史上發生了壹場驚天地泣鬼神的戰爭，北京城裏的康熙皇上，聽說地處雲南的吳三桂正在悄悄地發展生物武器，於是派出得力助手：驍騎營都統、禦賜黃馬褂、頭戴三眼花翎、壹等鹿鼎公，韋小寶前往討伐…</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B56.png').default} alt="B56" /></div>
												<div className='btn_detail'><a id='btn_set56'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>摳你己襪卡卡村</p>
												<p className='author'>作者：天行音樂<br />時長 72分鐘</p>
												<p id='fm_desc' className='many_txt'>探索傳說中全世界最聰明的村子～卡卡村。聽說這個村子隱藏在壹個不為人知的角落，悄悄地延續了三千多年的歷史。從卡卡村流傳出來的故事曾經名滿天下，象是…全天下都知道的…〈國王的新衣〉，試想卡卡村是全世界最聰明的村子，它既然是壹個村子哪來的國王呢？當然，是村長嘛！除了〈村長的新衣〉，卡卡村裏還發生了其他什麽奇妙怪異的事件呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B57.png').default} alt="B57" /></div>
												<div className='btn_detail'><a id='btn_set57'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>公公徹夜未眠</p>
												<p className='author'>作者：相聲瓦舍<br />時長 99分鐘</p>
												<p id='fm_desc' className='many_txt'>《公公徹夜未眠》由「瓦舍金三寶」馮翊綱、宋少卿、黃士偉領銜演出，以幽默風趣的狂想手法，照映現代爭名奪利、窺探八卦秘辛、金迷紙醉的生活。這位神秘的西廠公公到底是誰？他的小嘍囉們又會如何來暗算東廠公公呢？《公公徹夜未眠》爆笑絕倫的唇槍舌戰，讓您徹底體悟何謂〝殺人不見血，笑裡藏刀！〞</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B58.png').default} alt="B58" /></div>
												<div className='btn_detail'><a id='btn_set58'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>他怎麼那麼紅</p>
												<p className='author'>作者：相聲瓦舍<br />時長 189分鐘</p>
												<p id='fm_desc' className='many_txt'>【相聲瓦舍】馮翊綱、宋少卿將傳統經典相聲段子《報菜名》、《倭瓜鑣》、《扒馬褂》 ……等名作重新詮釋，再加上知名舞臺劇演員黃士偉，真是各獻各的寶，各演各的戲，不僅是笑料百出，更是將傳統相聲藝術呈現出前所未見的新面貌。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B59.png').default} alt="B59" /></div>
												<div className='btn_detail'><a id='btn_set59'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>瓦舍說金庸</p>
												<p className='author'>作者：相聲瓦舍<br />時長 97分鐘</p>
												<p id='fm_desc' className='many_txt'>你，看過、玩過金庸、就是沒聽過【相聲瓦舍】說金庸！這次，來點不一樣！ 馮翊綱編劇、與鐵板搭檔宋少卿同台演出。不管有沒有讀過金庸小說，只要看了場演出，都要給你不同的武俠官感，金庸小說的江湖歷險、兒女柔情、古典文史滲入相聲劇，幻化《瓦舍說金庸》，帶你穿越時空，行俠
													仗義！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B60.png').default} alt="B60" /></div>
												<div className='btn_detail'><a id='btn_set60'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>丁菱娟的職場哲學成為更好的自己</p>
												<p className='author'>作者：丁菱娟<br />時長 298分鐘</p>
												<p id='fm_desc' className='many_txt'>工作對您而言是什麼？是謀生溫飽？是鍛鍊成長？還是實現夢想的階梯？
													想在江湖生存，就得有一套磨練專業、經營人脈的場哲學。
													丁菱娟無私的以自身經驗與你分享：如何從菜鳥時期便能起步就定位？如何融入企業文化、如何搞懂職場處世？還有每人必學之向上管理。最後她說：「提升自己，永遠是最值得的投資。」
													因此，職場雖然充滿挑戰和荊棘，無論如何，相信學習與努力，必能成為更好的自己！進入職場，你不必走得快，但一定要走得遠。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B61.png').default} alt="B61" /></div>
												<div className='btn_detail'><a id='btn_set61'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>大話成語</p>
												<p className='author'>作者：臺北曲藝團<br />時長 202分鐘</p>
												<p id='fm_desc' className='many_txt'>台北曲藝團《大話成語》以相聲和評書多種說唱表演藝術形式
													又說又演，演繹成語的魅力，饒富知識性、娛樂性、趣味性
													老少咸宜，雅俗共賞！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B62.png').default} alt="B62" /></div>
												<div className='btn_detail'><a id='btn_set62'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人賣我</p>
												<p className='author'>作者：臺北曲藝團<br />時長 58分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B63.png').default} alt="B63" /></div>
												<div className='btn_detail'><a id='btn_set63'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人疑鄰偷斧</p>
												<p className='author'>作者：臺北曲藝團<br />時長 61分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容61分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B64.png').default} alt="B64" /></div>
												<div className='btn_detail'><a id='btn_set64'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人棺材鋪</p>
												<p className='author'>作者：臺北曲藝團<br />時長 57分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容57分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B65.png').default} alt="B65" /></div>
												<div className='btn_detail'><a id='btn_set65'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人武松打店</p>
												<p className='author'>作者：臺北曲藝團<br />時長 69分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容57分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B66.png').default} alt="B66" /></div>
												<div className='btn_detail'><a id='btn_set66'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人詩情畫意</p>
												<p className='author'>作者：臺北曲藝團<br />時長 57分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容57分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B67.png').default} alt="B67" /></div>
												<div className='btn_detail'><a id='btn_set67'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>開心開開心心走一回</p>
												<p className='author'>作者：王建煊<br />時長 122分鐘</p>
												<p id='fm_desc' className='many_txt'>人生苦短，一晃就過去了。在這短暫的人生裡，若能開開心心的走一回，該是多麼美好。可是開心的日子哪裡找呢？
													這本書中有輕鬆幽默的例子，也有嚴肅的命題，希望引起讀者的共鳴，在觀念上、行動上，都能更容易的邁上開心之路。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B68.png').default} alt="B68" /></div>
												<div className='btn_detail'><a id='btn_set68'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>用愛心說誠實話</p>
												<p className='author'>作者：王建煊<br />時長 128分鐘</p>
												<p id='fm_desc' className='all_txt'>現在願意說誠實話的人愈來愈少，這本書以小故事的方式，用愛心道出一些真話，作者和您一起…聽誠實話、說誠實話，凡事長進。</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B69.png').default} alt="B69" /></div>
												<div className='btn_detail'><a id='btn_set69'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>幸福童話35篇關於愛的故事</p>
												<p className='author'>作者：宇宙光<br />時長 349分鐘</p>
												<p id='fm_desc' className='many_txt'>幸福是神話嗎？如何避免落入不幸的陷阱？特選自德國文學作品的三十五篇「小小說」，篇篇都是啟迪幸福的鑰匙，值得追求幸福的你一聽再聽。每個故事的共同主題是「愛」，包含了夫妻間的深情、戀人的愛情、親情的滿足、鄰人的友誼、陌生人之間可貴無私的愛……，觸動你我的心弦，彈奏出幸福之歌。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B70.png').default} alt="B70" /></div>
												<div className='btn_detail'><a id='btn_set70'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>EFT情緒釋放技巧</p>
												<p className='author'>作者：Carol林嘉瑗<br />時長 232分鐘</p>
												<p id='fm_desc' className='many_txt'>「EFT 情緒釋放技巧」（Emotional Freedom Techniques），是能量心理治療體系當中的一種，快速又有效的能量心理學技術。是一套簡單方便，以及具突破技巧，能迅速有效解決情緒與心理問題。現今許多國家的心理學家運用它來進行治療，成千上萬的人運用它來進行減壓、情緒排毒與療癒重大創傷。
													在「EFT 情緒釋放技巧」裡，Carol老師會引導你一層層深入你的情緒核心，碰觸最真實的自己， 啟發內在的力量與愛，協助你卸下情緒的包袱，釋放深藏的痛苦種子，找到心靈的平靜與寧靜，重新認識自己、接受自己，重建自信。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B71.png').default} alt="B71" /></div>
												<div className='btn_detail'><a id='btn_set71'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>EFT人和領導術</p>
												<p className='author'>作者：Carol林嘉瑗<br />時長 178分鐘</p>
												<p id='fm_desc' className='many_txt'>經由EFT人和領導術，你可以很快的瞭解，對手是什麼樣的人，您可以用很簡單的肢體語言，輕鬆的跟他產生良性互動。更重要的是你會更了解自己。理解自己與他人的不同，然後用簡單具體的方式，快速地增進彼此的人際關係，進而達成你想要的目標。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B72.png').default} alt="B72" /></div>
												<div className='btn_detail'><a id='btn_set72'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣答嘴鼓誰人甲你比</p>
												<p className='author'>作者：王一明、康康<br />時長 16分鐘</p>
												<p id='fm_desc' className='many_txt'>唸歌，講古，答嘴鼓， 台語三大說唱藝術。
													流行音樂跟傳統藝術也要跨界，來個斜槓合作！
													當康康遇見王一明， 當金曲獎最佳台語男歌手 遇上 金曲獎最佳戲曲曲藝專輯獎得主， 當綜藝天王主持一哥遇上廣播金鐘獎最佳綜合節目主持人，
													兩個老男人比來比去的，到底會比出什麼來?
													誰人甲你比！ 台灣答嘴鼓系列 2020 推出最新段目！ 我們比看看，也歡迎你來聽看看， 正宗台語相聲！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B73.png').default} alt="B73" /></div>
												<div className='btn_detail'><a id='btn_set73'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>異界龍印之尊</p>
												<p className='author'>作者：聲朗文化<br />時長 807分鐘</p>
												<p id='fm_desc' className='many_txt'>修道對於22世紀的人來說，只是一些幻想家的幻想而已。盧軒在以前只是一個普通人，根本不相信什麽鬼神之說的，而現在他已經成為了蓮花道人的弟子。
													22世紀的地球，大量的工業開採使地球已經變成了毫無靈氣的藍色星球，盧軒為了修煉自身，盡快開啟通天之法，迎天地之大機緣，他離開生活了20年的地球，前往修道界最好的星球--靈星，遇到了雷厲風行的小仙女念巧兒，開啟了一段傳奇故事！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B74.png').default} alt="B74" /></div>
												<div className='btn_detail'><a id='btn_set74'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>靈武大陸之魔界</p>
												<p className='author'>作者：聲朗文化<br />時長 667分鐘</p>
												<p id='fm_desc' className='many_txt'>一把被封印的飲血魔刀突然控制了靈武鎮朱家弟子朱董陽，為了爭搶魔戒統一全世界，成為萬物之主，它將朱家夷成平地，原本偌大的家園，變成了殘破不堪的碎石瓦礫。雖然無數的強者都來阻止它，但是無一例外都死在了飲血魔刀之下，成為了魔刀的補品。
													十五歲的朱家少年朱孝天召喚魔戒，十年如一日的潛修，與魔刀展開了曠世絕倫的對決。最終，朱孝天把魔刀變成了一把普通兵刃！世界再也不會遭到飲血魔刀的迫害，持續了數千年的災禍終於得到了控制。
													而朱孝天也成為了新一代的大俠，更是把無極宗發揚光大！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B75.png').default} alt="B75" /></div>
												<div className='btn_detail'><a id='btn_set75'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李建復帶你重返我的民歌年代</p>
												<p className='author'>作者：李建復<br />時長 387分鐘</p>
												<p id='fm_desc' className='many_txt'>民歌是華人流行音樂的搖籃，不僅開啟了百花齊放的音樂創作方式，也真實反映當時的社會風氣與生活，在這次的節目裡，李建復邀訪各民歌時期的名家，經由這些音樂人的分享，帶你回到那些年一起抱著吉他唱歌的日子，唱響你的民歌時代。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B76.png').default} alt="B76" /></div>
												<div className='btn_detail'><a id='btn_set76'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>那些年那些人那些事都是我要講的故事</p>
												<p className='author'>作者：王正方<br />時長 259分鐘</p>
												<p id='fm_desc' className='many_txt'>塵起塵落後，溫暖又寂寞，王正方：「人生無非是緣聚緣散一場。」
													王正方，從一個美國教授、電機博士，一頭栽進電影圈，成為獨立製片的導演，他的電影，總是在刻劃真實人生；而他的真實人生，也彷彿在搬演電影。
													在他顛沛如光影的生命劇展裡，總有大時代的角色能與他來段對手戲，王正方用他慣常的幽默、灑脫、與細膩的人情味，說著自己與記憶中的那個人的故事，故事令人心神嚮往，那人讓你魂牽夢縈。
													『王正方：那些年、那些人、那些事…都是我要講的故事』專輯，集結了由王正方談他在人生路上所遇見的那些「精采有趣的人物、他所欽佩仰慕的前輩」，帶你發現王正方「憶中人」那些你所不知道的事。
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B77.png').default} alt="B77" /></div>
												<div className='btn_detail'><a id='btn_set77'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>泡沫</p>
												<p className='author'>作者：林隆璇<br />時長 35分鐘</p>
												<p id='fm_desc' className='many_txt'>人呢，經由眼耳鼻舌身去感受，再加上心的各種作用，形成了色受想行識五蘊。這五蘊看似堅實，實際上卻須臾變化不停，「觀色如聚沫，受如水上泡，想如春時焰，諸行如芭蕉，諸識法如幻。」如許深奧的道理，但有時我們剎那間又能明白。鋼琴王子林隆璇老師演奏了這九首曲目，都是堪布 竹清嘉措仁波切所創作的道歌，他以琴音洗滌現代人的迷惑，期許人人的智慧都能如花綻放。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B78.png').default} alt="B78" /></div>
												<div className='btn_detail'><a id='btn_set78'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>吉祥之光何等燦然</p>
												<p className='author'>作者：林隆璇<br />時長 30分鐘</p>
												<p id='fm_desc' className='many_txt'>天地之間最強靭的，是心的力量；宇宙之中最大的奇蹟，也是來自於心。因此再也沒有什麼事情，比認識自己的心更重要的了。這十首動聽的鋼琴曲目，由鋼琴王子林隆璇老師演奏堪布 竹清嘉措仁波切創作的道歌，奔放自由的音樂表情，來自於修心超過二十年的他，琴藝精湛且能隨心所欲。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B79.png').default} alt="B79" /></div>
												<div className='btn_detail'><a id='btn_set79'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>通樂想通了就快樂</p>
												<p className='author'>作者：王建煊<br />時長 126分鐘</p>
												<p id='fm_desc' className='many_txt'>許多事想通了就快樂，想不通就難過，有時鑽牛角尖，甚至弄到殺人或自我毀滅的地步。有個女孩，相交多年的男友移情別戀。她憤怒、痛苦、茶不思飯不想……簡直不知如何是好？她問前監察院長王建煊怎麼辦……？你想成為錢財的主人嗎……？你贊成黃昏之戀嗎……？讓王建煊藉由人生經驗，以小故事幫助大家當沮喪來訪時，轉個念頭，便有豁達的人生！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B80.png').default} alt="B80" /></div>
												<div className='btn_detail'><a id='btn_set80'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>療癒爵士之愛深夜單人舞</p>
												<p className='author'>作者：安譜<br />時長 67分鐘</p>
												<p id='fm_desc' className='all_txt'>分手後的深夜，一個人原來可以不用感覺孤單，第一次發先。
													原來城市的喧囂可以變成安靜，夜晚天空中，有星星！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B81.png').default} alt="B81" /></div>
												<div className='btn_detail'><a id='btn_set81'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>漫步森林靜心舒壓系列</p>
												<p className='author'>作者：安譜<br />時長 86分鐘</p>
												<p id='fm_desc' className='all_txt'>這份來自森林的禮物，是輕拂的風之頌，輕輕柔柔撫慰著疲憊的心靈，讓音樂伴隨而來的釋放，忘卻壓力！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B82.png').default} alt="B82" /></div>
												<div className='btn_detail'><a id='btn_set82'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>鉛筆盒幻想曲幸福晨光序曲</p>
												<p className='author'>作者：安譜<br />時長 48分鐘</p>
												<p id='fm_desc' className='all_txt'>有一個鉛筆盒，裡面住著美麗的鉛筆，每一支鉛筆，都期待著被小主人拿出來，畫出美麗的色彩!</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B83.png').default} alt="B83" /></div>
												<div className='btn_detail'><a id='btn_set83'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>新鮮的滋味揮別憂鬱系列</p>
												<p className='author'>作者：安譜<br />時長 168分鐘</p>
												<p id='fm_desc' className='all_txt'>早起很重要，清晨的第一口新鮮空氣是一天最棒的好福氣！好好吸一口，馬上清醒了！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B84.png').default} alt="B84" /></div>
												<div className='btn_detail'><a id='btn_set84'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>花裙子的微笑巴莎諾瓦放鬆時刻</p>
												<p className='author'>作者：安譜<br />時長 47分鐘</p>
												<p id='fm_desc' className='all_txt'>簡樸的南歐小鎮，平和的日子因為不知名的女孩搬入而充滿了奇想，會有什麼令人回味無窮的故事呢？</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B85.png').default} alt="B85" /></div>
												<div className='btn_detail'><a id='btn_set85'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>那天散步遇到你巴莎諾瓦放鬆時刻</p>
												<p className='author'>作者：安譜<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>咖啡、奶茶、曾經一起去的蛋糕店，在這樣的午後忽然成了一幅淡彩畫。朦朧之間，音樂響起，是那天一起跳舞的午後巴莎諾瓦，我又看到妳了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B86.png').default} alt="B86" /></div>
												<div className='btn_detail'><a id='btn_set86'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>早安元氣幸福晨光序曲</p>
												<p className='author'>作者：安譜<br />時長 31分鐘</p>
												<p id='fm_desc' className='all_txt'>早安！剔透純淨的音樂，伴隨著清新的節奏，一天的開始是最美的時光，要開開心心喔！就是現在，今天出發吧！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B87.png').default} alt="B87" /></div>
												<div className='btn_detail'><a id='btn_set87'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>雙魚座舒眠好夢揮別憂鬱系列</p>
												<p className='author'>作者：安譜<br />時長 87分鐘</p>
												<p id='fm_desc' className='many_txt'>12星座睡覺時要伴隨什麼樣的舒眠音樂呢？
													白天，每一個星座的人，有著不一樣的煩惱方式，說晚安後，一定也需要不一樣的舒眠音樂！就讓安譜最精緻的舒眠音樂伴隨您進入夢鄉。這一集，就先請雙魚座的朋友們，舒舒服服進入夢鄉！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B88.png').default} alt="B88" /></div>
												<div className='btn_detail'><a id='btn_set88'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>江湖九分熟</p>
												<p className='author'>作者：聲朗文化<br />時長 574分鐘</p>
												<p id='fm_desc' className='many_txt'>江湖一分熟，回家種紅薯；江湖兩分熟，打雜都不屬；江湖三分熟，勉強能做主；江湖四分熟，敢和命打賭；江湖五分熟，屈指便可數；江湖六分熟，人人都讓路；江湖七分熟，鬼都不敢堵；江湖八分熟，頭上是盟主；江湖九分熟，腳踩一片土；江湖十分熟，此乃神人，鬼主。
													江湖新菜譜火熱出爐！配料如下：七小邪，一雙被七小邪“借”走的冰蠶鞋，兩本被七小邪順走的《九宗秘笈》上下冊。
													但凡集齊配料，送至九王爺或者官府總督面前，便可免費品嘗九分熟的江湖一份！
													江湖之大，奇人之多，不論混了多久，都始終是小蝦米，不願做一輩子的蝦米，於是，很多人借此機會想要翻身當盟主，於是，史上最浩蕩的一次“通緝令”，使江湖上無數英雄狗熊摩拳擦掌，開始了他們的翻身之旅。
													跑江湖也能混到個武林盟主當當，這一趟，不算白來……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B89.png').default} alt="B89" /></div>
												<div className='btn_detail'><a id='btn_set89'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>差點是女皇</p>
												<p className='author'>作者：聲朗文化<br />時長 446分鐘</p>
												<p id='fm_desc' className='many_txt'>少女金卡卡是個偷搶打混的不良少女，一次犯案時誤傷企業大少伊流影。他在醒來後失憶，並執意認為她是他的女友。“用像海洋那麼寬廣的愛去愛你”，他愛的不過是一段漂浮不定的回憶。“你什麼時候才能愛的是我呢”，她等待著，可她的愛卻始終比他快了一步。
													2010年尾，易開罐用最爆笑的文字講訴了一段最痛徹心扉的愛情。我們都愛過，笑著，哭了，希望最後記得的仍是快樂。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B90.png').default} alt="B90" /></div>
												<div className='btn_detail'><a id='btn_set90'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人井底之蛙</p>
												<p className='author'>作者：臺北曲藝團<br />時長 50分鐘</p>
												<p id='fm_desc' className='many_txt'>喜迎25系列_2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！ 演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少鹹宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B91.png').default} alt="B91" /></div>
												<div className='btn_detail'><a id='btn_set91'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人武松打虎</p>
												<p className='author'>作者：臺北曲藝團<br />時長 60分鐘</p>
												<p id='fm_desc' className='many_txt'>喜迎25系列_2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！ 演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少鹹宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B92.png').default} alt="B92" /></div>
												<div className='btn_detail'><a id='btn_set92'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人大改行</p>
												<p className='author'>作者：臺北曲藝團<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>喜迎25系列_2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！ 演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少鹹宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B93.png').default} alt="B93" /></div>
												<div className='btn_detail'><a id='btn_set93'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第9部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B94.png').default} alt="B94" /></div>
												<div className='btn_detail'><a id='btn_set94'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第8部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B95.png').default} alt="B95" /></div>
												<div className='btn_detail'><a id='btn_set95'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第7部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B96.png').default} alt="B96" /></div>
												<div className='btn_detail'><a id='btn_set96'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第6部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 57分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B97.png').default} alt="B97" /></div>
												<div className='btn_detail'><a id='btn_set97'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第5部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 56分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B98.png').default} alt="B98" /></div>
												<div className='btn_detail'><a id='btn_set98'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第4部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B99.png').default} alt="B99" /></div>
												<div className='btn_detail'><a id='btn_set99'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第3部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B100.png').default} alt="B100" /></div>
												<div className='btn_detail'><a id='btn_set100'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第2部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 47分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B101.png').default} alt="B101" /></div>
												<div className='btn_detail'><a id='btn_set101'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第1部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B102.png').default} alt="B102" /></div>
												<div className='btn_detail'><a id='btn_set102'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>信仰與命運</p>
												<p className='author'>作者：聖嚴法師<br />時長 155分鐘</p>
												<p id='fm_desc' className='many_txt'>聖嚴法師作品《信仰與命運》。聖嚴法師，佛學大師、教育家、佛教弘法大師、日本立正大學博士，也是禪宗曹洞宗的第五十代傳人、臨濟宗的第五十七代傳人、臺灣法鼓山的創辦人。聖嚴法師，1930年出生於中國江蘇省南通縣，13歲出家，青年時期留學日本，1975年獲日本立正大學文學博士學位。回臺灣後，聖嚴法師歷任臺灣中國文化大學教授，中華學術院佛學研究所所長，美國佛教會副會長及譯經院院長，創辦中華佛學研究所，發行佛學學報及佛學研究年刊，為輔大、政大、文大博士及碩士研究生擔任論文指導。又創辦法鼓山國內外禪修，文教、慈善體系的人文社會大學、僧伽大學、僧團道場、七個基金會、中英文四種定期刊物。他以中、日、英三種語文在亞、美、歐各洲出版的著作近百種。他的著作之中發行量最多的是《正信的佛教》，已超過三百萬冊，譯本最多的是《信心銘》，已有十種，系列冊數最多的是[寰遊自傳]及[禪修指引]，這些著述均受廣大讀者的歡迎。聖嚴法師所推動的理念是，提升人的品質，建設人間淨土，以教育完成關懷任務，以關懷達到教育目的。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B103.png').default} alt="B103" /></div>
												<div className='btn_detail'><a id='btn_set103'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會花宅</p>
												<p className='author'>作者：臺北曲藝團<br />時長 27分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B104.png').default} alt="B104" /></div>
												<div className='btn_detail'><a id='btn_set104'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會男朋友女朋友</p>
												<p className='author'>作者：臺北曲藝團<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B105.png').default} alt="B105" /></div>
												<div className='btn_detail'><a id='btn_set105'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會買賣論</p>
												<p className='author'>作者：臺北曲藝團<br />時長 26分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B106.png').default} /></div>
												<div className='btn_detail'><a id='btn_set106'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會段子一</p>
												<p className='author'>作者：臺北曲藝團<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B107.png').default} /></div>
												<div className='btn_detail'><a id='btn_set107'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會喜迎25鬧生日</p>
												<p className='author'>作者：臺北曲藝團<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B108.png').default} /></div>
												<div className='btn_detail'><a id='btn_set108'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會反七口</p>
												<p className='author'>作者：臺北曲藝團<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B109.png').default} /></div>
												<div className='btn_detail'><a id='btn_set109'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會六口人</p>
												<p className='author'>作者：臺北曲藝團<br />時長 42分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B110.png').default} /></div>
												<div className='btn_detail'><a id='btn_set110'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會彬彬有禮</p>
												<p className='author'>作者：臺北曲藝團<br />時長 44分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B111.png').default} /></div>
												<div className='btn_detail'><a id='btn_set111'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會四管四轄</p>
												<p className='author'>作者：臺北曲藝團<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B112.png').default} /></div>
												<div className='btn_detail'><a id='btn_set112'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會歪批三國</p>
												<p className='author'>作者：臺北曲藝團<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B113.png').default} /></div>
												<div className='btn_detail'><a id='btn_set113'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會二人見面忙把手</p>
												<p className='author'>作者：臺北曲藝團<br />時長 29分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B114.png').default} /></div>
												<div className='btn_detail'><a id='btn_set114'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會記得當年那首歌</p>
												<p className='author'>作者：臺北曲藝團<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B115.png').default} /></div>
												<div className='btn_detail'><a id='btn_set115'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶旅遊篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 64分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B116.png').default} /></div>
												<div className='btn_detail'><a id='btn_set116'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶音樂篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 74分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B117.png').default} /></div>
												<div className='btn_detail'><a id='btn_set117'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶生活篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 93分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B118.png').default} /></div>
												<div className='btn_detail'><a id='btn_set118'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶民俗節慶篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B119.png').default} /></div>
												<div className='btn_detail'><a id='btn_set119'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶叫賣篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 88分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。台灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的台灣聲音為主軸，喚起台灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B120.png').default} /></div>
												<div className='btn_detail'><a id='btn_set120'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶人文自然篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 74分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。台灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的台灣聲音為主軸，喚起台灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B121.png').default} /></div>
												<div className='btn_detail'><a id='btn_set121'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>30個台灣地景故事</p>
												<p className='author'>作者：管家琪<br />時長 266分鐘</p>
												<p id='fm_desc' className='many_txt'>蘭嶼島為什麼叫做蘭嶼？半屏山是怎麼來的？基隆的仙洞以前為什麼叫白米壺？土地公為什麼在玉山山頂晒白銀？阿里山的姑娘真的美如水？管家琪以輕鬆、知性的說故事方式，告訴大家臺灣30個地景故事，讓我們知道臺灣在人文與地理景觀上的變化，同時了解臺灣、認識臺灣。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B122.png').default} /></div>
												<div className='btn_detail'><a id='btn_set122'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>他鄉故鄉</p>
												<p className='author'>作者：中央廣播電台<br />時長 659分鐘</p>
												<p id='fm_desc' className='many_txt'>「他鄉．故鄉」是一系列以陸配、外配、外勞和留學生為主角的廣播劇，他們都是普通人，沒有眩人的家世背景，甚至，生活在社會最基層，必須辛勤工作才能糊口，可是，他們靠著自己的努力，在這塊包容他們的土地上紮根，成長，開花，結果。把他鄉變成了故鄉，把自己活成讓人佩服的勇者。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B123.png').default} /></div>
												<div className='btn_detail'><a id='btn_set123'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣記憶</p>
												<p className='author'>作者：中央廣播電台<br />時長 676分鐘</p>
												<p id='fm_desc' className='many_txt'>回溯歷史，許多臺灣人，臺灣事，都讓後人難以忘懷。「臺灣記憶」以人物為經，事件為緯，結合史實，用戲劇方式勾勒出三百多年以來臺灣史上的重要事件：鄭氏父子來臺、治臺；臺灣文化、教育、社會的發展；臺灣人在乙未戰爭和霧社事件中的英勇表現；日治時期臺灣人的反日本殖民運動等等。這些歷史，是臺灣永遠不可能遺忘的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B124.png').default} /></div>
												<div className='btn_detail'><a id='btn_set124'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間5</p>
												<p className='author'>作者：李季準<br />時長 248分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準是台灣資深的廣播主持人，低沉磁性的嗓音，陪伴了許多聽眾度過無數個日夜。曾替絲襪廣告配音，經典台詞是「腰部以下，全部透明」，這句話，成為大家耳熟能詳的廣告用語!在廣播界，李季準以感性與多元播報內容，被譽為經典，過去曾5度獲得廣播金鐘獎榮譽，代表節目為感性時間，這是他上山下海親自採訪台灣各界人事物所精心製作的內容，並配上台灣民謠與音樂，讓節目內容更為豐富多元</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B125.png').default} /></div>
												<div className='btn_detail'><a id='btn_set125'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間4</p>
												<p className='author'>作者：李季準<br />時長 231分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準是台灣資深的廣播主持人，低沉磁性的嗓音，陪伴了許多聽眾度過無數個日夜。曾替絲襪廣告配音，經典台詞是「腰部以下，全部透明」，這句話，成為大家耳熟能詳的廣告用語!在廣播界，李季準以感性與多元播報內容，被譽為經典，過去曾5度獲得廣播金鐘獎榮譽，代表節目為感性時間，這是他上山下海親自採訪台灣各界人事物所精心製作的內容，並配上台灣民謠與音樂，讓節目內容更為豐富多元</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B126.png').default} /></div>
												<div className='btn_detail'><a id='btn_set126'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間3</p>
												<p className='author'>作者：李季準<br />時長 182分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準在台灣70～90年代，有「電台情人」之稱，「感性時間，祝您晚安！」這是李季準最廣為人知的招牌節目「感性時間」的問候語。1975年開播，一播出就超過20年歷史，吸引無數知音。節目內容以日常小事溝通情感、陶冶性靈為主，是不少夜貓子的心靈療癒妙方，更是李季準生平最費心盡力製作、經營最久的空中節目。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B127.png').default} /></div>
												<div className='btn_detail'><a id='btn_set127'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間2</p>
												<p className='author'>作者：李季準<br />時長 215分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準是台灣資深的廣播主持人，低沉磁性的嗓音，陪伴了許多聽眾度過無數個日夜。曾替絲襪廣告配音，經典台詞是「腰部以下，全部透明」，這句話，成為大家耳熟能詳的廣告用語!在廣播界，李季準以感性與多元播報內容，被譽為經典，過去曾5度獲得廣播金鐘獎榮譽，代表節目為感性時間，這是他上山下海親自採訪台灣各界人事物所精心製作的內容，並配上台灣民謠與音樂，讓節目內容更為豐富多元</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B128.png').default} /></div>
												<div className='btn_detail'><a id='btn_set128'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間1</p>
												<p className='author'>作者：李季準<br />時長 209分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準，台灣知名廣播及電視節目主持人，聲音富有磁性、低沉渾厚、極具魅力，於主持廣播《感性時間》、《知性時間》等節目期間，曾有「電台情人」之稱號被被譽為台灣第一代「電台情人」。其製作的節目，五度獲的廣播金鐘獎的肯定，第50屆台灣金鐘獎，李季準更獲得特別貢獻獎，以表彰對台灣廣播界的貢獻，”感性時間”節目是其代表性節目，提供聽眾許多台灣音樂與知性訪談的內容。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B129.png').default} /></div>
												<div className='btn_detail'><a id='btn_set129'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>提升女性豐滿UPUP</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B130.png').default} /></div>
												<div className='btn_detail'><a id='btn_set130'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>超級學習記憶</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B131.png').default} /></div>
												<div className='btn_detail'><a id='btn_set131'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>維持苗條體態</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B132.png').default} /></div>
												<div className='btn_detail'><a id='btn_set132'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>紓壓放鬆法門</p>
												<p className='author'>作者：鈺蓁<br />時長 34分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B133.png').default} /></div>
												<div className='btn_detail'><a id='btn_set133'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠中的瑜珈</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到內容純淨無暇，零壓力的聽覺享受，宛如睡眠中的瑜珈，讓使用者進入最自然放鬆的睡眠狀態中，享受到瑜珈運動所帶來的身心健康愉悅的舒適感受，享受舒眠的快樂
													【使用方法】
													1聆聽過程最好使用耳機，以更好感受音聲導引雙耳波差的效果
													2聆聽過程請輕輕閉上眼睛並保持身體放鬆
													3聆聽前請深呼吸三次.音聲導引~雙腦同步，領先一步
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B134.png').default} /></div>
												<div className='btn_detail'><a id='btn_set134'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>牽爸媽的手自在到老</p>
												<p className='author'>作者：張曉卉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>第一本照顧父母的有聲指南！
													當你對爸媽說，今晚我不回家吃飯、下個月我再回去看你時，他們正不停地老下去。
													無論現在他們多有活力，仍難逃老、病、死的劇本，你為心底時而閃過的那一天，做好準備了嗎？
													如同「育兒教養書」為兒女的成長做好準備，學習為長輩創造健康、圓滿的人生下半場，也有你一定該知道的幾件事。
													隨資深專業廣播人凌爾祥的聲音指引，學習陪伴、照顧長者，幫他們延緩退化、縮短臥床時間，讓為人子女的你，學習照顧父母，預約圓滿老年，牽爸媽的手自在到老，不留遺憾。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B135.png').default} /></div>
												<div className='btn_detail'><a id='btn_set135'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟星座成功學</p>
												<p className='author'>作者：季欣麟<br />時長 252分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，帶您以太陽、上升星座及水星、金星來帶你瞭解你在工作、事業、正財、偏財的運勢，並帶你從風水土火四象星座來提點你的事業成功致富的地雷，以及事業方面心想事成的方法，並帶你瞭解專屬於你的事業開運數字、開運顏色、開運物品、開運寶石、開運貴人，讓季欣麟為您解開12星座的事業及財富秘密，給你滿滿開運行動力，在你成功致富之路上，祝你一臂之力！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B136.png').default} /></div>
												<div className='btn_detail'><a id='btn_set136'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟星座幸福學</p>
												<p className='author'>作者：季欣麟<br />時長 254分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，帶您以太陽、上升星座剖析你的情人的愛情特質及特徵，從交往期到建立家庭，為您剖析星座情人的愛情觀、家庭觀以及看待親密關係的真正態度及想法，瞭解各星座情人的愛情地雷，以及如何做可以維持兩人感情穩定。此外，並以基本宮、固定宮、變動宮分類，量身打造星座情人的愛情攻略，瞭解星座情人在愛情中所想要的最終幸福泉源，更以金星與火星不同的特質，帶您認識星座情人的愛情、婚姻、愛情行動力與親密關係的屬性，讓季欣麟為您層層解開12星座情人的愛情密碼，拉長幸福保鮮期，助您在愛情幸福之路，走的更甜蜜順利，在情人心中立於不敗之地。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B137.png').default} /></div>
												<div className='btn_detail'><a id='btn_set137'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟的2020星座開運指南</p>
												<p className='author'>作者：季欣麟<br />時長 295分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，為您剖析在2020年12星座的事業、財富、感情、健康密碼！事業運勢如何提升？正財偏財如何取得？桃花將會如何開啟？健康狀況如何留意？還有事業財富及愛情開運的數字、顏色、物品、寶石、月份又將是甚麼？讓季欣麟為您帶來12星座在事業、財富、感情、健康各方面的指引；另外，根據2020年的星盤走勢，行星坐落在不同的宮位上又該如何趨吉避凶？讓季欣麟大師給您貼心叮嚀，指引你通往開運之路!!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B138.png').default} /></div>
												<div className='btn_detail'><a id='btn_set138'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>12星座孩子的教養攻略</p>
												<p className='author'>作者：季欣麟<br />時長 221分鐘</p>
												<p id='fm_desc' className='many_txt'>「適性而教」是現代教養的新觀念，身為父母，必須順著孩子的部份天生性格去教導、啟發他們，這樣「順水推舟」的教養原則，不但能夠在孩子成長的過程當中，達到事半功倍的效果，還可以在教養過程當中，增進良好的親子關係。
													主講者季欣麟老師深度研究星盤20多年，這次將以星座的角度，提供您12星座孩子的教養攻略，想要給孩子最好教育方式的你，可千萬別錯過了！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B139.png').default} /></div>
												<div className='btn_detail'><a id='btn_set139'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>陳德中引導正念冥想</p>
												<p className='author'>作者：陳德中<br />時長 117分鐘</p>
												<p id='fm_desc' className='many_txt'>正念風潮正在蔓延！
													讓台大醫院、廣達、台積電的正念訓練師資，帶你用正念揮別壓力與憂慮，找回穩定、自信與情緒自由！
													醫學界用正念幫助病人改善：
													慢性疼痛、焦慮、憂鬱、睡眠障礙，並增強免疫系統。

													企業界用正念幫助員工提升：
													專注力、情緒管理能力、復原力、創造力、領導力與人際溝通能力。

													教育界用正念幫助學生增強：
													學習效率與情緒平衡，並可優化大腦。

													你，也能用正念改善健康、工作與家庭生活！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B140.png').default} /></div>
												<div className='btn_detail'><a id='btn_set140'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦笑本部</p>
												<p className='author'>作者：魚蹦興業<br />時長 44分鐘</p>
												<p id='fm_desc' className='all_txt'>高密度笑點轟炸，快狠準表演節奏
													要你挑戰顏面神經的極限
													直搗笑本部，枯燥人生再也不冷場！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B141.png').default} /></div>
												<div className='btn_detail'><a id='btn_set141'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦笑本部續集</p>
												<p className='author'>作者：魚蹦興業<br />時長 69分鐘</p>
												<p id='fm_desc' className='all_txt'>高密度笑點轟炸，快狠準表演節奏
													要你挑戰顏面神經的極限
													直搗笑本部，枯燥人生再也不冷場！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B142.png').default} /></div>
												<div className='btn_detail'><a id='btn_set142'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>達康玩漫才</p>
												<p className='author'>作者：達康.come<br />時長 75分鐘</p>
												<p id='fm_desc' className='all_txt'>玩樂漫才，一笑到底 ；一個舞台，兩個搞笑人，
													漫才段子+營養話題talk+現場互動
													歡迎來到達康.come的漫才小宇宙</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B143.png').default} /></div>
												<div className='btn_detail'><a id='btn_set143'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>達康下凡來解答</p>
												<p className='author'>作者：達康.come<br />時長 48分鐘</p>
												<p id='fm_desc' className='many_txt'>由現場觀眾填寫題目卡，隨機抽出後，由達康在漫才的舞台上用「漫才」的態度即興解謎。
													任何嚴肅的難題，都能利用輕鬆泰然的角度轉化，生活何必如此勞累？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B144.png').default} /></div>
												<div className='btn_detail'><a id='btn_set144'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>大滿貫</p>
												<p className='author'>作者：台北曲藝團<br />時長 79分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B145.png').default} /></div>
												<div className='btn_detail'><a id='btn_set145'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>說書唱曲談今古</p>
												<p className='author'>作者：林文彬<br />時長 143分鐘</p>
												<p id='fm_desc' className='many_txt'>專業的林文彬已是台灣竹板第一人，風靡無數海內外觀眾。但林不只是竹板王子，此次他將使出渾身解數，為觀眾帶來由京韻大鼓、竹板、單弦與奉調大鼓乃至對口相聲等交織而成的〝林來瘋〞曲藝之夜。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B146.png').default} /></div>
												<div className='btn_detail'><a id='btn_set146'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>關於愛情分手</p>
												<p className='author'>作者：魚蹦興業<br />時長 33分鐘</p>
												<p id='fm_desc' className='many_txt'>分手可以是任何一種原因，不管是不愛了、劈腿了、改變性向，或是單純很渣⋯諸如此類，總之天時地利人和少了一個都無法繼續下去，但唯有經歷過這一切才能促使我們成長，找到更適合自己的生活方式，對吧？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B147.png').default} /></div>
												<div className='btn_detail'><a id='btn_set147'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>關於愛情熱戀</p>
												<p className='author'>作者：魚蹦興業<br />時長 40分鐘</p>
												<p id='fm_desc' className='many_txt'>曖昧過後就是兩人陷入熱戀的時候，每天就想跟對方膩在一起，熱戀中更會讓人智商莫名變低，心甘情願做出一些不可思議的甜蜜事，回想起來是否會覺得自己好蠢好傻好天真呢?</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B148.png').default} /></div>
												<div className='btn_detail'><a id='btn_set148'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>廢物野餐趴</p>
												<p className='author'>作者：魚蹦興業<br />時長 66分鐘</p>
												<p id='fm_desc' className='many_txt'>多久沒有軟趴趴的躺在野餐墊上耍廢廢呢？沒有開玩笑，魚蹦興業邀請觀眾攜帶自己的食物，一起來脫鞋子趴趴地，欣賞魚蹦興業推出的最新秋季野餐趴，現場還有演員精心準備的限量餐點，吃完就沒囉，實在超棒棒！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B149.png').default} /></div>
												<div className='btn_detail'><a id='btn_set149'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣答嘴鼓點燈</p>
												<p className='author'>作者：王一明；梅子；恆春兮；齊軒<br />時長 61分鐘</p>
												<p id='fm_desc' className='many_txt'>點燈，是民間信仰傳統的儀式之一，人們相信透過點燈祈福，可以保佑平安，利路亨通。 台灣答嘴鼓的說唱團隊，除了王一明、梅子，此次特別邀請廣播名主持人阿國、齊軒，以及「工商服務」恆春兮一起點燈。 共有光明燈、太歲燈、文昌燈、招財燈、姻緣燈、平安燈，歡迎您一起來點燈！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B151.png').default} /></div>
												<div className='btn_detail'><a id='btn_set151'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>蒲松齡與聊齋誌異</p>
												<p className='author'>作者：朱嘉雯<br />時長 724分鐘</p>
												<p id='fm_desc' className='many_txt'>清朝初年，山東淄川蒲松齡的《聊齋志異》，不僅是一部談鬼說狐的系列故事總集，同時也是作家一生思想與信仰的結晶。其間有可歌可泣的俠義小說、纏綿哀婉的戀愛情節、光怪陸離的海內外傳說，更精彩的是那些花妖狐精、煙粉靈怪林林總總不可思議的生命故事！
													徜徉在這片故事之海，追逐文學與哲理的層層浪花，我們將從中體會世俗倫常中最深刻的道理，以及發覺人性底層最殷切的欲望。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B152.png').default} /></div>
												<div className='btn_detail'><a id='btn_set152'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>法螺之聲</p>
												<p className='author'>作者：德謙讓卓（堪布竹清嘉措仁波切）<br />時長 76分鐘</p>
												<p id='fm_desc' className='many_txt'>這輯《法螺之聲》收錄十七首德謙讓卓的歌訣寶藏，每一支歌即是一篇精華教法，透過歌唱禪修，不但可以調伏粗重的煩惱習氣，還能夠細微地轉化自己的情緒與覺察，學習以柔軟平和的心境，來面對無常的大千世界，開展無盡的本然智慧。
													德謙讓卓（堪布竹清嘉措仁波切）是當今噶舉派至為珍貴的長老教師之一，擅長以金剛道歌來教導弟子。在他的課堂上，如珍寶一般的口訣和心要，由他證悟的心流中自然而出，弟子們在加持之下即席譜成歌曲傳唱。這也是金剛乘無間斷的傳承教法之一，至今依然鮮活、強而有力。
													堪布仁波切教導說：「金剛道歌」的修持有三種方式：第一種：專注在聲音上盡情唱誦。第二種：思維或禪修歌詞的意義。第三種：直接安住在心性中。若能以這三種方式來聆賞或學唱這些金剛歌，就是一種修持了。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B153.png').default} /></div>
												<div className='btn_detail'><a id='btn_set153'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第10部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 60分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B154.png').default} /></div>
												<div className='btn_detail'><a id='btn_set154'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悲心祈願</p>
												<p className='author'>作者：德謙讓卓（堪布竹清嘉措仁波切）<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>德謙讓卓（堪布竹清嘉措仁波切）是當今噶舉派至為珍貴的長老教師之一，擅長以金剛道歌來教導弟子。在他的課堂上，如珍寶一般的口訣和心要，由他證悟的心流中自然而出，弟子們在加持之下即席譜成歌曲傳唱。這也是金剛乘無間斷的傳承教法之一，至今依然鮮活、強而有力。
													這一輯《悲心祈願》，主要收錄了德謙讓卓在弘法旅途中，在節慶之日或弟子們的請求下，對於情器世間莊嚴的祈願，以溫暖的大悲心，帶給弟子們光明的大信心。適合經常唱誦，提振我們的正能量。
													堪布仁波切教導說：「金剛道歌」的修持有三種方式：第一種：專注在聲音上盡情唱誦。第二種：思維或禪修歌詞的意義。第三種：直接安住在心性中。若能以這三種方式來聆賞或學唱這些金剛歌，就是一種修持了。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B155.png').default} /></div>
												<div className='btn_detail'><a id='btn_set155'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>正念行持歌</p>
												<p className='author'>作者：德謙讓卓（堪布竹清嘉措仁波切）<br />時長 35分鐘</p>
												<p id='fm_desc' className='many_txt'>和一般流行音樂不一樣，「金剛歌」是出世間的歌曲，最早源自於印度，瑜伽士透過歌曲來傳達見地、體驗，或者是守護他的覺證。因此唱金剛歌最好同時思維詞義，或者，心也配合著修持，以此達到禪修、增加信心與了悟。
													德謙讓卓（堪布竹清嘉措仁波切）是當今噶舉派至為珍貴的長老教師之一，擅長以金剛道歌來教導弟子。在他的課堂上，如珍寶一般的口訣和心要，由他證悟的心流中自然而出，弟子們在加持之下即席譜成歌曲傳唱。這也是金剛乘無間斷的傳承教法之一，至今依然鮮活、強而有力。
													這一輯《正念行持歌》，主要收錄了德謙讓卓對於弟子們日常生活的提醒，這些口訣和心要，對於在都會中生活、工作的人們特別相應。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B156.png').default} /></div>
												<div className='btn_detail'><a id='btn_set156'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>身安心安禪安</p>
												<p className='author'>作者：聖嚴法師<br />時長 149分鐘</p>
												<p id='fm_desc' className='many_txt'>禪修的境界令人嚮往，禪法的修行卻常讓人覺得難以企及，望之興嘆。本次講座
													，聖嚴法師闡明甚麼才是正確的禪法修行，以及如何將禪修的觀念和方法，運用
													在日常生活之中。
													聖嚴法師更進一步歸納出，以禪法來安住身心的四個層次，使現代人能在簡明清
													晰的指引下，循序漸進，拾級而上，在禪修中獲得安定身心，安家、安業的利益</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B157.png').default} /></div>
												<div className='btn_detail'><a id='btn_set157'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>普賢行願品</p>
												<p className='author'>作者：郭蘅祈<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>「開經偈」指念經前所念誦的四句偈，其偈文是“無上甚深微妙法，百千萬劫難遭遇，我今見聞得受持，願解如來真實義。”這首偈的由來，據說是武則天做皇帝時，由於武則天是虔誠的佛教徒，她對於華嚴經非常地愛好。就題了這四句“開經偈”。
													「普賢行願品」：普賢，所謂「道遍宇宙曰普，德鄰極聖曰賢」，意思是他的道遍滿宇宙，他的德行和最高尚的聖人是一樣的，和最高尚的聖人作鄰居了。行願品，「行」是他修行的大行；「願」是他所發的願。普賢菩薩修行發的行願是最大的，所以叫大行普賢菩薩。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B158.png').default} /></div>
												<div className='btn_detail'><a id='btn_set158'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聖嚴法師佛曲集</p>
												<p className='author'>作者：法鼓文化<br />時長 48分鐘</p>
												<p id='fm_desc' className='many_txt'>以聖嚴法師深刻雋永的智慧法語，由音樂界各菩薩發心譜曲，法鼓山僧團及法鼓山成人學佛合唱團共同演唱，十首佛曲作品意境各有不同，時而寬廣契闊，時而輕快活潑。經過五個月的籌備時間，從選曲、練唱，到進錄音室，史上難得法師參與錄製的佛曲音樂作品終於完成!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B159.png').default} /></div>
												<div className='btn_detail'><a id='btn_set159'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聽見菩薩</p>
												<p className='author'>作者：法鼓文化<br />時長 39分鐘</p>
												<p id='fm_desc' className='all_txt'>在紅塵最繁華處，聽見菩薩最深的慈悲，守護每一顆心。
													獻給　每一顆在紅塵中行走的心靈
													「菩薩在哪里？在心裏。」──聖嚴法師</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B160.png').default} /></div>
												<div className='btn_detail'><a id='btn_set160'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我為你祝福</p>
												<p className='author'>作者：法鼓文化<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>聖嚴法師以其睿智的文字，編寫四首意趣深遠且蘊含悲願的現代歌詞；青年音樂創作家王建勛先生則以溫馨、活潑的音樂手法，為這四首佛曲賦予多元的現代風貌。
													在這緊張繁忙、人我疏離的現代社會，相信這不一樣的聲音，將能讓你我拋開煩惱，將身心安住於清涼而智慧的佛法海音之中。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B161.png').default} /></div>
												<div className='btn_detail'><a id='btn_set161'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>華嚴經淨行品</p>
												<p className='author'>作者：聖嚴法師<br />時長 224分鐘</p>
												<p id='fm_desc' className='many_txt'>《華嚴經》在中國佛教史上非常重要，也廣為流傳，在中國三種翻譯，《淨行品》是晉譯六十卷，《華嚴經》的第七品。由智首菩薩向文殊菩薩請示，使身口意三業得清淨的方法，而文殊菩薩回答智首菩薩的問題，就是《淨行品》全品的內容。淨，是清淨，就是不染汙，佛法特別重視身口意三種行為，也就是由心理的狀態，影響我們的語言行為和身體行為。身口意三業的或善或惡，能夠使我們在生死輪回之中上升或下降；能夠使我們從生死輪回得到解脫；也能夠使我們在生死之中廣度無量眾生，成就無上菩提。《華嚴經淨行品》要我們把貪、嗔、癡三毒的身口意三業，轉變為修行戒定慧三學的身口意三業，從苦海到彼岸而得解脫，成就菩薩道，終能成佛。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B162.png').default} /></div>
												<div className='btn_detail'><a id='btn_set162'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>觀世音菩薩</p>
												<p className='author'>作者：白銀<br />時長 93分鐘</p>
												<p id='fm_desc' className='all_txt'>詳述和娑婆世界眾生， 特別有緣的觀世音菩薩， 其出典、 道場、 示現、 形像、 法門等考證。</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B163.png').default} /></div>
												<div className='btn_detail'><a id='btn_set163'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>佛說阿彌陀經</p>
												<p className='author'>作者：聖嚴法師<br />時長 124分鐘</p>
												<p id='fm_desc' className='many_txt'>善導大師說：“如來所以與出世，唯說佛陀本願海。”大多數佛經都是釋迦牟尼佛應請法者而說，只有《阿彌陀佛》是釋迦牟尼佛見此世界眾生機緣成熟，可以接受此種不分根器皆能得度的圓融法門而無問自說。《阿彌陀經》又名《一切諸佛所護念經》，任何人只要持誦這部經、念阿彌陀佛名號，等於念了一切諸佛，就受到一切諸佛的讚歎和護持。這部經介紹西方極樂世界的國土莊嚴，以及阿彌陀佛的功德莊嚴，同時也說明了往生極樂淨土的修行方法。釋迦牟尼佛在經中多次勸請眾生“應當發願，願生彼國”，所以念佛法門不僅是淨土宗才修，而是所有宗派都在修。念佛念到一心不亂，不僅臨命終時會見到阿彌陀佛前來接引，也將了悟現世之中，人的生老病死、物的興衰起落，種種現象就像是在極樂世界一樣，即使禽鳥鳴叫、微風吹動，都是在為我們訴說、演示著微妙甚深的佛法。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B164.png').default} /></div>
												<div className='btn_detail'><a id='btn_set164'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>佛說盂蘭盆經</p>
												<p className='author'>作者：聖嚴法師<br />時長 243分鐘</p>
												<p id='fm_desc' className='many_txt'>《佛說盂蘭盆經》由西晉竺法護翻譯，屬方等部經典。“盂蘭盆”的梵文Ullambamna，中文的意譯為“就倒懸”。梵文的倒懸，主要是形容墮惡道的眾生，由於內心顛倒，而經常受苦，此經即是講述救度在餓鬼道中父母的法門，被視為佛經著名的孝經。佛陀大弟子目犍連，為了解救墮餓鬼道的母親，向佛請法，佛開示於七月十五日，在僧侶安居修行三個月滿之後，以種種衣服飲食供僧，仰仗僧侶自恣的戒德清淨，解救眾生倒懸之苦，即可令其母脫離苦難。依本經之說行之盂蘭盆會，已普遍流行於民間，因此，民俗信仰以中元為鬼節，跟《盂蘭盆經》有很大的關係。此經配合著民俗信仰及孝道思想，貼切著每一個人，與我們生活息息相關，因此受到重視、流傳與弘揚。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B165.png').default} /></div>
												<div className='btn_detail'><a id='btn_set165'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>村上春樹沒有色彩的多崎作和他的巡禮之年亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 111分鐘</p>
												<p id='fm_desc' className='many_txt'>原先有點想要放棄預告中決定的這一本長篇，村上的「沒有色彩的多崎作和他的巡禮之年」，這樣的書名，應該是村上創作中最長的了。開頭讀的時候真的有點累，這裡起個頭那裡起個頭，卻個個都是無厘頭。很覺得村上春樹是在故弄玄虛。曾經在日記中寫道:讀村上的一這一本長篇，覺得累，也許換成短篇比較好講。
													可是又給了自己一點壓力，因為發現這一本小說從二○一三年到現在，已經是第七刷。不知真的賣了多少本，應該是很受歡迎的一本小說。
													在快要午夜開始繼續的讀，讀到後來愈來愈有精神，好像天地間一片黑夜中，只有我跟村上書中人物依然活動著，再無其它。
													村上畢竟是個了不起的天才，從看來隨興的描寫出手，卻漸漸次引人深入很深很深的內心世界。最厲害的是讓我們相信包括我們自己在內，也可能如此的恐怖。
													平常的生活，認真的話，可以追索到最原始的本性中，那樣的本性尤也許善良，也許邪惡，可都不是沒有理由的，村上的天分與訓練就在這樣的情況下展露出來。
													這個「作」是個非常平凡的男子，直到目前的三十六歲，也沒有什麼驚人的成就，也沒什麼可以稱作失敗的經驗，就像在東京地鐵中的無數的平凡人一樣，然而村上把我們帶入他的內心，感受到他的痛苦，他的渴望，我們讀到了了更為成熟的村上春樹，而且，他以其出神入化的人物與情節，讓讀者在享受類似偵探小說般的緊張與盼望中，得到的是豁然開朗的境界。已經清晨三點了，卻讓人無法入眠，因為太多的思緒要整理。其實，真的很享受這樣子睡不著的感覺。
													歡迎來聽山崎作，這個沒有色彩的平凡男子驚人的故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B166.png').default} /></div>
												<div className='btn_detail'><a id='btn_set166'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>普賢菩薩行願贊</p>
												<p className='author'>作者：聖嚴法師<br />時長 261分鐘</p>
												<p id='fm_desc' className='many_txt'>《普賢菩薩行願贊》，唐代不空三藏翻譯，每句七字，每四句一頌，共有六十二頌。《華嚴經》是經中之王，介紹大乘菩薩修行的十種次第，而普賢行願就是《華嚴經》最精華的核心內容，可視為其心要。普賢的梵文是samantabhadra，又譯為“遍吉”，代表著普通存在任何一個地方，而能使眾生得益的大菩薩；普賢菩薩在《華嚴經》與《法華經》都有極為重要的低位，在諸大菩薩具足的“悲、智、願、行”四種條件之中，普賢菩薩代表著大修行成就，與代表無上智慧的文殊菩薩關係密切，兩位菩薩德行的配合，象徵著大乘精神最究竟的完成。普賢行願的精神是“以願遵行，以行踐願”，“願”是發起上求佛道、下度眾生的心願；“行”是照著佛法所示而實踐菩薩行。如欲修行大乘佛教，應行菩薩行、求一切智，成熟一切眾生，隨順無上菩提，圓滿普賢行願海。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B167.png').default} /></div>
												<div className='btn_detail'><a id='btn_set167'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>觀世音菩薩普門品</p>
												<p className='author'>作者：聖嚴法師<br />時長 153分鐘</p>
												<p id='fm_desc' className='many_txt'>觀世音菩薩可說是最受人們歡迎，也是與中國最有緣的一尊菩薩。許多人被他的無量慈悲心感化，因而願做觀世音的千手千眼，與菩薩一起護航眾生平安。《普門品》主要為介紹觀世音菩薩名號由來，以及他以三十三種化身廣度眾生，免除水、火、風、刀杖、惡鬼、幽襲、險路七難，脫離貧、嗔、癡三毒，並應求男、求女二種祈求。觀世音菩薩的弘誓深如海，只要一心稱念他的名號，菩薩便會立即聞聲救苦，助人化險為夷。如果我們遇到任何人，不管是得到幫助或受到打擊，當能感恩這些讓我們成長的助緣，災難便不再是災難，而是觀世音菩薩的化身示現。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B168.png').default} /></div>
												<div className='btn_detail'><a id='btn_set168'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>金剛經如是說</p>
												<p className='author'>作者：聖嚴法師<br />時長 160分鐘</p>
												<p id='fm_desc' className='many_txt'>《金剛經》全文五千八百餘字，篇幅雖短，卻是哲理豐富。在般若經典中，受到普遍持誦的程度僅次於《心經》。“金剛”梵語意思是指質地最堅最利之物，擁有“不為一切所摧，而能破一切”且堅利之質本來具足的特性。用來譬喻人的般若智慧不因平富貴賤、聰明愚昧而有差別，只是被私心所生的煩惱遮蔽。如何降伏心中的煩惱？《金剛經》說：“菩薩于法，應無所住，行於佈施”。意指與人互動不氣分別態度，不惦念佈施的行為、財務，不在乎自我的利害得失，時時抱持助人離苦得樂的慈悲心，就能降伏執著、煩惱，這就是《金剛經》所說的無住智慧。以無住的智慧融會運用在日常生活中，將為生命開啟究竟的自由圓滿。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B169.png').default} /></div>
												<div className='btn_detail'><a id='btn_set169'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>地藏菩薩本願經</p>
												<p className='author'>作者：聖嚴法師<br />時長 189分鐘</p>
												<p id='fm_desc' className='many_txt'>《地藏菩薩本願經》是地藏法門的入門經典，以優美的文字介紹地藏菩薩的大願法門，也是引領眾生從凡夫到成佛的指南。地藏菩薩為眾生負載一切苦難，猶如大地孕育眾生，能夠蘊藏萬物，讓眾生取之不盡、用之不竭，這也正是地藏菩薩名為“地藏”的原因。他修行的功德圓滿，早與佛等齊，但卻發願度盡六道眾生之後，始願成佛：“地獄不空，誓不成佛；眾生度盡，方登菩提。”依著這樣的願力，不斷廣度眾生。地藏菩薩的大願法門非常殊勝，而且容易修持，我們一方面可學習他廣度眾生的願力，另一方面則可誦持地藏菩薩的名號、經典，並且修持他的懺悔除障之法門，使所有眾生都能化解一切罪業，自在無疑。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B170.png').default} /></div>
												<div className='btn_detail'><a id='btn_set170'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>祈普行心靈系列3</p>
												<p className='author'>作者：郭蘅祈<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>金剛薩埵為消業滅罪之唯一主尊，行者為懺罪解冤，修本尊法，功效最快最大，且為成就無上菩提必經階程。常持本尊真言，能破除煩惱，止諸惡念，生諸功德。 凡修法誦經持咒，課將畢時，加誦百字明三遍或七遍，然後回向，則一切功德圓滿，偶有錯漏，金剛護法，不將為咎 。此咒功德利益是能降魔除障，免除危險！！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B171.png').default} /></div>
												<div className='btn_detail'><a id='btn_set171'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>祈普行心靈系列2</p>
												<p className='author'>作者：郭蘅祈<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>郭蘅祈（郭子）以『祈¬菩行』，祈願用跨界『心』音樂，將對佛法的感念，用最誠摯的歌聲與現代音樂與¬您分享。唱詠諸佛慈悲智慧，自在空性，修習佛法於現¬代都會之中。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B172.png').default} /></div>
												<div className='btn_detail'><a id='btn_set172'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>祈普行心靈系列1</p>
												<p className='author'>作者：郭蘅祈<br />時長 98分鐘</p>
												<p id='fm_desc' className='many_txt'>四無量心(慈、悲、喜、捨)，在原始佛教中，本是佛陀所重視的修行法門之一。世尊不但順應當時沙門、婆羅門等，希求生梵天而教授其法， 更進而開示，修四無量心能得無量心解脫的要義。慈悲本是佛教的精髓，大乘行者無不以此為要著。而長養慈悲的方法，不外乎
													是修習四無量心。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B173.png').default} /></div>
												<div className='btn_detail'><a id='btn_set173'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聖嚴法師音樂傳記歸程</p>
												<p className='author'>作者：法鼓文化<br />時長 42分鐘</p>
												<p id='fm_desc' className='many_txt'>音樂版的《歸程》，引領您深入聖嚴法師從出生、出家、從軍、閉關、留學，直至創建法鼓山的百轉千折。
													《歸程組曲》特邀兩岸詞曲大師黃瑩與黃佩勤共同合作，將具時代意義的中外世界名曲重新填詞，透過音樂情境引領回到聖嚴法師的成長時空。由名指揮家張佳韻指揮愚韻交響樂團演奏，以及當代聲樂名家張杏月、鄧吉龍、臺北市內合唱團、法鼓山合唱團，共同細膩詮釋本曲。
													《法鼓組曲》的〈法鼓頌〉、〈法鼓山〉，氣勢奔騰，猶如雷霆萬鈞，讓人體驗到法鼓山所展現出的人間淨土新氣象。悠揚動聽的〈慈悲〉、〈四眾佛子共勉語〉、〈我為你祝福〉，則讓人感受到學佛人的歡喜自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B174.png').default} /></div>
												<div className='btn_detail'><a id='btn_set174'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>許倬雲說美國走向衰敗的大蘋果</p>
												<p className='author'>作者：許倬雲<br />時長 141分鐘</p>
												<p id='fm_desc' className='many_txt'>美國開國至今三百多年，從地區性的殖民政權，逐漸擴張成世界最大的自由市場和資本主義的國家，在經過兩次世界大戰後，更一躍成了世界第一霸權。不過近年來，美國漸漸從極盛的巔峰走向衰弱，各界開始湧入許多批判聲音：控訴美國文化的失落、遺失的美國精神、甚至是懷疑起國家制度設計上出現重大錯誤。此外，美國人民也開始歸罪於若干年來的政治現象，並以選票表達自己的不滿。政治上的變化，更加速了美國整體發展的不確定性。雖然，政治和經濟、文化等因素相較起來，是結果而非原因。不過錯的政治人物與政治機緣，的確會造就推波助瀾，使得加速衰敗的可能性。
													其實，美國這三百年來的變化，如同任何一個朝代一樣，有盛有衰，諸多因素都能影響到美國本身許多內部的變化，任何問題在每個階段的發展過程中，逐漸呈現出獨特的現象， 有好也有壞，但終究會出現一必然的結果。
													許倬雲教授從1957年赴美國念書開始，便以留學生的角度開始觀察美國社會現象。到了執教時期，更因為於四處演講授課的關係，累積了深厚的學術研究底蘊，此外，許教授不但從一個中國人，一個東方人的角度看美國，又在美國內部居住一甲子的時間，成為一個深度介入的美國居民。從中西兩邊角度相互對比，加上自己好奇心切，對於歷史、文化、社會觀察，皆有更進一步的認識。由他來為我們整理爬梳美國一路發展至今的歷程，再合適不過。
													許倬雲教授將其對美國一甲子的變化，其回憶和檢討，以有聲書的方式，化為十講。每一講談及其美國發展出現變化的特點，如何延伸到後代。既是按照時間的程序，也是按照他觀察到的現象陳述。在他提供的諸多線索當中，將會提供你做出更深入的推敲。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B175.png').default} /></div>
												<div className='btn_detail'><a id='btn_set175'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>頂尖CEO的乘法領導EMBA的二十堂領導課</p>
												<p className='author'>作者：方素惠<br />時長 154分鐘</p>
												<p id='fm_desc' className='many_txt'>環境快速變動，今天的領導人必須將吸收知識不斷成長，當作優先要務。學習已經不是一個選項，而是非這麼做不可。
													更重要的是，正因為領導的重點不在於主管本身，而是團隊成員，領導人不只要提升自我，還必須協助部屬成長，釋放整個團隊力量。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B176.png').default} /></div>
												<div className='btn_detail'><a id='btn_set176'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悅讀心旅行王文華開除自己的總經理</p>
												<p className='author'>作者：李悅心<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>走進城市悅動心節目主播李悅心的悅讀心旅行：
													不是介紹一本書或一部電影，而是透過書（電影）中的文字，去表達DJ李悅心對各種事物的領略與看法。本期主題王文華《開除自己的總經理》。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B177.png').default} /></div>
												<div className='btn_detail'><a id='btn_set177'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悅讀心旅行金質靈金帷純還在學2父女的人生問答題</p>
												<p className='author'>作者：李悅心<br />時長 49分鐘</p>
												<p id='fm_desc' className='many_txt'>走進城市悅動心節目主播李悅心的悅讀心旅行：
													不是介紹一本書或一部電影，而是透過書（電影）中的文字，去表達DJ李悅心對各種事物的領略與看法。本期主題金質靈、金帷純《還在學2-父女的人生問答題》。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B178.png').default} /></div>
												<div className='btn_detail'><a id='btn_set178'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悅讀心旅行金惟純還在學成功不是你想的那樣</p>
												<p className='author'>作者：李悅心<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>走進城市悅動心節目主播李悅心的悅讀心旅行：
													不是介紹一本書或一部電影，而是透過書（電影）中的文字，去表達DJ李悅心對各種事物的領略與看法。本期主題金惟純《還在學——人生不是你想的那樣》。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B179.png').default} /></div>
												<div className='btn_detail'><a id='btn_set179'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賴佩霞快樂家不費力的領導</p>
												<p className='author'>作者：賴佩霞<br />時長 252分鐘</p>
												<p id='fm_desc' className='many_txt'>只有老闆、主管才需要領導力嗎？
													其實，領導力人人都需要、任何關係裡都需要，你可以領導自己的生命有所不同！
													幸福是人生終極追求，如果在家庭里中可以把親人心力朝着正向引導，轉變念頭，避免深陷不必要的負面糾葛；如果企業中的領導可以修正其不良習性，發揮影響力，為企業帶來無可限量的助益。
													如果，你也想擁有幸福領導力，讓每個場域都因你而離苦得樂。
													請從真實自我的人性根本出發，覺醒，覺知，讓自己成為愛的主體，不費力地快樂領導。
													如何經營快樂？如何擁有幸福領導力？
													讓高階領導人教練賴佩霞交給你這把密鑰，教你有效的幸福領導！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B180.png').default} /></div>
												<div className='btn_detail'><a id='btn_set180'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>向經典學戰略習戰術</p>
												<p className='author'>作者：李克明<br />時長 293分鐘</p>
												<p id='fm_desc' className='many_txt'>「經典」與生活息息相關，無論是戰場、商場、人際互動上的挑戰、人生難題，在「經典」中都可以找到解方，李克明博士以十多年公餘的時間勤學儒、道、法、兵、縱橫、釋各家經典，證以企管、法律專業訓練與實務經驗，穿插對應的西方觀念，整理出與現代人生活工作所面臨挑戰息息相關的道、神、聖、賢心性智慧。除實踐在自己做人處事上外，並將其以栩栩如生的方式推廣傳播出去，期能在中國人的社會中端正風氣、重振四維八德的價值觀，有朝一日推廣到全球。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B181.png').default} /></div>
												<div className='btn_detail'><a id='btn_set181'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>8分鐘提升領導力的21種方法</p>
												<p className='author'>作者：馬歇．葛史密斯<br />時長 189分鐘</p>
												<p id='fm_desc' className='many_txt'>事情交辦了，為什麼完全沒有進展？
													為什麼我的部屬不能像我一樣？誰是不可教練的人？
													從新手主管，到財星五百大企業CEO都常落入的陷阱，
													世界第一領導人教練葛史密斯給您，最深刻而直指核心的叮嚀。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B182.png').default} /></div>
												<div className='btn_detail'><a id='btn_set182'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟星座成功學</p>
												<p className='author'>作者：季欣麟<br />時長 252分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，帶您以太陽、上升星座及水星、金星來帶你瞭解你在工作、事業、正財、偏財的運勢，並帶你從風水土火四象星座來提點你的事業成功致富的地雷，以及事業方面心想事成的方法，並帶你瞭解專屬於你的事業開運數字、開運顏色、開運物品、開運寶石、開運貴人，讓季欣麟為您解開12星座的事業及財富秘密，給你滿滿開運行動力，在你成功致富之路上，祝你一臂之力！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B183.png').default} /></div>
												<div className='btn_detail'><a id='btn_set183'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>財富的秘密</p>
												<p className='author'>作者：林偉賢<br />時長 43分鐘</p>
												<p id='fm_desc' className='many_txt'>企業管理博士，實踐家知識管理集團董事長，《培訓》雜誌國際中文版創始人，中華教育訓練發展協會理事長，曼陀羅訓練的共同創辦人。專攻企業商業模式的林偉賢，把慈濟精神融入所教課程，即使一個人得花上超過30萬台幣的學費，還是讓企業家們趨之若鶩。全球最大電子商務網站、阿裏巴巴集團董事會主席馬雲，人稱「口才帝」，說話素來以幽默、直指要害、善於激勵而出名，也曾特地去上林偉賢的課。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B184.png').default} /></div>
												<div className='btn_detail'><a id='btn_set184'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>別人的情緒你讀懂了嗎</p>
												<p className='author'>作者：啟點文化<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>回應≠回話，你習慣回答的是別人的表面訊息？還是心理期待？
													小小的差別，卻有大大的影響。
													一個人的命運，是他回應力的總和。
													Response ＋ ability ＝Responsibility
													有專業，再加上有人味，才能讓你更上一層樓！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B185.png').default} /></div>
												<div className='btn_detail'><a id='btn_set185'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>為什麼讀書</p>
												<p className='author'>作者：啟點文化<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>如果問你為什麼吃飯？你怎麼選擇要吃什麼？
													可能你會覺得有點莫名其妙，
													餓了就吃，喜歡吃就吃，哪有這麼多為什麼。
													同樣的邏輯，我們能不能放在閱讀身上？
													因為單純的想讀文字，所以讀書，
													因為單純的喜歡這類型的作品，所以啃書。
													讀書，從來都是自私的。
													作者一句簡單但犀利的話，
													是一種體恤，讓我們不需要有個冠冕堂皇的理由，
													可以更輕鬆、更自在地靠近任何一本書，
													只要你想讀。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B186.png').default} /></div>
												<div className='btn_detail'><a id='btn_set186'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>為什麼我們經常誤解人心</p>
												<p className='author'>作者：啟點文化<br />時長 29分鐘</p>
												<p id='fm_desc' className='many_txt'>你會想要擁有「讀心術」嗎？你想要一眼就看穿別人在想什麼嗎？
													其實，當你有這個念頭時，你就踏入「誤解」的陷阱中。
													作者用許多研究證明，人總是活在「自以為是」的習慣中，
													以至於我們對他人的理解，往往是片面、零碎的。
													如何能真正認識人？
													不再被「以為」，這個世界上最曖昧可怕的字眼給綁架，
													你將在此書中得到完整的解答。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B187.png').default} /></div>
												<div className='btn_detail'><a id='btn_set187'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>好人怎麼會幹壞事</p>
												<p className='author'>作者：啟點文化<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>小時候，老師說只有壞人才會做壞事，
													但長大後，卻發現把事情做壞的，通常是自以為是好人的人。
													到底哪裡出問題了？才會讓好人幹了壞事還不自知。
													其實，你我心中都有可能藏著許多心智臭蟲，
													讓我們不小心對世界產生的偏見。
													但透過「內隱關聯測驗」（IAT），你有機會檢測一下自己，
													到底有沒有自己想像的好？
													測驗很刺激，請小心服用喔！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B188.png').default} /></div>
												<div className='btn_detail'><a id='btn_set188'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>說故事的領導</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>人，很喜歡聽故事，但到底故事是什麼？
													故事一定要用「從前從前」開頭嗎？
													人物角色怎麼樣才算有特色？
													要讓主角做什麼事情，故事才會好聽呢？
													可以把平常對話的內容記錄下來，直接變對白嗎？
													這些答案在書中都有完整的說明，
													而且當你能把自己的故事講好，你就能改寫自己的命運，
													讓生命看見不同的風景。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B189.png').default} /></div>
												<div className='btn_detail'><a id='btn_set189'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>吵架讓我倆明天會更好</p>
												<p className='author'>作者：啟點文化<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>覺得吵架很累嗎？
													害怕吵架會讓感情變糟嗎？
													很有可能是因為你“吵錯架”了。
													你只處理表面的問題，而沒有滿足背後的需要。
													好好的吵，是一種真心誠意的探險，
													理解彼此真正的在乎。
													來吧！趕緊收聽這段對談，看看自己到底吵錯了什麼？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B190.png').default} /></div>
												<div className='btn_detail'><a id='btn_set190'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>每天最重要的2小時</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>常常覺得時間不夠用嗎？
													明明一直忙個不停，可是成就感卻沒有提升？
													像個陀螺般打轉，不敢怠慢，效率卻沒有提升？
													其實，你不需要怕分心，只要你知道如何管理你的心智狀態。
													放自己一馬，才有機會再次快馬加鞭。
													簡單五策略，打造2小時高效率工作狀態，讓你不用再瞎忙。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B191.png').default} /></div>
												<div className='btn_detail'><a id='btn_set191'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>創造力</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>你有想做的事情嗎？
													可能是寫作、歌唱、攝影、料理、繪畫⋯⋯，
													你知道在創作的路程上會遭遇哪些挑戰？又該如何面對嗎？
													很多人都有創作的慾望，卻常常被許多莫名的小聲音給淹沒，
													我寫得不夠好？沒靈感怎麼辦？別人會怎麼說？會不會賣？
													這些問題伊莉莎白.吉兒伯特都遇過，更在自己的書《享受吧！一個人的旅行》大賣後，沒有被成功壓垮。
													就讓經驗豐富的伊莉莎白來告訴你，如何健康的面對創作？你該怎麼想，才不會把自己卡住？讓你所熱愛的事情，持續為你帶來快樂。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B192.png').default} /></div>
												<div className='btn_detail'><a id='btn_set192'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>精準表達</p>
												<p className='author'>作者：啟點文化<br />時長 27分鐘</p>
												<p id='fm_desc' className='many_txt'>你有聽過無聊的畢業致詞嗎？
													明明是結婚典禮，搞得像佈道大會？
													開會像馬拉松一樣漫長，讓人無力？
													這些都是可以避免的，作者累積的數年的實務經驗，
													告訴你“精準”，不是自己講的爽，
													而是在對的時刻，以對的語氣，向對的人傳達對的訊息。
													同時，書中也提到哪些習慣是不良的表達？
													容易讓人昏昏欲睡、逃之夭夭。
													掌握重要關鍵，你也可以一開口就抓住所有人的耳朵。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B193.png').default} /></div>
												<div className='btn_detail'><a id='btn_set193'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>做自己的生命設計師</p>
												<p className='author'>作者：啟點文化<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>我們常常會愛上第一個想到的主意，然後拒絕放手。
													生涯卡住，是因為我們常常問錯問題，在爬坡時，抱怨重力太大，讓自己無法輕鬆。花許多時間試圖解決重力問題，而不是想辦法讓自己變輕。
													當你懂得運用設計師的思維，重新定義你真正該解決的問題，也許你會發現答案其實很簡單，你不需要換工作、取得新學位才能過上精彩的人生。
													設計師只處理能解決的問題，同樣的，面對人生，你又把時間花在哪裡了呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B194.png').default} /></div>
												<div className='btn_detail'><a id='btn_set194'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>情緒勒索</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>你常常為了滿足別人，而讓自己委屈嗎？
													為了不被別人討厭，你情願討厭自己？
													當你企圖透過別人給你認同感，以換取對方需要的安全感，
													你們之間的交易就已經完成，你成為失去自由的俘虜，
													一起共構出一段不平等的關係。
													希望透過這本書，能協助你辨識出關係中的綁匪，同時避免自己被勒索。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B195.png').default} /></div>
												<div className='btn_detail'><a id='btn_set195'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>讓顧客的錢自動流進來</p>
												<p className='author'>作者：啟點文化<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>世界上最困難的事情，
													就是把觀念放到別人腦袋，
													把對方的錢放在自己口袋。
													要如何不只讓客戶心甘情願掏錢，而且還不只一次，
													能夠持續付下去。
													作者建議把客戶變訂戶，就能定期掏錢，一消費就是好幾年。
													想知道如何做到嗎？趕緊收聽這段有聲書評。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B196.png').default} /></div>
												<div className='btn_detail'><a id='btn_set196'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>你的善良必須有點鋒芒</p>
												<p className='author'>作者：啟點文化<br />時長 26分鐘</p>
												<p id='fm_desc' className='many_txt'>人說「聰明是天賦，善良是選擇」
													既然是選擇，你把善良留給誰就變得相對重要了。
													你是否會常常委屈自己，只為了成就別人口中的「好人」
													為朋友兩肋插刀，可心裡頭卻期盼有一天，對方也會如此對你。
													當你勉強自己幫助別人時，你就會落入交換的圈套，
													只要對方做的跟你想的不一樣，便覺得不值得。
													最後賠上一段珍貴的關係。
													其實，你可以活得不這麼憋屈的，只要你懂得什麼才是真正重要的善良！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B197.png').default} /></div>
												<div className='btn_detail'><a id='btn_set197'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>人類還在玩猿猴把戲</p>
												<p className='author'>作者：啟點文化<br />時長 24分鐘</p>
												<p id='fm_desc' className='many_txt'>你知道狒狒在問候彼此時，會握住彼此的睪丸嗎？
													其實，人類也會做類似的事情，並沒有比較高尚喔！
													許多你現在覺得是“文明”衍生出來的社交行為，
													在猿猴身上都可以找到相同的行為模式。
													科技改變我們生活方式，卻沒有改變人性，
													拿掉無可救藥的優越感吧！說不定，你會活得比較自由。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B198.png').default} /></div>
												<div className='btn_detail'><a id='btn_set198'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>用心表達做好人際溝通</p>
												<p className='author'>作者：方信智<br />時長 78分鐘</p>
												<p id='fm_desc' className='many_txt'>擁有極具說服力的人際表達能力，是決定是否能夠受到顧客歡迎，甚或是個人在職場成敗與否，最關鍵的核心因素！因此，透過對人性的充分了解，學會如何「將心比心」給對方他最需要的，而不是我們認為最好的，來贏取認同與合作。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B199.png').default} /></div>
												<div className='btn_detail'><a id='btn_set199'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>溝通魔法師</p>
												<p className='author'>作者：中國生產力中心<br />時長 56分鐘</p>
												<p id='fm_desc' className='many_txt'>「說服」不是高超的說話技巧，而是卓越的動機給予和決策協助。本影碟帶領您瞭解「說服」的四大步驟─確定方向、引發動機、引導決策、再次確認，利用神經語言程式學的技巧，讓您的意見或點子無法被忽視，充分發揮影響力。
													2-1 如何讓說服更具吸引力
													2-2 說服中的引導與決策</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B200.png').default} /></div>
												<div className='btn_detail'><a id='btn_set200'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>贏得好的關係塑造你的親和力</p>
												<p className='author'>作者：中國生產力中心<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>以神精語言程式學（Neuro-Linguistic Programming; NLP）為基礎，解析親和能力到底是如何產生的？如何經由簡單的呼應，以及臨摹溝通對方的表情、肢體、聲音，來建立良好互動關係，輕鬆塑造人際好關係！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B201.png').default} /></div>
												<div className='btn_detail'><a id='btn_set201'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>人際溝通</p>
												<p className='author'>作者：中國生產力中心<br />時長 158分鐘</p>
												<p id='fm_desc' className='many_txt'>利用訊息傳播原理，教導您從開口之前到說話的結束，該注意那些訣竅。學習如何由一個原本孤獨的個體，具備深層而細膩的溝通技巧，如何像一面鏡子一樣，忠實反映出對方所講的事實與感情，及如何擬定溝通策略。
													5-1說話的技巧
													5-2聽的藝術
													5-3回饋與抉擇
													5-4溝通策略的分析運用（上）
													5-5溝通策略分析運用（下）</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B202.png').default} /></div>
												<div className='btn_detail'><a id='btn_set202'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>文明自然和科技的三角關係</p>
												<p className='author'>作者：曹興誠<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>科學是我們對客觀世界的精確了解；技術是解決問題或製造的方法，不管是科學或是技術的進步，都會改變人類生態及人文之間的關係。--曹興誠,如是說..
													科技與人文間，如何達到平衡?自然和科技，如何達到共生、共利、共享的境地？曹興誠以其科技人的理性與收藏家的感性，細說自然、科技與文明三者之間的箇中智慧，細細剖析平衡之道</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B203.png').default} /></div>
												<div className='btn_detail'><a id='btn_set203'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聖嚴法師音樂故事遠行</p>
												<p className='author'>作者：聖嚴法師<br />時長 39分鐘</p>
												<p id='fm_desc' className='many_txt'>遠行，是為了完成心願。透過遠行，聖嚴法師將漢傳佛教種子播種在世界各地，耕耘著人們的心田。本輯由名音樂製作人戴維雄精心創作，以十首音樂故事展現聖嚴法師的生命地圖， 隨著音樂一起行旅聖嚴法師的感人故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B204.png').default} /></div>
												<div className='btn_detail'><a id='btn_set204'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>夏韻芬的親子理財課</p>
												<p className='author'>作者：夏韻芬<br />時長 207分鐘</p>
												<p id='fm_desc' className='many_txt'>從小讓孩子養成正確的金錢觀，懂得愛惜物力，留錢給孩子，無法成全孩子的財富，正確的做法，就是教他面對金錢的態度，以及學習處理金錢的本事，讓孩子可以靠自己的能力經營自己的生活，這才是父母給與子女的真正資產。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B205.png').default} /></div>
												<div className='btn_detail'><a id='btn_set205'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聲動美術館</p>
												<p className='author'>作者：朱家綺、林育淳<br />時長 766分鐘</p>
												<p id='fm_desc' className='many_txt'>藝術生活化，生活藝術化，這是人類欣賞進而參與藝術的最終目標。無論是過去的經典作品或今日的現代創作，都是反映著每個時代的人類生活和社會狀況，「聲動美術館」希望藉由藝術作品穿越時空，從不同角度去了解成就現今社會局勢的歷史脈絡。
													本節目由央廣與台北市立美術館合作，結合專業的知識和故事的分享，讓聽眾可以對台灣畫家有基本且完整的認識之外，也希望藉此激發聽眾興趣，進一步主動欣賞畫家作品。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B206.png').default} /></div>
												<div className='btn_detail'><a id='btn_set206'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>世界名畫背後的故事</p>
												<p className='author'>作者：鄭治桂<br />時長 229分鐘</p>
												<p id='fm_desc' className='many_txt'>《世界名畫背後的故事》精選出這一生中一定要知道的20張世界名畫，由曾兩度擔任奧賽美術館的官方導覽，台灣知名的藝術評論家—鄭治桂教授親自導聆，帶你一探藝術大師們創作的歷程，看懂他們想傳達的意念。從巴洛克寫實派、浪漫派、分割派、印象派到立體派，鄭治桂要把這20張名畫帶給他的感動，一一復刻給你。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B207.png').default} /></div>
												<div className='btn_detail'><a id='btn_set207'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賴聲川的創作密碼小火慢燉的靈感</p>
												<p className='author'>作者：賴聲川<br />時長 114分鐘</p>
												<p id='fm_desc' className='many_txt'>賴老師說：「在我的個人經驗中，《如夢之夢》的創意過程特別適合拿來當案例討論，因為靈感顯現的過程特別明確、清晰，也因為親身經歷，我不用加以揣測，可以第一手經驗如實揭露。」
													八小時的超長時間、夢中夢的複雜故事、從上海到巴黎，從民國到現代的時空變換、還有「蓮花池」的沉浸式體驗……都成了這部戲的密碼。
													《如夢之夢》2000年首演，故事開始，演員圍繞觀眾演出，隨著故事發展，跟著講述人的情感入夢。這場大夢如今已經20年。
													新年伊始，從《如夢之夢》開始揭秘，紀念《如夢之夢》創作20周年。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B208.png').default} /></div>
												<div className='btn_detail'><a id='btn_set208'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>劇作家賴聲川上劇場丁乃竺戲劇對話錄</p>
												<p className='author'>作者：賴聲川<br />時長 79分鐘</p>
												<p id='fm_desc' className='many_txt'>借由《賴聲川劇作集》出版之際，華人劇場製作大咖、上劇場CEO丁乃竺對談劇作家賴聲川，二人首次集中分享包含《暗戀桃花源》《圓環物語》《紅色的天空》《十三角關係》《如夢之夢》《在那遙遠的星球，一粒沙》《如影隨行》《寶島一村》《水中之書》在內九部作品的創作故事。賴聲川和丁乃竺兩人，並分享了賴聲川分別作為“賴編劇”“賴導演”“賴先生”的有趣故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B209.png').default} /></div>
												<div className='btn_detail'><a id='btn_set209'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賴聲川創意戲劇學50講</p>
												<p className='author'>作者：賴聲川<br />時長 346分鐘</p>
												<p id='fm_desc' className='many_txt'>享譽國際的賴聲川導演，總是能夠創造出「精緻藝術」與「大眾文化」的稀有結合，將富有新意、深度內涵、生命反思及文化底蘊呈現於作品當中，進而創造新市場、新觀眾以及新文化創意產業。
													2006年，賴導出版多年創作的創意奧祕《賴聲川的創意學》一書。2011年，亦展開《賴聲川的戲劇學》戲劇研習大師班巡迴講學，將三十年的編劇、導演、即興創作心得與經驗和戲劇工作者分享。結合創意、編劇、創作、導演四大主線，講述從業30餘年的思考與智慧，幫你構建屬於自己的“創意金字塔模型”。 </p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B210.png').default} /></div>
												<div className='btn_detail'><a id='btn_set210'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠音樂3靜心安眠 </p>
												<p className='author'>作者：愛播聽書<br />時長 20分鐘</p>
												<p id='fm_desc' className='many_txt'>都市紛雜的快節奏，帶來慢性疲倦和精神緊張，暫且放下一切的執著，讓音樂重新幫你找回失去已久的自然睡眠，靜靜的享受如嬰兒般深度睡眠的樂趣......在甜美的夢鄉中，感受極度的放鬆與舒緩，現在，閉上眼睛，慢慢聆聽這美好樂音…… </p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B211.png').default} /></div>
												<div className='btn_detail'><a id='btn_set211'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠音樂2安心入眠</p>
												<p className='author'>作者：愛播聽書<br />時長 15分鐘</p>
												<p id='fm_desc' className='many_txt'>本音樂為渴望健康睡眠的人們，提供進入深度睡眠的有效方法。旋律輕柔、樂音委婉，營造特別的安寧平靜的氛圍，讓人放鬆，不會感到緊繃!希望在每個漫漫長夜，幫助每個人都能有個好夢。現在，閉上眼睛，慢慢聆聽這美好樂音……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B212.png').default} /></div>
												<div className='btn_detail'><a id='btn_set212'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠音樂1安枕無憂</p>
												<p className='author'>作者：愛播聽書<br />時長 15分鐘</p>
												<p id='fm_desc' className='many_txt'>我們利用情境音樂與精心創作的音符，為心靈準備了一趟迷人之旅，邀您展開心靈漫步;透過自然和諧的美妙音樂，釋放焦躁不安的情緒，產生內在詳和與安定感，最棒的睡眠音樂，帶你進入安枕無憂的好眠!現在，閉上眼睛，慢慢聆聽這美好樂音……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B213.png').default} /></div>
												<div className='btn_detail'><a id='btn_set213'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>8大紓壓睡眠放鬆方法</p>
												<p className='author'>作者：高尚美<br />時長 74分鐘</p>
												<p id='fm_desc' className='many_txt'>壓力是造成無法安眠的最大因素，抒壓放鬆，睡個好覺，是現代人關心的課題。本套抒壓助眠放鬆課程由專業心理諮商師高尚美設計，專為解決焦慮、憂鬱、失眠者所設計的,本課程廣受各大醫院、企業、社區機構好評，歡迎一起學習8大抒壓放鬆方法，只要8堂課，讓您一夜好眠到天亮，天天元氣過生活。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B214.png').default} /></div>
												<div className='btn_detail'><a id='btn_set214'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>正念減壓8堂課</p>
												<p className='author'>作者：石世明<br />時長 126分鐘</p>
												<p id='fm_desc' className='many_txt'>8堂課程結束後，當你回頭看自己寫的作業，每一個字都代表著你的練習經驗、你的進步，更重要的是你和生命對話，在癌症治療之後，你真正將時間給了「你」自己，透過這個歷程你一點、一滴地學習如何「疼惜自己」。
													第一課    擔憂無止盡：認識擔憂內在反應，與其建立不同關係。
													第二課    認出情緒漩渦：了解負向循環及慣性，學習同在模式。
													第三課    不再對自己射箭：覺察慣性反應模式和受苦根源，運用擔憂與不如意。
													第四課    以呼吸接納：回到當下，從自我疼惜行動轉換態度。
													第五課    身體掃描：體察身心變化與情緒關聯，以覺察回應壓力。
													第六課    正念傾聽：將同在模式進行溝通，體驗不同品質的人際互動。
													第七課    開發內在能量：透過呼吸與個人深度力量接壤，從心出發，給予他人祝福與關懷。
													第八課    正念走出新生活：將專注與覺察融入生活，建立新習慣。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B215.png').default} /></div>
												<div className='btn_detail'><a id='btn_set215'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>真逆齡有聲書</p>
												<p className='author'>作者：陳亮恭<br />時長 40分鐘</p>
												<p id='fm_desc' className='many_txt'>不到40歲就當上國際醫學期刊主編的高齡醫學專家陳亮恭醫師，爬梳國際間最新研究，提供令人振奮的健康增齡策略，釐清各種養生說法。現在用聽的也能健康逆齡。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B216.png').default} /></div>
												<div className='btn_detail'><a id='btn_set216'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>走出情傷你的未來充滿希望</p>
												<p className='author'>作者：Carol林嘉瑗<br />時長 218分鐘</p>
												<p id='fm_desc' className='many_txt'>課程介紹：
													你的心還在痛嗎？你的傷還忘不了嗎？你的苦沒有人知道嗎？如果你無法釋懷一段難忘的傷痛，讓我們一起來幫你快速的走出情傷吧！
													你不能釋懷的是什麼呢？曾經相愛的兩人，為何會反目成仇；曾經許下的未來，最後卻成空；曾經有過愛的記憶，如今卻成為心中的痛；曾經攜手建立的家，最後卻各奔西東。如果這些都放下了，還有什麼放不下呢？她/他對你精神上的傷害、言語上和身體上的暴力等等…，你能撫平傷痛，再往幸福的道路走下去嗎？
													不論你是感情受創、失婚男女或是單親爸媽，或是被拋棄的曠男怨女。或者長年陷在自責、後悔或自怨自艾之中的中年人，你在撫平情傷的道路上，找不到出口嗎？就讓Carol老師以她親身的經驗來告訴你，所有的傷痛都是一段你人生道路必要的提醒，它要告訴你的是，你必須要改變了、你必須要成長了。就如Carol老師所說 “若我此生來到世界的其中一個目的是學會『寬恕』，必然要有另一個靈魂同意扮演『加害者』的角色…… 。
													“我們每一個人都是一個奇蹟，要練習看到自己的美麗和燦爛。”-Carol Lin
													在這堂課，Carol老師將會以EFT情緒排毒敲拍的練習，來帶領每位學員釋放深藏在內心壓抑許久的情傷，轉換為重新燃起生命火花的動力，為自己的未來展開全新的一頁，讓美麗與燦爛照耀你深情的臉龐。
													PS: EFT(Emotional Freedom Techniques)，直接翻成中文，可以譯為情緒釋放技術。實際上，EFT現今在北美洲、歐洲及澳洲廣泛被心理學專家採用。世界各地亦有成千上萬來自不同背景的人士在日常生活上應用EFT減壓及解決情緒上的問題。
													EFT能在短短5-30分鐘之內，平靜個人情緒，如：恐懼、憤怒、悲傷、緊張及焦慮等。即使是非常嚴重的心理問題，在EFT的輔助之下，也能夠得到緩解。
													EFT的基本原理是以卡拉漢博士(Dr. Roger Callahan)的經絡心理學為基礎，透過輕敲身體的特殊穴位，能夠快速的解決各種狀況。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B217.png').default} /></div>
												<div className='btn_detail'><a id='btn_set217'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>建立和諧家庭必修的21堂課</p>
												<p className='author'>作者：賴佩霞<br />時長 202分鐘</p>
												<p id='fm_desc' className='many_txt'>明星級情商導師-賴佩霞，為了幫助更多在愛裏迷失的人，將所見所學，打造了21堂幸福必修課，教妳如何檢視自己，修復關系，進而能夠建立和諧的家庭生活，要讓妳重新在親密關系中，真實做自己，壹起建立幸福美滿的理想人生，現在開始，帶妳重新檢視家庭問題，停．看．聽 創造幸福好生活!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B218.png').default} /></div>
												<div className='btn_detail'><a id='btn_set218'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李建復告訴你成就一生的10個好習慣</p>
												<p className='author'>作者：李建復<br />時長 130分鐘</p>
												<p id='fm_desc' className='many_txt'>我們一直在找尋可以使人功成名就的速成方法!殊不知，”成功”近在眼前，只要稍微改變一下我們的生活習慣，就可以搭上成功列班車，培養10種生活好習慣，成功真的就在不遠處。現在讓李建復告訴你:成就一生的10個好習慣，讓你和成功不再擦肩而過，現在快付諸行動吧!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B219.png').default} /></div>
												<div className='btn_detail'><a id='btn_set219'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>生命的河流</p>
												<p className='author'>作者：陶曉清<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>《生命的河流》，她以自身為例，紀錄下與親朋好友曾發生過的衝突，巧妙運用她所學到的諮商理論，透過淺顯易懂的文字，讓大家能一目瞭然。希望透過生命河流的探索航行，可以幫助更多人加入尋找自我的行列。讓我們帶著一顆溫暖而平靜的心，繼續往下一站航行。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B220.png').default} /></div>
												<div className='btn_detail'><a id='btn_set220'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦小教室</p>
												<p className='author'>作者：魚蹦興業<br />時長 36分鐘</p>
												<p id='fm_desc' className='many_txt'>《魚蹦小教室》首先帶領大家暖身熟悉「熱門必修課程」，從小時候夢想至校園小情愛至人生工作，搭配選修新創歌曲暢談人生大小事，再加上互動遊戲，集結歡樂時刻，挑戰觀眾極限！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B221.png').default} /></div>
												<div className='btn_detail'><a id='btn_set221'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦週記</p>
												<p className='author'>作者：魚蹦興業<br />時長 24分鐘</p>
												<p id='fm_desc' className='many_txt'>漫才界四大天王：惡魔、喬瑟夫、大寶、冠冠，分享他們生活中的趣事，還有每週最有梗的熱話題， 最跳脫邏輯的觀點，最貼近心靈的笑點，都在「魚蹦週記」！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B222.png').default} /></div>
												<div className='btn_detail'><a id='btn_set222'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>漫才秀</p>
												<p className='author'>作者：魚蹦興業<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>「漫才」的表演，主要是以兩人為一組，一個裝傻、一個吐槽，在一搭一唱之間搭建起搞笑的段子。形式雖然類似傳統的相聲，但卻更為自由，不用刻意講求字正腔圓，也沒有沈重的傳統包袱，因此反而更能反應出現代年輕人的潮流與流行文化。以平均每三至五秒的笑點爆發頻率，讓你經歷前所未有的笑感體驗。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B223.png').default} /></div>
												<div className='btn_detail'><a id='btn_set223'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聽說你</p>
												<p className='author'>作者：魚蹦興業<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>最有創意的唬爛大賽，兩人一組，由一方提出天馬行空的提問，另一方負責鬼扯，給你情理之外、邏輯之外、認知之外的想像力，聽說你……聽了笑到天上去！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B224.png').default} /></div>
												<div className='btn_detail'><a id='btn_set224'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>藝曲趣教遊之對口相聲篇</p>
												<p className='author'>作者：臺北曲藝團<br />時長 88分鐘</p>
												<p id='fm_desc' className='many_txt'>國文，幹麽這麼背？
													傳統說唱跨足國文教學的瘋狂想頭！
													專治：古文消化不良症候群、看到文言文發囧rz症
													承天寺Ya遊國臺語互尬，讓蘇東坡笑到發麻！
													中式RAP溜出賣油翁，歐陽脩直推讃！
													偉人傳顛覆偉人嚴肅形象、賣鬼穿梭陰陽兩界現身站臺！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B225.png').default} /></div>
												<div className='btn_detail'><a id='btn_set225'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>誰殺了羅伯特？</p>
												<p className='author'>作者：相聲瓦舍<br />時長 100分鐘</p>
												<p id='fm_desc' className='many_txt'>故事從一樁完美的謀殺案開始，隨著嫌疑犯陸續登場，犯案動機被一一揭露，眼看真相就要大白，命案關鍵人物馮翊綱卻被踢爆暗中兼差情趣伴侶，專精小遊戲！而一向花心的宋少卿，難得一次專情，為何卻搞出人命！？美艷女明星、超猛水電工、性感人妻、女高中生、還有七八十歲的老婆婆，到底誰是兇手？馮翊綱、宋少卿又有什麼不可告人的秘密呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B226.png').default} /></div>
												<div className='btn_detail'><a id='btn_set226'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>上次這次下次</p>
												<p className='author'>作者：相聲瓦舍<br />時長 95分鐘</p>
												<p id='fm_desc' className='many_txt'>人的一生總會遇到這樣的時刻，往左走,往右走，就會大不相同，馮翊綱飾演的和珅家裡，像海一樣的池塘，跟他的人生有何關係？宋少卿到底要選擇搜集煙屁股小蘋果，還是選擇搜集小熊維妮的COCO？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B227.png').default} /></div>
												<div className='btn_detail'><a id='btn_set227'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>蔣先生你幹什麼</p>
												<p className='author'>作者：相聲瓦舍<br />時長 102分鐘</p>
												<p id='fm_desc' className='many_txt'>以三國人物蔣幹為線，中間夾雜音樂歌曲、串場，有點偏離相聲的傳統表演模式，但是演員的表演是按照相聲的套路，笑料的鋪墊、包袱的組織都是純粹的相聲風格，帶著些生澀的國語更具有喜劇效果。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B228.png').default} /></div>
												<div className='btn_detail'><a id='btn_set228'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>記得當時那個小</p>
												<p className='author'>作者：相聲瓦舍<br />時長 120分鐘</p>
												<p id='fm_desc' className='many_txt'>一齣以校園為背景的歡樂相聲劇。相信大家一定都還記得校園中，那個走路有風的英俊教官，隔壁班那個老愛偷看美眉的怪怪男，以及那些努力想讓裙子再短一點、頭髮再長一點的校園美女。那時候……，記得當時那個小，我愛蹺課你愛笑，有一天並肩坐在福利社，老師在找、教官在叫，我們不知怎樣睡著了，夢裡板子挨多少？……《記得當時那個小》將帶您超越時空，重溫過去的歡笑記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B229.png').default} /></div>
												<div className='btn_detail'><a id='btn_set229'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>蹦蹦占卜屋</p>
												<p className='author'>作者：魚蹦興業<br />時長 41分鐘</p>
												<p id='fm_desc' className='all_txt'>隨著天氣的變化對每個人都帶來影響 ，鐵口不直斷，揭開這神秘的面紗，帶領大家盛開笑顏，一探究竟！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B230.png').default} /></div>
												<div className='btn_detail'><a id='btn_set230'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>村上春樹短篇集亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 89分鐘</p>
												<p id='fm_desc' className='many_txt'>日本文學一個最主要的傳統特點就是委婉細膩，富於陰柔之美，善於用小場景、小情節、小道具來傳達人物豐富多變、細小微妙的心理感受、情趣和意緒，營造出令人心旌搖曳的傷感、悲憫和韻味綿長的藝術情調。在村上筆下，這樣的情調、韻致、氛圍可謂隨處可見，而且經營得出神入化，曲盡其妙。作者自己也說過：“我的確非常喜歡日常生活中無所謂的細節性風景，非常喜歡觀察各種各樣的人是怎樣通過這些細節同世界發生關係，以及這些無關緊要的瑣事是怎樣得以發生的，我對此非常有興趣”。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B231.png').default} /></div>
												<div className='btn_detail'><a id='btn_set231'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>鍾曉陽停車暫借問亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 102分鐘</p>
												<p id='fm_desc' className='many_txt'>本書以中國東北為背景，從四十年代寫到六十年代，從東北寫到香港，以“妾住長城外”、“停車暫借問”、“卻遺枕函淚”三部曲敘述了趙寧靜一生的浪漫愛情傳奇。一九八二年，《停車暫借問》先後在臺港兩地出版，引起轟動，名盛文壇。近三十年來，再版無數次，深受讀者喜愛，已成為一代經典。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B232.png').default} /></div>
												<div className='btn_detail'><a id='btn_set232'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>張愛玲短篇小說選亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 109分鐘</p>
												<p id='fm_desc' className='many_txt'>今天書場要講張愛玲的兩篇小說，第一爐香、第二爐香。分別是兩個故事。一個寫的是放蕩，一個寫的是禁慾。還沒有查考一下這兩篇是在她幾歲的作品，研究她的論文車載斗量，查一查應該不難。要說她的作品無懈可擊，也許太誇張。然而這樣的細膩，常常少不了驚心動魄，才氣之高，不再話下。單單看她選擇題材，便知她有多大的膽識了。
													書場講書，也常常讓我產生一種一再重覆的感覺，就是想以一整輪作一個作者的專題，要講要聽，都可以過癮。讀張愛玲的作品，這樣的感受更深。但是從這一輪開始，同一個作者，長短篇各一次，試試看大家的感覺如何，要是可以，先維持一陣再說了。
													有書客要求我講講她的另一篇短篇「封鎖」，那是讀過之後很難忘的作品，我們會談到。但是這一篇不算頂好，問題在那兒?從「封鎖」看張愛玲的特殊問題，也許會對她的瞭解更多。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B233.png').default} /></div>
												<div className='btn_detail'><a id='btn_set233'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>卡爾維諾短篇小說選阿根廷螞蟻亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 97分鐘</p>
												<p id='fm_desc' className='many_txt'>我常常有這樣的感覺，那就是，人生有許多種的損失，有的損失很容易判斷，比如說金錢的損失，還有失去了最愛的人，失去了健康等等，這樣的損失，不必等到真的沒有了才會有感覺，事先都可料到的。然而還有一種，那就是除非你真正得到了，否則，你就會發現差一點就有那麼大的損失。
													比如說，一位出色的老師的課程。學生在選課的時候，大多不會預知這一堂課該有多好，常常找個好混的就好。老師既不是有名的大師，也沒有為自己的課程作宣傳，有的人偶爾因為其他的課程都被人選滿了，只好選這個他並不知怎樣的課。但是，這一門課，也許在後來改變了有些學生的一生。這種「不知道的損失」，常常是損失了最為可貴的機緣。得到的人在後來常常會想，倘若沒有遇到這一位老師還是這一門課，我的人生會多麼的無聊無趣啊！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B234.png').default} /></div>
												<div className='btn_detail'><a id='btn_set234'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>馬奎斯百年孤寂亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 120分鐘</p>
												<p id='fm_desc' className='many_txt'>本週四亮軒書場要講的是賈西亞馬奎斯的「百年孤寂」，這本書，是馬奎斯一生最重要的代表作，至少最大多數的人都知道這一本書。
													「百年孤寂」描述的是在哥倫比亞的一個大家族的六代的故事，從開始建立一個家庭，到這個家庭繁盛光輝，成為最大的一個家族，然而歷經革命、戰亂，由盛而衰的一部大書。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B235.png').default} /></div>
												<div className='btn_detail'><a id='btn_set235'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>高行健靈山亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 120分鐘</p>
												<p id='fm_desc' className='many_txt'>靈山，諾貝爾文學獎得主高行健的代表作。他的書原本一點都不暢銷，也沒幾個人知道他。要是有人聽過他的名字的話，會認為那是個畫家。他以大潑墨的減筆山水為主要的表現方法，靠賣畫為生，但是並非生意興隆。在得獎之前就來過臺灣，但是好像也沒開畫展。從中國移民到巴黎，再也沒回去，入了法國國藉。經歷過文革的浩劫，親眼目睹了許多悲慘又荒謬的景況，決心當個世界人，不再眷戀所謂祖國。也因此，共和國認為第一個拿到諾貝爾文學獎的中國人是莫言。我們不用計較，他的作品充滿了中國的風格，歷史的，文化的，政治的、信仰的，我們很難找出一部這樣的大書，能夠同樣的富於中國的色彩。那麼好，有個法國人用中文寫了一部了不起的中國風格的作品，此書名為靈山。但是此書卻道出了整個人類心靈的故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B236.png').default} /></div>
												<div className='btn_detail'><a id='btn_set236'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>川端康成千羽鶴亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 82分鐘</p>
												<p id='fm_desc' className='many_txt'>讀川端康成的作品，原本對他的短篇沒有寄予厚望，想不到讀來滋味深長。可見年紀真的有差別。從前要讀出他的淡，就不容易，現在卻很能欣賞他的淡，因其淡，所以特別的讓人回味無窮。他著墨極輕，愈是用情深，愈是寫得淡，時而極輕的一點，使得讀者頓時恍然大悟，真是了不起。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B237.png').default} /></div>
												<div className='btn_detail'><a id='btn_set237'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>海明威老人與海亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 111分鐘</p>
												<p id='fm_desc' className='many_txt'>一葉扁舟，一個老漁夫，還有一條大部分時間在海底，咬了他的釣鉤的碩大無朋的那隻馬林魚，一群鯊魚，以及一個沒有參與這一場生死博鬥，在漁村裡的男孩，也是老漁夫唯一的朋友，就是這個名震青史的文學鉅著所有的角色了。即使畫一幅畫，只這麼幾個元素，要成為小品，也許辦得到，成為古今鉅構，難極了，然而海明威作到了。人要不朽，在創作的路上，質比量重要，雖然海明威的創作也很多。然而，在他用兩個月完成了這個篇幅不長的小說之後，他自己也說，這可能是他一生最好的一部作品。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B238.png').default} /></div>
												<div className='btn_detail'><a id='btn_set238'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>福樓拜包法利夫人亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 108分鐘</p>
												<p id='fm_desc' className='many_txt'>福婁拜爾的包法利夫人，是一種永恆。我們有許多書可讀，但是這一本包法利夫人，總讓人覺得可以一讀再讀。我讀了幾遍，不太記得，每回都像是親自見到了女主角愛瑪一樣，很像與故友重逢。再一次的感受她的天真、狂野、困苦、勇敢、癡情、失落與絕望。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B239.png').default} /></div>
												<div className='btn_detail'><a id='btn_set239'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>張愛玲紅玫瑰與白玫瑰亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 116分鐘</p>
												<p id='fm_desc' className='many_txt'>紅玫瑰與白玫瑰，是張愛玲很有名的作品。這部作品完成的時候，她才二十二歲。我們當然非常驚訝這麼一個年輕的女子，居然對男女的心理寫得那麼透骨。她的出身應該有很大的影響，那一個沒落的貴族，裡面有許許多多她從小就體會到的黑暗。而且，她也聽得多，男人是怎麼從一個純潔的少年，到了中年，成了行屍走肉，能騙能嫖，自鳴得意，她點點滴滴的聽。一段一段的記，又一再翻翻覆覆的玩味。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B240.png').default} /></div>
												<div className='btn_detail'><a id='btn_set240'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>遠藤周作海與毒藥亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 124分鐘</p>
												<p id='fm_desc' className='many_txt'>「海與毒藥」，是三十四歲的時候發表的作品。那時是一九五七年，昭和三十二年。遠藤的成長歲月，跟二次大戰相當重疊。一九四五年日本無條件投降，成書是在無條件投降的十二年後，時間距離日本戰敗非常接近，日本的重新建設是在越戰爆發之後，遠藤此作，時間與空間的背景，都還彌漫著在戰火之餘的空氣中。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B241.png').default} /></div>
												<div className='btn_detail'><a id='btn_set241'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>傑克倫敦短篇小說選亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 123分鐘</p>
												<p id='fm_desc' className='many_txt'>十九世紀末到二十世紀初，傑克倫敦的作品風靡全美國。他活著的時候，作品一出版便洛陽紙貴，各國爭相翻譯。這位只活了四十一歲，自殺而死的作家，是一位狂熱的寫作迷。短短十六年的寫作生涯，寫下了五十餘部的作品，再度的證明，所有的天才，都曾經瘋狂的努力。書場所談到的，幾乎無一不是狂寫狂讀的作家。傑克倫敦寫下了十九部長篇小說，一百五十多篇短篇。又寫下了三個劇本，還有許許多多的隨筆評論。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B242.png').default} /></div>
												<div className='btn_detail'><a id='btn_set242'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>莫泊桑脂肪球亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 112分鐘</p>
												<p id='fm_desc' className='many_txt'>尼采對於當代的法國人，他說他只佩服一個，就是莫泊桑。當然尼采這話說得很過分，卻也突顯了莫泊桑的文學造詣境界很高。
													這一次要講的「脂肪球」，是他驚天動地的成名作，這一篇作品原來是發表在他的老師左拉的辦的雜誌上，沒想到這一期的雜誌大為暢銷，從此，莫泊桑的稿約不斷，他後來成為一個有錢人，甚至於也有了自己的遊艇。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B243.png').default} /></div>
												<div className='btn_detail'><a id='btn_set243'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賈平凹長篇廢都亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 136分鐘</p>
												<p id='fm_desc' className='many_txt'>《廢都》是作家賈平凹創作的長篇小說，1993年首次發表。小說寫的是80年代我國西北一個大城市裏一群知識份子的生活故事。小說主人公叫莊之蝶，是西京城四大文化名人之一，也是四大名人中最有能耐的一個，屬“西京文壇上數一數二的頂尖人物”。小說中有大量的“性”描寫，故而引起較多的爭議。小說還較多地運用了象徵的手法，是該小說值得注意的一個藝術特點。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B244.png').default} /></div>
												<div className='btn_detail'><a id='btn_set244'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>莫言我們的荊軻亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 121分鐘</p>
												<p id='fm_desc' className='many_txt'>《我們的荊軻》是以現代人的視角重新審視、解讀荊軻刺秦王的故事。《霸王別姬》同樣是歷史故事新說，莫言在該劇中將刻畫人物的理念運用至極致，向讀者展示出一個為愛而生為愛而死的虞姬。《鍋爐工的妻子》是一部現實題材的劇本，也是三部劇中唯一還沒有和觀眾見面的，講述了一個女知青在社會變遷中的多舛命運。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B245.png').default} /></div>
												<div className='btn_detail'><a id='btn_set245'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>赫曼赫塞漂泊的靈魂亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>在上星期書場結束，大家紛紛回家之前，我作了簡單的口頭報告說，下星期要講赫曼‧赫塞的小說，馬上就有一位女性書客對我說，我最喜歡赫曼‧赫塞了！可不是，我也想說這樣的一句話，而且，我相信，想跟我說這句話的人一定還有不少。就像有的電影導演一樣，我們總會癡迷於某幾個導演，小津安二啦、候麥啦、安哲普洛斯啦、伍迪艾倫啦等等。心中沒有英雄的人生是很荒涼的，能夠有緣把赫曼‧赫塞放在心中的英雄榜上，人生應該蠻充實的。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B246.png').default} /></div>
												<div className='btn_detail'><a id='btn_set246'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>陳映真小說趙南棟亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 125分鐘</p>
												<p id='fm_desc' className='many_txt'>這篇作品，選自(陳映真作品集)，一共有十五冊，出版於一九八八年，其中小說五集，其他則為訪談，隨筆，序文及書評，政論及批判，論陳映真等等。由此可見其博大淵深。
													在這裡只能簡單的說，他是一位澈底的人道主義者，而一位積極的人道主義者，很難不是社會主義者，成為許多人眼中的革命家，也很自然。
													要說我十分敬佩的社會主義信徒，我佩服抗戰時四川的盧作郛，擔任過共產黨主席的瞿秋白，由於政治的原因，無法對共產黨有足夠的了解，應該還有其他人吧？陳映真不會是共產黨，否則一定被槍決，不會關在綠島七年後獲釋。
													依照文集姚一葦教授的總序所言，他的(趙南棟)是他們相交三十年以來，寫得最讓他動心的一篇。
													陳映真已經在幾年前，在北京長久臥病之後去世，台灣也有很大篇幅的報導，但是事過境遷，自始至終，還有多少人記得這位堅持理想，以全力多方面實踐，無怨無悔了一生的人?
													白色恐怖時代，說實話，不太清楚。我們大多數人都很顧現實的過日子，絕不越線。但我們不知道，也有人為他們的理想，萬死不辭。
													抗日曾經是一股洪流，激起無數青年愛國的熱血，但也因內亂內戰，多少熱血青年身陷牢獄，曝屍荒野與刑場。
													趙南棟，便是從如此背景中法展出來的故事。
													這篇作品，不像類似的傷痕小說，裡面有許多的冤情。在綠島被囚禁，大多數被槍決的人，他們的確是在那時的政治性定義下的所謂敵人。他們坦然的接受橫加其身的命運。既使是共產黨，難道就沒有仁人志士嗎？
													陳映真是從歷史與哲學的滲透理解之後，才寫出這一篇看似平淡，骨子裡驚心動魄的作品。
													這些無名英雄的曦牲，換來了甚麼?是資本主義，物質生活的追求，隱藏在所謂民主外表下自私的野心跟慾望，精神與肉體的無限墮落。他們的父母一一因對國家民族的理想而被槍決，他們的子女，卻耽溺於墮落腐化的世界。
													陳映真提出了深刻的批判，但他沒有一句說教，只是冷靜的，以飽含詩情的文字，舖陳一篇史詩般的故事。那麼樣的凄涼，那麼樣的無奈。如果要知道誰是陳映真，毫無疑問，從(趙南棟)這篇作品開始，可以一識這位徐復觀教授所說海峽兩岸第一人。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B247.png').default} /></div>
												<div className='btn_detail'><a id='btn_set247'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>歐亨利短篇小說選亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 106分鐘</p>
												<p id='fm_desc' className='many_txt'>十九世紀下半的歐美文壇，在小說創作方面，進入成熟的階段，名家輩出，美不勝收。但是以短篇名世者不多。長篇寫來固然不易，能以充分的滲透力撼動人心，甚至於其哲思影響到了讀者的人生觀，這是長篇作品的重要作用。短篇小說欲達這樣的目標就不太容易，因為沒有足夠的篇幅經營出足夠的張力，大多以巧思取勝。所以，短篇創作中的傑作也非常難得。中國的蒲松齡，法國的莫泊桑，美國的歐亨利，俄國的果戈里，都以短篇創作名世，的確不容易。
													歐亨利在美國西部成長，之後在西南部、紐約等地生活，活了僅僅四十七歲，而他的一生為了討生活，過得十分辛苦，創作時間也只有短短的十年。在這十年當中，寫下了二百八十多篇作品，大多是為了生活而寫，卻能出類拔萃，是個異數。
													歐亨利成為一位傳諸久遠的小說家，也是他本人始料未及。最早的時候他是一位在報刊上畫諷剌漫畫的畫家，本來沒有要成為小說家的意思。他興趣廣泛，曾經有很長的段時間從事新聞工作，然後又搞出版，還當過德州的牛仔，也曾經是銀行行員，作過藥房的藥劑師，也在藥廠工作過。也在宏都拉斯跟一位火車大盜成為知友，這一段時間，是為了逃躲政府的追拿，因為他涉嫌在銀行工作期間，挪用了顧客的存款。他本可從此逍遙於美國之外，卻又因妻子病重，情義所鍾，毅然回國就擒。
													這麼複雜的經歷，自然成為他創作的最好的題材。然而一位好作家絕對不會只以題材取勝，赫曼赫塞半生都安安靜靜的住在瑞士的山區，照樣寫下了許多懾人心神的作品，莎士比亞的作品背景遍及當時歐洲許多國度，他本人卻沒有到處遊歷，只是多讀書而已。一位出色的作家，靠的是他的思想與創意。歐亨利的那一篇「禮物」，講的是一對恩愛夫妻互贈禮物，就是從未讀過他的作品的讀者，也都知道那一對貧困的夫妻互贈錶鍊與一把講究的梳子的故事。
													其實他並沒有因為文學的創作吃太多的苦頭，在世的時候已經是名作家了。然而依他的生平種種看來，他對寫作是否像其他的大文豪一樣，有很深的使命感，讓人懷疑。因為他大多是應出版家還是報刊主編之請創作，定期交稿，產量豐富。他特別長於巧思，總能給讀者一個意想不到的結尾，又能貼近人性。這都是在市場上最受歡迎的風格，難得的是在滿足讀者之餘，他的作品充滿了對人情世故的參悟，出入自如。
													也許歐亨利一生只愛一個女子，就是他那二十九歲早逝的元配，多年之後的二度婚姻，並沒有帶給他快樂。最後的歲月中，他總是拖著病體在南南北北中輾轉。最後是寂寞的死在紐約，床前只有一個醫生。
													但是他死後卻連續有許多的作品專輯出版，大為暢銷，經過了一百多年，依然是非常暢銷的作家。
													他的短篇常常很短，這與莫泊桑不一樣，莫泊桑的作品雖然說是短篇，長達一兩萬字的作品很多。歐亨利的作品大部分是適於報刊發表一日完結的作品，兩三千字都算是長的了。
													二月一日晚間的亮軒書場，我們會講到他的三篇作品，一篇跟他本人的經歷很有關係，一篇是有點怪異的，卻充滿了對愛情憧憬的無奈。還有一篇是他平生所寫最長的長篇，三段故事，寫出在人生中難以逃避的命運，也是我最激賞的一篇。
													歐亨利的一生，也許比他的小說更精采，也有人寫下了他的傳記，然而，便是寫傳記的作家，也不得不說，他的一生非常神秘，他為人也非常寡合，可說沒有什麼朋友，要了解他，應該從他的作品中搜尋。而一位作家的平生，再引起讀者的好奇，也不如好好的欣賞他的作品來得重要。
													這位美國文學史上最出色的短篇小說家，會成為我們心靈中的一部分，相信他變化無端的人生，也會由他的作品反映出來。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-2"><br /><br />
									<ul className="book">
										{/* html_book文學 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B30.png').default} /></div>
												<div className='btn_detail'><a id='btn_set30'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>歷史為什麼讓我們發笑</p>
												<p className='author'>作者：王偉忠張大春<br />時長 75分鐘</p>
												<p id='fm_desc' className='many_txt'>王偉忠VS張大春,兩人將以對談形式展現發笑對話的最高境界,說歷史為什麼讓我們發笑,這對談主題由張大春親自提出,向來滿腹詩書,信口成章的兩人,誓言要作場不一樣的顛覆對談,全場沒有嚴肅正經的歷史論述,只有一段段說古論今,體現現代情境的荒繆笑果.試想: 周幽王為求褒姒一笑，點燃烽火，戲弄諸侯的情節到五十步笑百步”的成語，乃至蘇軾的《蝶戀花》：「……牆裡鞦韆牆外道，牆外行人牆裡佳人笑……」等,這點點滴滴的經典陳跡,已成歷史,令人發笑，讓人不知所以!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B73.png').default} /></div>
												<div className='btn_detail'><a id='btn_set73'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>異界龍印之尊</p>
												<p className='author'>作者：聲朗文化<br />時長 807分鐘</p>
												<p id='fm_desc' className='many_txt'>修道對於22世紀的人來說，只是一些幻想家的幻想而已。盧軒在以前只是一個普通人，根本不相信什麽鬼神之說的，而現在他已經成為了蓮花道人的弟子。
													22世紀的地球，大量的工業開採使地球已經變成了毫無靈氣的藍色星球，盧軒為了修煉自身，盡快開啟通天之法，迎天地之大機緣，他離開生活了20年的地球，前往修道界最好的星球--靈星，遇到了雷厲風行的小仙女念巧兒，開啟了一段傳奇故事！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B74.png').default} /></div>
												<div className='btn_detail'><a id='btn_set74'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>靈武大陸之魔界</p>
												<p className='author'>作者：聲朗文化<br />時長 667分鐘</p>
												<p id='fm_desc' className='many_txt'>一把被封印的飲血魔刀突然控制了靈武鎮朱家弟子朱董陽，為了爭搶魔戒統一全世界，成為萬物之主，它將朱家夷成平地，原本偌大的家園，變成了殘破不堪的碎石瓦礫。雖然無數的強者都來阻止它，但是無一例外都死在了飲血魔刀之下，成為了魔刀的補品。
													十五歲的朱家少年朱孝天召喚魔戒，十年如一日的潛修，與魔刀展開了曠世絕倫的對決。最終，朱孝天把魔刀變成了一把普通兵刃！世界再也不會遭到飲血魔刀的迫害，持續了數千年的災禍終於得到了控制。
													而朱孝天也成為了新一代的大俠，更是把無極宗發揚光大！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B88.png').default} /></div>
												<div className='btn_detail'><a id='btn_set88'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>江湖九分熟</p>
												<p className='author'>作者：聲朗文化<br />時長 574分鐘</p>
												<p id='fm_desc' className='many_txt'>江湖一分熟，回家種紅薯；江湖兩分熟，打雜都不屬；江湖三分熟，勉強能做主；江湖四分熟，敢和命打賭；江湖五分熟，屈指便可數；江湖六分熟，人人都讓路；江湖七分熟，鬼都不敢堵；江湖八分熟，頭上是盟主；江湖九分熟，腳踩一片土；江湖十分熟，此乃神人，鬼主。
													江湖新菜譜火熱出爐！配料如下：七小邪，一雙被七小邪“借”走的冰蠶鞋，兩本被七小邪順走的《九宗秘笈》上下冊。
													但凡集齊配料，送至九王爺或者官府總督面前，便可免費品嘗九分熟的江湖一份！
													江湖之大，奇人之多，不論混了多久，都始終是小蝦米，不願做一輩子的蝦米，於是，很多人借此機會想要翻身當盟主，於是，史上最浩蕩的一次“通緝令”，使江湖上無數英雄狗熊摩拳擦掌，開始了他們的翻身之旅。
													跑江湖也能混到個武林盟主當當，這一趟，不算白來……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B89.png').default} /></div>
												<div className='btn_detail'><a id='btn_set89'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>差點是女皇</p>
												<p className='author'>作者：聲朗文化<br />時長 446分鐘</p>
												<p id='fm_desc' className='many_txt'>少女金卡卡是個偷搶打混的不良少女，一次犯案時誤傷企業大少伊流影。他在醒來後失憶，並執意認為她是他的女友。“用像海洋那麼寬廣的愛去愛你”，他愛的不過是一段漂浮不定的回憶。“你什麼時候才能愛的是我呢”，她等待著，可她的愛卻始終比他快了一步。
													2010年尾，易開罐用最爆笑的文字講訴了一段最痛徹心扉的愛情。我們都愛過，笑著，哭了，希望最後記得的仍是快樂。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B151.png').default} /></div>
												<div className='btn_detail'><a id='btn_set151'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>蒲松齡與聊齋誌異</p>
												<p className='author'>作者：朱嘉雯<br />時長 724分鐘</p>
												<p id='fm_desc' className='many_txt'>清朝初年，山東淄川蒲松齡的《聊齋志異》，不僅是一部談鬼說狐的系列故事總集，同時也是作家一生思想與信仰的結晶。其間有可歌可泣的俠義小說、纏綿哀婉的戀愛情節、光怪陸離的海內外傳說，更精彩的是那些花妖狐精、煙粉靈怪林林總總不可思議的生命故事！
													徜徉在這片故事之海，追逐文學與哲理的層層浪花，我們將從中體會世俗倫常中最深刻的道理，以及發覺人性底層最殷切的欲望。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B165.png').default} /></div>
												<div className='btn_detail'><a id='btn_set165'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>村上春樹沒有色彩的多崎作和他的巡禮之年亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 111分鐘</p>
												<p id='fm_desc' className='many_txt'>原先有點想要放棄預告中決定的這一本長篇，村上的「沒有色彩的多崎作和他的巡禮之年」，這樣的書名，應該是村上創作中最長的了。開頭讀的時候真的有點累，這裡起個頭那裡起個頭，卻個個都是無厘頭。很覺得村上春樹是在故弄玄虛。曾經在日記中寫道:讀村上的一這一本長篇，覺得累，也許換成短篇比較好講。
													可是又給了自己一點壓力，因為發現這一本小說從二○一三年到現在，已經是第七刷。不知真的賣了多少本，應該是很受歡迎的一本小說。
													在快要午夜開始繼續的讀，讀到後來愈來愈有精神，好像天地間一片黑夜中，只有我跟村上書中人物依然活動著，再無其它。
													村上畢竟是個了不起的天才，從看來隨興的描寫出手，卻漸漸次引人深入很深很深的內心世界。最厲害的是讓我們相信包括我們自己在內，也可能如此的恐怖。
													平常的生活，認真的話，可以追索到最原始的本性中，那樣的本性尤也許善良，也許邪惡，可都不是沒有理由的，村上的天分與訓練就在這樣的情況下展露出來。
													這個「作」是個非常平凡的男子，直到目前的三十六歲，也沒有什麼驚人的成就，也沒什麼可以稱作失敗的經驗，就像在東京地鐵中的無數的平凡人一樣，然而村上把我們帶入他的內心，感受到他的痛苦，他的渴望，我們讀到了了更為成熟的村上春樹，而且，他以其出神入化的人物與情節，讓讀者在享受類似偵探小說般的緊張與盼望中，得到的是豁然開朗的境界。已經清晨三點了，卻讓人無法入眠，因為太多的思緒要整理。其實，真的很享受這樣子睡不著的感覺。
													歡迎來聽山崎作，這個沒有色彩的平凡男子驚人的故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B230.png').default} /></div>
												<div className='btn_detail'><a id='btn_set230'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>村上春樹短篇集亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 89分鐘</p>
												<p id='fm_desc' className='many_txt'>日本文學一個最主要的傳統特點就是委婉細膩，富於陰柔之美，善於用小場景、小情節、小道具來傳達人物豐富多變、細小微妙的心理感受、情趣和意緒，營造出令人心旌搖曳的傷感、悲憫和韻味綿長的藝術情調。在村上筆下，這樣的情調、韻致、氛圍可謂隨處可見，而且經營得出神入化，曲盡其妙。作者自己也說過：“我的確非常喜歡日常生活中無所謂的細節性風景，非常喜歡觀察各種各樣的人是怎樣通過這些細節同世界發生關係，以及這些無關緊要的瑣事是怎樣得以發生的，我對此非常有興趣”。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B231.png').default} /></div>
												<div className='btn_detail'><a id='btn_set231'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>鍾曉陽停車暫借問亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 102分鐘</p>
												<p id='fm_desc' className='many_txt'>本書以中國東北為背景，從四十年代寫到六十年代，從東北寫到香港，以“妾住長城外”、“停車暫借問”、“卻遺枕函淚”三部曲敘述了趙寧靜一生的浪漫愛情傳奇。一九八二年，《停車暫借問》先後在臺港兩地出版，引起轟動，名盛文壇。近三十年來，再版無數次，深受讀者喜愛，已成為一代經典。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B232.png').default} /></div>
												<div className='btn_detail'><a id='btn_set232'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>張愛玲短篇小說選亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 109分鐘</p>
												<p id='fm_desc' className='many_txt'>今天書場要講張愛玲的兩篇小說，第一爐香、第二爐香。分別是兩個故事。一個寫的是放蕩，一個寫的是禁慾。還沒有查考一下這兩篇是在她幾歲的作品，研究她的論文車載斗量，查一查應該不難。要說她的作品無懈可擊，也許太誇張。然而這樣的細膩，常常少不了驚心動魄，才氣之高，不再話下。單單看她選擇題材，便知她有多大的膽識了。
													書場講書，也常常讓我產生一種一再重覆的感覺，就是想以一整輪作一個作者的專題，要講要聽，都可以過癮。讀張愛玲的作品，這樣的感受更深。但是從這一輪開始，同一個作者，長短篇各一次，試試看大家的感覺如何，要是可以，先維持一陣再說了。
													有書客要求我講講她的另一篇短篇「封鎖」，那是讀過之後很難忘的作品，我們會談到。但是這一篇不算頂好，問題在那兒?從「封鎖」看張愛玲的特殊問題，也許會對她的瞭解更多。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B233.png').default} /></div>
												<div className='btn_detail'><a id='btn_set233'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>卡爾維諾短篇小說選阿根廷螞蟻亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 97分鐘</p>
												<p id='fm_desc' className='many_txt'>我常常有這樣的感覺，那就是，人生有許多種的損失，有的損失很容易判斷，比如說金錢的損失，還有失去了最愛的人，失去了健康等等，這樣的損失，不必等到真的沒有了才會有感覺，事先都可料到的。然而還有一種，那就是除非你真正得到了，否則，你就會發現差一點就有那麼大的損失。
													比如說，一位出色的老師的課程。學生在選課的時候，大多不會預知這一堂課該有多好，常常找個好混的就好。老師既不是有名的大師，也沒有為自己的課程作宣傳，有的人偶爾因為其他的課程都被人選滿了，只好選這個他並不知怎樣的課。但是，這一門課，也許在後來改變了有些學生的一生。這種「不知道的損失」，常常是損失了最為可貴的機緣。得到的人在後來常常會想，倘若沒有遇到這一位老師還是這一門課，我的人生會多麼的無聊無趣啊！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B234.png').default} /></div>
												<div className='btn_detail'><a id='btn_set234'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>馬奎斯百年孤寂亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 120分鐘</p>
												<p id='fm_desc' className='many_txt'>本週四亮軒書場要講的是賈西亞馬奎斯的「百年孤寂」，這本書，是馬奎斯一生最重要的代表作，至少最大多數的人都知道這一本書。
													「百年孤寂」描述的是在哥倫比亞的一個大家族的六代的故事，從開始建立一個家庭，到這個家庭繁盛光輝，成為最大的一個家族，然而歷經革命、戰亂，由盛而衰的一部大書。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B235.png').default} /></div>
												<div className='btn_detail'><a id='btn_set235'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>高行健靈山亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 120分鐘</p>
												<p id='fm_desc' className='many_txt'>靈山，諾貝爾文學獎得主高行健的代表作。他的書原本一點都不暢銷，也沒幾個人知道他。要是有人聽過他的名字的話，會認為那是個畫家。他以大潑墨的減筆山水為主要的表現方法，靠賣畫為生，但是並非生意興隆。在得獎之前就來過臺灣，但是好像也沒開畫展。從中國移民到巴黎，再也沒回去，入了法國國藉。經歷過文革的浩劫，親眼目睹了許多悲慘又荒謬的景況，決心當個世界人，不再眷戀所謂祖國。也因此，共和國認為第一個拿到諾貝爾文學獎的中國人是莫言。我們不用計較，他的作品充滿了中國的風格，歷史的，文化的，政治的、信仰的，我們很難找出一部這樣的大書，能夠同樣的富於中國的色彩。那麼好，有個法國人用中文寫了一部了不起的中國風格的作品，此書名為靈山。但是此書卻道出了整個人類心靈的故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B236.png').default} /></div>
												<div className='btn_detail'><a id='btn_set236'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>川端康成千羽鶴亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 82分鐘</p>
												<p id='fm_desc' className='many_txt'>讀川端康成的作品，原本對他的短篇沒有寄予厚望，想不到讀來滋味深長。可見年紀真的有差別。從前要讀出他的淡，就不容易，現在卻很能欣賞他的淡，因其淡，所以特別的讓人回味無窮。他著墨極輕，愈是用情深，愈是寫得淡，時而極輕的一點，使得讀者頓時恍然大悟，真是了不起。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B237.png').default} /></div>
												<div className='btn_detail'><a id='btn_set237'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>海明威老人與海亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 111分鐘</p>
												<p id='fm_desc' className='many_txt'>一葉扁舟，一個老漁夫，還有一條大部分時間在海底，咬了他的釣鉤的碩大無朋的那隻馬林魚，一群鯊魚，以及一個沒有參與這一場生死博鬥，在漁村裡的男孩，也是老漁夫唯一的朋友，就是這個名震青史的文學鉅著所有的角色了。即使畫一幅畫，只這麼幾個元素，要成為小品，也許辦得到，成為古今鉅構，難極了，然而海明威作到了。人要不朽，在創作的路上，質比量重要，雖然海明威的創作也很多。然而，在他用兩個月完成了這個篇幅不長的小說之後，他自己也說，這可能是他一生最好的一部作品。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B238.png').default} /></div>
												<div className='btn_detail'><a id='btn_set238'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>福樓拜包法利夫人亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 108分鐘</p>
												<p id='fm_desc' className='many_txt'>福婁拜爾的包法利夫人，是一種永恆。我們有許多書可讀，但是這一本包法利夫人，總讓人覺得可以一讀再讀。我讀了幾遍，不太記得，每回都像是親自見到了女主角愛瑪一樣，很像與故友重逢。再一次的感受她的天真、狂野、困苦、勇敢、癡情、失落與絕望。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B239.png').default} /></div>
												<div className='btn_detail'><a id='btn_set239'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>張愛玲紅玫瑰與白玫瑰亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 116分鐘</p>
												<p id='fm_desc' className='many_txt'>紅玫瑰與白玫瑰，是張愛玲很有名的作品。這部作品完成的時候，她才二十二歲。我們當然非常驚訝這麼一個年輕的女子，居然對男女的心理寫得那麼透骨。她的出身應該有很大的影響，那一個沒落的貴族，裡面有許許多多她從小就體會到的黑暗。而且，她也聽得多，男人是怎麼從一個純潔的少年，到了中年，成了行屍走肉，能騙能嫖，自鳴得意，她點點滴滴的聽。一段一段的記，又一再翻翻覆覆的玩味。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B240.png').default} /></div>
												<div className='btn_detail'><a id='btn_set240'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>遠藤周作海與毒藥亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 124分鐘</p>
												<p id='fm_desc' className='many_txt'>「海與毒藥」，是三十四歲的時候發表的作品。那時是一九五七年，昭和三十二年。遠藤的成長歲月，跟二次大戰相當重疊。一九四五年日本無條件投降，成書是在無條件投降的十二年後，時間距離日本戰敗非常接近，日本的重新建設是在越戰爆發之後，遠藤此作，時間與空間的背景，都還彌漫著在戰火之餘的空氣中。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B241.png').default} /></div>
												<div className='btn_detail'><a id='btn_set241'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>傑克倫敦短篇小說選亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 123分鐘</p>
												<p id='fm_desc' className='many_txt'>十九世紀末到二十世紀初，傑克倫敦的作品風靡全美國。他活著的時候，作品一出版便洛陽紙貴，各國爭相翻譯。這位只活了四十一歲，自殺而死的作家，是一位狂熱的寫作迷。短短十六年的寫作生涯，寫下了五十餘部的作品，再度的證明，所有的天才，都曾經瘋狂的努力。書場所談到的，幾乎無一不是狂寫狂讀的作家。傑克倫敦寫下了十九部長篇小說，一百五十多篇短篇。又寫下了三個劇本，還有許許多多的隨筆評論。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B242.png').default} /></div>
												<div className='btn_detail'><a id='btn_set242'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>莫泊桑脂肪球亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 112分鐘</p>
												<p id='fm_desc' className='many_txt'>尼采對於當代的法國人，他說他只佩服一個，就是莫泊桑。當然尼采這話說得很過分，卻也突顯了莫泊桑的文學造詣境界很高。
													這一次要講的「脂肪球」，是他驚天動地的成名作，這一篇作品原來是發表在他的老師左拉的辦的雜誌上，沒想到這一期的雜誌大為暢銷，從此，莫泊桑的稿約不斷，他後來成為一個有錢人，甚至於也有了自己的遊艇。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B243.png').default} /></div>
												<div className='btn_detail'><a id='btn_set243'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賈平凹長篇廢都亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 136分鐘</p>
												<p id='fm_desc' className='many_txt'>《廢都》是作家賈平凹創作的長篇小說，1993年首次發表。小說寫的是80年代我國西北一個大城市裏一群知識份子的生活故事。小說主人公叫莊之蝶，是西京城四大文化名人之一，也是四大名人中最有能耐的一個，屬“西京文壇上數一數二的頂尖人物”。小說中有大量的“性”描寫，故而引起較多的爭議。小說還較多地運用了象徵的手法，是該小說值得注意的一個藝術特點。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B244.png').default} /></div>
												<div className='btn_detail'><a id='btn_set244'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>莫言我們的荊軻亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 121分鐘</p>
												<p id='fm_desc' className='many_txt'>《我們的荊軻》是以現代人的視角重新審視、解讀荊軻刺秦王的故事。《霸王別姬》同樣是歷史故事新說，莫言在該劇中將刻畫人物的理念運用至極致，向讀者展示出一個為愛而生為愛而死的虞姬。《鍋爐工的妻子》是一部現實題材的劇本，也是三部劇中唯一還沒有和觀眾見面的，講述了一個女知青在社會變遷中的多舛命運。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B245.png').default} /></div>
												<div className='btn_detail'><a id='btn_set245'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>赫曼赫塞漂泊的靈魂亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>在上星期書場結束，大家紛紛回家之前，我作了簡單的口頭報告說，下星期要講赫曼‧赫塞的小說，馬上就有一位女性書客對我說，我最喜歡赫曼‧赫塞了！可不是，我也想說這樣的一句話，而且，我相信，想跟我說這句話的人一定還有不少。就像有的電影導演一樣，我們總會癡迷於某幾個導演，小津安二啦、候麥啦、安哲普洛斯啦、伍迪艾倫啦等等。心中沒有英雄的人生是很荒涼的，能夠有緣把赫曼‧赫塞放在心中的英雄榜上，人生應該蠻充實的。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B246.png').default} /></div>
												<div className='btn_detail'><a id='btn_set246'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>陳映真小說趙南棟亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 125分鐘</p>
												<p id='fm_desc' className='many_txt'>這篇作品，選自(陳映真作品集)，一共有十五冊，出版於一九八八年，其中小說五集，其他則為訪談，隨筆，序文及書評，政論及批判，論陳映真等等。由此可見其博大淵深。
													在這裡只能簡單的說，他是一位澈底的人道主義者，而一位積極的人道主義者，很難不是社會主義者，成為許多人眼中的革命家，也很自然。
													要說我十分敬佩的社會主義信徒，我佩服抗戰時四川的盧作郛，擔任過共產黨主席的瞿秋白，由於政治的原因，無法對共產黨有足夠的了解，應該還有其他人吧？陳映真不會是共產黨，否則一定被槍決，不會關在綠島七年後獲釋。
													依照文集姚一葦教授的總序所言，他的(趙南棟)是他們相交三十年以來，寫得最讓他動心的一篇。
													陳映真已經在幾年前，在北京長久臥病之後去世，台灣也有很大篇幅的報導，但是事過境遷，自始至終，還有多少人記得這位堅持理想，以全力多方面實踐，無怨無悔了一生的人?
													白色恐怖時代，說實話，不太清楚。我們大多數人都很顧現實的過日子，絕不越線。但我們不知道，也有人為他們的理想，萬死不辭。
													抗日曾經是一股洪流，激起無數青年愛國的熱血，但也因內亂內戰，多少熱血青年身陷牢獄，曝屍荒野與刑場。
													趙南棟，便是從如此背景中法展出來的故事。
													這篇作品，不像類似的傷痕小說，裡面有許多的冤情。在綠島被囚禁，大多數被槍決的人，他們的確是在那時的政治性定義下的所謂敵人。他們坦然的接受橫加其身的命運。既使是共產黨，難道就沒有仁人志士嗎？
													陳映真是從歷史與哲學的滲透理解之後，才寫出這一篇看似平淡，骨子裡驚心動魄的作品。
													這些無名英雄的曦牲，換來了甚麼?是資本主義，物質生活的追求，隱藏在所謂民主外表下自私的野心跟慾望，精神與肉體的無限墮落。他們的父母一一因對國家民族的理想而被槍決，他們的子女，卻耽溺於墮落腐化的世界。
													陳映真提出了深刻的批判，但他沒有一句說教，只是冷靜的，以飽含詩情的文字，舖陳一篇史詩般的故事。那麼樣的凄涼，那麼樣的無奈。如果要知道誰是陳映真，毫無疑問，從(趙南棟)這篇作品開始，可以一識這位徐復觀教授所說海峽兩岸第一人。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B247.png').default} /></div>
												<div className='btn_detail'><a id='btn_set247'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>歐亨利短篇小說選亮軒書場</p>
												<p className='author'>作者：亮軒<br />時長 106分鐘</p>
												<p id='fm_desc' className='many_txt'>十九世紀下半的歐美文壇，在小說創作方面，進入成熟的階段，名家輩出，美不勝收。但是以短篇名世者不多。長篇寫來固然不易，能以充分的滲透力撼動人心，甚至於其哲思影響到了讀者的人生觀，這是長篇作品的重要作用。短篇小說欲達這樣的目標就不太容易，因為沒有足夠的篇幅經營出足夠的張力，大多以巧思取勝。所以，短篇創作中的傑作也非常難得。中國的蒲松齡，法國的莫泊桑，美國的歐亨利，俄國的果戈里，都以短篇創作名世，的確不容易。
													歐亨利在美國西部成長，之後在西南部、紐約等地生活，活了僅僅四十七歲，而他的一生為了討生活，過得十分辛苦，創作時間也只有短短的十年。在這十年當中，寫下了二百八十多篇作品，大多是為了生活而寫，卻能出類拔萃，是個異數。
													歐亨利成為一位傳諸久遠的小說家，也是他本人始料未及。最早的時候他是一位在報刊上畫諷剌漫畫的畫家，本來沒有要成為小說家的意思。他興趣廣泛，曾經有很長的段時間從事新聞工作，然後又搞出版，還當過德州的牛仔，也曾經是銀行行員，作過藥房的藥劑師，也在藥廠工作過。也在宏都拉斯跟一位火車大盜成為知友，這一段時間，是為了逃躲政府的追拿，因為他涉嫌在銀行工作期間，挪用了顧客的存款。他本可從此逍遙於美國之外，卻又因妻子病重，情義所鍾，毅然回國就擒。
													這麼複雜的經歷，自然成為他創作的最好的題材。然而一位好作家絕對不會只以題材取勝，赫曼赫塞半生都安安靜靜的住在瑞士的山區，照樣寫下了許多懾人心神的作品，莎士比亞的作品背景遍及當時歐洲許多國度，他本人卻沒有到處遊歷，只是多讀書而已。一位出色的作家，靠的是他的思想與創意。歐亨利的那一篇「禮物」，講的是一對恩愛夫妻互贈禮物，就是從未讀過他的作品的讀者，也都知道那一對貧困的夫妻互贈錶鍊與一把講究的梳子的故事。
													其實他並沒有因為文學的創作吃太多的苦頭，在世的時候已經是名作家了。然而依他的生平種種看來，他對寫作是否像其他的大文豪一樣，有很深的使命感，讓人懷疑。因為他大多是應出版家還是報刊主編之請創作，定期交稿，產量豐富。他特別長於巧思，總能給讀者一個意想不到的結尾，又能貼近人性。這都是在市場上最受歡迎的風格，難得的是在滿足讀者之餘，他的作品充滿了對人情世故的參悟，出入自如。
													也許歐亨利一生只愛一個女子，就是他那二十九歲早逝的元配，多年之後的二度婚姻，並沒有帶給他快樂。最後的歲月中，他總是拖著病體在南南北北中輾轉。最後是寂寞的死在紐約，床前只有一個醫生。
													但是他死後卻連續有許多的作品專輯出版，大為暢銷，經過了一百多年，依然是非常暢銷的作家。
													他的短篇常常很短，這與莫泊桑不一樣，莫泊桑的作品雖然說是短篇，長達一兩萬字的作品很多。歐亨利的作品大部分是適於報刊發表一日完結的作品，兩三千字都算是長的了。
													二月一日晚間的亮軒書場，我們會講到他的三篇作品，一篇跟他本人的經歷很有關係，一篇是有點怪異的，卻充滿了對愛情憧憬的無奈。還有一篇是他平生所寫最長的長篇，三段故事，寫出在人生中難以逃避的命運，也是我最激賞的一篇。
													歐亨利的一生，也許比他的小說更精采，也有人寫下了他的傳記，然而，便是寫傳記的作家，也不得不說，他的一生非常神秘，他為人也非常寡合，可說沒有什麼朋友，要了解他，應該從他的作品中搜尋。而一位作家的平生，再引起讀者的好奇，也不如好好的欣賞他的作品來得重要。
													這位美國文學史上最出色的短篇小說家，會成為我們心靈中的一部分，相信他變化無端的人生，也會由他的作品反映出來。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-3"><br /><br />
									<ul className="book">
										{/* html_book相聲 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B55.png').default} /></div>
												<div className='btn_detail'><a id='btn_set55'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>消失的931</p>
												<p className='author'>作者：天行音樂<br />時長 71分鐘</p>
												<p id='fm_desc' className='many_txt'>〈公元1673年〉--公元1673年，人類歷史上發生了壹場驚天地泣鬼神的戰爭，北京城裏的康熙皇上，聽說地處雲南的吳三桂正在悄悄地發展生物武器，於是派出得力助手：驍騎營都統、禦賜黃馬褂、頭戴三眼花翎、壹等鹿鼎公，韋小寶前往討伐…</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B56.png').default} /></div>
												<div className='btn_detail'><a id='btn_set56'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>摳你己襪卡卡村</p>
												<p className='author'>作者：天行音樂<br />時長 72分鐘</p>
												<p id='fm_desc' className='many_txt'>探索傳說中全世界最聰明的村子～卡卡村。聽說這個村子隱藏在壹個不為人知的角落，悄悄地延續了三千多年的歷史。從卡卡村流傳出來的故事曾經名滿天下，象是…全天下都知道的…〈國王的新衣〉，試想卡卡村是全世界最聰明的村子，它既然是壹個村子哪來的國王呢？當然，是村長嘛！除了〈村長的新衣〉，卡卡村裏還發生了其他什麽奇妙怪異的事件呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B57.png').default} /></div>
												<div className='btn_detail'><a id='btn_set57'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>公公徹夜未眠</p>
												<p className='author'>作者：相聲瓦舍<br />時長 99分鐘</p>
												<p id='fm_desc' className='many_txt'>《公公徹夜未眠》由「瓦舍金三寶」馮翊綱、宋少卿、黃士偉領銜演出，以幽默風趣的狂想手法，照映現代爭名奪利、窺探八卦秘辛、金迷紙醉的生活。這位神秘的西廠公公到底是誰？他的小嘍囉們又會如何來暗算東廠公公呢？《公公徹夜未眠》爆笑絕倫的唇槍舌戰，讓您徹底體悟何謂〝殺人不見血，笑裡藏刀！〞</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B58.png').default} /></div>
												<div className='btn_detail'><a id='btn_set58'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>他怎麼那麼紅</p>
												<p className='author'>作者：相聲瓦舍<br />時長 189分鐘</p>
												<p id='fm_desc' className='many_txt'>【相聲瓦舍】馮翊綱、宋少卿將傳統經典相聲段子《報菜名》、《倭瓜鑣》、《扒馬褂》 ……等名作重新詮釋，再加上知名舞臺劇演員黃士偉，真是各獻各的寶，各演各的戲，不僅是笑料百出，更是將傳統相聲藝術呈現出前所未見的新面貌。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B59.png').default} /></div>
												<div className='btn_detail'><a id='btn_set59'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>瓦舍說金庸</p>
												<p className='author'>作者：相聲瓦舍<br />時長 97分鐘</p>
												<p id='fm_desc' className='many_txt'>你，看過、玩過金庸、就是沒聽過【相聲瓦舍】說金庸！這次，來點不一樣！ 馮翊綱編劇、與鐵板搭檔宋少卿同台演出。不管有沒有讀過金庸小說，只要看了場演出，都要給你不同的武俠官感，金庸小說的江湖歷險、兒女柔情、古典文史滲入相聲劇，幻化《瓦舍說金庸》，帶你穿越時空，行俠
													仗義！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B61.png').default} /></div>
												<div className='btn_detail'><a id='btn_set61'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>大話成語</p>
												<p className='author'>作者：臺北曲藝團<br />時長 202分鐘</p>
												<p id='fm_desc' className='many_txt'>台北曲藝團《大話成語》以相聲和評書多種說唱表演藝術形式
													又說又演，演繹成語的魅力，饒富知識性、娛樂性、趣味性
													老少咸宜，雅俗共賞！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B62.png').default} /></div>
												<div className='btn_detail'><a id='btn_set62'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人賣我</p>
												<p className='author'>作者：臺北曲藝團<br />時長 58分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B63.png').default} /></div>
												<div className='btn_detail'><a id='btn_set63'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人疑鄰偷斧</p>
												<p className='author'>作者：臺北曲藝團<br />時長 61分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容61分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B64.png').default} /></div>
												<div className='btn_detail'><a id='btn_set64'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人棺材鋪</p>
												<p className='author'>作者：臺北曲藝團<br />時長 57分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容57分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B65.png').default} /></div>
												<div className='btn_detail'><a id='btn_set65'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人武松打店</p>
												<p className='author'>作者：臺北曲藝團<br />時長 69分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容57分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B66.png').default} /></div>
												<div className='btn_detail'><a id='btn_set66'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人詩情畫意</p>
												<p className='author'>作者：臺北曲藝團<br />時長 57分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。純聲音內容57分鐘 / 2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													藉說古道今達寓教於樂之功。內容富有歷史感﹐包括忠孝仁愛禮義廉恥智勇信等核心價值。 涵蓋了散說(評書)、韻誦(快書)、滑稽(相聲)、敘唱等各類說唱藝術形式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B90.png').default} /></div>
												<div className='btn_detail'><a id='btn_set90'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人井底之蛙</p>
												<p className='author'>作者：臺北曲藝團<br />時長 50分鐘</p>
												<p id='fm_desc' className='many_txt'>喜迎25系列_2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！ 演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少鹹宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B91.png').default} /></div>
												<div className='btn_detail'><a id='btn_set91'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人武松打虎</p>
												<p className='author'>作者：臺北曲藝團<br />時長 60分鐘</p>
												<p id='fm_desc' className='many_txt'>喜迎25系列_2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！ 演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少鹹宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B92.png').default} /></div>
												<div className='btn_detail'><a id='btn_set92'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>永遠的說書人大改行</p>
												<p className='author'>作者：臺北曲藝團<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>喜迎25系列_2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！ 演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少鹹宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B93.png').default} /></div>
												<div className='btn_detail'><a id='btn_set93'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第9部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B94.png').default} /></div>
												<div className='btn_detail'><a id='btn_set94'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第8部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B95.png').default} /></div>
												<div className='btn_detail'><a id='btn_set95'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第7部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B96.png').default} /></div>
												<div className='btn_detail'><a id='btn_set96'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第6部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 57分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B97.png').default} /></div>
												<div className='btn_detail'><a id='btn_set97'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第5部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 56分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B98.png').default} /></div>
												<div className='btn_detail'><a id='btn_set98'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第4部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B99.png').default} /></div>
												<div className='btn_detail'><a id='btn_set99'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第3部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B100.png').default} /></div>
												<div className='btn_detail'><a id='btn_set100'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第2部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 47分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B101.png').default} /></div>
												<div className='btn_detail'><a id='btn_set101'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第1部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B103.png').default} /></div>
												<div className='btn_detail'><a id='btn_set103'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會花宅</p>
												<p className='author'>作者：臺北曲藝團<br />時長 27分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B104.png').default} /></div>
												<div className='btn_detail'><a id='btn_set104'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會男朋友女朋友</p>
												<p className='author'>作者：臺北曲藝團<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B105.png').default} /></div>
												<div className='btn_detail'><a id='btn_set105'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會買賣論</p>
												<p className='author'>作者：臺北曲藝團<br />時長 26分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B106.png').default} /></div>
												<div className='btn_detail'><a id='btn_set106'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會段子一</p>
												<p className='author'>作者：臺北曲藝團<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B107.png').default} /></div>
												<div className='btn_detail'><a id='btn_set107'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會喜迎25鬧生日</p>
												<p className='author'>作者：臺北曲藝團<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B108.png').default} /></div>
												<div className='btn_detail'><a id='btn_set108'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會反七口</p>
												<p className='author'>作者：臺北曲藝團<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B109.png').default} /></div>
												<div className='btn_detail'><a id='btn_set109'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會六口人</p>
												<p className='author'>作者：臺北曲藝團<br />時長 42分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B110.png').default} /></div>
												<div className='btn_detail'><a id='btn_set110'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會彬彬有禮</p>
												<p className='author'>作者：臺北曲藝團<br />時長 44分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B111.png').default} /></div>
												<div className='btn_detail'><a id='btn_set111'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會四管四轄</p>
												<p className='author'>作者：臺北曲藝團<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B112.png').default} /></div>
												<div className='btn_detail'><a id='btn_set112'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會歪批三國</p>
												<p className='author'>作者：臺北曲藝團<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B113.png').default} /></div>
												<div className='btn_detail'><a id='btn_set113'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會二人見面忙把手</p>
												<p className='author'>作者：臺北曲藝團<br />時長 29分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B114.png').default} /></div>
												<div className='btn_detail'><a id='btn_set114'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>臺北相聲大會記得當年那首歌</p>
												<p className='author'>作者：臺北曲藝團<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B140.png').default} /></div>
												<div className='btn_detail'><a id='btn_set140'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦笑本部</p>
												<p className='author'>作者：魚蹦興業<br />時長 44分鐘</p>
												<p id='fm_desc' className='all_txt'>高密度笑點轟炸，快狠準表演節奏
													要你挑戰顏面神經的極限
													直搗笑本部，枯燥人生再也不冷場！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B141.png').default} /></div>
												<div className='btn_detail'><a id='btn_set141'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦笑本部續集</p>
												<p className='author'>作者：魚蹦興業<br />時長 69分鐘</p>
												<p id='fm_desc' className='all_txt'>高密度笑點轟炸，快狠準表演節奏
													要你挑戰顏面神經的極限
													直搗笑本部，枯燥人生再也不冷場！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B142.png').default} /></div>
												<div className='btn_detail'><a id='btn_set142'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>達康玩漫才</p>
												<p className='author'>作者：達康.come<br />時長 75分鐘</p>
												<p id='fm_desc' className='all_txt'>玩樂漫才，一笑到底 ；一個舞台，兩個搞笑人，
													漫才段子+營養話題talk+現場互動
													歡迎來到達康.come的漫才小宇宙</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B143.png').default} /></div>
												<div className='btn_detail'><a id='btn_set143'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>達康下凡來解答</p>
												<p className='author'>作者：達康.come<br />時長 48分鐘</p>
												<p id='fm_desc' className='many_txt'>由現場觀眾填寫題目卡，隨機抽出後，由達康在漫才的舞台上用「漫才」的態度即興解謎。
													任何嚴肅的難題，都能利用輕鬆泰然的角度轉化，生活何必如此勞累？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B144.png').default} /></div>
												<div className='btn_detail'><a id='btn_set144'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>大滿貫</p>
												<p className='author'>作者：台北曲藝團<br />時長 79分鐘</p>
												<p id='fm_desc' className='many_txt'>2018年，迎接25歲，台北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！
													演出內容包括相聲的傳統段目、現代創作和個人絕活 。 節目滑稽爆笑﹑幽默風趣﹐精采熱鬧、老少咸宜﹐以達到娛樂效果為主。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B145.png').default} /></div>
												<div className='btn_detail'><a id='btn_set145'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>說書唱曲談今古</p>
												<p className='author'>作者：林文彬<br />時長 143分鐘</p>
												<p id='fm_desc' className='many_txt'>專業的林文彬已是台灣竹板第一人，風靡無數海內外觀眾。但林不只是竹板王子，此次他將使出渾身解數，為觀眾帶來由京韻大鼓、竹板、單弦與奉調大鼓乃至對口相聲等交織而成的〝林來瘋〞曲藝之夜。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B146.png').default} /></div>
												<div className='btn_detail'><a id='btn_set146'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>關於愛情分手</p>
												<p className='author'>作者：魚蹦興業<br />時長 33分鐘</p>
												<p id='fm_desc' className='many_txt'>分手可以是任何一種原因，不管是不愛了、劈腿了、改變性向，或是單純很渣⋯諸如此類，總之天時地利人和少了一個都無法繼續下去，但唯有經歷過這一切才能促使我們成長，找到更適合自己的生活方式，對吧？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B147.png').default} /></div>
												<div className='btn_detail'><a id='btn_set147'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>關於愛情熱戀</p>
												<p className='author'>作者：魚蹦興業<br />時長 40分鐘</p>
												<p id='fm_desc' className='many_txt'>曖昧過後就是兩人陷入熱戀的時候，每天就想跟對方膩在一起，熱戀中更會讓人智商莫名變低，心甘情願做出一些不可思議的甜蜜事，回想起來是否會覺得自己好蠢好傻好天真呢?</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B148.png').default} /></div>
												<div className='btn_detail'><a id='btn_set148'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>廢物野餐趴</p>
												<p className='author'>作者：魚蹦興業<br />時長 66分鐘</p>
												<p id='fm_desc' className='many_txt'>多久沒有軟趴趴的躺在野餐墊上耍廢廢呢？沒有開玩笑，魚蹦興業邀請觀眾攜帶自己的食物，一起來脫鞋子趴趴地，欣賞魚蹦興業推出的最新秋季野餐趴，現場還有演員精心準備的限量餐點，吃完就沒囉，實在超棒棒！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B149.png').default} /></div>
												<div className='btn_detail'><a id='btn_set149'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣答嘴鼓點燈</p>
												<p className='author'>作者：王一明；梅子；恆春兮；齊軒<br />時長 61分鐘</p>
												<p id='fm_desc' className='many_txt'>點燈，是民間信仰傳統的儀式之一，人們相信透過點燈祈福，可以保佑平安，利路亨通。 台灣答嘴鼓的說唱團隊，除了王一明、梅子，此次特別邀請廣播名主持人阿國、齊軒，以及「工商服務」恆春兮一起點燈。 共有光明燈、太歲燈、文昌燈、招財燈、姻緣燈、平安燈，歡迎您一起來點燈！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B153.png').default} /></div>
												<div className='btn_detail'><a id='btn_set153'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>相聲來了第10部</p>
												<p className='author'>作者：馮翊綱、宋少卿、黃士偉<br />時長 60分鐘</p>
												<p id='fm_desc' className='many_txt'>1988年4月，二十歲出頭的幾個學生，如馮翊綱、宋少卿...等人，以“在劇場說相聲”為意，開始從事相聲表演，這個當時默默無聞、什麼也沒有的小劇團，被命名為[相聲瓦舍]。
													相聲瓦舍改編傳統的段子來說，好讓相聲能夠從曆史中重新走過來，也創作新的作品來演，好讓相聲能夠不斷的向未來走來。你看相聲來了！相聲真的來了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B220.png').default} /></div>
												<div className='btn_detail'><a id='btn_set220'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦小教室</p>
												<p className='author'>作者：魚蹦興業<br />時長 36分鐘</p>
												<p id='fm_desc' className='many_txt'>《魚蹦小教室》首先帶領大家暖身熟悉「熱門必修課程」，從小時候夢想至校園小情愛至人生工作，搭配選修新創歌曲暢談人生大小事，再加上互動遊戲，集結歡樂時刻，挑戰觀眾極限！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B221.png').default} /></div>
												<div className='btn_detail'><a id='btn_set221'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>魚蹦週記</p>
												<p className='author'>作者：魚蹦興業<br />時長 24分鐘</p>
												<p id='fm_desc' className='many_txt'>漫才界四大天王：惡魔、喬瑟夫、大寶、冠冠，分享他們生活中的趣事，還有每週最有梗的熱話題， 最跳脫邏輯的觀點，最貼近心靈的笑點，都在「魚蹦週記」！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B222.png').default} /></div>
												<div className='btn_detail'><a id='btn_set222'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>漫才秀</p>
												<p className='author'>作者：魚蹦興業<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>「漫才」的表演，主要是以兩人為一組，一個裝傻、一個吐槽，在一搭一唱之間搭建起搞笑的段子。形式雖然類似傳統的相聲，但卻更為自由，不用刻意講求字正腔圓，也沒有沈重的傳統包袱，因此反而更能反應出現代年輕人的潮流與流行文化。以平均每三至五秒的笑點爆發頻率，讓你經歷前所未有的笑感體驗。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B223.png').default} /></div>
												<div className='btn_detail'><a id='btn_set223'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聽說你</p>
												<p className='author'>作者：魚蹦興業<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>最有創意的唬爛大賽，兩人一組，由一方提出天馬行空的提問，另一方負責鬼扯，給你情理之外、邏輯之外、認知之外的想像力，聽說你……聽了笑到天上去！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B224.png').default} /></div>
												<div className='btn_detail'><a id='btn_set224'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>藝曲趣教遊之對口相聲篇</p>
												<p className='author'>作者：臺北曲藝團<br />時長 88分鐘</p>
												<p id='fm_desc' className='many_txt'>國文，幹麽這麼背？
													傳統說唱跨足國文教學的瘋狂想頭！
													專治：古文消化不良症候群、看到文言文發囧rz症
													承天寺Ya遊國臺語互尬，讓蘇東坡笑到發麻！
													中式RAP溜出賣油翁，歐陽脩直推讃！
													偉人傳顛覆偉人嚴肅形象、賣鬼穿梭陰陽兩界現身站臺！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B225.png').default} /></div>
												<div className='btn_detail'><a id='btn_set225'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>誰殺了羅伯特？</p>
												<p className='author'>作者：相聲瓦舍<br />時長 100分鐘</p>
												<p id='fm_desc' className='many_txt'>故事從一樁完美的謀殺案開始，隨著嫌疑犯陸續登場，犯案動機被一一揭露，眼看真相就要大白，命案關鍵人物馮翊綱卻被踢爆暗中兼差情趣伴侶，專精小遊戲！而一向花心的宋少卿，難得一次專情，為何卻搞出人命！？美艷女明星、超猛水電工、性感人妻、女高中生、還有七八十歲的老婆婆，到底誰是兇手？馮翊綱、宋少卿又有什麼不可告人的秘密呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B226.png').default} /></div>
												<div className='btn_detail'><a id='btn_set226'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>上次這次下次</p>
												<p className='author'>作者：相聲瓦舍<br />時長 95分鐘</p>
												<p id='fm_desc' className='many_txt'>人的一生總會遇到這樣的時刻，往左走,往右走，就會大不相同，馮翊綱飾演的和珅家裡，像海一樣的池塘，跟他的人生有何關係？宋少卿到底要選擇搜集煙屁股小蘋果，還是選擇搜集小熊維妮的COCO？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B227.png').default} /></div>
												<div className='btn_detail'><a id='btn_set227'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>蔣先生你幹什麼</p>
												<p className='author'>作者：相聲瓦舍<br />時長 102分鐘</p>
												<p id='fm_desc' className='many_txt'>以三國人物蔣幹為線，中間夾雜音樂歌曲、串場，有點偏離相聲的傳統表演模式，但是演員的表演是按照相聲的套路，笑料的鋪墊、包袱的組織都是純粹的相聲風格，帶著些生澀的國語更具有喜劇效果。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B228.png').default} /></div>
												<div className='btn_detail'><a id='btn_set228'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>記得當時那個小</p>
												<p className='author'>作者：相聲瓦舍<br />時長 120分鐘</p>
												<p id='fm_desc' className='many_txt'>一齣以校園為背景的歡樂相聲劇。相信大家一定都還記得校園中，那個走路有風的英俊教官，隔壁班那個老愛偷看美眉的怪怪男，以及那些努力想讓裙子再短一點、頭髮再長一點的校園美女。那時候……，記得當時那個小，我愛蹺課你愛笑，有一天並肩坐在福利社，老師在找、教官在叫，我們不知怎樣睡著了，夢裡板子挨多少？……《記得當時那個小》將帶您超越時空，重溫過去的歡笑記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B229.png').default} /></div>
												<div className='btn_detail'><a id='btn_set229'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>蹦蹦占卜屋</p>
												<p className='author'>作者：魚蹦興業<br />時長 41分鐘</p>
												<p id='fm_desc' className='all_txt'>隨著天氣的變化對每個人都帶來影響 ，鐵口不直斷，揭開這神秘的面紗，帶領大家盛開笑顏，一探究竟！</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-4"><br /><br />
									<ul className="book">
										{/* html_book健康養生 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B17.png').default} /></div>
												<div className='btn_detail'><a id='btn_set17'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟2021星座開運指南</p>
												<p className='author'>作者：季欣麟<br />時長 281分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，為您剖析在2021年12星座的事業、財富、感情、健康密碼！事業運勢如何提升？正財偏財如何取得？桃花將會如何開啟？健康狀況如何留意？還有事業財富及愛情開運的數字、顏色、物品、寶石、月份又將是甚麼？讓季欣麟為您帶來12星座在事業、財富、感情、健康各方面的指引；另外，根據2021年的星盤走勢，行星坐落在不同的宮位上又該如何趨吉避凶？讓季欣麟大師給您貼心叮嚀，指引你通往開運之路!!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B19.png').default} /></div>
												<div className='btn_detail'><a id='btn_set19'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>許常德的愛情箴言愛情練習題QA</p>
												<p className='author'>作者：許常德<br />時長 105分鐘</p>
												<p id='fm_desc' className='many_txt'>擅於解答愛情與人生難題的許常德，某年開始不經意的回答愛情問題，對於愛情有獨到見解的許常德，讓提問者因此認清沒人敢說的真相，旁觀者也得到共鳴，他分享愛、書寫愛、講解愛，如果想要愛，就不能忽視愛裡的「得到」與「失去」的學問。
													集結許常德的愛情建議，替愛情上的各樣疑難雜症開立處方簽，一起探討「愛」這個人類社會最普遍又最迷惘的主題。透過許常德的解析，將感情從相識、相愛、相處到相守的要領全都拆解，幫助愛情中的迷途羔羊找到方向，引領你看透愛的本質，走過愛裡的迷思，重新練習好•好•愛。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B51.png').default} /></div>
												<div className='btn_detail'><a id='btn_set51'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>意識力量轉化癌症癌症不是絕症</p>
												<p className='author'>作者：許添盛<br />時長 72分鐘</p>
												<p id='fm_desc' className='many_txt'>得了癌症，就代表離死亡不遠了？
													許醫師給你一個癌症新定義──它不是絶症！
													癌症不應該只被視為身體的疾病，它是透過身體而反映出來的人生現況。你應該視它為人生的轉機──不是教你怎樣吃更多的健康食品，或是如何去找更多的抗癌方式；而教你如何去改變人生，引導你重新檢討對生命的態度。
													心靈如果沒有被瞭解、被洞悉、沒有予以面對的話，任何只考慮身體的醫療、物質的醫療，都是捨本逐末的做法。癌症的治療，如果只對身體進行手術、化療、放射治療或是荷爾蒙療法，甚至「另類療法」或實驗療法，都是不夠的，最終還是得從「心」著手。
													長久以來，大家都感受到醫學的無力感，也認同身心靈一體的觀點，可是卻鮮少有人能夠把這樣的洞見，變成可供操作、甚至複製的治療方法。許醫師從事身心靈整體健康研究十數年，對於癌症的治療及預防復發有獨特心得。在他的「身心靈整體健康成長團體」、「美麗人生癌症病患成長團體」裏，的確有現代醫學未知的的理論基礎及治療技巧，治癒的效果斐然可觀，而這些你可以在這套有聲書裏找到。
													當你聆聽時，也許呼應了你內心所隱約感覺到的真理，或是喚醒了你對生命的真知灼見。不管你是癌症病友、病友家屬，或是治療癌症的專業人員，希望這本對癌症截然不同的認知以及因而產生的全新治療法，能夠為你帶來不同的思考方式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B52.png').default} /></div>
												<div className='btn_detail'><a id='btn_set52'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>威力最強的抗癌心法癌症不是絕症</p>
												<p className='author'>作者：許添盛<br />時長 64分鐘</p>
												<p id='fm_desc' className='many_txt'>得了癌症，就代表離死亡不遠了？
													許醫師給你一個癌症新定義──它不是絶症！
													癌症不應該只被視為身體的疾病，它是透過身體而反映出來的人生現況。你應該視它為人生的轉機──不是教你怎樣吃更多的健康食品，或是如何去找更多的抗癌方式；而教你如何去改變人生，引導你重新檢討對生命的態度。
													心靈如果沒有被瞭解、被洞悉、沒有予以面對的話，任何只考慮身體的醫療、物質的醫療，都是捨本逐末的做法。癌症的治療，如果只對身體進行手術、化療、放射治療或是荷爾蒙療法，甚至「另類療法」或實驗療法，都是不夠的，最終還是得從「心」著手。
													長久以來，大家都感受到醫學的無力感，也認同身心靈一體的觀點，可是卻鮮少有人能夠把這樣的洞見，變成可供操作、甚至複製的治療方法。許醫師從事身心靈整體健康研究十數年，對於癌症的治療及預防復發有獨特心得。在他的「身心靈整體健康成長團體」、「美麗人生癌症病患成長團體」裏，的確有現代醫學未知的的理論基礎及治療技巧，治癒的效果斐然可觀，而這些你可以在這套有聲書裏找到。
													當你聆聽時，也許呼應了你內心所隱約感覺到的真理，或是喚醒了你對生命的真知灼見。不管你是癌症病友、病友家屬，或是治療癌症的專業人員，希望這本對癌症截然不同的認知以及因而產生的全新治療法，能夠為你帶來不同的思考方式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B53.png').default} /></div>
												<div className='btn_detail'><a id='btn_set53'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>你可以不生病癌症不是絕症</p>
												<p className='author'>作者：許添盛<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>得了癌症，就代表離死亡不遠了？
													許醫師給你一個癌症新定義──它不是絶症！
													癌症不應該只被視為身體的疾病，它是透過身體而反映出來的人生現況。你應該視它為人生的轉機──不是教你怎樣吃更多的健康食品，或是如何去找更多的抗癌方式；而教你如何去改變人生，引導你重新檢討對生命的態度。
													心靈如果沒有被瞭解、被洞悉、沒有予以面對的話，任何只考慮身體的醫療、物質的醫療，都是捨本逐末的做法。癌症的治療，如果只對身體進行手術、化療、放射治療或是荷爾蒙療法，甚至「另類療法」或實驗療法，都是不夠的，最終還是得從「心」著手。
													長久以來，大家都感受到醫學的無力感，也認同身心靈一體的觀點，可是卻鮮少有人能夠把這樣的洞見，變成可供操作、甚至複製的治療方法。許醫師從事身心靈整體健康研究十數年，對於癌症的治療及預防復發有獨特心得。在他的「身心靈整體健康成長團體」、「美麗人生癌症病患成長團體」裏，的確有現代醫學未知的的理論基礎及治療技巧，治癒的效果斐然可觀，而這些你可以在這套有聲書裏找到。
													當你聆聽時，也許呼應了你內心所隱約感覺到的真理，或是喚醒了你對生命的真知灼見。不管你是癌症病友、病友家屬，或是治療癌症的專業人員，希望這本對癌症截然不同的認知以及因而產生的全新治療法，能夠為你帶來不同的思考方式。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B54.png').default} /></div>
												<div className='btn_detail'><a id='btn_set54'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>啟動內在感官的十二堂課</p>
												<p className='author'>作者：許添盛<br />時長 482分鐘</p>
												<p id='fm_desc' className='many_txt'>這套啟動內在感官的十二個初階練習，是以賽斯思想為基礎的靜心冥想課程，對於想要真正認識自己、想要瞭解事事物物的真實原貌、 想要擴展意識以覺知更大的心靈實相，甚至只是想讓心安靜下來，訓練專注力與練習放鬆，以儲備能量面對每天嶄新挑戰的現代人，提供一系列平易淺近的方法，能有效幫助學習者實際體驗並落實賽斯思想於生活當中。循序漸進，全程參與，相信大家將會體驗到生命的奇妙感受！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B67.png').default} /></div>
												<div className='btn_detail'><a id='btn_set67'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>開心開開心心走一回</p>
												<p className='author'>作者：王建煊<br />時長 122分鐘</p>
												<p id='fm_desc' className='many_txt'>人生苦短，一晃就過去了。在這短暫的人生裡，若能開開心心的走一回，該是多麼美好。可是開心的日子哪裡找呢？
													這本書中有輕鬆幽默的例子，也有嚴肅的命題，希望引起讀者的共鳴，在觀念上、行動上，都能更容易的邁上開心之路。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B68.png').default} /></div>
												<div className='btn_detail'><a id='btn_set68'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>用愛心說誠實話</p>
												<p className='author'>作者：王建煊<br />時長 128分鐘</p>
												<p id='fm_desc' className='all_txt'>現在願意說誠實話的人愈來愈少，這本書以小故事的方式，用愛心道出一些真話，作者和您一起…聽誠實話、說誠實話，凡事長進。</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B69.png').default} /></div>
												<div className='btn_detail'><a id='btn_set69'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>幸福童話35篇關於愛的故事</p>
												<p className='author'>作者：宇宙光<br />時長 349分鐘</p>
												<p id='fm_desc' className='many_txt'>幸福是神話嗎？如何避免落入不幸的陷阱？特選自德國文學作品的三十五篇「小小說」，篇篇都是啟迪幸福的鑰匙，值得追求幸福的你一聽再聽。每個故事的共同主題是「愛」，包含了夫妻間的深情、戀人的愛情、親情的滿足、鄰人的友誼、陌生人之間可貴無私的愛……，觸動你我的心弦，彈奏出幸福之歌。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B70.png').default} /></div>
												<div className='btn_detail'><a id='btn_set70'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>EFT情緒釋放技巧</p>
												<p className='author'>作者：Carol林嘉瑗<br />時長 232分鐘</p>
												<p id='fm_desc' className='many_txt'>「EFT 情緒釋放技巧」（Emotional Freedom Techniques），是能量心理治療體系當中的一種，快速又有效的能量心理學技術。是一套簡單方便，以及具突破技巧，能迅速有效解決情緒與心理問題。現今許多國家的心理學家運用它來進行治療，成千上萬的人運用它來進行減壓、情緒排毒與療癒重大創傷。
													在「EFT 情緒釋放技巧」裡，Carol老師會引導你一層層深入你的情緒核心，碰觸最真實的自己， 啟發內在的力量與愛，協助你卸下情緒的包袱，釋放深藏的痛苦種子，找到心靈的平靜與寧靜，重新認識自己、接受自己，重建自信。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B71.png').default} /></div>
												<div className='btn_detail'><a id='btn_set71'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>EFT人和領導術</p>
												<p className='author'>作者：Carol林嘉瑗<br />時長 178分鐘</p>
												<p id='fm_desc' className='many_txt'>經由EFT人和領導術，你可以很快的瞭解，對手是什麼樣的人，您可以用很簡單的肢體語言，輕鬆的跟他產生良性互動。更重要的是你會更了解自己。理解自己與他人的不同，然後用簡單具體的方式，快速地增進彼此的人際關係，進而達成你想要的目標。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B79.png').default} /></div>
												<div className='btn_detail'><a id='btn_set79'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>通樂想通了就快樂</p>
												<p className='author'>作者：王建煊<br />時長 126分鐘</p>
												<p id='fm_desc' className='many_txt'>許多事想通了就快樂，想不通就難過，有時鑽牛角尖，甚至弄到殺人或自我毀滅的地步。有個女孩，相交多年的男友移情別戀。她憤怒、痛苦、茶不思飯不想……簡直不知如何是好？她問前監察院長王建煊怎麼辦……？你想成為錢財的主人嗎……？你贊成黃昏之戀嗎……？讓王建煊藉由人生經驗，以小故事幫助大家當沮喪來訪時，轉個念頭，便有豁達的人生！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B80.png').default} /></div>
												<div className='btn_detail'><a id='btn_set80'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>療癒爵士之愛深夜單人舞</p>
												<p className='author'>作者：安譜<br />時長 67分鐘</p>
												<p id='fm_desc' className='all_txt'>分手後的深夜，一個人原來可以不用感覺孤單，第一次發先。
													原來城市的喧囂可以變成安靜，夜晚天空中，有星星！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B81.png').default} /></div>
												<div className='btn_detail'><a id='btn_set81'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>漫步森林靜心舒壓系列</p>
												<p className='author'>作者：安譜<br />時長 86分鐘</p>
												<p id='fm_desc' className='all_txt'>這份來自森林的禮物，是輕拂的風之頌，輕輕柔柔撫慰著疲憊的心靈，讓音樂伴隨而來的釋放，忘卻壓力！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B82.png').default} /></div>
												<div className='btn_detail'><a id='btn_set82'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>鉛筆盒幻想曲幸福晨光序曲</p>
												<p className='author'>作者：安譜<br />時長 48分鐘</p>
												<p id='fm_desc' className='all_txt'>有一個鉛筆盒，裡面住著美麗的鉛筆，每一支鉛筆，都期待著被小主人拿出來，畫出美麗的色彩!</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B83.png').default} /></div>
												<div className='btn_detail'><a id='btn_set83'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>新鮮的滋味揮別憂鬱系列</p>
												<p className='author'>作者：安譜<br />時長 168分鐘</p>
												<p id='fm_desc' className='all_txt'>早起很重要，清晨的第一口新鮮空氣是一天最棒的好福氣！好好吸一口，馬上清醒了！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B84.png').default} /></div>
												<div className='btn_detail'><a id='btn_set84'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>花裙子的微笑巴莎諾瓦放鬆時刻</p>
												<p className='author'>作者：安譜<br />時長 47分鐘</p>
												<p id='fm_desc' className='all_txt'>簡樸的南歐小鎮，平和的日子因為不知名的女孩搬入而充滿了奇想，會有什麼令人回味無窮的故事呢？</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B85.png').default} /></div>
												<div className='btn_detail'><a id='btn_set85'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>那天散步遇到你巴莎諾瓦放鬆時刻</p>
												<p className='author'>作者：安譜<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>咖啡、奶茶、曾經一起去的蛋糕店，在這樣的午後忽然成了一幅淡彩畫。朦朧之間，音樂響起，是那天一起跳舞的午後巴莎諾瓦，我又看到妳了！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B86.png').default} /></div>
												<div className='btn_detail'><a id='btn_set86'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>早安元氣幸福晨光序曲</p>
												<p className='author'>作者：安譜<br />時長 31分鐘</p>
												<p id='fm_desc' className='all_txt'>早安！剔透純淨的音樂，伴隨著清新的節奏，一天的開始是最美的時光，要開開心心喔！就是現在，今天出發吧！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B87.png').default} /></div>
												<div className='btn_detail'><a id='btn_set87'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>雙魚座舒眠好夢揮別憂鬱系列</p>
												<p className='author'>作者：安譜<br />時長 87分鐘</p>
												<p id='fm_desc' className='many_txt'>12星座睡覺時要伴隨什麼樣的舒眠音樂呢？
													白天，每一個星座的人，有著不一樣的煩惱方式，說晚安後，一定也需要不一樣的舒眠音樂！就讓安譜最精緻的舒眠音樂伴隨您進入夢鄉。這一集，就先請雙魚座的朋友們，舒舒服服進入夢鄉！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B124.png').default} /></div>
												<div className='btn_detail'><a id='btn_set124'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間5</p>
												<p className='author'>作者：李季準<br />時長 248分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準是台灣資深的廣播主持人，低沉磁性的嗓音，陪伴了許多聽眾度過無數個日夜。曾替絲襪廣告配音，經典台詞是「腰部以下，全部透明」，這句話，成為大家耳熟能詳的廣告用語!在廣播界，李季準以感性與多元播報內容，被譽為經典，過去曾5度獲得廣播金鐘獎榮譽，代表節目為感性時間，這是他上山下海親自採訪台灣各界人事物所精心製作的內容，並配上台灣民謠與音樂，讓節目內容更為豐富多元</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B125.png').default} /></div>
												<div className='btn_detail'><a id='btn_set125'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間4</p>
												<p className='author'>作者：李季準<br />時長 231分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準是台灣資深的廣播主持人，低沉磁性的嗓音，陪伴了許多聽眾度過無數個日夜。曾替絲襪廣告配音，經典台詞是「腰部以下，全部透明」，這句話，成為大家耳熟能詳的廣告用語!在廣播界，李季準以感性與多元播報內容，被譽為經典，過去曾5度獲得廣播金鐘獎榮譽，代表節目為感性時間，這是他上山下海親自採訪台灣各界人事物所精心製作的內容，並配上台灣民謠與音樂，讓節目內容更為豐富多元</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B126.png').default} /></div>
												<div className='btn_detail'><a id='btn_set126'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間3</p>
												<p className='author'>作者：李季準<br />時長 182分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準在台灣70～90年代，有「電台情人」之稱，「感性時間，祝您晚安！」這是李季準最廣為人知的招牌節目「感性時間」的問候語。1975年開播，一播出就超過20年歷史，吸引無數知音。節目內容以日常小事溝通情感、陶冶性靈為主，是不少夜貓子的心靈療癒妙方，更是李季準生平最費心盡力製作、經營最久的空中節目。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B127.png').default} /></div>
												<div className='btn_detail'><a id='btn_set127'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間2</p>
												<p className='author'>作者：李季準<br />時長 215分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準是台灣資深的廣播主持人，低沉磁性的嗓音，陪伴了許多聽眾度過無數個日夜。曾替絲襪廣告配音，經典台詞是「腰部以下，全部透明」，這句話，成為大家耳熟能詳的廣告用語!在廣播界，李季準以感性與多元播報內容，被譽為經典，過去曾5度獲得廣播金鐘獎榮譽，代表節目為感性時間，這是他上山下海親自採訪台灣各界人事物所精心製作的內容，並配上台灣民謠與音樂，讓節目內容更為豐富多元</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B128.png').default} /></div>
												<div className='btn_detail'><a id='btn_set128'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李季準的感性時間1</p>
												<p className='author'>作者：李季準<br />時長 209分鐘</p>
												<p id='fm_desc' className='many_txt'>李季準，台灣知名廣播及電視節目主持人，聲音富有磁性、低沉渾厚、極具魅力，於主持廣播《感性時間》、《知性時間》等節目期間，曾有「電台情人」之稱號被被譽為台灣第一代「電台情人」。其製作的節目，五度獲的廣播金鐘獎的肯定，第50屆台灣金鐘獎，李季準更獲得特別貢獻獎，以表彰對台灣廣播界的貢獻，”感性時間”節目是其代表性節目，提供聽眾許多台灣音樂與知性訪談的內容。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B129.png').default} /></div>
												<div className='btn_detail'><a id='btn_set129'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>提升女性豐滿UPUP</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B130.png').default} /></div>
												<div className='btn_detail'><a id='btn_set130'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>超級學習記憶</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B131.png').default} /></div>
												<div className='btn_detail'><a id='btn_set131'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>維持苗條體態</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B132.png').default} /></div>
												<div className='btn_detail'><a id='btn_set132'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>紓壓放鬆法門</p>
												<p className='author'>作者：鈺蓁<br />時長 34分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到傳遞正面訊息，內容純淨無暇，零壓力的聽覺享受，加強減壓幫助放鬆，學習正確放鬆的方法，享受徹底進入輕鬆的自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B133.png').default} /></div>
												<div className='btn_detail'><a id='btn_set133'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠中的瑜珈</p>
												<p className='author'>作者：鈺蓁<br />時長 65分鐘</p>
												<p id='fm_desc' className='many_txt'>順著雙腦同步的聲音訊號，溫和地引導你進入深沉而易接受的放鬆狀態。這時，你將聽到內容純淨無暇，零壓力的聽覺享受，宛如睡眠中的瑜珈，讓使用者進入最自然放鬆的睡眠狀態中，享受到瑜珈運動所帶來的身心健康愉悅的舒適感受，享受舒眠的快樂
													【使用方法】
													1聆聽過程最好使用耳機，以更好感受音聲導引雙耳波差的效果
													2聆聽過程請輕輕閉上眼睛並保持身體放鬆
													3聆聽前請深呼吸三次.音聲導引~雙腦同步，領先一步
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B134.png').default} /></div>
												<div className='btn_detail'><a id='btn_set134'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>牽爸媽的手自在到老</p>
												<p className='author'>作者：張曉卉<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>第一本照顧父母的有聲指南！
													當你對爸媽說，今晚我不回家吃飯、下個月我再回去看你時，他們正不停地老下去。
													無論現在他們多有活力，仍難逃老、病、死的劇本，你為心底時而閃過的那一天，做好準備了嗎？
													如同「育兒教養書」為兒女的成長做好準備，學習為長輩創造健康、圓滿的人生下半場，也有你一定該知道的幾件事。
													隨資深專業廣播人凌爾祥的聲音指引，學習陪伴、照顧長者，幫他們延緩退化、縮短臥床時間，讓為人子女的你，學習照顧父母，預約圓滿老年，牽爸媽的手自在到老，不留遺憾。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B135.png').default} /></div>
												<div className='btn_detail'><a id='btn_set135'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟星座成功學</p>
												<p className='author'>作者：季欣麟<br />時長 252分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，帶您以太陽、上升星座及水星、金星來帶你瞭解你在工作、事業、正財、偏財的運勢，並帶你從風水土火四象星座來提點你的事業成功致富的地雷，以及事業方面心想事成的方法，並帶你瞭解專屬於你的事業開運數字、開運顏色、開運物品、開運寶石、開運貴人，讓季欣麟為您解開12星座的事業及財富秘密，給你滿滿開運行動力，在你成功致富之路上，祝你一臂之力！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B136.png').default} /></div>
												<div className='btn_detail'><a id='btn_set136'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟星座幸福學</p>
												<p className='author'>作者：季欣麟<br />時長 254分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，帶您以太陽、上升星座剖析你的情人的愛情特質及特徵，從交往期到建立家庭，為您剖析星座情人的愛情觀、家庭觀以及看待親密關係的真正態度及想法，瞭解各星座情人的愛情地雷，以及如何做可以維持兩人感情穩定。此外，並以基本宮、固定宮、變動宮分類，量身打造星座情人的愛情攻略，瞭解星座情人在愛情中所想要的最終幸福泉源，更以金星與火星不同的特質，帶您認識星座情人的愛情、婚姻、愛情行動力與親密關係的屬性，讓季欣麟為您層層解開12星座情人的愛情密碼，拉長幸福保鮮期，助您在愛情幸福之路，走的更甜蜜順利，在情人心中立於不敗之地。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B137.png').default} /></div>
												<div className='btn_detail'><a id='btn_set137'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟的2020星座開運指南</p>
												<p className='author'>作者：季欣麟<br />時長 295分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，為您剖析在2020年12星座的事業、財富、感情、健康密碼！事業運勢如何提升？正財偏財如何取得？桃花將會如何開啟？健康狀況如何留意？還有事業財富及愛情開運的數字、顏色、物品、寶石、月份又將是甚麼？讓季欣麟為您帶來12星座在事業、財富、感情、健康各方面的指引；另外，根據2020年的星盤走勢，行星坐落在不同的宮位上又該如何趨吉避凶？讓季欣麟大師給您貼心叮嚀，指引你通往開運之路!!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B138.png').default} /></div>
												<div className='btn_detail'><a id='btn_set138'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>12星座孩子的教養攻略</p>
												<p className='author'>作者：季欣麟<br />時長 221分鐘</p>
												<p id='fm_desc' className='many_txt'>「適性而教」是現代教養的新觀念，身為父母，必須順著孩子的部份天生性格去教導、啟發他們，這樣「順水推舟」的教養原則，不但能夠在孩子成長的過程當中，達到事半功倍的效果，還可以在教養過程當中，增進良好的親子關係。
													主講者季欣麟老師深度研究星盤20多年，這次將以星座的角度，提供您12星座孩子的教養攻略，想要給孩子最好教育方式的你，可千萬別錯過了！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B139.png').default} /></div>
												<div className='btn_detail'><a id='btn_set139'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>陳德中引導正念冥想</p>
												<p className='author'>作者：陳德中<br />時長 117分鐘</p>
												<p id='fm_desc' className='many_txt'>正念風潮正在蔓延！
													讓台大醫院、廣達、台積電的正念訓練師資，帶你用正念揮別壓力與憂慮，找回穩定、自信與情緒自由！
													醫學界用正念幫助病人改善：
													慢性疼痛、焦慮、憂鬱、睡眠障礙，並增強免疫系統。

													企業界用正念幫助員工提升：
													專注力、情緒管理能力、復原力、創造力、領導力與人際溝通能力。

													教育界用正念幫助學生增強：
													學習效率與情緒平衡，並可優化大腦。

													你，也能用正念改善健康、工作與家庭生活！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B210.png').default} /></div>
												<div className='btn_detail'><a id='btn_set210'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠音樂3靜心安眠 </p>
												<p className='author'>作者：愛播聽書<br />時長 20分鐘</p>
												<p id='fm_desc' className='many_txt'>都市紛雜的快節奏，帶來慢性疲倦和精神緊張，暫且放下一切的執著，讓音樂重新幫你找回失去已久的自然睡眠，靜靜的享受如嬰兒般深度睡眠的樂趣......在甜美的夢鄉中，感受極度的放鬆與舒緩，現在，閉上眼睛，慢慢聆聽這美好樂音…… </p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B211.png').default} /></div>
												<div className='btn_detail'><a id='btn_set211'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠音樂2安心入眠</p>
												<p className='author'>作者：愛播聽書<br />時長 15分鐘</p>
												<p id='fm_desc' className='many_txt'>本音樂為渴望健康睡眠的人們，提供進入深度睡眠的有效方法。旋律輕柔、樂音委婉，營造特別的安寧平靜的氛圍，讓人放鬆，不會感到緊繃!希望在每個漫漫長夜，幫助每個人都能有個好夢。現在，閉上眼睛，慢慢聆聽這美好樂音……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B212.png').default} /></div>
												<div className='btn_detail'><a id='btn_set212'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>睡眠音樂1安枕無憂</p>
												<p className='author'>作者：愛播聽書<br />時長 15分鐘</p>
												<p id='fm_desc' className='many_txt'>我們利用情境音樂與精心創作的音符，為心靈準備了一趟迷人之旅，邀您展開心靈漫步;透過自然和諧的美妙音樂，釋放焦躁不安的情緒，產生內在詳和與安定感，最棒的睡眠音樂，帶你進入安枕無憂的好眠!現在，閉上眼睛，慢慢聆聽這美好樂音……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B213.png').default} /></div>
												<div className='btn_detail'><a id='btn_set213'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>8大紓壓睡眠放鬆方法</p>
												<p className='author'>作者：高尚美<br />時長 74分鐘</p>
												<p id='fm_desc' className='many_txt'>壓力是造成無法安眠的最大因素，抒壓放鬆，睡個好覺，是現代人關心的課題。本套抒壓助眠放鬆課程由專業心理諮商師高尚美設計，專為解決焦慮、憂鬱、失眠者所設計的,本課程廣受各大醫院、企業、社區機構好評，歡迎一起學習8大抒壓放鬆方法，只要8堂課，讓您一夜好眠到天亮，天天元氣過生活。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B214.png').default} /></div>
												<div className='btn_detail'><a id='btn_set214'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>正念減壓8堂課</p>
												<p className='author'>作者：石世明<br />時長 126分鐘</p>
												<p id='fm_desc' className='many_txt'>8堂課程結束後，當你回頭看自己寫的作業，每一個字都代表著你的練習經驗、你的進步，更重要的是你和生命對話，在癌症治療之後，你真正將時間給了「你」自己，透過這個歷程你一點、一滴地學習如何「疼惜自己」。
													第一課    擔憂無止盡：認識擔憂內在反應，與其建立不同關係。
													第二課    認出情緒漩渦：了解負向循環及慣性，學習同在模式。
													第三課    不再對自己射箭：覺察慣性反應模式和受苦根源，運用擔憂與不如意。
													第四課    以呼吸接納：回到當下，從自我疼惜行動轉換態度。
													第五課    身體掃描：體察身心變化與情緒關聯，以覺察回應壓力。
													第六課    正念傾聽：將同在模式進行溝通，體驗不同品質的人際互動。
													第七課    開發內在能量：透過呼吸與個人深度力量接壤，從心出發，給予他人祝福與關懷。
													第八課    正念走出新生活：將專注與覺察融入生活，建立新習慣。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B215.png').default} /></div>
												<div className='btn_detail'><a id='btn_set215'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>真逆齡有聲書</p>
												<p className='author'>作者：陳亮恭<br />時長 40分鐘</p>
												<p id='fm_desc' className='many_txt'>不到40歲就當上國際醫學期刊主編的高齡醫學專家陳亮恭醫師，爬梳國際間最新研究，提供令人振奮的健康增齡策略，釐清各種養生說法。現在用聽的也能健康逆齡。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B216.png').default} /></div>
												<div className='btn_detail'><a id='btn_set216'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>走出情傷你的未來充滿希望</p>
												<p className='author'>作者：Carol林嘉瑗<br />時長 218分鐘</p>
												<p id='fm_desc' className='many_txt'>課程介紹：
													你的心還在痛嗎？你的傷還忘不了嗎？你的苦沒有人知道嗎？如果你無法釋懷一段難忘的傷痛，讓我們一起來幫你快速的走出情傷吧！
													你不能釋懷的是什麼呢？曾經相愛的兩人，為何會反目成仇；曾經許下的未來，最後卻成空；曾經有過愛的記憶，如今卻成為心中的痛；曾經攜手建立的家，最後卻各奔西東。如果這些都放下了，還有什麼放不下呢？她/他對你精神上的傷害、言語上和身體上的暴力等等…，你能撫平傷痛，再往幸福的道路走下去嗎？
													不論你是感情受創、失婚男女或是單親爸媽，或是被拋棄的曠男怨女。或者長年陷在自責、後悔或自怨自艾之中的中年人，你在撫平情傷的道路上，找不到出口嗎？就讓Carol老師以她親身的經驗來告訴你，所有的傷痛都是一段你人生道路必要的提醒，它要告訴你的是，你必須要改變了、你必須要成長了。就如Carol老師所說 “若我此生來到世界的其中一個目的是學會『寬恕』，必然要有另一個靈魂同意扮演『加害者』的角色…… 。
													“我們每一個人都是一個奇蹟，要練習看到自己的美麗和燦爛。”-Carol Lin
													在這堂課，Carol老師將會以EFT情緒排毒敲拍的練習，來帶領每位學員釋放深藏在內心壓抑許久的情傷，轉換為重新燃起生命火花的動力，為自己的未來展開全新的一頁，讓美麗與燦爛照耀你深情的臉龐。
													PS: EFT(Emotional Freedom Techniques)，直接翻成中文，可以譯為情緒釋放技術。實際上，EFT現今在北美洲、歐洲及澳洲廣泛被心理學專家採用。世界各地亦有成千上萬來自不同背景的人士在日常生活上應用EFT減壓及解決情緒上的問題。
													EFT能在短短5-30分鐘之內，平靜個人情緒，如：恐懼、憤怒、悲傷、緊張及焦慮等。即使是非常嚴重的心理問題，在EFT的輔助之下，也能夠得到緩解。
													EFT的基本原理是以卡拉漢博士(Dr. Roger Callahan)的經絡心理學為基礎，透過輕敲身體的特殊穴位，能夠快速的解決各種狀況。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B217.png').default} /></div>
												<div className='btn_detail'><a id='btn_set217'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>建立和諧家庭必修的21堂課</p>
												<p className='author'>作者：賴佩霞<br />時長 202分鐘</p>
												<p id='fm_desc' className='many_txt'>明星級情商導師-賴佩霞，為了幫助更多在愛裏迷失的人，將所見所學，打造了21堂幸福必修課，教妳如何檢視自己，修復關系，進而能夠建立和諧的家庭生活，要讓妳重新在親密關系中，真實做自己，壹起建立幸福美滿的理想人生，現在開始，帶妳重新檢視家庭問題，停．看．聽 創造幸福好生活!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B218.png').default} /></div>
												<div className='btn_detail'><a id='btn_set218'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李建復告訴你成就一生的10個好習慣</p>
												<p className='author'>作者：李建復<br />時長 130分鐘</p>
												<p id='fm_desc' className='many_txt'>我們一直在找尋可以使人功成名就的速成方法!殊不知，”成功”近在眼前，只要稍微改變一下我們的生活習慣，就可以搭上成功列班車，培養10種生活好習慣，成功真的就在不遠處。現在讓李建復告訴你:成就一生的10個好習慣，讓你和成功不再擦肩而過，現在快付諸行動吧!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B219.png').default} /></div>
												<div className='btn_detail'><a id='btn_set219'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>生命的河流</p>
												<p className='author'>作者：陶曉清<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>《生命的河流》，她以自身為例，紀錄下與親朋好友曾發生過的衝突，巧妙運用她所學到的諮商理論，透過淺顯易懂的文字，讓大家能一目瞭然。希望透過生命河流的探索航行，可以幫助更多人加入尋找自我的行列。讓我們帶著一顆溫暖而平靜的心，繼續往下一站航行。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-5"><br /><br />
									<ul className="book">
										{/* html_book藝術人文 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B18.png').default} /></div>
												<div className='btn_detail'><a id='btn_set18'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>張艾嘉的音樂故事曖魅</p>
												<p className='author'>作者：張艾嘉<br />時長 76分鐘</p>
												<p id='fm_desc' className='many_txt'>東方人愛聽鄉野傳奇、西方人流行都市傳說，演出者與作曲家如何用聲音與音符述說這些精采故事，讓人聽得拍案叫絕又盪氣迴腸？
													愛情故事，向來為世人歌詠，那些千回百折的幽微心事，如何透過甜苦交織的幽幽訴說與百轉千回的曲調，讓人感同身受？
													張艾嘉的音樂故事，以鄉野傳奇為主軸，結合聲音演繹與古典樂曲，在音樂彈奏與視覺效果的演出中，不只能聽到魔性奇幻又刻骨銘心的經典樂曲名作，還能感受張艾嘉豐富多變的聲音表情以及鋼琴炫技的繽紛燦爛
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B72.png').default} /></div>
												<div className='btn_detail'><a id='btn_set72'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣答嘴鼓誰人甲你比</p>
												<p className='author'>作者：王一明、康康<br />時長 16分鐘</p>
												<p id='fm_desc' className='many_txt'>唸歌，講古，答嘴鼓， 台語三大說唱藝術。
													流行音樂跟傳統藝術也要跨界，來個斜槓合作！
													當康康遇見王一明， 當金曲獎最佳台語男歌手 遇上 金曲獎最佳戲曲曲藝專輯獎得主， 當綜藝天王主持一哥遇上廣播金鐘獎最佳綜合節目主持人，
													兩個老男人比來比去的，到底會比出什麼來?
													誰人甲你比！ 台灣答嘴鼓系列 2020 推出最新段目！ 我們比看看，也歡迎你來聽看看， 正宗台語相聲！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B75.png').default} /></div>
												<div className='btn_detail'><a id='btn_set75'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>李建復帶你重返我的民歌年代</p>
												<p className='author'>作者：李建復<br />時長 387分鐘</p>
												<p id='fm_desc' className='many_txt'>民歌是華人流行音樂的搖籃，不僅開啟了百花齊放的音樂創作方式，也真實反映當時的社會風氣與生活，在這次的節目裡，李建復邀訪各民歌時期的名家，經由這些音樂人的分享，帶你回到那些年一起抱著吉他唱歌的日子，唱響你的民歌時代。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B76.png').default} /></div>
												<div className='btn_detail'><a id='btn_set76'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>那些年那些人那些事都是我要講的故事</p>
												<p className='author'>作者：王正方<br />時長 259分鐘</p>
												<p id='fm_desc' className='many_txt'>塵起塵落後，溫暖又寂寞，王正方：「人生無非是緣聚緣散一場。」
													王正方，從一個美國教授、電機博士，一頭栽進電影圈，成為獨立製片的導演，他的電影，總是在刻劃真實人生；而他的真實人生，也彷彿在搬演電影。
													在他顛沛如光影的生命劇展裡，總有大時代的角色能與他來段對手戲，王正方用他慣常的幽默、灑脫、與細膩的人情味，說著自己與記憶中的那個人的故事，故事令人心神嚮往，那人讓你魂牽夢縈。
													『王正方：那些年、那些人、那些事…都是我要講的故事』專輯，集結了由王正方談他在人生路上所遇見的那些「精采有趣的人物、他所欽佩仰慕的前輩」，帶你發現王正方「憶中人」那些你所不知道的事。
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B77.png').default} /></div>
												<div className='btn_detail'><a id='btn_set77'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>泡沫</p>
												<p className='author'>作者：林隆璇<br />時長 35分鐘</p>
												<p id='fm_desc' className='many_txt'>人呢，經由眼耳鼻舌身去感受，再加上心的各種作用，形成了色受想行識五蘊。這五蘊看似堅實，實際上卻須臾變化不停，「觀色如聚沫，受如水上泡，想如春時焰，諸行如芭蕉，諸識法如幻。」如許深奧的道理，但有時我們剎那間又能明白。鋼琴王子林隆璇老師演奏了這九首曲目，都是堪布 竹清嘉措仁波切所創作的道歌，他以琴音洗滌現代人的迷惑，期許人人的智慧都能如花綻放。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B78.png').default} /></div>
												<div className='btn_detail'><a id='btn_set78'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>吉祥之光何等燦然</p>
												<p className='author'>作者：林隆璇<br />時長 30分鐘</p>
												<p id='fm_desc' className='many_txt'>天地之間最強靭的，是心的力量；宇宙之中最大的奇蹟，也是來自於心。因此再也沒有什麼事情，比認識自己的心更重要的了。這十首動聽的鋼琴曲目，由鋼琴王子林隆璇老師演奏堪布 竹清嘉措仁波切創作的道歌，奔放自由的音樂表情，來自於修心超過二十年的他，琴藝精湛且能隨心所欲。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B115.png').default} /></div>
												<div className='btn_detail'><a id='btn_set115'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶旅遊篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 64分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B116.png').default} /></div>
												<div className='btn_detail'><a id='btn_set116'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶音樂篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 74分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B117.png').default} /></div>
												<div className='btn_detail'><a id='btn_set117'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶生活篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 93分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B118.png').default} /></div>
												<div className='btn_detail'><a id='btn_set118'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶民俗節慶篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。臺灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的臺灣聲音為主軸，喚起臺灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B119.png').default} /></div>
												<div className='btn_detail'><a id='btn_set119'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶叫賣篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 88分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。台灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的台灣聲音為主軸，喚起台灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B120.png').default} /></div>
												<div className='btn_detail'><a id='btn_set120'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣聲音記憶人文自然篇</p>
												<p className='author'>作者：中央廣播電臺<br />時長 74分鐘</p>
												<p id='fm_desc' className='many_txt'>在我們生活周遭，有著無數的聲音。或許，在經常聽到這些聲音的時候，我們並不會有什麼特別感觸。不過，當時移事往，那些聲音，就成為記憶中的一部份，和我們的童年、少年、青年結為一體，無可分割。台灣有許多聲音，是永遠停留在人們生命深處的。當歲月流逝，那些記憶中的聲音卻會更加清晰的在心中響起，為童年的溫暖，青春的印記留下軌跡。本節目是以具本土性的台灣聲音為主軸，喚起台灣人共同的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B121.png').default} /></div>
												<div className='btn_detail'><a id='btn_set121'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>30個台灣地景故事</p>
												<p className='author'>作者：管家琪<br />時長 266分鐘</p>
												<p id='fm_desc' className='many_txt'>蘭嶼島為什麼叫做蘭嶼？半屏山是怎麼來的？基隆的仙洞以前為什麼叫白米壺？土地公為什麼在玉山山頂晒白銀？阿里山的姑娘真的美如水？管家琪以輕鬆、知性的說故事方式，告訴大家臺灣30個地景故事，讓我們知道臺灣在人文與地理景觀上的變化，同時了解臺灣、認識臺灣。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B122.png').default} /></div>
												<div className='btn_detail'><a id='btn_set122'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>他鄉故鄉</p>
												<p className='author'>作者：中央廣播電台<br />時長 659分鐘</p>
												<p id='fm_desc' className='many_txt'>「他鄉．故鄉」是一系列以陸配、外配、外勞和留學生為主角的廣播劇，他們都是普通人，沒有眩人的家世背景，甚至，生活在社會最基層，必須辛勤工作才能糊口，可是，他們靠著自己的努力，在這塊包容他們的土地上紮根，成長，開花，結果。把他鄉變成了故鄉，把自己活成讓人佩服的勇者。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B123.png').default} /></div>
												<div className='btn_detail'><a id='btn_set123'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>台灣記憶</p>
												<p className='author'>作者：中央廣播電台<br />時長 676分鐘</p>
												<p id='fm_desc' className='many_txt'>回溯歷史，許多臺灣人，臺灣事，都讓後人難以忘懷。「臺灣記憶」以人物為經，事件為緯，結合史實，用戲劇方式勾勒出三百多年以來臺灣史上的重要事件：鄭氏父子來臺、治臺；臺灣文化、教育、社會的發展；臺灣人在乙未戰爭和霧社事件中的英勇表現；日治時期臺灣人的反日本殖民運動等等。這些歷史，是臺灣永遠不可能遺忘的記憶。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B205.png').default} /></div>
												<div className='btn_detail'><a id='btn_set205'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聲動美術館</p>
												<p className='author'>作者：朱家綺、林育淳<br />時長 766分鐘</p>
												<p id='fm_desc' className='many_txt'>藝術生活化，生活藝術化，這是人類欣賞進而參與藝術的最終目標。無論是過去的經典作品或今日的現代創作，都是反映著每個時代的人類生活和社會狀況，「聲動美術館」希望藉由藝術作品穿越時空，從不同角度去了解成就現今社會局勢的歷史脈絡。
													本節目由央廣與台北市立美術館合作，結合專業的知識和故事的分享，讓聽眾可以對台灣畫家有基本且完整的認識之外，也希望藉此激發聽眾興趣，進一步主動欣賞畫家作品。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B206.png').default} /></div>
												<div className='btn_detail'><a id='btn_set206'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>世界名畫背後的故事</p>
												<p className='author'>作者：鄭治桂<br />時長 229分鐘</p>
												<p id='fm_desc' className='many_txt'>《世界名畫背後的故事》精選出這一生中一定要知道的20張世界名畫，由曾兩度擔任奧賽美術館的官方導覽，台灣知名的藝術評論家—鄭治桂教授親自導聆，帶你一探藝術大師們創作的歷程，看懂他們想傳達的意念。從巴洛克寫實派、浪漫派、分割派、印象派到立體派，鄭治桂要把這20張名畫帶給他的感動，一一復刻給你。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B207.png').default} /></div>
												<div className='btn_detail'><a id='btn_set207'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賴聲川的創作密碼小火慢燉的靈感</p>
												<p className='author'>作者：賴聲川<br />時長 114分鐘</p>
												<p id='fm_desc' className='many_txt'>賴老師說：「在我的個人經驗中，《如夢之夢》的創意過程特別適合拿來當案例討論，因為靈感顯現的過程特別明確、清晰，也因為親身經歷，我不用加以揣測，可以第一手經驗如實揭露。」
													八小時的超長時間、夢中夢的複雜故事、從上海到巴黎，從民國到現代的時空變換、還有「蓮花池」的沉浸式體驗……都成了這部戲的密碼。
													《如夢之夢》2000年首演，故事開始，演員圍繞觀眾演出，隨著故事發展，跟著講述人的情感入夢。這場大夢如今已經20年。
													新年伊始，從《如夢之夢》開始揭秘，紀念《如夢之夢》創作20周年。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B208.png').default} /></div>
												<div className='btn_detail'><a id='btn_set208'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>劇作家賴聲川上劇場丁乃竺戲劇對話錄</p>
												<p className='author'>作者：賴聲川<br />時長 79分鐘</p>
												<p id='fm_desc' className='many_txt'>借由《賴聲川劇作集》出版之際，華人劇場製作大咖、上劇場CEO丁乃竺對談劇作家賴聲川，二人首次集中分享包含《暗戀桃花源》《圓環物語》《紅色的天空》《十三角關係》《如夢之夢》《在那遙遠的星球，一粒沙》《如影隨行》《寶島一村》《水中之書》在內九部作品的創作故事。賴聲川和丁乃竺兩人，並分享了賴聲川分別作為“賴編劇”“賴導演”“賴先生”的有趣故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B209.png').default} /></div>
												<div className='btn_detail'><a id='btn_set209'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賴聲川創意戲劇學50講</p>
												<p className='author'>作者：賴聲川<br />時長 346分鐘</p>
												<p id='fm_desc' className='many_txt'>享譽國際的賴聲川導演，總是能夠創造出「精緻藝術」與「大眾文化」的稀有結合，將富有新意、深度內涵、生命反思及文化底蘊呈現於作品當中，進而創造新市場、新觀眾以及新文化創意產業。
													2006年，賴導出版多年創作的創意奧祕《賴聲川的創意學》一書。2011年，亦展開《賴聲川的戲劇學》戲劇研習大師班巡迴講學，將三十年的編劇、導演、即興創作心得與經驗和戲劇工作者分享。結合創意、編劇、創作、導演四大主線，講述從業30餘年的思考與智慧，幫你構建屬於自己的“創意金字塔模型”。 </p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-6"><br /><br />
									<ul className="book">
										{/* html_book財經企管 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B1.png').default} /></div>
												<div className='btn_detail'><a id='btn_set1'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>郝哥說書解讀50部必讀的投資經典一</p>
												<p className='author'>作者：郝旭烈<br />時長 73分鐘</p>
												<p id='fm_desc' className='many_txt'>郝哥，知名創投公司的執行合夥人、培訓超過一萬人的企業王牌財務講師， 從財經的經典重溫、必讀經典理財書、思考致富、生活實用、投資知識、投資實戰、 財富自由等七大財管類別中，精選出50本理財投資暢銷書。 在《郝哥說書》中，郝哥親自為你導讀每本書的精華重點， 同時加入實戰與顧問案例，以十五分鐘時間，帶入簡易方法來解讀作者觀點， 陪你從個人理財到企業經營，了解投資這件事， 讓理財投資書籍再也不艱澀難懂，還能成為你的生活好幫手，帶你邁向財富自由!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B20.png').default} /></div>
												<div className='btn_detail'><a id='btn_set20'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>黃子佼演藝圈的生存之道</p>
												<p className='author'>作者：黃子佼<br />時長 121分鐘</p>
												<p id='fm_desc' className='many_txt'>五光十色的演藝圈，看似豐富精彩，但背後所需要的付出與努力，絕對超乎眾人想像！黃子佼在演藝圈歷練三十年，從一開始的幫襯綠葉，到現在的一線主持人，當中所累積的豐厚經驗，對許多嚮往演藝工作新進後輩來說，可以說是相當珍貴的教材。然而，在黃子佼享受成功果實之前，其實也經歷過相當長時間的低潮期，後來，他靠著勤奮不懈的態度與隨時充足的準備，才從低谷爬起。至今，黃子佼在主持、音樂、歌唱、戲劇、電影…等領域，都有相當出色的成績。他自成一格的處世態度以及工作心法，想必非常值得你我學習。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B60.png').default} /></div>
												<div className='btn_detail'><a id='btn_set60'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>丁菱娟的職場哲學成為更好的自己</p>
												<p className='author'>作者：丁菱娟<br />時長 298分鐘</p>
												<p id='fm_desc' className='many_txt'>工作對您而言是什麼？是謀生溫飽？是鍛鍊成長？還是實現夢想的階梯？
													想在江湖生存，就得有一套磨練專業、經營人脈的場哲學。
													丁菱娟無私的以自身經驗與你分享：如何從菜鳥時期便能起步就定位？如何融入企業文化、如何搞懂職場處世？還有每人必學之向上管理。最後她說：「提升自己，永遠是最值得的投資。」
													因此，職場雖然充滿挑戰和荊棘，無論如何，相信學習與努力，必能成為更好的自己！進入職場，你不必走得快，但一定要走得遠。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B174.png').default} /></div>
												<div className='btn_detail'><a id='btn_set174'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>許倬雲說美國走向衰敗的大蘋果</p>
												<p className='author'>作者：許倬雲<br />時長 141分鐘</p>
												<p id='fm_desc' className='many_txt'>美國開國至今三百多年，從地區性的殖民政權，逐漸擴張成世界最大的自由市場和資本主義的國家，在經過兩次世界大戰後，更一躍成了世界第一霸權。不過近年來，美國漸漸從極盛的巔峰走向衰弱，各界開始湧入許多批判聲音：控訴美國文化的失落、遺失的美國精神、甚至是懷疑起國家制度設計上出現重大錯誤。此外，美國人民也開始歸罪於若干年來的政治現象，並以選票表達自己的不滿。政治上的變化，更加速了美國整體發展的不確定性。雖然，政治和經濟、文化等因素相較起來，是結果而非原因。不過錯的政治人物與政治機緣，的確會造就推波助瀾，使得加速衰敗的可能性。
													其實，美國這三百年來的變化，如同任何一個朝代一樣，有盛有衰，諸多因素都能影響到美國本身許多內部的變化，任何問題在每個階段的發展過程中，逐漸呈現出獨特的現象， 有好也有壞，但終究會出現一必然的結果。
													許倬雲教授從1957年赴美國念書開始，便以留學生的角度開始觀察美國社會現象。到了執教時期，更因為於四處演講授課的關係，累積了深厚的學術研究底蘊，此外，許教授不但從一個中國人，一個東方人的角度看美國，又在美國內部居住一甲子的時間，成為一個深度介入的美國居民。從中西兩邊角度相互對比，加上自己好奇心切，對於歷史、文化、社會觀察，皆有更進一步的認識。由他來為我們整理爬梳美國一路發展至今的歷程，再合適不過。
													許倬雲教授將其對美國一甲子的變化，其回憶和檢討，以有聲書的方式，化為十講。每一講談及其美國發展出現變化的特點，如何延伸到後代。既是按照時間的程序，也是按照他觀察到的現象陳述。在他提供的諸多線索當中，將會提供你做出更深入的推敲。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B175.png').default} /></div>
												<div className='btn_detail'><a id='btn_set175'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>頂尖CEO的乘法領導EMBA的二十堂領導課</p>
												<p className='author'>作者：方素惠<br />時長 154分鐘</p>
												<p id='fm_desc' className='many_txt'>環境快速變動，今天的領導人必須將吸收知識不斷成長，當作優先要務。學習已經不是一個選項，而是非這麼做不可。
													更重要的是，正因為領導的重點不在於主管本身，而是團隊成員，領導人不只要提升自我，還必須協助部屬成長，釋放整個團隊力量。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B176.png').default} /></div>
												<div className='btn_detail'><a id='btn_set176'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悅讀心旅行王文華開除自己的總經理</p>
												<p className='author'>作者：李悅心<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>走進城市悅動心節目主播李悅心的悅讀心旅行：
													不是介紹一本書或一部電影，而是透過書（電影）中的文字，去表達DJ李悅心對各種事物的領略與看法。本期主題王文華《開除自己的總經理》。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B177.png').default} /></div>
												<div className='btn_detail'><a id='btn_set177'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悅讀心旅行金質靈金帷純還在學2父女的人生問答題</p>
												<p className='author'>作者：李悅心<br />時長 49分鐘</p>
												<p id='fm_desc' className='many_txt'>走進城市悅動心節目主播李悅心的悅讀心旅行：
													不是介紹一本書或一部電影，而是透過書（電影）中的文字，去表達DJ李悅心對各種事物的領略與看法。本期主題金質靈、金帷純《還在學2-父女的人生問答題》。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B178.png').default} /></div>
												<div className='btn_detail'><a id='btn_set178'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悅讀心旅行金惟純還在學成功不是你想的那樣</p>
												<p className='author'>作者：李悅心<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>走進城市悅動心節目主播李悅心的悅讀心旅行：
													不是介紹一本書或一部電影，而是透過書（電影）中的文字，去表達DJ李悅心對各種事物的領略與看法。本期主題金惟純《還在學——人生不是你想的那樣》。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B179.png').default} /></div>
												<div className='btn_detail'><a id='btn_set179'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>賴佩霞快樂家不費力的領導</p>
												<p className='author'>作者：賴佩霞<br />時長 252分鐘</p>
												<p id='fm_desc' className='many_txt'>只有老闆、主管才需要領導力嗎？
													其實，領導力人人都需要、任何關係裡都需要，你可以領導自己的生命有所不同！
													幸福是人生終極追求，如果在家庭里中可以把親人心力朝着正向引導，轉變念頭，避免深陷不必要的負面糾葛；如果企業中的領導可以修正其不良習性，發揮影響力，為企業帶來無可限量的助益。
													如果，你也想擁有幸福領導力，讓每個場域都因你而離苦得樂。
													請從真實自我的人性根本出發，覺醒，覺知，讓自己成為愛的主體，不費力地快樂領導。
													如何經營快樂？如何擁有幸福領導力？
													讓高階領導人教練賴佩霞交給你這把密鑰，教你有效的幸福領導！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B180.png').default} /></div>
												<div className='btn_detail'><a id='btn_set180'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>向經典學戰略習戰術</p>
												<p className='author'>作者：李克明<br />時長 293分鐘</p>
												<p id='fm_desc' className='many_txt'>「經典」與生活息息相關，無論是戰場、商場、人際互動上的挑戰、人生難題，在「經典」中都可以找到解方，李克明博士以十多年公餘的時間勤學儒、道、法、兵、縱橫、釋各家經典，證以企管、法律專業訓練與實務經驗，穿插對應的西方觀念，整理出與現代人生活工作所面臨挑戰息息相關的道、神、聖、賢心性智慧。除實踐在自己做人處事上外，並將其以栩栩如生的方式推廣傳播出去，期能在中國人的社會中端正風氣、重振四維八德的價值觀，有朝一日推廣到全球。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B181.png').default} /></div>
												<div className='btn_detail'><a id='btn_set181'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>8分鐘提升領導力的21種方法</p>
												<p className='author'>作者：馬歇．葛史密斯<br />時長 189分鐘</p>
												<p id='fm_desc' className='many_txt'>事情交辦了，為什麼完全沒有進展？
													為什麼我的部屬不能像我一樣？誰是不可教練的人？
													從新手主管，到財星五百大企業CEO都常落入的陷阱，
													世界第一領導人教練葛史密斯給您，最深刻而直指核心的叮嚀。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B182.png').default} /></div>
												<div className='btn_detail'><a id='btn_set182'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>季欣麟星座成功學</p>
												<p className='author'>作者：季欣麟<br />時長 252分鐘</p>
												<p id='fm_desc' className='many_txt'>亞洲頂級星象大師季欣麟，帶您以太陽、上升星座及水星、金星來帶你瞭解你在工作、事業、正財、偏財的運勢，並帶你從風水土火四象星座來提點你的事業成功致富的地雷，以及事業方面心想事成的方法，並帶你瞭解專屬於你的事業開運數字、開運顏色、開運物品、開運寶石、開運貴人，讓季欣麟為您解開12星座的事業及財富秘密，給你滿滿開運行動力，在你成功致富之路上，祝你一臂之力！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B183.png').default} /></div>
												<div className='btn_detail'><a id='btn_set183'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>財富的秘密</p>
												<p className='author'>作者：林偉賢<br />時長 43分鐘</p>
												<p id='fm_desc' className='many_txt'>企業管理博士，實踐家知識管理集團董事長，《培訓》雜誌國際中文版創始人，中華教育訓練發展協會理事長，曼陀羅訓練的共同創辦人。專攻企業商業模式的林偉賢，把慈濟精神融入所教課程，即使一個人得花上超過30萬台幣的學費，還是讓企業家們趨之若鶩。全球最大電子商務網站、阿裏巴巴集團董事會主席馬雲，人稱「口才帝」，說話素來以幽默、直指要害、善於激勵而出名，也曾特地去上林偉賢的課。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B184.png').default} /></div>
												<div className='btn_detail'><a id='btn_set184'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>別人的情緒你讀懂了嗎</p>
												<p className='author'>作者：啟點文化<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>回應≠回話，你習慣回答的是別人的表面訊息？還是心理期待？
													小小的差別，卻有大大的影響。
													一個人的命運，是他回應力的總和。
													Response ＋ ability ＝Responsibility
													有專業，再加上有人味，才能讓你更上一層樓！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B185.png').default} /></div>
												<div className='btn_detail'><a id='btn_set185'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>為什麼讀書</p>
												<p className='author'>作者：啟點文化<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>如果問你為什麼吃飯？你怎麼選擇要吃什麼？
													可能你會覺得有點莫名其妙，
													餓了就吃，喜歡吃就吃，哪有這麼多為什麼。
													同樣的邏輯，我們能不能放在閱讀身上？
													因為單純的想讀文字，所以讀書，
													因為單純的喜歡這類型的作品，所以啃書。
													讀書，從來都是自私的。
													作者一句簡單但犀利的話，
													是一種體恤，讓我們不需要有個冠冕堂皇的理由，
													可以更輕鬆、更自在地靠近任何一本書，
													只要你想讀。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B186.png').default} /></div>
												<div className='btn_detail'><a id='btn_set186'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>為什麼我們經常誤解人心</p>
												<p className='author'>作者：啟點文化<br />時長 29分鐘</p>
												<p id='fm_desc' className='many_txt'>你會想要擁有「讀心術」嗎？你想要一眼就看穿別人在想什麼嗎？
													其實，當你有這個念頭時，你就踏入「誤解」的陷阱中。
													作者用許多研究證明，人總是活在「自以為是」的習慣中，
													以至於我們對他人的理解，往往是片面、零碎的。
													如何能真正認識人？
													不再被「以為」，這個世界上最曖昧可怕的字眼給綁架，
													你將在此書中得到完整的解答。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B187.png').default} /></div>
												<div className='btn_detail'><a id='btn_set187'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>好人怎麼會幹壞事</p>
												<p className='author'>作者：啟點文化<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>小時候，老師說只有壞人才會做壞事，
													但長大後，卻發現把事情做壞的，通常是自以為是好人的人。
													到底哪裡出問題了？才會讓好人幹了壞事還不自知。
													其實，你我心中都有可能藏著許多心智臭蟲，
													讓我們不小心對世界產生的偏見。
													但透過「內隱關聯測驗」（IAT），你有機會檢測一下自己，
													到底有沒有自己想像的好？
													測驗很刺激，請小心服用喔！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B188.png').default} /></div>
												<div className='btn_detail'><a id='btn_set188'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>說故事的領導</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>人，很喜歡聽故事，但到底故事是什麼？
													故事一定要用「從前從前」開頭嗎？
													人物角色怎麼樣才算有特色？
													要讓主角做什麼事情，故事才會好聽呢？
													可以把平常對話的內容記錄下來，直接變對白嗎？
													這些答案在書中都有完整的說明，
													而且當你能把自己的故事講好，你就能改寫自己的命運，
													讓生命看見不同的風景。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B189.png').default} /></div>
												<div className='btn_detail'><a id='btn_set189'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>吵架讓我倆明天會更好</p>
												<p className='author'>作者：啟點文化<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>覺得吵架很累嗎？
													害怕吵架會讓感情變糟嗎？
													很有可能是因為你“吵錯架”了。
													你只處理表面的問題，而沒有滿足背後的需要。
													好好的吵，是一種真心誠意的探險，
													理解彼此真正的在乎。
													來吧！趕緊收聽這段對談，看看自己到底吵錯了什麼？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B190.png').default} /></div>
												<div className='btn_detail'><a id='btn_set190'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>每天最重要的2小時</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>常常覺得時間不夠用嗎？
													明明一直忙個不停，可是成就感卻沒有提升？
													像個陀螺般打轉，不敢怠慢，效率卻沒有提升？
													其實，你不需要怕分心，只要你知道如何管理你的心智狀態。
													放自己一馬，才有機會再次快馬加鞭。
													簡單五策略，打造2小時高效率工作狀態，讓你不用再瞎忙。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B191.png').default} /></div>
												<div className='btn_detail'><a id='btn_set191'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>創造力</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>你有想做的事情嗎？
													可能是寫作、歌唱、攝影、料理、繪畫⋯⋯，
													你知道在創作的路程上會遭遇哪些挑戰？又該如何面對嗎？
													很多人都有創作的慾望，卻常常被許多莫名的小聲音給淹沒，
													我寫得不夠好？沒靈感怎麼辦？別人會怎麼說？會不會賣？
													這些問題伊莉莎白.吉兒伯特都遇過，更在自己的書《享受吧！一個人的旅行》大賣後，沒有被成功壓垮。
													就讓經驗豐富的伊莉莎白來告訴你，如何健康的面對創作？你該怎麼想，才不會把自己卡住？讓你所熱愛的事情，持續為你帶來快樂。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B192.png').default} /></div>
												<div className='btn_detail'><a id='btn_set192'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>精準表達</p>
												<p className='author'>作者：啟點文化<br />時長 27分鐘</p>
												<p id='fm_desc' className='many_txt'>你有聽過無聊的畢業致詞嗎？
													明明是結婚典禮，搞得像佈道大會？
													開會像馬拉松一樣漫長，讓人無力？
													這些都是可以避免的，作者累積的數年的實務經驗，
													告訴你“精準”，不是自己講的爽，
													而是在對的時刻，以對的語氣，向對的人傳達對的訊息。
													同時，書中也提到哪些習慣是不良的表達？
													容易讓人昏昏欲睡、逃之夭夭。
													掌握重要關鍵，你也可以一開口就抓住所有人的耳朵。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B193.png').default} /></div>
												<div className='btn_detail'><a id='btn_set193'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>做自己的生命設計師</p>
												<p className='author'>作者：啟點文化<br />時長 32分鐘</p>
												<p id='fm_desc' className='many_txt'>我們常常會愛上第一個想到的主意，然後拒絕放手。
													生涯卡住，是因為我們常常問錯問題，在爬坡時，抱怨重力太大，讓自己無法輕鬆。花許多時間試圖解決重力問題，而不是想辦法讓自己變輕。
													當你懂得運用設計師的思維，重新定義你真正該解決的問題，也許你會發現答案其實很簡單，你不需要換工作、取得新學位才能過上精彩的人生。
													設計師只處理能解決的問題，同樣的，面對人生，你又把時間花在哪裡了呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B194.png').default} /></div>
												<div className='btn_detail'><a id='btn_set194'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>情緒勒索</p>
												<p className='author'>作者：啟點文化<br />時長 31分鐘</p>
												<p id='fm_desc' className='many_txt'>你常常為了滿足別人，而讓自己委屈嗎？
													為了不被別人討厭，你情願討厭自己？
													當你企圖透過別人給你認同感，以換取對方需要的安全感，
													你們之間的交易就已經完成，你成為失去自由的俘虜，
													一起共構出一段不平等的關係。
													希望透過這本書，能協助你辨識出關係中的綁匪，同時避免自己被勒索。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B195.png').default} /></div>
												<div className='btn_detail'><a id='btn_set195'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>讓顧客的錢自動流進來</p>
												<p className='author'>作者：啟點文化<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>世界上最困難的事情，
													就是把觀念放到別人腦袋，
													把對方的錢放在自己口袋。
													要如何不只讓客戶心甘情願掏錢，而且還不只一次，
													能夠持續付下去。
													作者建議把客戶變訂戶，就能定期掏錢，一消費就是好幾年。
													想知道如何做到嗎？趕緊收聽這段有聲書評。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B196.png').default} /></div>
												<div className='btn_detail'><a id='btn_set196'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>你的善良必須有點鋒芒</p>
												<p className='author'>作者：啟點文化<br />時長 26分鐘</p>
												<p id='fm_desc' className='many_txt'>人說「聰明是天賦，善良是選擇」
													既然是選擇，你把善良留給誰就變得相對重要了。
													你是否會常常委屈自己，只為了成就別人口中的「好人」
													為朋友兩肋插刀，可心裡頭卻期盼有一天，對方也會如此對你。
													當你勉強自己幫助別人時，你就會落入交換的圈套，
													只要對方做的跟你想的不一樣，便覺得不值得。
													最後賠上一段珍貴的關係。
													其實，你可以活得不這麼憋屈的，只要你懂得什麼才是真正重要的善良！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B197.png').default} /></div>
												<div className='btn_detail'><a id='btn_set197'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>人類還在玩猿猴把戲</p>
												<p className='author'>作者：啟點文化<br />時長 24分鐘</p>
												<p id='fm_desc' className='many_txt'>你知道狒狒在問候彼此時，會握住彼此的睪丸嗎？
													其實，人類也會做類似的事情，並沒有比較高尚喔！
													許多你現在覺得是“文明”衍生出來的社交行為，
													在猿猴身上都可以找到相同的行為模式。
													科技改變我們生活方式，卻沒有改變人性，
													拿掉無可救藥的優越感吧！說不定，你會活得比較自由。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B198.png').default} /></div>
												<div className='btn_detail'><a id='btn_set198'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>用心表達做好人際溝通</p>
												<p className='author'>作者：方信智<br />時長 78分鐘</p>
												<p id='fm_desc' className='many_txt'>擁有極具說服力的人際表達能力，是決定是否能夠受到顧客歡迎，甚或是個人在職場成敗與否，最關鍵的核心因素！因此，透過對人性的充分了解，學會如何「將心比心」給對方他最需要的，而不是我們認為最好的，來贏取認同與合作。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B199.png').default} /></div>
												<div className='btn_detail'><a id='btn_set199'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>溝通魔法師</p>
												<p className='author'>作者：中國生產力中心<br />時長 56分鐘</p>
												<p id='fm_desc' className='many_txt'>「說服」不是高超的說話技巧，而是卓越的動機給予和決策協助。本影碟帶領您瞭解「說服」的四大步驟─確定方向、引發動機、引導決策、再次確認，利用神經語言程式學的技巧，讓您的意見或點子無法被忽視，充分發揮影響力。
													2-1 如何讓說服更具吸引力
													2-2 說服中的引導與決策</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B200.png').default} /></div>
												<div className='btn_detail'><a id='btn_set200'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>贏得好的關係塑造你的親和力</p>
												<p className='author'>作者：中國生產力中心<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>以神精語言程式學（Neuro-Linguistic Programming; NLP）為基礎，解析親和能力到底是如何產生的？如何經由簡單的呼應，以及臨摹溝通對方的表情、肢體、聲音，來建立良好互動關係，輕鬆塑造人際好關係！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B201.png').default} /></div>
												<div className='btn_detail'><a id='btn_set201'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>人際溝通</p>
												<p className='author'>作者：中國生產力中心<br />時長 158分鐘</p>
												<p id='fm_desc' className='many_txt'>利用訊息傳播原理，教導您從開口之前到說話的結束，該注意那些訣竅。學習如何由一個原本孤獨的個體，具備深層而細膩的溝通技巧，如何像一面鏡子一樣，忠實反映出對方所講的事實與感情，及如何擬定溝通策略。
													5-1說話的技巧
													5-2聽的藝術
													5-3回饋與抉擇
													5-4溝通策略的分析運用（上）
													5-5溝通策略分析運用（下）</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B202.png').default} /></div>
												<div className='btn_detail'><a id='btn_set202'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>文明自然和科技的三角關係</p>
												<p className='author'>作者：曹興誠<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>科學是我們對客觀世界的精確了解；技術是解決問題或製造的方法，不管是科學或是技術的進步，都會改變人類生態及人文之間的關係。--曹興誠,如是說..
													科技與人文間，如何達到平衡?自然和科技，如何達到共生、共利、共享的境地？曹興誠以其科技人的理性與收藏家的感性，細說自然、科技與文明三者之間的箇中智慧，細細剖析平衡之道</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B204.png').default} /></div>
												<div className='btn_detail'><a id='btn_set204'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>夏韻芬的親子理財課</p>
												<p className='author'>作者：夏韻芬<br />時長 207分鐘</p>
												<p id='fm_desc' className='many_txt'>從小讓孩子養成正確的金錢觀，懂得愛惜物力，留錢給孩子，無法成全孩子的財富，正確的做法，就是教他面對金錢的態度，以及學習處理金錢的本事，讓孩子可以靠自己的能力經營自己的生活，這才是父母給與子女的真正資產。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-7"><br /><br />
									<ul className="book">
										{/* html_book佛教 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B102.png').default} /></div>
												<div className='btn_detail'><a id='btn_set102'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>信仰與命運</p>
												<p className='author'>作者：聖嚴法師<br />時長 155分鐘</p>
												<p id='fm_desc' className='many_txt'>聖嚴法師作品《信仰與命運》。聖嚴法師，佛學大師、教育家、佛教弘法大師、日本立正大學博士，也是禪宗曹洞宗的第五十代傳人、臨濟宗的第五十七代傳人、臺灣法鼓山的創辦人。聖嚴法師，1930年出生於中國江蘇省南通縣，13歲出家，青年時期留學日本，1975年獲日本立正大學文學博士學位。回臺灣後，聖嚴法師歷任臺灣中國文化大學教授，中華學術院佛學研究所所長，美國佛教會副會長及譯經院院長，創辦中華佛學研究所，發行佛學學報及佛學研究年刊，為輔大、政大、文大博士及碩士研究生擔任論文指導。又創辦法鼓山國內外禪修，文教、慈善體系的人文社會大學、僧伽大學、僧團道場、七個基金會、中英文四種定期刊物。他以中、日、英三種語文在亞、美、歐各洲出版的著作近百種。他的著作之中發行量最多的是《正信的佛教》，已超過三百萬冊，譯本最多的是《信心銘》，已有十種，系列冊數最多的是[寰遊自傳]及[禪修指引]，這些著述均受廣大讀者的歡迎。聖嚴法師所推動的理念是，提升人的品質，建設人間淨土，以教育完成關懷任務，以關懷達到教育目的。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B152.png').default} /></div>
												<div className='btn_detail'><a id='btn_set152'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>法螺之聲</p>
												<p className='author'>作者：德謙讓卓（堪布竹清嘉措仁波切）<br />時長 76分鐘</p>
												<p id='fm_desc' className='many_txt'>這輯《法螺之聲》收錄十七首德謙讓卓的歌訣寶藏，每一支歌即是一篇精華教法，透過歌唱禪修，不但可以調伏粗重的煩惱習氣，還能夠細微地轉化自己的情緒與覺察，學習以柔軟平和的心境，來面對無常的大千世界，開展無盡的本然智慧。
													德謙讓卓（堪布竹清嘉措仁波切）是當今噶舉派至為珍貴的長老教師之一，擅長以金剛道歌來教導弟子。在他的課堂上，如珍寶一般的口訣和心要，由他證悟的心流中自然而出，弟子們在加持之下即席譜成歌曲傳唱。這也是金剛乘無間斷的傳承教法之一，至今依然鮮活、強而有力。
													堪布仁波切教導說：「金剛道歌」的修持有三種方式：第一種：專注在聲音上盡情唱誦。第二種：思維或禪修歌詞的意義。第三種：直接安住在心性中。若能以這三種方式來聆賞或學唱這些金剛歌，就是一種修持了。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B154.png').default} /></div>
												<div className='btn_detail'><a id='btn_set154'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>悲心祈願</p>
												<p className='author'>作者：德謙讓卓（堪布竹清嘉措仁波切）<br />時長 25分鐘</p>
												<p id='fm_desc' className='many_txt'>德謙讓卓（堪布竹清嘉措仁波切）是當今噶舉派至為珍貴的長老教師之一，擅長以金剛道歌來教導弟子。在他的課堂上，如珍寶一般的口訣和心要，由他證悟的心流中自然而出，弟子們在加持之下即席譜成歌曲傳唱。這也是金剛乘無間斷的傳承教法之一，至今依然鮮活、強而有力。
													這一輯《悲心祈願》，主要收錄了德謙讓卓在弘法旅途中，在節慶之日或弟子們的請求下，對於情器世間莊嚴的祈願，以溫暖的大悲心，帶給弟子們光明的大信心。適合經常唱誦，提振我們的正能量。
													堪布仁波切教導說：「金剛道歌」的修持有三種方式：第一種：專注在聲音上盡情唱誦。第二種：思維或禪修歌詞的意義。第三種：直接安住在心性中。若能以這三種方式來聆賞或學唱這些金剛歌，就是一種修持了。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B155.png').default} /></div>
												<div className='btn_detail'><a id='btn_set155'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>正念行持歌</p>
												<p className='author'>作者：德謙讓卓（堪布竹清嘉措仁波切）<br />時長 35分鐘</p>
												<p id='fm_desc' className='many_txt'>和一般流行音樂不一樣，「金剛歌」是出世間的歌曲，最早源自於印度，瑜伽士透過歌曲來傳達見地、體驗，或者是守護他的覺證。因此唱金剛歌最好同時思維詞義，或者，心也配合著修持，以此達到禪修、增加信心與了悟。
													德謙讓卓（堪布竹清嘉措仁波切）是當今噶舉派至為珍貴的長老教師之一，擅長以金剛道歌來教導弟子。在他的課堂上，如珍寶一般的口訣和心要，由他證悟的心流中自然而出，弟子們在加持之下即席譜成歌曲傳唱。這也是金剛乘無間斷的傳承教法之一，至今依然鮮活、強而有力。
													這一輯《正念行持歌》，主要收錄了德謙讓卓對於弟子們日常生活的提醒，這些口訣和心要，對於在都會中生活、工作的人們特別相應。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B156.png').default} /></div>
												<div className='btn_detail'><a id='btn_set156'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>身安心安禪安</p>
												<p className='author'>作者：聖嚴法師<br />時長 149分鐘</p>
												<p id='fm_desc' className='many_txt'>禪修的境界令人嚮往，禪法的修行卻常讓人覺得難以企及，望之興嘆。本次講座
													，聖嚴法師闡明甚麼才是正確的禪法修行，以及如何將禪修的觀念和方法，運用
													在日常生活之中。
													聖嚴法師更進一步歸納出，以禪法來安住身心的四個層次，使現代人能在簡明清
													晰的指引下，循序漸進，拾級而上，在禪修中獲得安定身心，安家、安業的利益</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B157.png').default} /></div>
												<div className='btn_detail'><a id='btn_set157'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>普賢行願品</p>
												<p className='author'>作者：郭蘅祈<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>「開經偈」指念經前所念誦的四句偈，其偈文是“無上甚深微妙法，百千萬劫難遭遇，我今見聞得受持，願解如來真實義。”這首偈的由來，據說是武則天做皇帝時，由於武則天是虔誠的佛教徒，她對於華嚴經非常地愛好。就題了這四句“開經偈”。
													「普賢行願品」：普賢，所謂「道遍宇宙曰普，德鄰極聖曰賢」，意思是他的道遍滿宇宙，他的德行和最高尚的聖人是一樣的，和最高尚的聖人作鄰居了。行願品，「行」是他修行的大行；「願」是他所發的願。普賢菩薩修行發的行願是最大的，所以叫大行普賢菩薩。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B158.png').default} /></div>
												<div className='btn_detail'><a id='btn_set158'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聖嚴法師佛曲集</p>
												<p className='author'>作者：法鼓文化<br />時長 48分鐘</p>
												<p id='fm_desc' className='many_txt'>以聖嚴法師深刻雋永的智慧法語，由音樂界各菩薩發心譜曲，法鼓山僧團及法鼓山成人學佛合唱團共同演唱，十首佛曲作品意境各有不同，時而寬廣契闊，時而輕快活潑。經過五個月的籌備時間，從選曲、練唱，到進錄音室，史上難得法師參與錄製的佛曲音樂作品終於完成!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B159.png').default} /></div>
												<div className='btn_detail'><a id='btn_set159'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聽見菩薩</p>
												<p className='author'>作者：法鼓文化<br />時長 39分鐘</p>
												<p id='fm_desc' className='all_txt'>在紅塵最繁華處，聽見菩薩最深的慈悲，守護每一顆心。
													獻給　每一顆在紅塵中行走的心靈
													「菩薩在哪里？在心裏。」──聖嚴法師</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B160.png').default} /></div>
												<div className='btn_detail'><a id='btn_set160'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我為你祝福</p>
												<p className='author'>作者：法鼓文化<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>聖嚴法師以其睿智的文字，編寫四首意趣深遠且蘊含悲願的現代歌詞；青年音樂創作家王建勛先生則以溫馨、活潑的音樂手法，為這四首佛曲賦予多元的現代風貌。
													在這緊張繁忙、人我疏離的現代社會，相信這不一樣的聲音，將能讓你我拋開煩惱，將身心安住於清涼而智慧的佛法海音之中。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B161.png').default} /></div>
												<div className='btn_detail'><a id='btn_set161'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>華嚴經淨行品</p>
												<p className='author'>作者：聖嚴法師<br />時長 224分鐘</p>
												<p id='fm_desc' className='many_txt'>《華嚴經》在中國佛教史上非常重要，也廣為流傳，在中國三種翻譯，《淨行品》是晉譯六十卷，《華嚴經》的第七品。由智首菩薩向文殊菩薩請示，使身口意三業得清淨的方法，而文殊菩薩回答智首菩薩的問題，就是《淨行品》全品的內容。淨，是清淨，就是不染汙，佛法特別重視身口意三種行為，也就是由心理的狀態，影響我們的語言行為和身體行為。身口意三業的或善或惡，能夠使我們在生死輪回之中上升或下降；能夠使我們從生死輪回得到解脫；也能夠使我們在生死之中廣度無量眾生，成就無上菩提。《華嚴經淨行品》要我們把貪、嗔、癡三毒的身口意三業，轉變為修行戒定慧三學的身口意三業，從苦海到彼岸而得解脫，成就菩薩道，終能成佛。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B162.png').default} /></div>
												<div className='btn_detail'><a id='btn_set162'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>觀世音菩薩</p>
												<p className='author'>作者：白銀<br />時長 93分鐘</p>
												<p id='fm_desc' className='all_txt'>詳述和娑婆世界眾生， 特別有緣的觀世音菩薩， 其出典、 道場、 示現、 形像、 法門等考證。</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B163.png').default} /></div>
												<div className='btn_detail'><a id='btn_set163'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>佛說阿彌陀經</p>
												<p className='author'>作者：聖嚴法師<br />時長 124分鐘</p>
												<p id='fm_desc' className='many_txt'>善導大師說：“如來所以與出世，唯說佛陀本願海。”大多數佛經都是釋迦牟尼佛應請法者而說，只有《阿彌陀佛》是釋迦牟尼佛見此世界眾生機緣成熟，可以接受此種不分根器皆能得度的圓融法門而無問自說。《阿彌陀經》又名《一切諸佛所護念經》，任何人只要持誦這部經、念阿彌陀佛名號，等於念了一切諸佛，就受到一切諸佛的讚歎和護持。這部經介紹西方極樂世界的國土莊嚴，以及阿彌陀佛的功德莊嚴，同時也說明了往生極樂淨土的修行方法。釋迦牟尼佛在經中多次勸請眾生“應當發願，願生彼國”，所以念佛法門不僅是淨土宗才修，而是所有宗派都在修。念佛念到一心不亂，不僅臨命終時會見到阿彌陀佛前來接引，也將了悟現世之中，人的生老病死、物的興衰起落，種種現象就像是在極樂世界一樣，即使禽鳥鳴叫、微風吹動，都是在為我們訴說、演示著微妙甚深的佛法。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B164.png').default} /></div>
												<div className='btn_detail'><a id='btn_set164'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>佛說盂蘭盆經</p>
												<p className='author'>作者：聖嚴法師<br />時長 243分鐘</p>
												<p id='fm_desc' className='many_txt'>《佛說盂蘭盆經》由西晉竺法護翻譯，屬方等部經典。“盂蘭盆”的梵文Ullambamna，中文的意譯為“就倒懸”。梵文的倒懸，主要是形容墮惡道的眾生，由於內心顛倒，而經常受苦，此經即是講述救度在餓鬼道中父母的法門，被視為佛經著名的孝經。佛陀大弟子目犍連，為了解救墮餓鬼道的母親，向佛請法，佛開示於七月十五日，在僧侶安居修行三個月滿之後，以種種衣服飲食供僧，仰仗僧侶自恣的戒德清淨，解救眾生倒懸之苦，即可令其母脫離苦難。依本經之說行之盂蘭盆會，已普遍流行於民間，因此，民俗信仰以中元為鬼節，跟《盂蘭盆經》有很大的關係。此經配合著民俗信仰及孝道思想，貼切著每一個人，與我們生活息息相關，因此受到重視、流傳與弘揚。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B166.png').default} /></div>
												<div className='btn_detail'><a id='btn_set166'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>普賢菩薩行願贊</p>
												<p className='author'>作者：聖嚴法師<br />時長 261分鐘</p>
												<p id='fm_desc' className='many_txt'>《普賢菩薩行願贊》，唐代不空三藏翻譯，每句七字，每四句一頌，共有六十二頌。《華嚴經》是經中之王，介紹大乘菩薩修行的十種次第，而普賢行願就是《華嚴經》最精華的核心內容，可視為其心要。普賢的梵文是samantabhadra，又譯為“遍吉”，代表著普通存在任何一個地方，而能使眾生得益的大菩薩；普賢菩薩在《華嚴經》與《法華經》都有極為重要的低位，在諸大菩薩具足的“悲、智、願、行”四種條件之中，普賢菩薩代表著大修行成就，與代表無上智慧的文殊菩薩關係密切，兩位菩薩德行的配合，象徵著大乘精神最究竟的完成。普賢行願的精神是“以願遵行，以行踐願”，“願”是發起上求佛道、下度眾生的心願；“行”是照著佛法所示而實踐菩薩行。如欲修行大乘佛教，應行菩薩行、求一切智，成熟一切眾生，隨順無上菩提，圓滿普賢行願海。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B167.png').default} /></div>
												<div className='btn_detail'><a id='btn_set167'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>觀世音菩薩普門品</p>
												<p className='author'>作者：聖嚴法師<br />時長 153分鐘</p>
												<p id='fm_desc' className='many_txt'>觀世音菩薩可說是最受人們歡迎，也是與中國最有緣的一尊菩薩。許多人被他的無量慈悲心感化，因而願做觀世音的千手千眼，與菩薩一起護航眾生平安。《普門品》主要為介紹觀世音菩薩名號由來，以及他以三十三種化身廣度眾生，免除水、火、風、刀杖、惡鬼、幽襲、險路七難，脫離貧、嗔、癡三毒，並應求男、求女二種祈求。觀世音菩薩的弘誓深如海，只要一心稱念他的名號，菩薩便會立即聞聲救苦，助人化險為夷。如果我們遇到任何人，不管是得到幫助或受到打擊，當能感恩這些讓我們成長的助緣，災難便不再是災難，而是觀世音菩薩的化身示現。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B168.png').default} /></div>
												<div className='btn_detail'><a id='btn_set168'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>金剛經如是說</p>
												<p className='author'>作者：聖嚴法師<br />時長 160分鐘</p>
												<p id='fm_desc' className='many_txt'>《金剛經》全文五千八百餘字，篇幅雖短，卻是哲理豐富。在般若經典中，受到普遍持誦的程度僅次於《心經》。“金剛”梵語意思是指質地最堅最利之物，擁有“不為一切所摧，而能破一切”且堅利之質本來具足的特性。用來譬喻人的般若智慧不因平富貴賤、聰明愚昧而有差別，只是被私心所生的煩惱遮蔽。如何降伏心中的煩惱？《金剛經》說：“菩薩于法，應無所住，行於佈施”。意指與人互動不氣分別態度，不惦念佈施的行為、財務，不在乎自我的利害得失，時時抱持助人離苦得樂的慈悲心，就能降伏執著、煩惱，這就是《金剛經》所說的無住智慧。以無住的智慧融會運用在日常生活中，將為生命開啟究竟的自由圓滿。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B169.png').default} /></div>
												<div className='btn_detail'><a id='btn_set169'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>地藏菩薩本願經</p>
												<p className='author'>作者：聖嚴法師<br />時長 189分鐘</p>
												<p id='fm_desc' className='many_txt'>《地藏菩薩本願經》是地藏法門的入門經典，以優美的文字介紹地藏菩薩的大願法門，也是引領眾生從凡夫到成佛的指南。地藏菩薩為眾生負載一切苦難，猶如大地孕育眾生，能夠蘊藏萬物，讓眾生取之不盡、用之不竭，這也正是地藏菩薩名為“地藏”的原因。他修行的功德圓滿，早與佛等齊，但卻發願度盡六道眾生之後，始願成佛：“地獄不空，誓不成佛；眾生度盡，方登菩提。”依著這樣的願力，不斷廣度眾生。地藏菩薩的大願法門非常殊勝，而且容易修持，我們一方面可學習他廣度眾生的願力，另一方面則可誦持地藏菩薩的名號、經典，並且修持他的懺悔除障之法門，使所有眾生都能化解一切罪業，自在無疑。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B170.png').default} /></div>
												<div className='btn_detail'><a id='btn_set170'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>祈普行心靈系列3</p>
												<p className='author'>作者：郭蘅祈<br />時長 55分鐘</p>
												<p id='fm_desc' className='many_txt'>金剛薩埵為消業滅罪之唯一主尊，行者為懺罪解冤，修本尊法，功效最快最大，且為成就無上菩提必經階程。常持本尊真言，能破除煩惱，止諸惡念，生諸功德。 凡修法誦經持咒，課將畢時，加誦百字明三遍或七遍，然後回向，則一切功德圓滿，偶有錯漏，金剛護法，不將為咎 。此咒功德利益是能降魔除障，免除危險！！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B171.png').default} /></div>
												<div className='btn_detail'><a id='btn_set171'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>祈普行心靈系列2</p>
												<p className='author'>作者：郭蘅祈<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>郭蘅祈（郭子）以『祈¬菩行』，祈願用跨界『心』音樂，將對佛法的感念，用最誠摯的歌聲與現代音樂與¬您分享。唱詠諸佛慈悲智慧，自在空性，修習佛法於現¬代都會之中。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B172.png').default} /></div>
												<div className='btn_detail'><a id='btn_set172'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>祈普行心靈系列1</p>
												<p className='author'>作者：郭蘅祈<br />時長 98分鐘</p>
												<p id='fm_desc' className='many_txt'>四無量心(慈、悲、喜、捨)，在原始佛教中，本是佛陀所重視的修行法門之一。世尊不但順應當時沙門、婆羅門等，希求生梵天而教授其法， 更進而開示，修四無量心能得無量心解脫的要義。慈悲本是佛教的精髓，大乘行者無不以此為要著。而長養慈悲的方法，不外乎
													是修習四無量心。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B173.png').default} /></div>
												<div className='btn_detail'><a id='btn_set173'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聖嚴法師音樂傳記歸程</p>
												<p className='author'>作者：法鼓文化<br />時長 42分鐘</p>
												<p id='fm_desc' className='many_txt'>音樂版的《歸程》，引領您深入聖嚴法師從出生、出家、從軍、閉關、留學，直至創建法鼓山的百轉千折。
													《歸程組曲》特邀兩岸詞曲大師黃瑩與黃佩勤共同合作，將具時代意義的中外世界名曲重新填詞，透過音樂情境引領回到聖嚴法師的成長時空。由名指揮家張佳韻指揮愚韻交響樂團演奏，以及當代聲樂名家張杏月、鄧吉龍、臺北市內合唱團、法鼓山合唱團，共同細膩詮釋本曲。
													《法鼓組曲》的〈法鼓頌〉、〈法鼓山〉，氣勢奔騰，猶如雷霆萬鈞，讓人體驗到法鼓山所展現出的人間淨土新氣象。悠揚動聽的〈慈悲〉、〈四眾佛子共勉語〉、〈我為你祝福〉，則讓人感受到學佛人的歡喜自在。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B203.png').default} /></div>
												<div className='btn_detail'><a id='btn_set203'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>聖嚴法師音樂故事遠行</p>
												<p className='author'>作者：聖嚴法師<br />時長 39分鐘</p>
												<p id='fm_desc' className='many_txt'>遠行，是為了完成心願。透過遠行，聖嚴法師將漢傳佛教種子播種在世界各地，耕耘著人們的心田。本輯由名音樂製作人戴維雄精心創作，以十首音樂故事展現聖嚴法師的生命地圖， 隨著音樂一起行旅聖嚴法師的感人故事。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-8"><br /><br />
									<ul className="book">
										{/* html_book兒童故事 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B2.png').default} /></div>
												<div className='btn_detail'><a id='btn_set2'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>花媽說故事愛麗絲夢遊仙境</p>
												<p className='author'>作者：王瑞芹花媽<br />時長 145分鐘</p>
												<p id='fm_desc' className='many_txt'>台灣頂尖資深配音員花媽王瑞芹，為寶貝嚴選經典長篇名著－英國數學家「路易斯‧卡洛爾」筆下最天馬行空、流傳150年的冒險童話《愛麗絲夢遊仙境》。邀請寶貝打開小耳朵，跟隨愛麗絲的步伐，與白兔先生踏進兔子洞，來到神奇地底世界一探究竟。
													這場夢境探險共有十七個章節，你將聽見愛麗絲吃遍身體變大變小的甜品、蛋糕和蘑菇，你會為她撞見的奇怪動物驚嘆不已，還會為了脾氣暴躁的紙牌王后而膽戰心驚！
													旅程困難重重…，而古靈精怪、勇敢無畏的愛麗絲有辦法迎刃而解嗎？噓～請仔細聆聽這場驚奇故事，花媽將一人分飾多角，以活靈活現、極具張力的聲音表演，陪伴寶貝勇闖夢遊仙境，一起追尋終點的解答！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B3.png').default} /></div>
												<div className='btn_detail'><a id='btn_set3'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>寶寶探索科學繪本有聲書</p>
												<p className='author'>作者：幼福文化<br />時長 67分鐘</p>
												<p id='fm_desc' className='many_txt'>本系列故事希望幫助孩子們更喜歡閱讀，並多觀察自己或周遭生活的發現，進而得到屬於自己獨一無二的想法或感觸，因此藉著與我們息息相關的科學知識，並以生動的故事情節，跟著孩子一起歡樂閱讀！
													小男孩亮亮被外星人綁架了，奇怪的外星人對他東摸摸西碰碰，超級好奇的模樣到底想做什麼呢？
													最喜歡在太陽天出門去玩了，可是沒一下子天空又突然下起雨來了，這奇怪的小雨滴到底是從哪裡來的？
													聽說很久以前，陸地兄弟的感情很好都捨不得分開，那為什麼現在我們要去很遠的陸地時，還要坐飛機才能跨過陸地呢？他們是吵架了嗎？
													有沒有可能，有一天可以坐飛機上學去呢？
													蔬菜們跟我們一樣，也都住在不一樣的建築物裡！
													你能想像還有誰會比袋鼠跳得更遠嗎？什麼！紀錄上最厲害的選手不是牠，這怎麼可能呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B7.png').default} /></div>
												<div className='btn_detail'><a id='btn_set7'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋安徒生童話</p>
												<p className='author'>作者：幼福文化<br />時長 41分鐘</p>
												<p id='fm_desc' className='many_txt'>收錄有「拇指姑娘、醜小鴨、國王的新衣、豌豆公主、賣火柴的小女孩」共五篇孩子喜愛的安徒生童話故事。以活潑的敘述方式，讓孩子快樂讀故事。
													每篇故事都有簡易的單字學習，孩子可跟著故事唸唸看，結合內文加深印象，反覆聆聽後，很快就能記住，如此一來，學習英語遍得更好玩不枯燥，簡單就學會了100個英文單字囉！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B8.png').default} /></div>
												<div className='btn_detail'><a id='btn_set8'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋格林童話</p>
												<p className='author'>作者：幼福文化<br />時長 39分鐘</p>
												<p id='fm_desc' className='many_txt'>收錄「白雪公主、七隻小羊、小紅帽、糖果屋、青蛙王子」共五篇孩子喜愛的格林童話故事。以活潑的敘述方式，讓孩子快樂讀故事。
													每篇故事都有簡易的單字學習，孩子可以跟著故事唸唸看，結合內文加深印象，反覆領聽後，很快就能記住，如此一來，學習英語遍得更好玩不枯燥，簡單就學了100個英文單字囉！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B9.png').default} /></div>
												<div className='btn_detail'><a id='btn_set9'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋伊索寓言</p>
												<p className='author'>作者：幼福文化<br />時長 36分鐘</p>
												<p id='fm_desc' className='many_txt'> 收錄「龜兔賽跑、北風與太陽、放羊的孩子、金斧頭和銀斧頭、城市老鼠與鄉下老鼠」共五篇孩子喜愛的伊索寓言故事。以活潑的敘述方式，讓孩子快樂讀故事。
													每篇故事都有簡易的單字學習，孩子可以跟著故事唸唸看，結合內文加深印象，反覆聆聽後，很快就能記住，如此一來，學習英語遍得更好玩不枯燥，簡單就學了100個英文單字囉！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B10.png').default} /></div>
												<div className='btn_detail'><a id='btn_set10'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭6</p>
												<p className='author'>作者：孫越<br />時長 28分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B11.png').default} /></div>
												<div className='btn_detail'><a id='btn_set11'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭5</p>
												<p className='author'>作者：孫越<br />時長 23分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B12.png').default} /></div>
												<div className='btn_detail'><a id='btn_set12'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭4</p>
												<p className='author'>作者：孫越<br />時長 47分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B13.png').default} /></div>
												<div className='btn_detail'><a id='btn_set13'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的歡樂世界</p>
												<p className='author'>作者：幼福文化<br />時長 42分鐘</p>
												<p id='fm_desc' className='many_txt'>從生活中遭遇、理解、突破，全數收錄在小雞妙妙的趣味繪本系列～
													小雞妙妙最喜歡的好朋友「莉莉」為什麼要討厭他呢？妙妙只是想跟莉莉一起坐所以推開了豬小弟，叫小兔子走開……為什麼大家都要討厭他呢？
													爸爸上班有好多事情要做，下班回家要在電腦前面待好久，假日還要去河邊釣魚……為什麼爸爸總是這麼忙呢？
													哇！今天小雞妙妙家的隔壁好像來了一戶新鄰居，新鄰居有個可愛的女兒叫莉莉，妙妙好想要跟她做朋友……但不管怎麼做，都還差一點點才能成為朋友呢！
													小雞妙妙腦袋裡總有奇奇怪怪的想法，最近似乎很沉迷在想像未來的自己，一下子想當廚師、又想當公車司機、還想當醫生……這麼多志願，到底哪一個才是認真的呢？
													今天小雞妙妙說這週五他要上台表演唱歌呢！爸爸媽媽也跟小雞妙妙一樣興奮，不論是走路、吃飯、洗澡妙妙都一直很認真在練習！但為什麼……老師居然說表演要取消了呢？
													小雞妙妙跟莉莉最愛玩辦家家酒了，像是今天妙妙就扮演一位醫生呢！看他好像很專業的樣子幫莉莉看病，但看著看著鼻水怎麼流出來啦！這下子妙妙真的要去看醫生了，可是……他最怕打針，怎麼辦才能不打針呀！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B14.png').default} /></div>
												<div className='btn_detail'><a id='btn_set14'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的生活歷險</p>
												<p className='author'>作者：幼福文化<br />時長 48分鐘</p>
												<p id='fm_desc' className='many_txt'>小雞妙妙的媽咪是雙重人格嗎？一下子好凶，一下子又笑咪咪的。一張圓圓的臉會笑咪咪；另一張長長的臉是凶巴巴，小雞妙妙最愛媽咪圓圓的臉了。
													大新聞！今天小雞妙妙有了一個新朋友，他都叫他「小毛球」，可是，明天小雞妙妙不能再陪小毛球玩了，因為他可是一隻大野狼呢！
													肩負捕捉蜈蚣的小雞，居然不知道蜈蚣的樣子嗎？
													有了月亮的陪伴，晚上睡覺小雞妙妙也不會害怕
													這麼多厲害的動物們，到底誰的爸爸最了不起呢？
													嗚嗚嗚……小雞妙妙到底是誰生的呢？小豬、小牛、小羊、小狗都是從媽媽的肚子裡出生的，為什麼小雞妙妙卻是從一顆蛋裡面生出來的呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B15.png').default} /></div>
												<div className='btn_detail'><a id='btn_set15'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>嘻遊記二胡遊台灣</p>
												<p className='author'>作者：甄藝樂場<br />時長 104分鐘</p>
												<p id='fm_desc' className='many_txt'>豬八戒與音樂精靈帶著「神奇的胡琴」，來到寶島臺灣！
													善良的音樂精靈一心想淨化人心、改造地球，
													沒想到「神奇的胡琴」卻不聽話。
													原本想改造臺灣的音樂精靈，竟然變成「魔琴妖精」，
													造成土石流、地震、海嘯等大災難！
													豬八戒該怎麼拯救發狂的音樂精靈，與亂七八糟的臺灣呢？</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B16.png').default} /></div>
												<div className='btn_detail'><a id='btn_set16'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>趣聽兒歌</p>
												<p className='author'>作者：甄藝樂場<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>《趣～聽兒歌》在製作人王甄羚、編劇吳政育及知名編曲家朱雲嵩老師的共同配合下,利用國樂演奏呈現出小朋友耳熟能詳的兒歌,另外在故事精靈和故事裡的角色帶領下,以歡樂開心的唱跳過程中,讓小朋友可以用輕鬆快樂的態度,來了解尊重別人及替別人著想的難能可貴之處!</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B21.png').default} /></div>
												<div className='btn_detail'><a id='btn_set21'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>SYR Snow White and the Seven Dwarves</p>
												<p className='author'>作者：優百科<br />時長 7分鐘</p>
												<p id='fm_desc' className='many_txt'>白雪公主因為被壞皇后嫉妒美貌，被趕到森林裡去了。她能平安地度過嗎？還會遇到什麼危險嗎？
													優百科英語故事書，訂購專線886-2-2556-3256</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B22.png').default} /></div>
												<div className='btn_detail'><a id='btn_set22'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>SYR Jack and the Beanstalk</p>
												<p className='author'>作者：優百科<br />時長 10分鐘</p>
												<p id='fm_desc' className='many_txt'>傑克與母親相依為命，窮到要變賣僅剩的一條牛來過日子。傑克到底會換得什麼東西來改善他們的生活呢？
													優百科英語故事書，訂購專線886-2-2556-3256</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B23.png').default} /></div>
												<div className='btn_detail'><a id='btn_set23'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>SYR Aladdin and the Wonderful Lamp</p>
												<p className='author'>作者：優百科<br />時長 9分鐘</p>
												<p id='fm_desc' className='many_txt'>阿拉丁遇到了一位魔術師，他請求阿拉丁幫他到一個洞穴中去取一
													盞燈。那盞燈有何神奇的魔力呢？
													優百科英語故事書，訂購專線886-2-2556-3256</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B24.png').default} /></div>
												<div className='btn_detail'><a id='btn_set24'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>海底兩萬哩</p>
												<p className='author'>作者：糖果姐姐<br />時長 50分鐘</p>
												<p id='fm_desc' className='many_txt'>時長：49分52秒
													太平洋、大西洋海面上；越來越多國家的船，被一隻全身漆黑、頭上有尖角的龐大怪物攻擊！終於，累積的恐懼與憤怒爆發，全世界都要消滅牠！
													但是，設備非常精良的林肯號軍艦與牠對峙時還是被擊垮；隨船的法國海洋生物學權威阿洛納斯博士與全美國最厲害的魚叉手尼德等人更是被吞進了怪物肚子裡，被迫經歷了一場讓人驚心動魄、嘆為觀止的海底之旅……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B25.png').default} /></div>
												<div className='btn_detail'><a id='btn_set25'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>木偶奇遇記</p>
												<p className='author'>作者：糖果姐姐<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>玉米鬚爺爺自從妻子生病過世後，日子變得好孤單！好辛苦！他多麼渴望有小孩子陪他啊！一天，身為木匠的他把一截木頭刻成一個小男孩的形狀，沒想到木頭男孩竟然會說話，還陪伴他一起生活……</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B26.png').default} /></div>
												<div className='btn_detail'><a id='btn_set26'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小王子</p>
												<p className='author'>作者：糖果姐姐<br />時長 69分鐘</p>
												<p id='fm_desc' className='many_txt'>時長：1小時08分44秒
													依據安東‧德‧聖艾修伯里的作品改編。主角伯裡在一次飛行時迫降沙漠，遇見了來自某星球的小王子，聽小王子奇妙的星際之旅故事…</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B27.png').default} /></div>
												<div className='btn_detail'><a id='btn_set27'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我的5分鐘故事集快樂小故事</p>
												<p className='author'>作者：幼福文化<br />時長 43分鐘</p>
												<p id='fm_desc' className='many_txt'>閱讀不僅能開啟生活新視野，更能增加不同的知識領域，與其對孩子講一大串道理，不如讓孩子快樂的聽故事、讀故事，甚至模仿故事。當孩子聆聽一篇篇快樂小故事，不僅能滿足孩子的情感需求，天天保持一顆開朗的心情。現在，就一同享受閱讀新樂趣吧！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B31.png').default} /></div>
												<div className='btn_detail'><a id='btn_set31'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>胖叔叔故事屋之美德故事1</p>
												<p className='author'>作者：胖叔叔<br />時長 92分鐘</p>
												<p id='fm_desc' className='many_txt'>美德故事是先人品格的展現，透過與他人的應對進退及無私付出，留下了一個又一個可敬的楷模典範，成為穿越數千年流傳下來的不敗經典，讓胖叔叔用最誠摯的聲音魅力，帶孩子悠遊穿梭於美德品格之中，再次感受人性的真善美。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B32.png').default} /></div>
												<div className='btn_detail'><a id='btn_set32'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我的5分鐘故事集之啟發小故事</p>
												<p className='author'>作者：幼福文化<br />時長 46分鐘</p>
												<p id='fm_desc' className='many_txt'>閱讀不僅能開啟生活新視野，更能增加不同的知識領域，在輕鬆簡短、寓意深遠的小故事中，以各種最奇妙、最耐人尋味的情節，激發孩子的想像空間以及提升想像力和創造力。現在，就一同享受閱讀新樂趣吧！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B33.png').default} /></div>
												<div className='btn_detail'><a id='btn_set33'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>我的5分鐘故事集之趣味小故事</p>
												<p className='author'>作者：幼福文化<br />時長 44分鐘</p>
												<p id='fm_desc' className='many_txt'>閱讀不僅能開啟生活新視野，更能增加不同的知識領域，讓孩子聆聽故事完哈哈大笑的同時，除了有一個香甜的夢鄉外，還可以藉由學習、模仿書中的動物主角，懂得以樂觀的心境和態度面對困難。現在，就一同享受閱讀新樂趣吧！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B34.png').default} /></div>
												<div className='btn_detail'><a id='btn_set34'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>童話屋世界童話</p>
												<p className='author'>作者：幼福文化<br />時長 35分鐘</p>
												<p id='fm_desc' className='many_txt'>有「三隻小豬、十二生肖、小木偶、阿拉丁與神燈、穿長靴的貓」共五篇孩子喜愛的世界童話。以活潑的敘述方式，讓孩子快樂讀故事。每篇故事都有簡易的單字學習，跟著故事唸唸看，結合內文加深印象，反覆聆聽後，很快就能記住，如此一來，學習英語變得好玩不枯燥，聽完一個童話，就學了100個英文單字囉
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B35.png').default} /></div>
												<div className='btn_detail'><a id='btn_set35'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>胖叔叔故事屋之傳奇故事1</p>
												<p className='author'>作者：胖叔叔<br />時長 81分鐘</p>
												<p id='fm_desc' className='many_txt'>傳奇故事是老祖宗創意的結晶，透過對天地自然的觀察，編撰了一個又一個讓想像力無邊無際飛馳的故事，成為穿越數千年流傳下來的不敗經典，讓胖叔叔用最生動的聲音魅力，帶孩子開啟一場傳奇故事的冒險之旅，也帶您再次感受中國傳奇故事之美。</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B36.png').default} /></div>
												<div className='btn_detail'><a id='btn_set36'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭1</p>
												<p className='author'>作者：孫越<br />時長 71分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B37.png').default} /></div>
												<div className='btn_detail'><a id='btn_set37'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭2</p>
												<p className='author'>作者：孫越<br />時長 64分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B38.png').default} /></div>
												<div className='btn_detail'><a id='btn_set38'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>孫越叔叔的故事大喇叭3</p>
												<p className='author'>作者：孫越<br />時長 72分鐘</p>
												<p id='fm_desc' className='many_txt'>讓好東西可以跟更多好朋友分享！
													這是一套由我們大家的好朋友──孫越叔叔主講，兒童教育專家──黃迺毓博士策劃的兒童生活品格故事，當中的故事內容是“創作”和“再創作”的故事，蘊藏許多做人做事的道理與正確的價值觀。
													這些創作的故事除了顧及趣味、耐聽的原則外，更具備深刻的生活品格教育意義，讓小朋友們一聽再聽，美好的品格與正確的價值觀，就隨之輕鬆根植在小朋友的心中，伴隨他們快樂的成長、茁壯！</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B39.png').default} /></div>
												<div className='btn_detail'><a id='btn_set39'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的成長日記</p>
												<p className='author'>作者：幼福文化<br />時長 51分鐘</p>
												<p id='fm_desc' className='many_txt'>更多有趣的童言童語及孩子們的疑難雜症，通通在繪本故事裡趣味學習吧！
													每個週五是小雞妙妙就讀得幼兒園的快樂分享日喔！你不知道什麼是「分享」嗎？就是把自己的東西或心情跟其他人一起共有呀！這樣不就是一個人的快樂變成好多人的快樂了嗎？小雞妙妙這次會帶什麼意想不到的快樂跟其他人分享呢？
													「分享」是能將美好的體驗、喜愛的事物與他人共享的感覺，讓孩子學習分享，希望他們也能藉由這種互動，獲得更多的愛。但要讓孩子學習分享除了循序漸進外，尊重孩子的個體及意願也是很重要的，強迫的效果只會適得其反，家長也可以向孩子分享，能產生更棒的互動火花！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B40.png').default} /></div>
												<div className='btn_detail'><a id='btn_set40'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>小雞妙妙的幸福旅行</p>
												<p className='author'>作者：幼福文化<br />時長 94分鐘</p>
												<p id='fm_desc' className='many_txt'>原來除了爸爸媽媽、兄弟姐妹外，還有「朋友」在關心我！
													為什麼小雞不能游泳呢？小雞妙妙也好想跟小鴨子們一起玩水喔！咦？野狼先生願意教妙妙游泳嗎？這真是太棒了，可是怎麼野狼先生看起來不懷好意的樣子，救命呀！快救救小雞妙妙吧！
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
								<div className="tab-content-9"><br /><br />
									<ul className="book">
										{/* html_book英語學習 */}
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B4.png').default} /></div>
												<div className='btn_detail'><a id='btn_set4'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下15出差旅遊</p>
												<p className='author'>作者：徐薇<br />時長 50分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B5.png').default} /></div>
												<div className='btn_detail'><a id='btn_set5'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下14房屋地產</p>
												<p className='author'>作者：徐薇<br />時長 52分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B6.png').default} /></div>
												<div className='btn_detail'><a id='btn_set6'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下13科技技術</p>
												<p className='author'>作者：徐薇<br />時長 56分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B28.png').default} /></div>
												<div className='btn_detail'><a id='btn_set28'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下12金融</p>
												<p className='author'>作者：徐薇<br />時長 52分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B29.png').default} /></div>
												<div className='btn_detail'><a id='btn_set29'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字下11製造</p>
												<p className='author'>作者：徐薇<br />時長 55分鐘</p>
												<p id='fm_desc' className='all_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B41.png').default} /></div>
												<div className='btn_detail'><a id='btn_set41'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上2人事薪資福利</p>
												<p className='author'>作者：徐薇<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B42.png').default} /></div>
												<div className='btn_detail'><a id='btn_set42'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上3辦公室電話傳真</p>
												<p className='author'>作者：徐薇<br />時長 52分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B43.png').default} /></div>
												<div className='btn_detail'><a id='btn_set43'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上4文書作業</p>
												<p className='author'>作者：徐薇<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B44.png').default} /></div>
												<div className='btn_detail'><a id='btn_set44'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上5會議</p>
												<p className='author'>作者：徐薇<br />時長 53分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B45.png').default} /></div>
												<div className='btn_detail'><a id='btn_set45'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上6買賣交易</p>
												<p className='author'>作者：徐薇<br />時長 59分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B46.png').default} /></div>
												<div className='btn_detail'><a id='btn_set46'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上7採購與物流</p>
												<p className='author'>作者：徐薇<br />時長 54分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B47.png').default} alt="B47" /></div>
												<div className='btn_detail'><a id='btn_set47'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上8廣告與宣傳</p>
												<p className='author'>作者：徐薇<br />時長 56分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B48.png').default} alt="B48" /></div>
												<div className='btn_detail'><a id='btn_set48'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上9業務協調</p>
												<p className='author'>作者：徐薇<br />時長 47分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B49.png').default} alt="B49" /></div>
												<div className='btn_detail'><a id='btn_set49'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上10企業經營</p>
												<p className='author'>作者：徐薇<br />時長 51分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508
												</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										<li>
											<div className='book_cover'>
												<div className='photo'><img src={require('../../fm_image/B50.png').default} alt="B50" /></div>
												<div className='btn_detail'><a id='btn_set50'>詳細集數</a></div>
											</div>
											<div className='book_about'>
												<p className='name'>教你背新多益單字上1職稱職務聘僱面試</p>
												<p className='author'>作者：徐薇<br />時長 67分鐘</p>
												<p id='fm_desc' className='many_txt'>4小時徐薇老師精華單字教學
													5小時美籍、英籍雙口音朗讀MP3
													記單字也學用法，多益單字再難都不怕！
													徐薇英文系列叢書,訂購專線 886-2-2708-5508</p>
												<p id='fm_ConBtn'>瞭解更多</p>
											</div>
										</li>
										{/* End html_book */}
									</ul>
								</div>
							</div>{/* <div id="tab"> */}
						</div>
					</div>
					{/* POP詳細集數 */}
					<div className="pop_overlay">
						<div className="pop_box" id="pop1">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 01有錢人和你想的不一樣</li>
										<li>第2集 02富爸爸窮爸爸</li>
										<li>第3集 03原則上</li>
										<li>第4集 04原則下</li>
										<li>第5集 05獲利優先</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop2">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊詞</li>
										<li>第2集 01掉進兔子洞上</li>
										<li>第3集 02掉進兔子洞下</li>
										<li>第4集 03眼淚的池塘</li>
										<li>第5集 04特殊的賽跑</li>
										<li>第6集 05兔子誤認愛麗絲</li>
										<li>第7集 06奇怪的藍眼睛毛毛蟲</li>
										<li>第8集 07神奇的蘑菇</li>
										<li>第9集 08闖入農莊</li>
										<li>第10集 09神秘的笑臉貓</li>
										<li>第11集 10瘋狂的茶會上</li>
										<li>第12集 11瘋狂的茶會下</li>
										<li>第13集 12王后來了</li>
										<li>第14集 13坑坑巴巴的球場</li>
										<li>第15集 14假海龜的海底故事</li>
										<li>第16集 15誰偷走了餡餅上</li>
										<li>第17集 16誰偷走了餡餅下</li>
										<li>第18集 17愛麗絲的證明完結篇</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop3">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1奇妙的身體</li>
										<li>第2集 2小水滴的秘密</li>
										<li>第3集 3會移動的陸地</li>
										<li>第4集 4坐著飛機去上學</li>
										<li>第5集 5蔬菜園裡的小秘密</li>
										<li>第6集 6誰跳得比袋鼠遠</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop4">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U15accommodation</li>
										<li>第2集 U15attendant</li>
										<li>第3集 U15Celsius</li>
										<li>第4集 U15deluxe</li>
										<li>第5集 U15destination</li>
										<li>第6集 U15detector</li>
										<li>第7集 U15escort</li>
										<li>第8集 U15exotic</li>
										<li>第9集 U15expedition</li>
										<li>第10集 U15hospitality</li>
										<li>第11集 U15imposing</li>
										<li>第12集 U15inclement</li>
										<li>第13集 U15metropolitan</li>
										<li>第14集 U15reservation</li>
										<li>第15集 U15resort</li>
										<li>第16集 U15token</li>
										<li>第17集 U15朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop5">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U14architect</li>
										<li>第2集 U14brick</li>
										<li>第3集 U14bulk</li>
										<li>第4集 U14carpenter</li>
										<li>第5集 U14cellar</li>
										<li>第6集 U14concrete</li>
										<li>第7集 U14disposal</li>
										<li>第8集 U14dome</li>
										<li>第9集 U14drain</li>
										<li>第10集 U14drape</li>
										<li>第11集 U14extinguish</li>
										<li>第12集 U14hedge</li>
										<li>第13集 U14knob</li>
										<li>第14集 U14laundromat</li>
										<li>第15集 U14lease</li>
										<li>第16集 U14lodge</li>
										<li>第17集 U14mattress</li>
										<li>第18集 U14mortgage</li>
										<li>第19集 U14property</li>
										<li>第20集 U14朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop6">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U13analyze</li>
										<li>第2集 U13apparatus</li>
										<li>第3集 U13beta</li>
										<li>第4集 U13capabality</li>
										<li>第5集 U13command</li>
										<li>第6集 U13compatible</li>
										<li>第7集 U13core</li>
										<li>第8集 U13cuttingedge</li>
										<li>第9集 U13default</li>
										<li>第10集 U13devise</li>
										<li>第11集 U13dimension</li>
										<li>第12集 U13disconnect</li>
										<li>第13集 U13electronic</li>
										<li>第14集 U13facilitate</li>
										<li>第15集 U13hacker</li>
										<li>第16集 U13icon</li>
										<li>第17集 U13insulation</li>
										<li>第18集 U13reverse</li>
										<li>第19集 U13satellite</li>
										<li>第20集 U13transmission</li>
										<li>第21集 U13uptodate</li>
										<li>第22集 U13朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop7">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1拇指姑娘</li>
										<li>第2集 2醜小鴨</li>
										<li>第3集 3國王的新衣</li>
										<li>第4集 4豌豆公主</li>
										<li>第5集 5賣火柴的小女孩</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop8">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 白雪公主</li>
										<li>第2集 七隻小羊</li>
										<li>第3集 小紅帽</li>
										<li>第4集 糖果屋</li>
										<li>第5集 青蛙王子</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop9">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1龜兔賽跑</li>
										<li>第2集 2北風與太陽</li>
										<li>第3集 3放羊的孩子</li>
										<li>第4集 4金斧頭和銀斧頭</li>
										<li>第5集 5城市老鼠與鄉下老鼠</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop10">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 19生命金錢</li>
										<li>第2集 20會說話的手錶</li>
										<li>第3集 21孫越給大朋友的貼心話</li>
										<li>第4集 22黃迺毓給大朋友的貼心話</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop11">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 16賺錢花錢</li>
										<li>第2集 17我享受彈鋼琴</li>
										<li>第3集 18馬婆婆要交朋友</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop12">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 13我本來就不想說謊</li>
										<li>第2集 14好心奶奶的禮物</li>
										<li>第3集 15一張沒有眉毛的臉</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop13">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1最愛是你</li>
										<li>第2集 2隱形老爸</li>
										<li>第3集 3我們是朋友嗎</li>
										<li>第4集 4只要我長大</li>
										<li>第5集 5最棒的我</li>
										<li>第6集 6勇敢超人</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop14">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1我愛媽咪</li>
										<li>第2集 2一起來玩吧</li>
										<li>第3集 3哈囉蜈蚣先生</li>
										<li>第4集 4月亮朋友</li>
										<li>第5集 5最強老爸</li>
										<li>第6集 6媽媽是顆蛋</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop15">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 神奇的胡琴</li>
										<li>第2集 豬八戒與甄甄私自下凡</li>
										<li>第3集 台北101演奏哀傷的喜宴</li>
										<li>第4集 日月潭歡樂地演奏悲劇</li>
										<li>第5集 邵族的貓頭鷹</li>
										<li>第6集 神奇胡琴變邪惡</li>
										<li>第7集 失控的魔琴妖精帶來災難</li>
										<li>第8集 魔琴妖精與降魔雷五槌</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop16">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 一起來聽故事囉</li>
										<li>第2集 魔法村裡的小花貓</li>
										<li>第3集 看小蜜蜂的好辦法</li>
										<li>第4集 蝴蝶小姐來幫忙</li>
										<li>第5集 快樂逍遙的黃鸝鳥</li>
										<li>第6集 爬呀爬呀努力的蝸牛</li>
										<li>第7集 大象你在煩惱什麼啊</li>
										<li>第8集 老虎怎麼變成貓啦</li>
										<li>第9集 大家都是好朋友</li>
										<li>第10集 小毛驢演唱</li>
										<li>第11集 小花貓演唱</li>
										<li>第12集 小蜜蜂演唱</li>
										<li>第13集 蝴蝶演唱</li>
										<li>第14集 我是隻小小鳥演唱</li>
										<li>第15集 蝸牛與黃鸝鳥演唱</li>
										<li>第16集 大象演唱</li>
										<li>第17集 兩隻老虎演唱</li>
										<li>第18集 快樂拍拍手</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop17">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 2021星座开运指南</li>
										<li>第2集 1水瓶座事業財富</li>
										<li>第3集 2水瓶座感情健康</li>
										<li>第4集 3雙魚座事業財富</li>
										<li>第5集 4雙魚座感情健康</li>
										<li>第6集 5白羊座事業財富</li>
										<li>第7集 6白羊座感情健康</li>
										<li>第8集 7金牛座事業財富</li>
										<li>第9集 8金牛座感情健康</li>
										<li>第10集 9雙子座事業財富</li>
										<li>第11集 10雙子座感情健康</li>
										<li>第12集 11巨蟹座事業財富</li>
										<li>第13集 12巨蟹座感情健康</li>
										<li>第14集 13獅子座事業財富</li>
										<li>第15集 14獅子座感情健康</li>
										<li>第16集 15處女座事業財富</li>
										<li>第17集 16處女座感情健康</li>
										<li>第18集 17天秤座事業財富</li>
										<li>第19集 18天秤座感情健康</li>
										<li>第20集 19天蠍座事業財富</li>
										<li>第21集 20天蠍座感情健康</li>
										<li>第22集 21射手座事業財富</li>
										<li>第23集 22射手座感情健康</li>
										<li>第24集 23摩羯座事業財富</li>
										<li>第25集 24摩羯座感情健康</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop18">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1遊戲人間的精靈帕克1</li>
										<li>第2集 2遊戲人間的精靈帕克2</li>
										<li>第3集 3水精靈的魅惑1</li>
										<li>第4集 4水精靈的魅惑2</li>
										<li>第5集 5絞刑臺1</li>
										<li>第6集 6絞刑臺2</li>
										<li>第7集 7鬼靈精怪史加波1</li>
										<li>第8集 8鬼靈精怪史加波2</li>
										<li>第9集 9思慕1</li>
										<li>第10集 10思慕2</li>
										<li>第11集 11苦戀1</li>
										<li>第12集 12苦戀2</li>
										<li>第13集 13埋藏1</li>
										<li>第14集 14 埋藏-2</li>
										<li>第15集 15蕾諾兒</li>
										<li>第16集 16彩蛋聖桑骷髏之舞</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop19">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊詞</li>
										<li>第2集 1愛情來的時候誰都說不準</li>
										<li>第3集 2如何看待愛情的現實面</li>
										<li>第4集 3相愛追求滿足相處追求平衡</li>
										<li>第5集 4兩性關係溫柔是唯一手段</li>
										<li>第6集 5訂立愛情遊戲規則彼此遵守底線</li>
										<li>第7集 6愛情的三角函數</li>
										<li>第8集 7幸福是看品質不是看佔有</li>
										<li>第9集 8說不愛了的勇氣</li>
										<li>第10集 9愛情中的兩位大師得到與失去</li>
										<li>第11集 10人生的感動是在遺憾裏找到的</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop20">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊詞</li>
										<li>第2集 1等了30年終於被看見</li>
										<li>第3集 2和自己賽跑</li>
										<li>第4集 3走出舒適圈迎接新挑戰</li>
										<li>第5集 4迎接沒有大眾媒體的時代</li>
										<li>第6集 5想進演藝圈靜下心來想想先</li>
										<li>第7集 6演藝圈需要認真的日常</li>
										<li>第8集 7堅持作對的事</li>
										<li>第9集 8禮尚往來</li>
										<li>第10集 9透過張學友演唱會向經典學習</li>
										<li>第11集 10漸進式還是暴衝式</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop21">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 故事</li>
										<li>第2集 話劇場景1</li>
										<li>第3集 話劇場景2</li>
										<li>第4集 話劇場景3</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop22">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 故事</li>
										<li>第2集 話劇場景1</li>
										<li>第3集 話劇場景2</li>
										<li>第4集 話劇場景3</li>
										<li>第5集 話劇場景4</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop23">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 故事</li>
										<li>第2集 話劇場景1</li>
										<li>第3集 話劇場景2</li>
										<li>第4集 話劇場景3</li>
										<li>第5集 話劇場景4</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop24">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 海底兩萬哩第1章</li>
										<li>第2集 海底兩萬哩第2章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop25">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 木偶奇遇記第1章</li>
										<li>第2集 木偶奇遇記第2章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop26">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 小王子第1章</li>
										<li>第2集 小王子第2章</li>
										<li>第3集 小王子第3章</li>
										<li>第4集 小王子第4章</li>
										<li>第5集 小王子第5章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop27">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 不知足的驢子</li>
										<li>第2集 三心二意的老虎</li>
										<li>第3集 女兒的願望</li>
										<li>第4集 小蜜蜂做好事</li>
										<li>第5集 等待幫助的車夫</li>
										<li>第6集 誰的方法比較好</li>
										<li>第7集 壞脾氣像什麼</li>
										<li>第8集 長頸鹿的優點</li>
										<li>第9集 勇氣十足的綿羊</li>
										<li>第10集 阿雨的願望</li>
										<li>第11集 雪人的故事</li>
										<li>第12集 長不大的紅杉</li>
										<li>第13集 小烏龜找工作</li>
										<li>第14集 海豚報恩記</li>
										<li>第15集 喜歡唱歌的小鳥</li>
										<li>第16集 害人又害己的松鼠</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop28">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U12assess</li>
										<li>第2集 U12asset</li>
										<li>第3集 U12audit</li>
										<li>第4集 U12bankrupt</li>
										<li>第5集 U12boom</li>
										<li>第6集 U12bounce</li>
										<li>第7集 U12collapse</li>
										<li>第8集 U12deficit</li>
										<li>第9集 U12delinquent</li>
										<li>第10集 U12deposit</li>
										<li>第11集 U12discrepancy</li>
										<li>第12集 U12dispense</li>
										<li>第13集 U12dividend</li>
										<li>第14集 U12expenditure</li>
										<li>第15集 U12fluctuate</li>
										<li>第16集 U12fraud</li>
										<li>第17集 U12gross</li>
										<li>第18集 U12outstanding</li>
										<li>第19集 U12plummet</li>
										<li>第20集 U12soar</li>
										<li>第21集 U12withdrawal</li>
										<li>第22集 U12朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop29">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U11adjustable</li>
										<li>第2集 U11artificial</li>
										<li>第3集 U11barren</li>
										<li>第4集 U11complement</li>
										<li>第5集 U11defect</li>
										<li>第6集 U11disposable</li>
										<li>第7集 U11facility</li>
										<li>第8集 U11fertilize</li>
										<li>第9集 U11flaw</li>
										<li>第10集 U11hazard</li>
										<li>第11集 U11innovation</li>
										<li>第12集 U11maintenance</li>
										<li>第13集 U11manipulate</li>
										<li>第14集 U11manufacture</li>
										<li>第15集 U11mingle</li>
										<li>第16集 U11patent</li>
										<li>第17集 U11periodic</li>
										<li>第18集 U11procedure</li>
										<li>第19集 U11progressive</li>
										<li>第20集 U11restricted</li>
										<li>第21集 U11stimulus</li>
										<li>第22集 U11synthetic</li>
										<li>第23集 U11朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop30">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 第1章當岳母刺字時媳婦是不贊成的</li>
										<li>第2集 第2章情人梗裏出西施</li>
										<li>第3集 第3章帶賽貂蟬</li>
										<li>第4集 第4章QA</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop31">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 孔子出生</li>
										<li>第2集 孔子遇神童</li>
										<li>第3集 路不拾遺</li>
										<li>第4集 孟母三遷</li>
										<li>第5集 孔子造鬼</li>
										<li>第6集 孝感動天</li>
										<li>第7集 負米養親</li>
										<li>第8集 單衣順母</li>
										<li>第9集 恭盡子職</li>
										<li>第10集 戲彩娛親</li>
										<li>第11集 鹿乳奉親</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop32">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 小老虎學抓魚</li>
										<li>第2集 太陽求偶記</li>
										<li>第3集 小壁虎借尾巴</li>
										<li>第4集 熊和蜂蜜</li>
										<li>第5集 黃鴨鴨的星球</li>
										<li>第6集 尾巴打結的老鼠</li>
										<li>第7集 克服恐懼大作戰</li>
										<li>第8集 小螃蟹打工記</li>
										<li>第9集 紙條上的字</li>
										<li>第10集 老虎出糗記</li>
										<li>第11集 羽毛的功能</li>
										<li>第12集 虎兄虎弟</li>
										<li>第13集 神奇的鏡子</li>
										<li>第14集 小豬的鄰居</li>
										<li>第15集 吹牛蛙與吹牛兔</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop33">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 真假國王</li>
										<li>第2集 虎王的畫像</li>
										<li>第3集 招潮蟹的大螯</li>
										<li>第4集 樹根裡的遊戲</li>
										<li>第5集 遺憾的獅子</li>
										<li>第6集 會孵蛋的黑熊</li>
										<li>第7集 小兔子的眼睛</li>
										<li>第8集 吸血鬼的新選擇</li>
										<li>第9集 雪人奇遇記</li>
										<li>第10集 感恩圖報的蜜蜂</li>
										<li>第11集 向爸爸買時間</li>
										<li>第12集 村裡的小樹苗</li>
										<li>第13集 小羊避暑</li>
										<li>第14集 長脖子真管用</li>
										<li>第15集 小煙囪的使命</li>
										<li>第16集 要命的金子</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop34">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1三隻小豬</li>
										<li>第2集 2十二生肖</li>
										<li>第3集 3小木偶</li>
										<li>第4集 4阿拉丁與神燈</li>
										<li>第5集 5穿長靴的貓</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop35">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊詞</li>
										<li>第2集 1女媧造人補天</li>
										<li>第3集 2嫦娥奔月</li>
										<li>第4集 3盤古開天</li>
										<li>第5集 4新西蘭神話</li>
										<li>第6集 5八仙過海</li>
										<li>第7集 6海克力士</li>
										<li>第8集 7牛郎織女</li>
										<li>第9集 8竹林公主</li>
										<li>第10集 9白蛇傳</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop36">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1我要穿好多的名牌</li>
										<li>第2集 2做在最小的身上</li>
										<li>第3集 3老鼠獅子獵人</li>
										<li>第4集 4金銀斧頭</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop37">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 5不會Say No的大白</li>
										<li>第2集 6時間好貴</li>
										<li>第3集 7誰當國王</li>
										<li>第4集 8究竟為誰建房子</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop38">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 9跟花談話的園丁</li>
										<li>第2集 10狗耳朵與豬嘴巴</li>
										<li>第3集 11請謝謝對不起</li>
										<li>第4集 12後悔還來得及</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop39">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1哼真小氣</li>
										<li>第2集 2還不想上學</li>
										<li>第3集 3我不怕</li>
										<li>第4集 4全部我都要</li>
										<li>第5集 5來做朋友嘛</li>
										<li>第6集 6不要不理我</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop40">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1這是我的</li>
										<li>第2集 2我最喜歡妳</li>
										<li>第3集 3妹妹你好</li>
										<li>第4集 4超級大謊言</li>
										<li>第5集 5媽媽生病啦</li>
										<li>第6集 6我才不要呢</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop41">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U2appoint</li>
										<li>第2集 U2compensation</li>
										<li>第3集 U2crucial</li>
										<li>第4集 U2deputy</li>
										<li>第5集 U2designate</li>
										<li>第6集 U2discretion</li>
										<li>第7集 U2eligible</li>
										<li>第8集 U2elite</li>
										<li>第9集 U2emolument</li>
										<li>第10集 U2fringe</li>
										<li>第11集 U2incentive</li>
										<li>第12集 U2inherit</li>
										<li>第13集 U2merit</li>
										<li>第14集 U2morale</li>
										<li>第15集 U2oust</li>
										<li>第16集 U2pension</li>
										<li>第17集 U2salary</li>
										<li>第18集 U2-shift</li>
										<li>第19集 U2stimulate</li>
										<li>第20集 U2substitute</li>
										<li>第21集 U2validity</li>
										<li>第22集 U2朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop42">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U3accessory</li>
										<li>第2集 U3attire</li>
										<li>第3集 U3badge</li>
										<li>第4集 U3carbon</li>
										<li>第5集 U3cartridge</li>
										<li>第6集 U3code</li>
										<li>第7集 U3congenial</li>
										<li>第8集 U3cubicle</li>
										<li>第9集 U3diagram</li>
										<li>第10集 U3efficient</li>
										<li>第11集 U3errand</li>
										<li>第12集 U3memorandum</li>
										<li>第13集 U3oversight</li>
										<li>第14集 U3peripheral</li>
										<li>第15集 U3project</li>
										<li>第16集 U3protocol</li>
										<li>第17集 U3punctual</li>
										<li>第18集 U3schedule</li>
										<li>第19集 U3stationery</li>
										<li>第20集 U3朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop43">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U4abstract</li>
										<li>第2集 U4acknowledge</li>
										<li>第3集 U4breach</li>
										<li>第4集 U4circular</li>
										<li>第5集 U4clause</li>
										<li>第6集 U4concern</li>
										<li>第7集 U4condition</li>
										<li>第8集 U4contract</li>
										<li>第9集 U4draft</li>
										<li>第10集 U4enclose</li>
										<li>第11集 U4expire</li>
										<li>第12集 U4format</li>
										<li>第13集 U4implement</li>
										<li>第14集 U4norm</li>
										<li>第15集 U4obligation</li>
										<li>第16集 U4policy</li>
										<li>第17集 U4regard</li>
										<li>第18集 U4subject</li>
										<li>第19集 U4terms</li>
										<li>第20集 U4transcript</li>
										<li>第21集 U4朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop44">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U5agenda</li>
										<li>第2集 U5alternative</li>
										<li>第3集 U5attend</li>
										<li>第4集 U5compromise</li>
										<li>第5集 U5condemn</li>
										<li>第6集 U5convey</li>
										<li>第7集 U5diplomacy</li>
										<li>第8集 U5discriminate</li>
										<li>第9集 U5distribute</li>
										<li>第10集 U5execute</li>
										<li>第11集 U5moderate</li>
										<li>第12集 U5panel</li>
										<li>第13集 U5pledge</li>
										<li>第14集 U5postpone</li>
										<li>第15集 U5reconcile</li>
										<li>第16集 U5relevant</li>
										<li>第17集 U5seminar</li>
										<li>第18集 U5straightforward</li>
										<li>第19集 U5summit</li>
										<li>第20集 U5tentative</li>
										<li>第21集 U5unanimous</li>
										<li>第22集 U5朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop45">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U6alter</li>
										<li>第2集 U6auction</li>
										<li>第3集 U6behalf</li>
										<li>第4集 U6commitment</li>
										<li>第5集 U6compact</li>
										<li>第6集 U6confidentiality</li>
										<li>第7集 U6decent</li>
										<li>第8集 U6deficiency</li>
										<li>第9集 U6diminish</li>
										<li>第10集 U6disclosure</li>
										<li>第11集 U6diverse</li>
										<li>第12集 U6endeavor</li>
										<li>第13集 U6exclusive</li>
										<li>第14集 U6indispensable</li>
										<li>第15集 U6invaluable</li>
										<li>第16集 U6magnify</li>
										<li>第17集 U6prevail</li>
										<li>第18集 U6prospective</li>
										<li>第19集 U6quota</li>
										<li>第20集 U6respective</li>
										<li>第21集 U6royalty</li>
										<li>第22集 U6transaction</li>
										<li>第23集 U6venue</li>
										<li>第24集 U6朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop46">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U7batch</li>
										<li>第2集 U7cling</li>
										<li>第3集 U7costeffective</li>
										<li>第4集 U7dispatch</li>
										<li>第5集 U7endorse</li>
										<li>第6集 U7excess</li>
										<li>第7集 U7fee</li>
										<li>第8集 U7freight</li>
										<li>第9集 U7installment</li>
										<li>第10集 U7inventory</li>
										<li>第11集 U7invoice</li>
										<li>第12集 U7linger</li>
										<li>第13集 U7logistics</li>
										<li>第14集 U7random</li>
										<li>第15集 U7refund</li>
										<li>第16集 U7reimburse</li>
										<li>第17集 U7solicit</li>
										<li>第18集 U7substantial</li>
										<li>第19集 U7verify</li>
										<li>第20集 U7voucher</li>
										<li>第21集 U7warranty</li>
										<li>第22集 U7朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop47">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U8abundance</li>
										<li>第2集 U8authentic</li>
										<li>第3集 U8campaign</li>
										<li>第4集 U8circulation</li>
										<li>第5集 U8comparable</li>
										<li>第6集 U8complimentary</li>
										<li>第7集 U8customize</li>
										<li>第8集 U8distinction</li>
										<li>第9集 U8exaggerate</li>
										<li>第10集 U8feature</li>
										<li>第11集 U8introductory</li>
										<li>第12集 U8issue</li>
										<li>第13集 U8merchandise</li>
										<li>第14集 U8pamphlet</li>
										<li>第15集 U8prevalent</li>
										<li>第16集 U8revelation</li>
										<li>第17集 U8specimen</li>
										<li>第18集 U8stereotype</li>
										<li>第19集 U8subscribe</li>
										<li>第20集 U8trait</li>
										<li>第21集 U8transparent</li>
										<li>第22集 U8versatile</li>
										<li>第23集 U8朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop48">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U9abide</li>
										<li>第2集 U9accommodate</li>
										<li>第3集 U9ambiguity</li>
										<li>第4集 U9backlog</li>
										<li>第5集 U9coincide</li>
										<li>第6集 U9conciliate</li>
										<li>第7集 U9contingent</li>
										<li>第8集 U9coordinate</li>
										<li>第9集 U9deliberate</li>
										<li>第10集 U9displace</li>
										<li>第11集 U9dispose</li>
										<li>第12集 U9expedite</li>
										<li>第13集 U9explicit</li>
										<li>第14集 U9imminent</li>
										<li>第15集 U9pertinent</li>
										<li>第16集 U9priority</li>
										<li>第17集 U9resolve</li>
										<li>第18集 U9strife</li>
										<li>第19集 U9朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop49">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U10abolish</li>
										<li>第2集 U10authority</li>
										<li>第3集 U10consent</li>
										<li>第4集 U10copyright</li>
										<li>第5集 U10critical</li>
										<li>第6集 U10dilemma</li>
										<li>第7集 U10enterprise</li>
										<li>第8集 U10franchise</li>
										<li>第9集 U10grant</li>
										<li>第10集 U10heir</li>
										<li>第11集 U10initial</li>
										<li>第12集 U10institution</li>
										<li>第13集 U10monopoly</li>
										<li>第14集 U10pending</li>
										<li>第15集 U10premises</li>
										<li>第16集 U10prospectus</li>
										<li>第17集 U10significant</li>
										<li>第18集 U10sponsor</li>
										<li>第19集 U10statement</li>
										<li>第20集 U10streamline</li>
										<li>第21集 U10takeover</li>
										<li>第22集 U10thrive</li>
										<li>第23集 U10yield</li>
										<li>第24集 U10朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop50">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 U1application</li>
										<li>第2集 U1assistant</li>
										<li>第3集 U1attribute</li>
										<li>第4集 U1board</li>
										<li>第5集 U1chief</li>
										<li>第6集 U1devote</li>
										<li>第7集 U1diploma</li>
										<li>第8集 U1fill</li>
										<li>第9集 U1freelance</li>
										<li>第10集 U1industry</li>
										<li>第11集 U1intern</li>
										<li>第12集 U1-novice</li>
										<li>第13集 U1occupation</li>
										<li>第14集 U1opportunity</li>
										<li>第15集 U1orientation</li>
										<li>第16集 U1permatemp</li>
										<li>第17集 U1personnel</li>
										<li>第18集 U1portfolio</li>
										<li>第19集 U1probation</li>
										<li>第20集 U1reference</li>
										<li>第21集 U1résumé</li>
										<li>第22集 U1staff</li>
										<li>第23集 U1vacancy</li>
										<li>第24集 U1朗讀</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop51">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 意識力量轉化癌症1</li>
										<li>第2集 意識力量轉化癌症2</li>
										<li>第3集 意識力量轉化癌症3</li>
										<li>第4集 意識力量轉化癌症4</li>
										<li>第5集 意識力量轉化癌症5</li>
										<li>第6集 意識力量轉化癌症6</li>
										<li>第7集 意識力量轉化癌症7</li>
										<li>第8集 意識力量轉化癌症8</li>
										<li>第9集 意識力量轉化癌症9</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop52">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 威力最強的抗癌心法1</li>
										<li>第2集 威力最強的抗癌心法2</li>
										<li>第3集 威力最強的抗癌心法3</li>
										<li>第4集 威力最強的抗癌心法4</li>
										<li>第5集 威力最強的抗癌心法5</li>
										<li>第6集 威力最強的抗癌心法6</li>
										<li>第7集 威力最強的抗癌心法7</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop53">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 你可以不生病1</li>
										<li>第2集 你可以不生病2</li>
										<li>第3集 你可以不生病3</li>
										<li>第4集 你可以不生病4</li>
										<li>第5集 你可以不生病5</li>
										<li>第6集 你可以不生病6</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop54">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1呼吸</li>
										<li>第2集 2放鬆</li>
										<li>第3集 3健康</li>
										<li>第4集 4活力</li>
										<li>第5集 5直覺</li>
										<li>第6集 6對話</li>
										<li>第7集 7感受</li>
										<li>第8集 8創造</li>
										<li>第9集 9豐盛</li>
										<li>第10集 10靜心</li>
										<li>第11集 11時光</li>
										<li>第12集 12發現</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop55">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 段子一西元1673年</li>
										<li>第2集 段子二狗元3761年</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop56">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1國家地理雜碎</li>
										<li>第2集 2卡卡村的小毛驢</li>
										<li>第3集 3全世界最聰明的村子</li>
										<li>第4集 4村長的新衣</li>
										<li>第5集 5輕鬆一下</li>
										<li>第6集 6卡卡村的卡卡牌</li>
										<li>第7集 7輕鬆兩下</li>
										<li>第8集 8麵包師傅的鼾聲</li>
										<li>第9集 9裁縫師傅給老婆的十二封信</li>
										<li>第10集 10看書的時間到了</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop57">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 段子一走狗</li>
										<li>第2集 段子二喪鐘</li>
										<li>第3集 段子三奴才</li>
										<li>第4集 段子四東西</li>
										<li>第5集 段子五幻覺</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop58">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 段子1扒馬褂</li>
										<li>第2集 段子2倭瓜鑣</li>
										<li>第3集 段子3報菜名</li>
										<li>第4集 段子4江河湖海</li>
										<li>第5集 段子5歪批三國</li>
										<li>第6集 太平歌詞韓信算卦</li>
										<li>第7集 太平歌詞五龍捧聖</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop59">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 段子一一二三</li>
										<li>第2集 段子二十六</li>
										<li>第3集 段子三十八</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop60">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊詞</li>
										<li>第2集 1你的科系不重要找理想工作檢視四要素</li>
										<li>第3集 2工作前幾年不怕起薪低</li>
										<li>第4集 3職涯起步前先完成五件事</li>
										<li>第5集 4顏值管理也是一種職場能力</li>
										<li>第6集 5新人們務必擺脫少爺公主病</li>
										<li>第7集 6可以天真但請認真</li>
										<li>第8集 7新手易犯的三個誤區</li>
										<li>第9集 8害怕失敗給你三個新思維</li>
										<li>第10集 9別誤會同事不需要掏心掏肺</li>
										<li>第11集 10別害羞這麼做拿回話語權</li>
										<li>第12集 11別害怕小人得道我這樣做</li>
										<li>第13集 12別生氣向討厭的人學習優點吧</li>
										<li>第14集 13別擔心說NO不是得罪人反而積極進攻</li>
										<li>第15集 14向上管理的四大秘訣</li>
										<li>第16集 15老闆我請你喝咖啡</li>
										<li>第17集 16老闆假日狂LINE我該怎麼辦</li>
										<li>第18集 17用心不用力成果看得見</li>
										<li>第19集 18如何打造你的職場關鍵字</li>
										<li>第20集 19工作專注的祕密我打網球學的道理</li>
										<li>第21集 20想發光發亮先學蹲馬步</li>
										<li>第22集 21不怕變動讓它成為你的機會</li>
										<li>第23集 22請先做單槓青年再來談斜槓</li>
										<li>第24集 23放下前你擁有了嗎</li>
										<li>第25集 24離職和面試一樣重要</li>
										<li>第26集 25達成夢想每年請做三件事</li>
										<li>第27集 26秘笈一讚美請公開斥責請私下</li>
										<li>第28集 27秘笈二對事情要堅定對待人要柔軟</li>
										<li>第29集 28秘笈三做人與做事隨位階不同而改變</li>
										<li>第30集 29秘笈四解決問題比給理由重要</li>
										<li>第31集 30秘笈五再難的客戶仍能扳回一城</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop61">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 綠珠墜樓段彥希</li>
										<li>第2集 十行俱下段彥希</li>
										<li>第3集 千金買賦段彥希</li>
										<li>第4集 七步之才宋明翰</li>
										<li>第5集 狡兔三窟宋明翰</li>
										<li>第6集 精衛填海張彥廷</li>
										<li>第7集 佝僂承蜩張彥廷</li>
										<li>第8集 求田問舍吳胤頡</li>
										<li>第9集 虎符救趙吳胤頡</li>
										<li>第10集 牛衣對泣吳胤頡</li>
										<li>第11集 米珠薪桂吳宥頡</li>
										<li>第12集 牛鼎烹雞吳宥頡</li>
										<li>第13集 一飯千金宋明翰</li>
										<li>第14集 桃李無言宋明翰</li>
										<li>第15集 夸父追日吳胤頡</li>
										<li>第16集 磨杵成針吳宥頡</li>
										<li>第17集 斷鶴續鳧吳宥頡</li>
										<li>第18集 愛鶴失眾吳宥頡</li>
										<li>第19集 千里命駕吳宥頡</li>
										<li>第20集 烏合之眾吳胤頡</li>
										<li>第21集 抱薪救火吳胤頡</li>
										<li>第22集 包藏禍心吳胤頡</li>
										<li>第23集 移花接木吳胤頡</li>
										<li>第24集 一衣帶水張彥廷</li>
										<li>第25集 錢可通神張彥廷</li>
										<li>第26集 冰山難靠段彥希</li>
										<li>第27集 以古非今段彥希</li>
										<li>第28集 沆瀣一氣宋明翰</li>
										<li>第29集 龍驤虎步宋明翰</li>
										<li>第30集 堅壁清野段彥希</li>
										<li>第31集 孟母三遷宋明翰</li>
										<li>第32集 目不識丁吳胤頡</li>
										<li>第33集 吳下阿蒙段彥希</li>
										<li>第34集 伏龍鳳雛宋明翰</li>
										<li>第35集 人人自危宋明翰</li>
										<li>第36集 土崩瓦解宋明翰</li>
										<li>第37集 狗猛酒酸吳胤頡</li>
										<li>第38集 弄獐宰相吳宥頡</li>
										<li>第39集 南柯一夢洪子晏</li>
										<li>第40集 蜀犬吠日洪子晏</li>
										<li>第41集 如湯沃雪段彥希</li>
										<li>第42集 雞口牛後段彥希</li>
										<li>第43集 李代桃僵段彥希</li>
										<li>第44集 雞蟲得失段彥希</li>
										<li>第45集 驥服鹽車吳宥頡</li>
										<li>第46集 齊大非偶吳宥頡</li>
										<li>第47集 扣盤捫燭洪子晏</li>
										<li>第48集 滅此朝食洪子晏</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop62">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1笛子演奏</li>
										<li>第2集 2對對子</li>
										<li>第3集 3賣我</li>
										<li>第4集 4孫臏傳奇8</li>
										<li>第5集 5溫酒斬華雄</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop63">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1龍宮借神鐵</li>
										<li>第2集 2孫臏傳奇7</li>
										<li>第3集 3戲劇雜談</li>
										<li>第4集 4疑鄰偷斧</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop64">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1棺材鋪</li>
										<li>第2集 2蟈蟈和蛐蛐</li>
										<li>第3集 3魯達除霸</li>
										<li>第4集 4孫臏傳奇6</li>
										<li>第5集 5笛子演奏</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop65">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1龜兔賽跑</li>
										<li>第2集 2空城計</li>
										<li>第3集 3孫臏傳奇5</li>
										<li>第4集 4武梆子</li>
										<li>第5集 5武松打店</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop66">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1繪聲繪色</li>
										<li>第2集 2詩情畫意</li>
										<li>第3集 3孫臏傳奇4</li>
										<li>第4集 4竹笛演奏</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop67">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1為什麼關在裡面的不是我</li>
										<li>第2集 2耗油的小孩</li>
										<li>第3集 3你的心臟還跳不跳</li>
										<li>第4集 4EatinNoout</li>
										<li>第5集 5受不了啦我也要</li>
										<li>第6集 6一盤五花肥肉一萬元</li>
										<li>第7集 7這回第六張</li>
										<li>第8集 8吃一碗飯卻要洗兩個碗</li>
										<li>第9集 9寵愛自己</li>
										<li>第10集 10好好看問別人舒服問自己</li>
										<li>第11集 11好好幹從前我跟你一樣</li>
										<li>第12集 12前頭快樂後頭受罪</li>
										<li>第13集 13慾望黑洞深深深</li>
										<li>第14集 14作個白日夢吧</li>
										<li>第15集 15改變不了就努力接納</li>
										<li>第16集 16死相難看</li>
										<li>第17集 17讓你的夢想更堅強</li>
										<li>第18集 18我喜歡從前那位老師</li>
										<li>第19集 19一年只有兩份禮物</li>
										<li>第20集 20醫生的大房子</li>
										<li>第21集 21世物美不美視心情而定</li>
										<li>第22集 22培養辯才無礙的能力</li>
										<li>第23集 23為什麼別人的大便比較臭</li>
										<li>第24集 24開錯了門跑錯了廁所</li>
										<li>第25集 25近水樓台先得月</li>
										<li>第26集 26人各有志</li>
										<li>第27集 27你竟然不認識劉德華</li>
										<li>第28集 28嚮往的歡愉</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop68">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 檜木還是橘子樹</li>
										<li>第2集 在孩子身上尋寶</li>
										<li>第3集 磨練多成長快</li>
										<li>第4集 工作何處尋</li>
										<li>第5集 讓孩子大受歡迎</li>
										<li>第6集 溺愛不等於關愛</li>
										<li>第7集 傾聽孩子的心聲</li>
										<li>第8集 真有那麼嚴重嗎</li>
										<li>第9集 遷怒先生外傳</li>
										<li>第10集 說對不起有什麼用</li>
										<li>第11集 有責任感的人哪裡找</li>
										<li>第12集 呷緊弄破碗</li>
										<li>第13集 總要留路給別人走</li>
										<li>第14集 金屬疲勞效應</li>
										<li>第15集 富不過三代</li>
										<li>第16集 讓身心休息一下</li>
										<li>第17集 僥倖罪惡的搖籃</li>
										<li>第18集 多頭與空頭的交戰</li>
										<li>第19集 一流加一流等於二流</li>
										<li>第20集 蝸牛蚯蚓過馬路</li>
										<li>第21集 人生何妨幽默一點</li>
										<li>第22集 我們都是屬鵝的</li>
										<li>第23集 婚姻條件說</li>
										<li>第24集 現在改用刀叉吃人肉了</li>
										<li>第25集 良心發現</li>
										<li>第26集 愛妻巷與同居街</li>
										<li>第27集 客氣害人</li>
										<li>第28集 不良示範</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop69">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1前言</li>
										<li>第2集 2女孩與一枚馬克</li>
										<li>第3集 3老太太的妙計</li>
										<li>第4集 4待會見</li>
										<li>第5集 5祖母的舊胸針</li>
										<li>第6集 6單車奇緣</li>
										<li>第7集 7我錯了</li>
										<li>第8集 8第十二位乘客</li>
										<li>第9集 9我要嫁給托瑪斯</li>
										<li>第10集 10鄰居的狗</li>
										<li>第11集 11月光曲</li>
										<li>第12集 12鐵石心腸</li>
										<li>第13集 13兩個母親一個小孩</li>
										<li>第14集 14拋錨</li>
										<li>第15集 15紐約大審</li>
										<li>第16集 16風車</li>
										<li>第17集 17日記</li>
										<li>第18集 18致暗戀的情人</li>
										<li>第19集 19奇蹟</li>
										<li>第20集 20霧中散步</li>
										<li>第21集 21永不分離</li>
										<li>第22集 22自由新天地</li>
										<li>第23集 23伊蕾娜</li>
										<li>第24集 24爸爸不會紮辮子</li>
										<li>第25集 25大衣</li>
										<li>第26集 26控告</li>
										<li>第27集 27載他回去</li>
										<li>第28集 28一束五十分尼的花</li>
										<li>第29集 29約定</li>
										<li>第30集 30馬丁尼女郎</li>
										<li>第31集 31戲</li>
										<li>第32集 32一把沙</li>
										<li>第33集 33隔房響起的咳嗽聲</li>
										<li>第34集 34夏季裡的一日</li>
										<li>第35集 35 人道精神</li>
										<li>第36集 36幸福童話</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop70">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1為什麼情緒管理排毒很重要</li>
										<li>第2集 2簡短介紹</li>
										<li>第3集 3我與EFT的接觸</li>
										<li>第4集 4如何利用情緒樹找到深根蒂固的信念</li>
										<li>第5集 5EFT情緒排毒敲打操敲拍位置介紹</li>
										<li>第6集 6十大情緒之一難以負荷的沉重感</li>
										<li>第7集 7十大情緒之二不斷的自我批判</li>
										<li>第8集 8十大情緒之三逃避現實</li>
										<li>第9集 9十大情緒之四拖延和自我破壞</li>
										<li>第10集 10十大情緒之五罪惡感和自責</li>
										<li>第11集 11十大情緒之六自我設限</li>
										<li>第12集 12十大情緒之七對某些事成癮</li>
										<li>第13集 13十大情緒之八對不可預知的改變感到恐懼</li>
										<li>第14集 14十大情緒之九害怕承受不起的失敗</li>
										<li>第15集 15十大情緒之十控制不了的憤怒</li>
										<li>第16集 16運用EFT幫助自己與他人情緒排毒</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop71">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 如何快速增加商場職場EQ和影響力</li>
										<li>第2集 課程概覽</li>
										<li>第3集 什麼是EFT如何運用EFT</li>
										<li>第4集 藍色屬性的人是什麼樣子</li>
										<li>第5集 藍色屬性的長處以及短處</li>
										<li>第6集 藍色屬性的演示demo</li>
										<li>第7集 如果對方是藍色我該怎麼做</li>
										<li>第8集 紅色屬性的人是什麼樣子</li>
										<li>第9集 紅色屬性的長處及短處</li>
										<li>第10集 紅色屬性的演示Demo</li>
										<li>第11集 如果對方是紅色我該怎麼做</li>
										<li>第12集 黃色屬性的人是什麼樣子</li>
										<li>第13集 黃色屬性的長處及短處</li>
										<li>第14集 黃色屬性的演示Demo</li>
										<li>第15集 如果對方是黃色</li>
										<li>第16集 綠色屬性的人是什麼樣子</li>
										<li>第17集 綠色屬性的長處及短處</li>
										<li>第18集 綠色屬性的演示Demo</li>
										<li>第19集 如果對方是綠色我該怎麼做</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop72">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 台灣答嘴鼓誰人甲你比</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop73">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 異界龍印之尊第01章</li>
										<li>第2集 異界龍印之尊第02章</li>
										<li>第3集 異界龍印之尊第03章</li>
										<li>第4集 異界龍印之尊第04章</li>
										<li>第5集 異界龍印之尊第05章</li>
										<li>第6集 異界龍印之尊第06章</li>
										<li>第7集 異界龍印之尊第07章</li>
										<li>第8集 異界龍印之尊第08章</li>
										<li>第9集 異界龍印之尊第09章</li>
										<li>第10集 異界龍印之尊第10章</li>
										<li>第11集 異界龍印之尊第11章</li>
										<li>第12集 異界龍印之尊第12章</li>
										<li>第13集 異界龍印之尊第13章</li>
										<li>第14集 異界龍印之尊第14章</li>
										<li>第15集 異界龍印之尊第15章</li>
										<li>第16集 異界龍印之尊第16章</li>
										<li>第17集 異界龍印之尊第17章</li>
										<li>第18集 異界龍印之尊第18章</li>
										<li>第19集 異界龍印之尊第19章</li>
										<li>第20集 異界龍印之尊第20章</li>
										<li>第21集 異界龍印之尊第21章</li>
										<li>第22集 異界龍印之尊第22章</li>
										<li>第23集 異界龍印之尊第23章</li>
										<li>第24集 異界龍印之尊第24章</li>
										<li>第25集 異界龍印之尊第25章</li>
										<li>第26集 異界龍印之尊第26章</li>
										<li>第27集 異界龍印之尊第27章</li>
										<li>第28集 異界龍印之尊第28章</li>
										<li>第29集 異界龍印之尊第29章</li>
										<li>第30集 異界龍印之尊第30章</li>
										<li>第31集 異界龍印之尊第31章</li>
										<li>第32集 異界龍印之尊第32章</li>
										<li>第33集 異界龍印之尊第33章</li>
										<li>第34集 異界龍印之尊第34章</li>
										<li>第35集 異界龍印之尊第35章</li>
										<li>第36集 異界龍印之尊第36章</li>
										<li>第37集 異界龍印之尊第37章</li>
										<li>第38集 異界龍印之尊第38章</li>
										<li>第39集 異界龍印之尊第39章</li>
										<li>第40集 異界龍印之尊第40章</li>
										<li>第41集 異界龍印之尊第41章</li>
										<li>第42集 異界龍印之尊第42章</li>
										<li>第43集 異界龍印之尊第43章</li>
										<li>第44集 異界龍印之尊第44章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop74">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 靈武大陸之魔界第01章</li>
										<li>第2集 靈武大陸之魔界第02章</li>
										<li>第3集 靈武大陸之魔界第03章</li>
										<li>第4集 靈武大陸之魔界第04章</li>
										<li>第5集 靈武大陸之魔界第05章</li>
										<li>第6集 靈武大陸之魔界第06章</li>
										<li>第7集 靈武大陸之魔界第07章</li>
										<li>第8集 靈武大陸之魔界第08章</li>
										<li>第9集 靈武大陸之魔界第09章</li>
										<li>第10集 靈武大陸之魔界第10章</li>
										<li>第11集 靈武大陸之魔界第11章</li>
										<li>第12集 靈武大陸之魔界第12章</li>
										<li>第13集 靈武大陸之魔界第13章</li>
										<li>第14集 靈武大陸之魔界第14章</li>
										<li>第15集 靈武大陸之魔界第15章</li>
										<li>第16集 靈武大陸之魔界第16章</li>
										<li>第17集 靈武大陸之魔界第17章</li>
										<li>第18集 靈武大陸之魔界第18章</li>
										<li>第19集 靈武大陸之魔界第19章</li>
										<li>第20集 靈武大陸之魔界第20章</li>
										<li>第21集 靈武大陸之魔界第21章</li>
										<li>第22集 靈武大陸之魔界第22章</li>
										<li>第23集 靈武大陸之魔界第23章</li>
										<li>第24集 靈武大陸之魔界第24章</li>
										<li>第25集 靈武大陸之魔界第25章</li>
										<li>第26集 靈武大陸之魔界第26章</li>
										<li>第27集 靈武大陸之魔界第27章</li>
										<li>第28集 靈武大陸之魔界第28章</li>
										<li>第29集 靈武大陸之魔界第29章</li>
										<li>第30集 靈武大陸之魔界第30章</li>
										<li>第31集 靈武大陸之魔界第31章</li>
										<li>第32集 靈武大陸之魔界第32章</li>
										<li>第33集 靈武大陸之魔界第33章</li>
										<li>第34集 靈武大陸之魔界第34章</li>
										<li>第35集 靈武大陸之魔界第35章</li>
										<li>第36集 靈武大陸之魔界第36章</li>
										<li>第37集 靈武大陸之魔界第37章</li>
										<li>第38集 靈武大陸之魔界第38章</li>
										<li>第39集 靈武大陸之魔界第39章</li>
										<li>第40集 靈武大陸之魔界第40章</li>
										<li>第41集 靈武大陸之魔界第41章</li>
										<li>第42集 靈武大陸之魔界第42章</li>
										<li>第43集 靈武大陸之魔界第43章</li>
										<li>第44集 靈武大陸之魔界第44章</li>
										<li>第45集 靈武大陸之魔界第45章</li>
										<li>第46集 靈武大陸之魔界第46章</li>
										<li>第47集 靈武大陸之魔界第47章</li>
										<li>第48集 靈武大陸之魔界第48章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop75">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊詞名人推薦黃子佼</li>
										<li>第2集 01李建復出道是場美麗的意外</li>
										<li>第3集 02李建復民風樂府</li>
										<li>第4集 03齊豫家中大甕裡的酸白菜</li>
										<li>第5集 04齊豫從穿搭到歌唱</li>
										<li>第6集 05莫凡與木船夥伴一起瘋狂的歲月</li>
										<li>第7集 06莫凡影響我最遠的一首歌曠野寄情</li>
										<li>第8集 07陳明韶金韻獎的第一名差點不是我</li>
										<li>第9集 08陳明韶唱免錢的給人聽</li>
										<li>第10集 09黃韻玲當別的小孩在玩扮家家酒</li>
										<li>第11集 10黃韻玲KTV包廂是我創作的練功房</li>
										<li>第12集 11潘越雲渾然天成的嗓音</li>
										<li>第13集 12潘越雲一張單程車票</li>
										<li>第14集 13陳樂融當個作詞人有什麼難的</li>
										<li>第15集 14陳樂融一首優美得震撼人心的歌曲美麗島</li>
										<li>第16集 15李壽全大學四年裡瘋狂的三千張西洋搖滾唱片是我的音樂養份</li>
										<li>第17集 16李壽全經典重製8又2分之一</li>
										<li>第18集 17丁曉雯樂聲流動的家</li>
										<li>第19集 18丁曉雯民歌那一段永遠不會變質的純真歲月</li>
										<li>第20集 19楊弦現代民歌之父談民歌印記</li>
										<li>第21集 20楊弦只要是想寫的歌就會一鼓作氣地把它完成</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop76">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 01林海音的語言魅力</li>
										<li>第2集 02充滿了生命之火的馬丁史柯西斯</li>
										<li>第3集 03我是陳映真的粉絲</li>
										<li>第4集 04李國修的山東話</li>
										<li>第5集 05駱玉笙大師的京韻大鼓</li>
										<li>第6集 06梅蘭芳的三角戀愛</li>
										<li>第7集 07梅蘭芳的夫人福芝芳</li>
										<li>第8集 08啼笑因緣張恨水</li>
										<li>第9集 09按摩浴缸大王Jacuzzi賈庫西</li>
										<li>第10集 10大家的孫叔叔</li>
										<li>第11集 11趙繼發與老烏龜</li>
										<li>第12集 12黃籽會的同志們</li>
										<li>第13集 13妳老瞅著我幹嘛</li>
										<li>第14集 14我們的化學老師</li>
										<li>第15集 15我是王正中的弟弟</li>
										<li>第16集 16容閎的故事</li>
										<li>第17集 17是誰教我拍電影</li>
										<li>第18集 18我和金大中喝過燒酒</li>
										<li>第19集 19兩次獲得奧斯卡金像獎最佳攝影的黃宗霑</li>
										<li>第20集 20我希望能夠和吳金銓導演說相聲</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop77">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 甘露的本質</li>
										<li>第2集 頂禮榮耀金剛薩埵</li>
										<li>第3集 不淨幻身</li>
										<li>第4集 清淨幻身</li>
										<li>第5集 心之法界明光要義</li>
										<li>第6集 關於顯相與實相的二十個令人驚歎的奇跡</li>
										<li>第7集 給佛法中心工作人員的忠告</li>
										<li>第8集 工作正念歌</li>
										<li>第9集 ZabsangShedrub我弟子</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop78">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 市中游平等訣</li>
										<li>第2集 吉祥光照全宇宙</li>
										<li>第3集 幸運的意義</li>
										<li>第4集 空離言詮歌</li>
										<li>第5集 若知顯相如上師</li>
										<li>第6集 萬物本貌</li>
										<li>第7集 金剛薩埵</li>
										<li>第8集 大手印大圓滿大中觀要義</li>
										<li>第9集 以十方諸佛為對境的甚深祈請</li>
										<li>第10集 神聖自生之悲心降</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop79">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1往好處想</li>
										<li>第2集 2名人的智慧與幽默</li>
										<li>第3集 3生死一念間</li>
										<li>第4集 4轉念就快樂</li>
										<li>第5集 5時時感恩快樂長存</li>
										<li>第6集 6別為小事抓狂</li>
										<li>第7集 7撿香蕉皮</li>
										<li>第8集 8痛苦來自想像</li>
										<li>第9集 9勿預支痛苦</li>
										<li>第10集 10生命冊</li>
										<li>第11集 11不甘心</li>
										<li>第12集 12開車讓字訣</li>
										<li>第13集 13你耳聰目明嗎</li>
										<li>第14集 14匿名情書</li>
										<li>第15集 15內在美外在美</li>
										<li>第16集 16家花哪有野花香</li>
										<li>第17集 17頌讚之餘拉拔一把吧</li>
										<li>第18集 18談死亡</li>
										<li>第19集 19更有價值的生命</li>
										<li>第20集 20愛心不熄火</li>
										<li>第21集 21什麼是生命寶藏</li>
										<li>第22集 22財主財奴</li>
										<li>第23集 23不腐餘財1</li>
										<li>第24集 24不腐餘財2</li>
										<li>第25集 25人是什麼動物</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop80">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1星星</li>
										<li>第2集 2一個人與一個人的一個人</li>
										<li>第3集 3紅酒裡的倒影</li>
										<li>第4集 4寧靜的暖空氣</li>
										<li>第5集 5城市低語</li>
										<li>第6集 6單人床單</li>
										<li>第7集 7杯子上的口紅印</li>
										<li>第8集 8鏡子與身影</li>
										<li>第9集 9回憶與一本紅色的書</li>
										<li>第10集 10愛情電影重播</li>
										<li>第11集 11忘記拿走的西裝外套</li>
										<li>第12集 12一起聽的那首歌</li>
										<li>第13集 13舊睡衣</li>
										<li>第14集 14打包的床邊故事</li>
										<li>第15集 15晚安</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop81">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1心靈呼吸</li>
										<li>第2集 2光之歌</li>
										<li>第3集 3漫步森林</li>
										<li>第4集 4翠綠色的約定</li>
										<li>第5集 5粉色靜思語</li>
										<li>第6集 6能量飛行</li>
										<li>第7集 7土地的香氣</li>
										<li>第8集 8新芽之喜</li>
										<li>第9集 9朝霧</li>
										<li>第10集 10林間悠靜處</li>
										<li>第11集 11月光與大樹</li>
										<li>第12集 12小溪在唱歌</li>
										<li>第13集 13芬多精之舞</li>
										<li>第14集 14林蔭下的世界</li>
										<li>第15集 15墨色夢境</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop82">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1立可白換新衣</li>
										<li>第2集 2鉛筆睡衣派對</li>
										<li>第3集 3小筆芯元氣體操</li>
										<li>第4集 4香水雙面膠之夢</li>
										<li>第5集 5黃色鉛筆與紅帽子 </li>
										<li>第6集 6小紙條飛行夢</li>
										<li>第7集 7粉紅圓規芭蕾舞</li>
										<li>第8集 8水果香</li>
										<li>第9集 9草莓橡皮擦</li>
										<li>第10集 10扭蛋冰淇淋</li>
										<li>第11集 11小刀勇士</li>
										<li>第12集 12原子筆三劍客</li>
										<li>第13集 13交換日記</li>
										<li>第14集 14抽屜的秘密</li>
										<li>第15集 15書包抱抱</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop83">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1新鮮的滋味</li>
										<li>第2集 2清脆悅心</li>
										<li>第3集 3彩色的思緒</li>
										<li>第4集 4心之晨光</li>
										<li>第5集 5與藍色同行</li>
										<li>第6集 6風的舞姿</li>
										<li>第7集 7咖啡香</li>
										<li>第8集 8晨浴之歌</li>
										<li>第9集 9嶄新的時刻</li>
										<li>第10集 10喜悅新原力</li>
										<li>第11集 11氣息之間</li>
										<li>第12集 12與陽光同行</li>
										<li>第13集 13大地拾穗</li>
										<li>第14集 14煥然一新</li>
										<li>第15集 15擁抱</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop84">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1陽光普照</li>
										<li>第2集 2花裙子的微笑</li>
										<li>第3集 3小鎮春天到</li>
										<li>第4集 4請妳喝一杯咖啡</li>
										<li>第5集 5花市的午後</li>
										<li>第6集 6蘋果園野餐</li>
										<li>第7集 7一起騎單車吧</li>
										<li>第8集 8忽然下起雨的夏天</li>
										<li>第9集 9兩張火車票</li>
										<li>第10集 10第一次遇見</li>
										<li>第11集 11楓葉與落日</li>
										<li>第12集 12橋上的街燈</li>
										<li>第13集 13紅色電話亭</li>
										<li>第14集 14女孩與蛋糕</li>
										<li>第15集 15木頭香小酒館</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop85">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1香醇之擁</li>
										<li>第2集 2我的小太陽</li>
										<li>第3集 3小時光咖啡館</li>
										<li>第4集 4月船之旅</li>
										<li>第5集 5從對街走來的女孩</li>
										<li>第6集 6似曾相識，某一天</li>
										<li>第7集 7與香水約會的下午</li>
										<li>第8集 8那天散步遇到妳</li>
										<li>第9集 9現在就可以跳舞吧</li>
										<li>第10集 10金色窗格中的倩影</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop86">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1晨露與玫瑰花</li>
										<li>第2集 2跳舞仙子</li>
										<li>第3集 3森林之浴</li>
										<li>第4集 4快樂的小松鼠</li>
										<li>第5集 5魔法三明治</li>
										<li>第6集 6蘋果小姐姐</li>
										<li>第7集 7小木屋舞會</li>
										<li>第8集 8蒲公英小飛俠</li>
										<li>第9集 9早安元氣公主</li>
										<li>第10集 10勇氣巧克力</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop87">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1水之舞</li>
										<li>第2集 2彩色夢境</li>
										<li>第3集 3雨的編織</li>
										<li>第4集 4藍色星空下</li>
										<li>第5集 5海之細語</li>
										<li>第6集 6天真恬淨</li>
										<li>第7集 7美之寧靜</li>
										<li>第8集 8秘境花園</li>
										<li>第9集 9浪漫森林</li>
										<li>第10集 10日暮之吻</li>
										<li>第11集 11舒柔宣言</li>
										<li>第12集 12愛情滿屋</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop88">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 引子</li>
										<li>第2集 01逍遙的老大</li>
										<li>第3集 02花羞無顏</li>
										<li>第4集 03追蹤七小邪</li>
										<li>第5集 04美人如玉冷如霜</li>
										<li>第6集 05教主很忙</li>
										<li>第7集 06究竟是誰負了誰</li>
										<li>第8集 07不是冤家不聚頭</li>
										<li>第9集 08得我者得江湖</li>
										<li>第10集 09羞花閉月花愁顫</li>
										<li>第11集 10月滿花舟</li>
										<li>第12集 11浣花微雨煮酒香</li>
										<li>第13集 12清夜一燈明</li>
										<li>第14集 13歲闌</li>
										<li>第15集 14花間良人歸</li>
										<li>第16集 番外歡喜天</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop89">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 楔子當王子邂逅強盜</li>
										<li>第2集 01偽裝女朋友</li>
										<li>第3集 02被歲月埋葬的過往</li>
										<li>第4集 03將錯就錯的愛</li>
										<li>第5集 04戀愛必修課</li>
										<li>第6集 05今天開始談戀愛</li>
										<li>第7集 06兩個無法相溶的世界</li>
										<li>第8集 08差點是女皇</li>
										<li>第9集 09罪之宿命</li>
										<li>第10集 10因愛而恨的報復</li>
										<li>第11集 11永不離開的約定</li>
										<li>第12集 尾聲我只在乎你</li>
										<li>第13集 番外100萬換換愛</li>
										<li>第14集 07救命啊！情感危機</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop90">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 一月紅柳樓</li>
										<li>第2集 一月緊急排練</li>
										<li>第3集 一月井底之蛙</li>
										<li>第4集 一月孫臏傳奇1</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop91">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 二月大嫂們</li>
										<li>第2集 二月孫臏傳奇</li>
										<li>第3集 二月武松打虎</li>
										<li>第4集 二月隱身草</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop92">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 三月大改行</li>
										<li>第2集 三月句句黑</li>
										<li>第3集 三月孫臏傳奇</li>
										<li>第4集 三月武松打虎</li>
										<li>第5集 三月喜相逢</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop93">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 六口人</li>
										<li>第2集 爸爸的兒子是誰</li>
										<li>第3集 開粥廠</li>
										<li>第4集 吝嗇鬼</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop94">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 說相聲</li>
										<li>第2集 紀曉嵐</li>
										<li>第3集 奪命列車</li>
										<li>第4集 和尚開葷</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop95">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 宋少卿牛肉麵館</li>
										<li>第2集 尊貴太太養生房</li>
										<li>第3集 正經事</li>
										<li>第4集 窮不怕</li>
										<li>第5集 抬杠公司</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop96">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 誰是兇手</li>
										<li>第2集 口吐蓮花</li>
										<li>第3集 令人頭痛</li>
										<li>第4集 山東門法</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop97">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 虎打武松</li>
										<li>第2集 我要拿金牌</li>
										<li>第3集 戲劇與方言</li>
										<li>第4集 集體即興創作</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop98">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 烏鴉嘴</li>
										<li>第2集 真功夫</li>
										<li>第3集 報菜名</li>
										<li>第4集 山西家信</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop99">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 勸架</li>
										<li>第2集 戒酒</li>
										<li>第3集 五紅圖</li>
										<li>第4集 平分秋色</li>
										<li>第5集 誰是白癡</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop100">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 搶年糕</li>
										<li>第2集 清朝聯考</li>
										<li>第3集 樑上君子</li>
										<li>第4集 白事會</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop101">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 我是蘇東坡</li>
										<li>第2集 我是乾隆皇</li>
										<li>第3集 十一言絕句</li>
										<li>第4集 慈禧端佑康頤昭豫莊誠壽恭欽獻崇熙聖母皇太后</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop102">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 信仰與命運第01章</li>
										<li>第2集 信仰與命運第02章</li>
										<li>第3集 信仰與命運第03章</li>
										<li>第4集 信仰與命運第04章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop103">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 花宅</li>
										<li>第2集 大學謎中謎</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop104">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 酒令</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop105">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 買賣論</li>
										<li>第2集 找五子</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop106">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 九月段子一</li>
										<li>第2集 九月相聲鬥漫才</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop107">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 八月喜迎25鬧生日</li>
										<li>第2集 八月八大吉祥</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop108">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 七月反七口</li>
										<li>第2集 七月四字歌</li>
										<li>第3集 七月影視控</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop109">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 六月結巴論</li>
										<li>第2集 六月六口人</li>
										<li>第3集 六月雙簧</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop110">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 五月滿漢全席</li>
										<li>第2集 五月陰陽五行</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop111">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 四月歌樂輕揚</li>
										<li>第2集 四月俏皮話</li>
										<li>第3集 四月四管四轄</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop112">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 三月廢話雜談</li>
										<li>第2集 三月歪批三國</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop113">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 二月二人見面忙把手</li>
										<li>第2集 二月滿腹經綸</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop114">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 一月開場</li>
										<li>第2集 一月繞口令</li>
										<li>第3集 一月一肚子三國</li>
										<li>第4集 一月結尾</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop115">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 水上摩托車</li>
										<li>第2集 輕航機</li>
										<li>第3集 SOGO音樂鐘</li>
										<li>第4集 儀隊交接操槍聲</li>
										<li>第5集 機場廣播及飛機起飛聲</li>
										<li>第6集 台北捷運</li>
										<li>第7集 菁寮教堂鐘聲</li>
										<li>第8集 木屐與木屐舞</li>
										<li>第9集 觀霧鳥鳴</li>
										<li>第10集 阿里山小火車</li>
										<li>第11集 台馬輪</li>
										<li>第12集 台糖五分車</li>
										<li>第13集 牡蠣風鈴</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop116">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 阿美族女子歌聲</li>
										<li>第2集 送檳榔的女孩</li>
										<li>第3集 邵族杵歌</li>
										<li>第4集 泰雅族祈福歌</li>
										<li>第5集 泰雅族人瑞演奏木琴</li>
										<li>第6集 泰雅族口簧琴</li>
										<li>第7集 魯凱族山歌</li>
										<li>第8集 北管</li>
										<li>第9集 南管</li>
										<li>第10集 布袋戲</li>
										<li>第11集 馬祖鼓板樂</li>
										<li>第12集 媽祖福州歌謠</li>
										<li>第13集 提弦</li>
										<li>第14集 伍佰現場演唱</li>
										<li>第15集 澎湖褒歌</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop117">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 刨冰</li>
										<li>第2集 狀元糕</li>
										<li>第3集 蚵仔剝殼</li>
										<li>第4集 蚵仔麵線蚵</li>
										<li>第5集 蔴荖</li>
										<li>第6集 爆米花</li>
										<li>第7集 搥貢丸</li>
										<li>第8集 擂茶</li>
										<li>第9集 製鐵壺</li>
										<li>第10集 木雕</li>
										<li>第11集 石雕</li>
										<li>第12集 打鐵</li>
										<li>第13集 油炸聲</li>
										<li>第14集 陀螺</li>
										<li>第15集 化緣</li>
										<li>第16集 響仁和鼓聲</li>
										<li>第17集 選舉</li>
										<li>第18集 職棒</li>
										<li>第19集 捕魚</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop118">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 跳鍾馗</li>
										<li>第2集 開龕門</li>
										<li>第3集 放水燈</li>
										<li>第4集 道士科儀</li>
										<li>第5集 乩童</li>
										<li>第6集 牽曲</li>
										<li>第7集 台灣陣頭</li>
										<li>第8集 求籤</li>
										<li>第9集 暮鼓晨鐘</li>
										<li>第10集 鹽水蜂炮</li>
										<li>第11集 大甲媽祖進香</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop119">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 衛生紙叫賣</li>
										<li>第2集 叭噗</li>
										<li>第3集 修理紗窗紗門</li>
										<li>第4集 肉粽叫賣聲</li>
										<li>第5集 磨剪刀叫聲</li>
										<li>第6集 舊銅鐵回收</li>
										<li>第7集 小籠包小饅頭</li>
										<li>第8集 烤蕃薯</li>
										<li>第9集 義賣現場</li>
										<li>第10集 漁獲叫賣</li>
										<li>第11集 夜市叫賣</li>
										<li>第12集 奮起湖便當</li>
										<li>第13集 芋頭冰</li>
										<li>第14集 衣服叫賣</li>
										<li>第15集 食品毛筆年貨叫賣</li>
										<li>第16集 豬血糕</li>
										<li>第17集 燒酒螺</li>
										<li>第18集 大餅饅頭</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop120">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 樹蛙</li>
										<li>第2集 台灣獼猴</li>
										<li>第3集 白耳畫眉</li>
										<li>第4集 五色鳥</li>
										<li>第5集 蟲鳴鳥叫</li>
										<li>第6集 黑面琵鷺</li>
										<li>第7集 馬祖燕鷗</li>
										<li>第8集 風櫃濤聲</li>
										<li>第9集 蟬叫蛙鳴</li>
										<li>第10集 風鈴季</li>
										<li>第11集 漁光國小</li>
										<li>第12集 獵人學校</li>
										<li>第13集 螺溪石硯</li>
										<li>第14集 台灣農村</li>
										<li>第15集 海豚</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop121">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1台灣地景故事總匯</li>
										<li>第2集 2高山深谷是怎麼來的</li>
										<li>第3集 3蘭嶼</li>
										<li>第4集 4蘭嶼情人洞</li>
										<li>第5集 5半屏山</li>
										<li>第6集 6基隆白米壺</li>
										<li>第7集 7野柳</li>
										<li>第8集 8野柳情人洞</li>
										<li>第9集 9中央山脈雪凱和泰懷絲</li>
										<li>第10集 10玉山土地公送白銀</li>
										<li>第11集 11阿里山</li>
										<li>第12集 12阿里山的火種</li>
										<li>第13集 13玉山的火種</li>
										<li>第14集 14姊妹潭</li>
										<li>第15集 15能高山</li>
										<li>第16集 16濁水溪</li>
										<li>第17集 17二八水</li>
										<li>第18集 18卑南溪</li>
										<li>第19集 19卑南高山的農夫</li>
										<li>第20集 20龜山島之一鄭成功跟妖霧</li>
										<li>第21集 21龜山島之二龍宮公主跟龜精</li>
										<li>第22集 22劍潭</li>
										<li>第23集 23劍井</li>
										<li>第24集 24鶯歌</li>
										<li>第25集 25澎湖列島</li>
										<li>第26集 26金瓜石</li>
										<li>第27集 27賴半街</li>
										<li>第28集 28葫蘆墩</li>
										<li>第29集 29日月潭的獨木舟</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop122">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 媽媽在這裡1</li>
										<li>第2集 媽媽在這裡2</li>
										<li>第3集 媽媽在這裡3</li>
										<li>第4集 媽媽在這裡4</li>
										<li>第5集 這裡是我家1</li>
										<li>第6集 這裡是我家2</li>
										<li>第7集 這裡是我家3</li>
										<li>第8集 這裡是我家4</li>
										<li>第9集 我們都是好姊妹1</li>
										<li>第10集 我們都是好姊妹2</li>
										<li>第11集 我們都是好姊妹3</li>
										<li>第12集 我們都是好姊妹4</li>
										<li>第13集 接續的情弦1</li>
										<li>第14集 接續的情弦2</li>
										<li>第15集 接續的情弦3</li>
										<li>第16集 接續的情弦4</li>
										<li>第17集 築夢台灣1</li>
										<li>第18集 築夢台灣2</li>
										<li>第19集 築夢台灣3</li>
										<li>第20集 築夢台灣4</li>
										<li>第21集 海闊憑魚躍天空任鳥飛1</li>
										<li>第22集 海闊憑魚躍天空任鳥飛2</li>
										<li>第23集 海闊憑魚躍天空任鳥飛3</li>
										<li>第24集 海闊憑魚躍天空任鳥飛4</li>
										<li>第25集 千里之外1</li>
										<li>第26集 千里之外2</li>
										<li>第27集 千里之外3</li>
										<li>第28集 千里之外4</li>
										<li>第29集 願嫁台灣郎1</li>
										<li>第30集 願嫁台灣郎2</li>
										<li>第31集 願嫁台灣郎3</li>
										<li>第32集 願嫁台灣郎4</li>
										<li>第33集 東協廣場的圖書館1</li>
										<li>第34集 東協廣場的圖書館2</li>
										<li>第35集 東協廣場的圖書館3</li>
										<li>第36集 東協廣場的圖書館4</li>
										<li>第37集 我從草原來1</li>
										<li>第38集 我從草原來2</li>
										<li>第39集 我從草原來3</li>
										<li>第40集 我從草原來4</li>
										<li>第41集 你在台灣好嗎1</li>
										<li>第42集 你在台灣好嗎2</li>
										<li>第43集 你在台灣好嗎3</li>
										<li>第44集 你在台灣好嗎4</li>
										<li>第45集 我要當導遊1</li>
										<li>第46集 我要當導遊2</li>
										<li>第47集 我要當導遊3</li>
										<li>第48集 我要當導遊4</li>
										<li>第49集 讓夢想起飛1</li>
										<li>第50集 讓夢想起飛2</li>
										<li>第51集 讓夢想起飛3</li>
										<li>第52集 讓夢想起飛4</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop123">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 撐起東南半天璧1</li>
										<li>第2集 撐起東南半天璧2</li>
										<li>第3集 撐起東南半天璧3</li>
										<li>第4集 撐起東南半天璧4</li>
										<li>第5集 東寧臥龍遺愛人間1</li>
										<li>第6集 東寧臥龍遺愛人間2</li>
										<li>第7集 東寧臥龍遺愛人間3</li>
										<li>第8集 東寧臥龍遺愛人間4</li>
										<li>第9集 桃李春風1</li>
										<li>第10集 桃李春風2</li>
										<li>第11集 桃李春風3</li>
										<li>第12集 桃李春風4</li>
										<li>第13集 葉王捏陶1</li>
										<li>第14集 葉王捏陶2</li>
										<li>第15集 葉王捏陶3</li>
										<li>第16集 葉王捏陶4</li>
										<li>第17集 火車來了1</li>
										<li>第18集 火車來了2</li>
										<li>第19集 火車來了3</li>
										<li>第20集 火車來了4</li>
										<li>第21集 沙場埋骨不降夷1</li>
										<li>第22集 沙場埋骨不降夷2</li>
										<li>第23集 沙場埋骨不降夷3</li>
										<li>第24集 沙場埋骨不降夷4</li>
										<li>第25集 仁心仁術1</li>
										<li>第26集 仁心仁術2</li>
										<li>第27集 仁心仁術3</li>
										<li>第28集 仁心仁術4</li>
										<li>第29集 重修龍山寺1</li>
										<li>第30集 重修龍山寺2</li>
										<li>第31集 重修龍山寺3</li>
										<li>第32集 重修龍山寺4</li>
										<li>第33集 霧社事件1</li>
										<li>第34集 霧社事件2</li>
										<li>第35集 霧社事件3</li>
										<li>第36集 霧社事件4</li>
										<li>第37集 台灣人的台灣1</li>
										<li>第38集 台灣人的台灣2</li>
										<li>第39集 台灣人的台灣3</li>
										<li>第40集 台灣人的台灣4</li>
										<li>第41集 青空一片雲1</li>
										<li>第42集 青空一片雲2</li>
										<li>第43集 青空一片雲3</li>
										<li>第44集 青空一片雲4</li>
										<li>第45集 愛愛寮1</li>
										<li>第46集 愛愛寮2</li>
										<li>第47集 愛愛寮3</li>
										<li>第48集 愛愛寮4</li>
										<li>第49集 來自恆春的歌謠1</li>
										<li>第50集 來自恆春的歌謠2</li>
										<li>第51集 來自恆春的歌謠3</li>
										<li>第52集 來自恆春的歌謠4</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop124">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 01王永德金門歷史1</li>
										<li>第2集 02王永德金門歷史2</li>
										<li>第3集 03基隆河的港仔口</li>
										<li>第4集 04男高音聲樂家張至城及吳美德夫婦</li>
										<li>第5集 05管風琴音樂推廣1</li>
										<li>第6集 06管風琴音樂推廣2</li>
										<li>第7集 07管風琴音樂推廣3</li>
										<li>第8集 08按摩師張茂榮1</li>
										<li>第9集 09按摩師張茂榮2</li>
										<li>第10集 10按摩師童清傳1</li>
										<li>第11集 11按摩師童清傳2</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop125">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 01獨立唱片代理商杜芳月</li>
										<li>第2集 02北投溫泉老店瀧乃湯</li>
										<li>第3集 03全盲演奏家黃東裕</li>
										<li>第4集 04石泉巖茶路古道</li>
										<li>第5集 05中國書畫收藏家岑得臨</li>
										<li>第6集 06石泉巖神奇泉水</li>
										<li>第7集 07音樂家崔玉盤</li>
										<li>第8集 08光鹽愛盲服務阮芬芳及蘇清富上</li>
										<li>第9集 09光鹽愛盲服務阮芬芳及蘇清富下</li>
										<li>第10集 10地下道的盲人胡琴演奏家曾宜真</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop126">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 01木瓜歷史知性時間</li>
										<li>第2集 02音樂創作人謝與威</li>
										<li>第3集 03新潮文庫世界名著出版家張清吉1</li>
										<li>第4集 04新潮文庫世界名著出版家張清吉2</li>
										<li>第5集 05鶯歌原民圖騰陶藝家陳木全1</li>
										<li>第6集 06鶯歌原民圖騰陶藝家陳木全2</li>
										<li>第7集 07獨立唱片代理商杜芳月1</li>
										<li>第8集 08獨立唱片代理商杜芳月2</li>
										<li>第9集 09淡江大學盲生資源教室楊勝宏1</li>
										<li>第10集 10淡江大學盲生資源教室楊勝宏2</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop127">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 01金剛經梵文翻譯許陽主1</li>
										<li>第2集 02金剛經梵文翻譯許陽主2</li>
										<li>第3集 03金剛經梵文翻譯許陽主3</li>
										<li>第4集 04台灣戏劇</li>
										<li>第5集 05貝多芬作品</li>
										<li>第6集 06陽明山的萬種風情</li>
										<li>第7集 07賴和醫療獎都市叢林醫師郭維租1</li>
										<li>第8集 08賴和醫療獎都市叢林醫師郭維租2</li>
										<li>第9集 09賴和醫療獎都市叢林醫師郭維租3</li>
										<li>第10集 10台北盆地北投唭哩岸歷史1</li>
										<li>第11集 11台北盆地北投唭哩岸歷史2</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop128">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 01與民國同壽的李郭敏女士上</li>
										<li>第2集 02與民國同壽的李郭敏女士下</li>
										<li>第3集 03專訪范楊坤談阿美族民歌采集上</li>
										<li>第4集 04專訪范楊坤談阿美族民歌采集下</li>
										<li>第5集 05尋找新港人的生命力上</li>
										<li>第6集 06尋找新港人的生命力下</li>
										<li>第7集 07專訪郭慶霖談金山鄉金包里1</li>
										<li>第8集 08專訪郭慶霖談金山鄉金包里2</li>
										<li>第9集 09專訪郭慶霖談金山鄉金包里3</li>
										<li>第10集 10專訪郭慶霖談金山鄉金包里4</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop129">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 提升女性豐滿UPUP</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop130">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 超級學習記憶</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop131">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 維持苗條體態</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop132">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 紓壓放鬆法門</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop133">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 睡眠中的瑜珈</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop134">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1發現和預防及早察覺長輩失能失智</li>
										<li>第2集 2照顧當父母失能了如何妥適照護</li>
										<li>第3集 3善終為父母預約一個美好尊嚴的人道告別</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop135">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1白羊座成功致富的方式</li>
										<li>第2集 2金牛座成功致富的方式</li>
										<li>第3集 3雙子座成功致富的方式</li>
										<li>第4集 4巨蟹座成功致富的方式</li>
										<li>第5集 5獅子座成功致富的方式</li>
										<li>第6集 6處女座成功致富的方式</li>
										<li>第7集 7天秤座成功致富的方式</li>
										<li>第8集 8天蠍座成功致富的方式</li>
										<li>第9集 9射手座成功致富的方式</li>
										<li>第10集 10魔羯座成功致富的方式</li>
										<li>第11集 11水瓶座成功致富的方式</li>
										<li>第12集 12雙魚座成功致富的方式</li>
										<li>第13集 13火象星座的工作及財富地雷</li>
										<li>第14集 14土象星座的工作及財富地雷</li>
										<li>第15集 15風象星座的工作及財富地雷</li>
										<li>第16集 16水象星座的工作及財富地雷</li>
										<li>第17集 17火象心想事成開運祕法</li>
										<li>第18集 18土象心想事成開運祕法</li>
										<li>第19集 19風象心想事成開運祕法</li>
										<li>第20集 20水象心想事成開運祕法</li>
										<li>第21集 發刊詞</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop136">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊辭</li>
										<li>第2集 1認識白羊座情人為眼光而生的情人</li>
										<li>第3集 2認識金牛座情人為伴侶而生的情人</li>
										<li>第4集 3認識雙子座情人為外貌而生的情人</li>
										<li>第5集 4認識巨蟹座情人為聰慧而生的情人</li>
										<li>第6集 5認識獅子座情人為崇拜而生的情人</li>
										<li>第7集 6認識處女座情人為服務而生的情人</li>
										<li>第8集 7認識天秤座情人為優雅而生的情人</li>
										<li>第9集 8認識天蠍座情人為夢幻而生的情人</li>
										<li>第10集 9認識射手座情人為樂觀而生的情人</li>
										<li>第11集 10認識魔羯座情人為質感而生的情人</li>
										<li>第12集 11認識水瓶座情人為家庭而生的情人</li>
										<li>第13集 12認識雙魚座情人為顏質而生的情人</li>
										<li>第14集 13抓住基本宮真心的愛情攻略</li>
										<li>第15集 14抓住固定宮真心的愛情攻略</li>
										<li>第16集 15抓住變動宮真心的愛情攻略</li>
										<li>第17集 16基本宮的完美愛情泉源崇高的理想與境界</li>
										<li>第18集 17固定宮的完美愛情泉源社會的支持與認可</li>
										<li>第19集 18變動宮的完美愛情泉源不同的完美狀態</li>
										<li>第20集 19金星落在12星座情人的愛情與婚姻特質</li>
										<li>第21集 20火星落在12星座情人的愛情行動力與親密關係特質</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop137">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊辭</li>
										<li>第2集 1整體運勢</li>
										<li>第3集 2摩羯座事業財富</li>
										<li>第4集 3摩羯座感情健康</li>
										<li>第5集 4水瓶座事業財富</li>
										<li>第6集 5水瓶座感情健康</li>
										<li>第7集 6雙魚座事業財富</li>
										<li>第8集 7雙魚座感情健康</li>
										<li>第9集 8白羊座事業財富</li>
										<li>第10集 9白羊座感情健康</li>
										<li>第11集 10金牛座事業財富</li>
										<li>第12集 11金牛座感情健康</li>
										<li>第13集 12雙子座事業財富</li>
										<li>第14集 13雙子座感情健康</li>
										<li>第15集 14巨蟹座事業財富</li>
										<li>第16集 15巨蟹座感情健康</li>
										<li>第17集 16獅子座事業財富</li>
										<li>第18集 17獅子座感情健康</li>
										<li>第19集 18處女座事業財富</li>
										<li>第20集 19處女座感情健康</li>
										<li>第21集 20天秤座事業財富</li>
										<li>第22集 21天秤座感情健康</li>
										<li>第23集 22天蠍座事業財富</li>
										<li>第24集 23天蠍座感情健康</li>
										<li>第25集 24射手座事業財富</li>
										<li>第26集 25射手座感情健康</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop138">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 發刊辭</li>
										<li>第2集 1白羊座</li>
										<li>第3集 2金牛座</li>
										<li>第4集 3雙子座</li>
										<li>第5集 4巨蟹座</li>
										<li>第6集 5獅子座</li>
										<li>第7集 6處女座</li>
										<li>第8集 7天秤座</li>
										<li>第9集 8天蠍座</li>
										<li>第10集 9射手座</li>
										<li>第11集 10魔羯座</li>
										<li>第12集 11水瓶座</li>
										<li>第13集 12.雙魚座</li>
										<li>第14集 13風象教養攻略</li>
										<li>第15集 14風象教養地雷</li>
										<li>第16集 15水象教養攻略</li>
										<li>第17集 16水象教養地雷</li>
										<li>第18集 17土象教養攻略</li>
										<li>第19集 18土象教養地雷</li>
										<li>第20集 19火象教養攻略</li>
										<li>第21集 20火象教養地雷</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop139">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1呼吸觀察</li>
										<li>第2集 2身體掃描</li>
										<li>第3集 3正念伸展</li>
										<li>第4集 4正念行走</li>
										<li>第5集 5整體靜坐</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop140">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1Running Man</li>
										<li>第2集 2拍拖不囉嗦</li>
										<li>第3集 3面試大考驗</li>
										<li>第4集 4分手專家</li>
										<li>第5集 5Double Date</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop141">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 6一起搖滾吧</li>
										<li>第2集 7美食鑑賞家</li>
										<li>第3集 8甜甜駕訓班</li>
										<li>第4集 9遊戲高手</li>
										<li>第5集 10睡眠大師</li>
										<li>第6集 11說話得體不dirty</li>
										<li>第7集 12鬧事補習班</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop142">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1女子無才便是德</li>
										<li>第2集 2不食主義者</li>
										<li>第3集 3交友軟體</li>
										<li>第4集 4陳同學</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop143">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1出門在外的必備良藥是什麼</li>
										<li>第2集 2怎麼和同事求婚</li>
										<li>第3集 3健康問題大哉問</li>
										<li>第4集 4疏忽女友怎麼辦</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop144">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 學唱歌</li>
										<li>第2集 燕青打擂</li>
										<li>第3集 黃鶴樓</li>
										<li>第4集 台灣NO1</li>
										<li>第5集 笛子演奏</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop145">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1完璧歸趙京韻大鼓</li>
										<li>第2集 2論拳對口相聲</li>
										<li>第3集 3鞭打蘆花奉調大鼓</li>
										<li>第4集 4單衣順母單弦</li>
										<li>第5集 5大秋景單弦</li>
										<li>第6集 6曹雪芹治病評書選段</li>
										<li>第7集 7長壽村竹板快書</li>
										<li>第8集 8放羊竹板快書</li>
										<li>第9集 9打籃球對口相聲</li>
										<li>第10集 10長坂坡京韻大鼓</li>
										<li>第11集 11定風波京韻大鼓</li>
										<li>第12集 12阿清伯京韻今聲</li>
										<li>第13集 13春茶京韻今聲</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop146">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 分手專家</li>
										<li>第2集 前任</li>
										<li>第3集 婚姻諮商師</li>
										<li>第4集 遠距離的信</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop147">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 拜訪爸爸</li>
										<li>第2集 求婚練習曲</li>
										<li>第3集 婚紗攝影</li>
										<li>第4集 情侶默契大考驗</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop148">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1名畫大喜利</li>
										<li>第2集 2婚姻諮商</li>
										<li>第3集 3大家都是大野狼</li>
										<li>第4集 4未來電梯</li>
										<li>第5集 5野餐鬼故事</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop149">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1光明燈</li>
										<li>第2集 2太歲燈</li>
										<li>第3集 3文昌燈</li>
										<li>第4集 4消災燈</li>
										<li>第5集 5姻緣燈</li>
										<li>第6集 6平安燈</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop151">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 第1章驚世駭俗談一場戀愛</li>
										<li>第2集 第2章放蕩生活的極致展演</li>
										<li>第3集 第3章魔幻寫實的寄託寓意</li>
										<li>第4集 第4章商品經濟激發人性潛能</li>
										<li>第5集 第5章弱女子的非常手段</li>
										<li>第6集 第6章文學家蒲松齡的生命理想與文學事業</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop152">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 三乘心要</li>
										<li>第2集 三圓滿清淨與五毒自解脫之連結</li>
										<li>第3集 大乘精要虛空善道</li>
										<li>第4集 不淨幻身</li>
										<li>第5集 清淨幻身</li>
										<li>第6集 心性明亮寬廣的法界</li>
										<li>第7集 四加行詩偈</li>
										<li>第8集 幸運的意義</li>
										<li>第9集 明光皓日之心髓</li>
										<li>第10集 法螺之聲</li>
										<li>第11集 勇士與懦夫一線之隔</li>
										<li>第12集 真正實相</li>
										<li>第13集 智慧之燈</li>
										<li>第14集 智慧雷霆</li>
										<li>第15集 萬物本貌</li>
										<li>第16集 寬廣的虛空</li>
										<li>第17集 龍樹五大因</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop153">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 相面</li>
										<li>第2集 夢中婚</li>
										<li>第3集 論捧逗</li>
										<li>第4集 姥姥年</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop154">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 新年祝願偈</li>
										<li>第2集 以十方諸佛為對境的甚深祈請</li>
										<li>第3集 吉祥光照全宇宙</li>
										<li>第4集 迅速成辦真實語祈願文</li>
										<li>第5集 速往淨土祈願文</li>
										<li>第6集 悲心祈願文</li>
										<li>第7集 大手印大圓滿</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop155">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 一切顯相</li>
										<li>第2集 工作正念歌</li>
										<li>第3集 市中遊平等訣</li>
										<li>第4集 平等性組曲</li>
										<li>第5集 萬法平等性之歌</li>
										<li>第6集 顯空平等性之歌</li>
										<li>第7集 此生顯空不二</li>
										<li>第8集 朋友</li>
										<li>第9集 金剛拳心要</li>
										<li>第10集 若知顯相如上師</li>
										<li>第11集 笑看顯相</li>
										<li>第12集 無常</li>
										<li>第13集 給佛法中心工作人員的忠告</li>
										<li>第14集 聞即了知</li>
										<li>第15集 瑜伽士與瑜伽女之歌</li>
										<li>第16集 爾若於見之中獲確信</li>
										<li>第17集 痛苦輪迴</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop156">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 身安心安禪安第01章</li>
										<li>第2集 身安心安禪安第02章</li>
										<li>第3集 身安心安禪安第03章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop157">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 開經偈</li>
										<li>第2集 普賢行願品重頌全本</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop158">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1法鼓山</li>
										<li>第2集 2法鼓頌</li>
										<li>第3集 3慈悲</li>
										<li>第4集 4四眾佛子共勉語</li>
										<li>第5集 5萬行菩薩共勉語</li>
										<li>第6集 6如來如去</li>
										<li>第7集 7法鼓頌音樂</li>
										<li>第8集 8法鼓頌</li>
										<li>第9集 9法鼓山</li>
										<li>第10集 10阿彌陀佛</li>
										<li>第11集 11人人有福</li>
										<li>第12集 12菩薩姻緣</li>
										<li>第13集 13清涼自在老菩薩之歌</li>
										<li>第14集 14法鼓山音樂</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop159">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1四眾佛子共勉語</li>
										<li>第2集 2菩薩行</li>
										<li>第3集 3老菩薩之歌</li>
										<li>第4集 4菩薩的手</li>
										<li>第5集 5友誼歌</li>
										<li>第6集 6四眾佛子共勉語演奏版</li>
										<li>第7集 7菩薩行演奏版</li>
										<li>第8集 8老菩薩之歌演奏版</li>
										<li>第9集 9菩薩手演奏版</li>
										<li>第10集 10友誼歌演奏版</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop160">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1演唱曲我為你祝福</li>
										<li>第2集 2演唱曲要不要</li>
										<li>第3集 3演唱曲環保列車</li>
										<li>第4集 4演唱曲平安歌</li>
										<li>第5集 5演奏曲我為你祝福</li>
										<li>第6集 6演奏曲要不要</li>
										<li>第7集 7演奏曲環保列車</li>
										<li>第8集 8演奏曲平安歌</li>
										<li>第9集 9伴唱曲我為你祝福</li>
										<li>第10集 10伴唱曲要不要</li>
										<li>第11集 11伴唱曲環保列車</li>
										<li>第12集 12伴唱曲平安</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop161">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 菩薩的各種成就</li>
										<li>第2集 清淨身口意</li>
										<li>第3集 種種力量</li>
										<li>第4集 種種智慧</li>
										<li>第5集 十度與十力</li>
										<li>第6集 緣起與空</li>
										<li>第7集 斷惡做善菩薩行</li>
										<li>第8集 實相即無相</li>
										<li>第9集 在家菩薩如何修行第01章</li>
										<li>第10集 在家菩薩如何修行第02章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop162">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 觀世音菩薩</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop163">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 無問自說</li>
										<li>第2集 國土的莊嚴</li>
										<li>第3集 無量光無量壽</li>
										<li>第4集 諸佛讚歎</li>
										<li>第5集 願心不退</li>
										<li>第6集 稀有易行之法門</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop164">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 唱誦與源流</li>
										<li>第2集 名稱與注疏</li>
										<li>第3集 經典的現代意義</li>
										<li>第4集 供僧盡孝道</li>
										<li>第5集 經題1</li>
										<li>第6集 經題2</li>
										<li>第7集 目連救母</li>
										<li>第8集 僧自恣日</li>
										<li>第9集 四事供養</li>
										<li>第10集 結夏安居</li>
										<li>第11集 具足清淨戒</li>
										<li>第12集 聖眾之道其德汪洋</li>
										<li>第13集 願七世父母得安樂</li>
										<li>第14集 佛歡喜日</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop165">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 沒有色彩的多崎作和他的巡禮之年上</li>
										<li>第2集 沒有色彩的多崎作和他的巡禮之年下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop166">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 源流與題解</li>
										<li>第2集 禮敬諸佛</li>
										<li>第3集 稱頌如來</li>
										<li>第4集 廣修供養上</li>
										<li>第5集 廣修供養下</li>
										<li>第6集 懺悔業障</li>
										<li>第7集 隨喜功德</li>
										<li>第8集 請轉法輪</li>
										<li>第9集 請佛住世</li>
										<li>第10集 常隨佛學</li>
										<li>第11集 恒順眾生</li>
										<li>第12集 不於菩提心生迷</li>
										<li>第13集 解脫三障諸煩惱</li>
										<li>第14集 同修同行善知識</li>
										<li>第15集 如一塵端如塵刹</li>
										<li>第16集 圓滿普賢行</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop167">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 觀世音菩薩普門品第01章</li>
										<li>第2集 觀世音菩薩普門品第02章</li>
										<li>第3集 觀世音菩薩普門品第03章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop168">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 序論</li>
										<li>第2集 空中鳥跡</li>
										<li>第3集 須菩提請法</li>
										<li>第4集 不取法不取非法</li>
										<li>第5集 實相非相</li>
										<li>第6集 拾二不執中</li>
										<li>第7集 離相無相</li>
										<li>第8集 無住心生</li>
										<li>第9集 信受演說功德</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop169">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 大地觀的修行</li>
										<li>第2集 地藏的意義</li>
										<li>第3集 佛心眾生心</li>
										<li>第4集 菩薩與菩薩戒</li>
										<li>第5集 心地法門</li>
										<li>第6集 學習地的精神</li>
										<li>第7集 本生本緣本行</li>
										<li>第8集 大道心終生1</li>
										<li>第9集 大道心終生2</li>
										<li>第10集 地藏菩薩的本願1</li>
										<li>第11集 地藏菩薩的本願2</li>
										<li>第12集 千百萬億的化身</li>
										<li>第13集 佈施與回向</li>
										<li>第14集 誠心修行</li>
										<li>第15集 地藏法門與認生</li>
										<li>第16集 地藏菩薩的本行功德</li>
										<li>第17集 如何修行地藏法門</li>
										<li>第18集 修行地藏法門的好處</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop170">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1金剛薩埵心咒</li>
										<li>第2集 2聽即解脫咒</li>
										<li>第3集 3迎向智慧明境</li>
										<li>第4集 4妙音天女</li>
										<li>第5集 5歡喜象王天</li>
										<li>第6集 6金剛薩埵百字明咒</li>
										<li>第7集 7天使也看見了</li>
										<li>第8集 8四無量心祈菩行</li>
										<li>第9集 9觀自在祈菩行2</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop171">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1緣起的呼喚</li>
										<li>第2集 2皈依頌</li>
										<li>第3集 3觀音菩薩六字真言</li>
										<li>第4集 4般若波羅蜜多心經</li>
										<li>第5集 5般若波羅蜜多心咒</li>
										<li>第6集 6文殊師利菩薩心咒</li>
										<li>第7集 7當下的呼喚</li>
										<li>第8集 8觀自在</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop172">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1四無量心</li>
										<li>第2集 2蓮花生大士心咒</li>
										<li>第3集 3白度母心咒</li>
										<li>第4集 4藥師佛如來心咒</li>
										<li>第5集 5綠度母心咒</li>
										<li>第6集 6普賢菩薩行願品</li>
										<li>第7集 7咕嚧咕咧佛母心咒</li>
										<li>第8集 8蓮花生大士心咒靜心長版</li>
										<li>第9集 9白度母心咒靜心長版</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop173">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1歸程組曲慧身出塵</li>
										<li>第2集 2歸程組曲剃度入山</li>
										<li>第3集 3歸程組曲執劍護教</li>
										<li>第4集 4歸程組曲慈悲</li>
										<li>第5集 5歸程組曲我為你祝福</li>
										<li>第6集 6歸程組曲法鼓山</li>
										<li>第7集 7法鼓組曲法鼓頌</li>
										<li>第8集 8法鼓組曲法鼓山</li>
										<li>第9集 9法鼓組曲四眾佛子共勉語</li>
										<li>第10集 10法鼓組曲慈悲</li>
										<li>第11集 11法鼓組曲我為你祝福</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop174">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1美國一甲子折翼老鷹近身觀察</li>
										<li>第2集 2由五月花到建國開拓的理想</li>
										<li>第3集 3寡頭佔有美國地方決策中樞</li>
										<li>第4集 4美國大西部開發土地與環境的破壞</li>
										<li>第5集 5多元大熔爐移民造就今日美國</li>
										<li>第6集 6操縱美國工商業發展的濫觴</li>
										<li>第7集 7美國式資本主義特色</li>
										<li>第8集 8城鄉差距造成的階級化</li>
										<li>第9集 9美國政治遊說文化的運作</li>
										<li>第10集 10偽善的美國人心態</li>
										<li>第11集 11無可救藥的美國走向衰敗的大蘋果</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop175">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1向200位CEO學領導</li>
										<li>第2集 2失敗是更好的老師</li>
										<li>第3集 3成功長得什麼樣子</li>
										<li>第4集 4不是憂慮失敗而是憂慮成功</li>
										<li>第5集 5簡單就是力量</li>
										<li>第6集 6做個乘法領導人</li>
										<li>第7集 7招喚行動</li>
										<li>第8集 8複製你的五星級人才</li>
										<li>第9集 9星期一早上九點你在做什麼</li>
										<li>第10集 10團隊合作的藝術</li>
										<li>第11集 11勤已經不能補拙</li>
										<li>第12集 12向即興劇學管理</li>
										<li>第13集 13顧客是最好的解答</li>
										<li>第14集 14抓住過去還是擁抱未來</li>
										<li>第15集 15不景氣的時候要有贏的心態</li>
										<li>第16集 16戰略的對話</li>
										<li>第17集 17放棄的藝術</li>
										<li>第18集 18別和過去談戀愛</li>
										<li>第19集 19做點小實驗</li>
										<li>第20集 20沒有追蹤就沒有管理</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop176">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 悅讀心旅行-王文華《開除自己的總經理》（試聽）</li>
										<li>第2集 悅讀心旅行-王文華《開除自己的總經理》</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop177">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 父女的人生問答題</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop178">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 成功不是你想的那樣</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop179">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1快樂是什麼</li>
										<li>第2集 2什麼樣才是好的領導人</li>
										<li>第3集 3要快樂同時不要滿足</li>
										<li>第4集 4錢不會讓你變好只會擴大你的現狀</li>
										<li>第5集 5想有錢就有錢的金錢修練</li>
										<li>第6集 6我們的成就是說出來的</li>
										<li>第7集 7一句謝謝的神奇力量</li>
										<li>第8集 8該為一天的幸運作什麼準備</li>
										<li>第9集 9允許自己被感動</li>
										<li>第10集 10別埋頭苦幹做個白日夢吧</li>
										<li>第11集 11祝福你的敵人</li>
										<li>第12集 12不僅要贏還要一直贏</li>
										<li>第13集 13不懂也是一種好領導</li>
										<li>第14集 14別人別人穿你的鞋</li>
										<li>第15集 15忠言逆耳的謊言</li>
										<li>第16集 16但是的秘密</li>
										<li>第17集 17別讓過去的成功騙了現在的自己</li>
										<li>第18集 18生氣時說不說話</li>
										<li>第19集 19問出成功的路徑而不是給予絕對的否定</li>
										<li>第20集 20不必一個人傷腦筋</li>
										<li>第21集 21最輕鬆的管理讓讚賞來得正是時候</li>
										<li>第22集 22成功不必在我</li>
										<li>第23集 23逮到開溜的自己</li>
										<li>第24集 24不要滾動怪罪過去的雪球</li>
										<li>第25集 25用公平打開偏心的圍欄</li>
										<li>第26集 26別怕你承擔得起你的對不起</li>
										<li>第27集 27打開你的耳朵和你的心</li>
										<li>第28集 28禮多人不怪 禮多更可愛</li>
										<li>第29集 29保護自己不必推卸責任</li>
										<li>第30集 30我不是宇宙的中心</li>
										<li>第31集 31小心目標成癮的陷阱</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop180">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1什麼是戰略</li>
										<li>第2集 2怎樣才是最會打仗的人</li>
										<li>第3集 3什麼是最常用在企業經營上的兵法觀念</li>
										<li>第4集 4怎樣的戰略才稱得上高大上</li>
										<li>第5集 5人生發展與企業經營為什麼都該建構藍海戰略</li>
										<li>第6集 6能讓企業大腕一統產業的戰略是什麼</li>
										<li>第7集 7什麼是讓天地皆加持神鬼人都援手的人生大戰略</li>
										<li>第8集 8孫子兵法用到商場上為什麼效果特好</li>
										<li>第9集 9什麼是讓您在談判中振振有詞取得上風的戰略</li>
										<li>第10集 10什麼是保證人生成功的黃金戰略</li>
										<li>第11集 11什麼是最能讓您乘風借力成就志業的戰略</li>
										<li>第12集 12什麼是戰術</li>
										<li>第13集 13戰場商場人生的好運那兒來</li>
										<li>第14集 14成就英雄偉業必要抓住什麼</li>
										<li>第15集 15何時進攻何時防守</li>
										<li>第16集 16作戰競技工作該使幾分力用什麼節奏</li>
										<li>第17集 17人生發展該補正自身短處還是發揮一己所長</li>
										<li>第18集 18要別人手中的魚該如何到手</li>
										<li>第19集 19以寡擊眾以弱對強如何得到勝利</li>
										<li>第20集 20要達到目標最快最有效的路線怎麼走</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop181">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1領導人的一個關鍵特質</li>
										<li>第2集 2停止做你太擅長的事</li>
										<li>第3集 3提升你的領導自信心</li>
										<li>第4集 4你喜歡領導團隊嗎</li>
										<li>第5集 5這不是虛偽這是專業</li>
										<li>第6集 6為你的進步負責</li>
										<li>第7集 7改變從自己做起</li>
										<li>第8集 8不只做事還要學會做人</li>
										<li>第9集 9當人人都需要你</li>
										<li>第10集 10別人不是你</li>
										<li>第11集 11沒有跟進就沒有成果</li>
										<li>第12集 12學會讓別人贏</li>
										<li>第13集 13重點是怎麼做而不是怎麼說</li>
										<li>第14集 14你是偏心的主管嗎</li>
										<li>第15集 15領導的開關永遠不關上</li>
										<li>第16集 16教練團隊的六個問題</li>
										<li>第17集 17領導力是做出來的</li>
										<li>第18集 18如何領導新世代員工</li>
										<li>第19集 19開口前想一想</li>
										<li>第20集 20練習授權練習放手</li>
										<li>第21集 21誰是不可被教練的人</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop182">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1白羊座成功致富的方式</li>
										<li>第2集 2金牛座成功致富的方式</li>
										<li>第3集 3雙子座成功致富的方式</li>
										<li>第4集 4巨蟹座成功致富的方式</li>
										<li>第5集 5獅子座成功致富的方式</li>
										<li>第6集 6處女座成功致富的方式</li>
										<li>第7集 7天秤座成功致富的方式</li>
										<li>第8集 8天蠍座成功致富的方式</li>
										<li>第9集 9射手座成功致富的方式</li>
										<li>第10集 10魔羯座成功致富的方式</li>
										<li>第11集 11水瓶座成功致富的方式</li>
										<li>第12集 12雙魚座成功致富的方式</li>
										<li>第13集 13火象星座的工作及財富地雷</li>
										<li>第14集 14土象星座的工作及財富地雷</li>
										<li>第15集 15風象星座的工作及財富地雷</li>
										<li>第16集 16水象星座的工作及財富地雷</li>
										<li>第17集 17火象心想事成開運祕法</li>
										<li>第18集 18土象心想事成開運祕法</li>
										<li>第19集 19風象心想事成開運祕法</li>
										<li>第20集 20水象心想事成開運祕法</li>
										<li>第21集 發刊詞</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop183">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 財富的秘密第01章</li>
										<li>第2集 財富的秘密第02章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop184">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 別人的情緒你讀懂了嗎</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop185">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 為什麼讀書</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop186">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 為什麼我們經常誤解人心</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop187">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 好人怎麼會幹壞事</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop188">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 說出一個好故事所有人都會跟你走</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop189">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 吵架吧我倆明天會更好</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop190">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 每天最重要的2小時</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop191">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 創造力</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop192">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 精準表達</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop193">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 做自己的生命設計師</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop194">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 情緒勒索</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop195">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 讓顧客的錢自動流進來</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop196">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 你的善良必須有點鋒芒</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop197">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 人類還在玩猿猴把戲</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop198">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1人際關係與溝通的真實面貌</li>
										<li>第2集 2溝通目的在於真心享建立共識</li>
										<li>第3集 3瞭解對象屬性給他真正需要的</li>
										<li>第4集 4傾聽要懂得聽而且要聽得懂</li>
										<li>第5集 5塑造個人的專業形象</li>
										<li>第6集 6溝通表達元素3加1缺一不可</li>
										<li>第7集 7有生命力的成功表達</li>
										<li>第8集 8從自我肯定開始去肯定別人</li>
										<li>第9集 9感恩是開啟一切真理的鑰匙</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop199">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 如何讓說服更具吸引力</li>
										<li>第2集 說服中的引導與決策</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop200">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 贏得好的關係塑造你的親和力</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop201">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1說話的技巧</li>
										<li>第2集 2聽的藝術</li>
										<li>第3集 3回饋與抉擇</li>
										<li>第4集 4溝通策略的分析運用上</li>
										<li>第5集 5溝通策略的分析運用下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop202">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1文明是自建天堂的努力</li>
										<li>第2集 2科技賦予人類超能力追求舒適生活</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop203">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 希望</li>
										<li>第2集 情義</li>
										<li>第3集 白色的山</li>
										<li>第4集 窗</li>
										<li>第5集 和平之路</li>
										<li>第6集 師父</li>
										<li>第7集 禮物</li>
										<li>第8集 您的遠行楊培安演唱</li>
										<li>第9集 他的身影伴唱曲</li>
										<li>第10集 您的遠行伴唱曲</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop204">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1有錢是教出來的</li>
										<li>第2集 2有天我不在了孩子怎麼辦</li>
										<li>第3集 3教他有錢不是給他錢</li>
										<li>第4集 4零用錢應該給多少</li>
										<li>第5集 5零用錢應該給多少台灣版</li>
										<li>第6集 6我們家很窮</li>
										<li>第7集 7老大老二不一樣</li>
										<li>第8集 8買個透明的存錢儲蓄罐</li>
										<li>第9集 9與孩子談錢</li>
										<li>第10集 10培養紅包小富豪</li>
										<li>第11集 11有錢從記賬開始</li>
										<li>第12集 12孩子你是真的需要還是想要</li>
										<li>第13集 13價格和價值別傻傻分不清楚</li>
										<li>第14集 14廣告騙人教孩子正確消費</li>
										<li>第15集 15與孩子一同玩遊戲學理財</li>
										<li>第16集 16逛超市也能理財賺錢</li>
										<li>第17集 17與孩子逛銀行了解錢滾錢</li>
										<li>第18集 18自助遊測試孩子的消費IQ</li>
										<li>第19集 19孩子也能打工存到第一桶金</li>
										<li>第20集 20教小孩有錢</li>
										<li>第21集 21為孩子存下未來</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop205">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1郭雪湖圓山附近</li>
										<li>第2集 2郭雪湖南街殷賑</li>
										<li>第3集 3陳澄波綢坊之午後</li>
										<li>第4集 4陳澄波夏日街景</li>
										<li>第5集 5石川欽一郎福爾摩沙</li>
										<li>第6集 6鹽月桃甫女子像</li>
										<li>第7集 7鄉原古統麗島名華鑑</li>
										<li>第8集 8木下靜涯南國初夏</li>
										<li>第9集 9黃土水水牛群像</li>
										<li>第10集 10陳進野邊</li>
										<li>第11集 11林玉山梅蘭竹菊</li>
										<li>第12集 12廖繼春有香蕉樹的院子</li>
										<li>第13集 13顏水龍蒙特梭利公園</li>
										<li>第14集 14李梅樹白衣少女</li>
										<li>第15集 15李石樵田園樂</li>
										<li>第16集 16楊三郎台北舊街</li>
										<li>第17集 17郭柏川孔廟</li>
										<li>第18集 18劉啟祥魚店</li>
										<li>第19集 19倪蔣懷台北李春生紀念館</li>
										<li>第20集 20李澤藩青草湖暮色</li>
										<li>第21集 21呂鐵州後庭</li>
										<li>第22集 22呂基正南湖大山</li>
										<li>第23集 23蕭如松窗邊</li>
										<li>第24集 24藝術家的太太們</li>
										<li>第25集 25藝術家的自畫像</li>
										<li>第26集 26藝術家筆下的家鄉</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop206">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1達芬奇蒙娜麗莎</li>
										<li>第2集 2達芬奇最後的晚餐</li>
										<li>第3集 3米開朗基羅創造亞當</li>
										<li>第4集 4拉斐爾雅典學園</li>
										<li>第5集 5波堤切利維納斯的誕生</li>
										<li>第6集 6凡艾克阿諾菲尼夫婦</li>
										<li>第7集 7魯本斯瑪麗梅迪奇抵達馬賽</li>
										<li>第8集 8大衛拿破崙加冕</li>
										<li>第9集 9米勒拾穗</li>
										<li>第10集 10梵高星夜</li>
										<li>第11集 11維米爾戴珍珠耳環的少女</li>
										<li>第12集 12雷諾瓦煎餅磨坊</li>
										<li>第13集 13馬諦斯戴帽仕女</li>
										<li>第14集 14卡拉瓦喬少年大衛</li>
										<li>第15集 15畢卡索格爾尼卡</li>
										<li>第16集 16馬奈陽台</li>
										<li>第17集 17莫內印象日出</li>
										<li>第18集 18梵高向日葵</li>
										<li>第19集 19高更我們從何處來</li>
										<li>第20集 20安格爾大宮女</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop207">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1劇場獨一無二的魅力</li>
										<li>第2集 2各國不同的戲劇形式</li>
										<li>第3集 3對空間與形式的探討</li>
										<li>第4集 4打破舞台思維</li>
										<li>第5集 5旅行的意義與思考</li>
										<li>第6集 6創意來源於生活</li>
										<li>第7集 7如夢之夢曾經如是的創作</li>
										<li>第8集 8觀眾互動提問</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop208">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1對談部份</li>
										<li>第2集 2QA提問部分</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop209">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1創造美的人要會魔法</li>
										<li>第2集 2創意是無法容易獲得的</li>
										<li>第3集 3戲是手工藝人心是材料素材 </li>
										<li>第4集 4創意的動機是愛才會有勇敢與自由</li>
										<li>第5集 5如何在生活中培養你的美學與品位</li>
										<li>第6集 6賴聲川的一頁大綱工作法</li>
										<li>第7集 7創意人的思考：沒有靈感的狀態</li>
										<li>第8集 8抓住靈感：如何積累實踐</li>
										<li>第9集 9即興創作上</li>
										<li>第10集 10即興創作下</li>
										<li>第11集 11寶島一村上</li>
										<li>第12集 12寶島一村下</li>
										<li>第13集 13師從Shireen打破思考box</li>
										<li>第14集 14知道什麼能做什麼不能做</li>
										<li>第15集 15創意總論要看見什麼你就先要是什麼</li>
										<li>第16集 16創意總論確立世界觀對生命有看法創意才有意義</li>
										<li>第17集 17視野多廣創作就有多廣</li>
										<li>第18集 18創意的根就在於動機</li>
										<li>第19集 19穿越習性透視作品的動機</li>
										<li>第20集 20從披頭四和巴布狄倫音樂中瞭解戲劇的結構1</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop210">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 靜心安眠第01章</li>
										<li>第2集 靜心安眠第02章</li>
										<li>第3集 靜心安眠第03章</li>
										<li>第4集 靜心安眠第04章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop211">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 安心入眠第01章</li>
										<li>第2集 安心入眠第02章</li>
										<li>第3集 安心入眠第03章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop212">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 安枕無憂第01章</li>
										<li>第2集 安枕無憂第02章</li>
										<li>第3集 安枕無憂第03章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop213">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1早安篇腹式呼吸放鬆練習</li>
										<li>第2集 2早安篇肌肉放鬆練習</li>
										<li>第3集 3午安篇腹式呼吸放鬆練習</li>
										<li>第4集 4午安篇肌肉放鬆練習</li>
										<li>第5集 5午安篇冥想放鬆練習</li>
										<li>第6集 6晚安篇腹式呼吸放鬆練習</li>
										<li>第7集 7晚安篇肌肉放鬆練習</li>
										<li>第8集 8晚安篇冥想放鬆練習</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop214">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1前言</li>
										<li>第2集 2我為何來到這裡</li>
										<li>第3集 3葡萄乾練習</li>
										<li>第4集 4呼吸覺察練習</li>
										<li>第5集 5三分鐘呼吸空間</li>
										<li>第6集 6正念走路</li>
										<li>第7集 7身體掃描</li>
										<li>第8集 8慈心觀練習</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop215">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 真逆齡有聲書第01章</li>
										<li>第2集 真逆齡有聲書第02章</li>
										<li>第3集 真逆齡有聲書第03章</li>
										<li>第4集 真逆齡有聲書第04章</li>
										<li>第5集 真逆齡有聲書第05章</li>
										<li>第6集 真逆齡有聲書第06章</li>
										<li>第7集 真逆齡有聲書第07章</li>
										<li>第8集 真逆齡有聲書第08章</li>
										<li>第9集 真逆齡有聲書第09章</li>
										<li>第10集 真逆齡有聲書第10章</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop216">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1抽離與投入</li>
										<li>第2集 2你最深處的信念是什麼</li>
										<li>第3集 3情緒樹</li>
										<li>第4集 4運用情緒樹面對接受釋放轉念</li>
										<li>第5集 5EFT練習</li>
										<li>第6集 6EFT練習二</li>
										<li>第7集 7EFT練習三</li>
										<li>第8集 8學會寬恕</li>
										<li>第9集 9忍耐對自我的傷害</li>
										<li>第10集 10潛意識的探照燈</li>
										<li>第11集 11從潛意識的探照燈看見互相依賴的關係</li>
										<li>第12集 12最終回運用NLP走向未來</li>
										<li>第13集 13EFT情傷療癒找到全新的自己</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop217">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1親密關係是在愛裡誠實作自己</li>
										<li>第2集 2老公有小三要忍還是爭</li>
										<li>第3集 3吵架可以千萬別口無遮攔</li>
										<li>第4集 4當另一半跟你抱怨時要當垃圾桶還是大喇叭</li>
										<li>第5集 5兩地婚姻抓緊時間可以愛更多</li>
										<li>第6集 6夫妻關係常保鮮七年也不會癢</li>
										<li>第7集 7別讓金錢壓垮夫妻感情</li>
										<li>第8集 8婆媳關係好不好老公最關鍵</li>
										<li>第9集 9與婆婆同住聽話有禮就不矛盾</li>
										<li>第10集 10自己的孩子自己帶</li>
										<li>第11集 11婆婆火大時放低姿態化解紛爭</li>
										<li>第12集 12夫妻同心自主獨立婆媳問題化無形</li>
										<li>第13集 13討好婆婆很簡單嘴巴甜一點幸福多一點</li>
										<li>第14集 14婆媳過招是場不會贏的戰爭</li>
										<li>第15集 15有點黏又不會太黏與父母的距離</li>
										<li>第16集 16祝福與諒解父母親再結新歡時</li>
										<li>第17集 17生小孩的目的為繼起之生命或不小心亂了套</li>
										<li>第18集 18聽爸媽的話-孩子你就乖一點</li>
										<li>第19集 19面對子女做不到的就不要說</li>
										<li>第20集 20捍衛幸福小人退散</li>
										<li>第21集 21愛的靜心練習停看聽創造幸福好生活</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop218">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1上</li>
										<li>第2集 2下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop219">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1引言</li>
										<li>第2集 2第一段</li>
										<li>第3集 3第二段</li>
										<li>第4集 生命的河流_第三段</li>
										<li>第5集 5歌</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop220">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 Party Man</li>
										<li>第2集 小王子歷險記</li>
										<li>第3集 刮出新視界</li>
										<li>第4集 魔髮奇緣</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop221">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1大寶養了一隻烏骨雞</li>
										<li>第2集 2所有男人都是女兒控？</li>
										<li>第3集 3大寶冠冠只當三個月的兵</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop222">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1最想要的居家風格</li>
										<li>第2集 2不要招惹單親家庭幫啊！</li>
										<li>第3集 3解救總統女兒</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop223">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1冠冠跟川普是朋友？</li>
										<li>第2集 2喬瑟夫發生前所未聞的交通事故</li>
										<li>第3集 3看電影配爆米花已落伍，要配魚鱗啦！</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop224">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 4你最有品對口相聲</li>
										<li>第2集 1承天寺Ya遊對口相聲</li>
										<li>第3集 5偉人傳對口相聲</li>
										<li>第4集 2對對聯對口相聲</li>
										<li>第5集 6諺語談對口相聲</li>
										<li>第6集 3火星文對口相聲</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop225">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1嫌疑犯們01</li>
										<li>第2集 2嫌疑犯們02</li>
										<li>第3集 3嫌疑犯們03</li>
										<li>第4集 4嫌疑犯們04</li>
										<li>第5集 5嫌疑犯們05</li>
										<li>第6集 6嫌疑犯們06</li>
										<li>第7集 7嫌疑犯們07</li>
										<li>第8集 8真正的兇手01</li>
										<li>第9集 9真正的兇手02</li>
										<li>第10集 10真正的兇手03</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop226">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1上半場上次和這次01</li>
										<li>第2集 2上半場上次和這次02</li>
										<li>第3集 3上半場上次和這次03</li>
										<li>第4集 4上半場上次和這次04</li>
										<li>第5集 5下半場下次01</li>
										<li>第6集 6下半場下次02</li>
										<li>第7集 7下半場下次03</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop227">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1舌燦蓮花蔣先生</li>
										<li>第2集 2煽風點火幹什麼</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop228">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1A片</li>
										<li>第2集 2空襲</li>
										<li>第3集 3志向</li>
										<li>第4集 4聯誼</li>
										<li>第5集 5話劇</li>
										<li>第6集 6約會</li>
										<li>第7集 7鴕鳥</li>
										<li>第8集 8身世</li>
										<li>第9集 9車站</li>
										<li>第10集 10尾聲</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop229">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1DD廟電感應</li>
										<li>第2集 2大預演家</li>
										<li>第3集 3世界末日</li>
										<li>第4集 4親愛的塔羅牌</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop230">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 1雪哈莎拉德</li>
										<li>第2集 2沒有女人的男人們</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop231">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 停車暫借問上</li>
										<li>第2集 停車暫借問下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop232">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 張愛玲短篇小說選上</li>
										<li>第2集 張愛玲短篇小說選下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop233">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 阿根廷螞蟻上</li>
										<li>第2集 阿根廷螞蟻下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop234">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 百年孤寂上</li>
										<li>第2集 百年孤寂中</li>
										<li>第3集 百年孤寂下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop235">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 靈山上</li>
										<li>第2集 靈山下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop236">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 千羽鶴上</li>
										<li>第2集 千羽鶴下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop237">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 老人與海上</li>
										<li>第2集 老人與海下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop238">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 包法利夫人上</li>
										<li>第2集 包法利夫人下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop239">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 紅玫瑰與白玫瑰上</li>
										<li>第2集 紅玫瑰與白玫瑰下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop240">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 海與毒藥上</li>
										<li>第2集 海與毒藥下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop241">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 傑克倫敦短篇小說選上</li>
										<li>第2集 傑克倫敦短篇小說選下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop242">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 脂肪球</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop243">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 廢都上</li>
										<li>第2集 廢都下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop244">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 我們的荊軻上</li>
										<li>第2集 我們的荊軻下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop245">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 漂泊的靈魂</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop246">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 趙南棟上</li>
										<li>第2集 趙南棟下</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pop_box" id="pop247">
							<div className="pop_head">詳細集數<a className="btn_close"></a></div>
							<div className="pop_in">
								<div className="txtBox mCustomScrollbar" data-mcs-theme="light-2">
									<ul>
										<li>第1集 歐亨利短篇小說選上</li>
										<li>第2集 歐亨利短篇小說選下</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption0301;